
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0c20"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0c20"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("izkmZ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $d84b4be4e3dc49f3$export$ffb0004e005737fa; }, function (v) { return $d84b4be4e3dc49f3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $d84b4be4e3dc49f3$export$34b9dba7ce09269b; }, function (v) { return $d84b4be4e3dc49f3$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $d84b4be4e3dc49f3$export$25062201e9e25d76; }, function (v) { return $d84b4be4e3dc49f3$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d84b4be4e3dc49f3$export$ffb0004e005737fa;
var $d84b4be4e3dc49f3$export$34b9dba7ce09269b;
var $d84b4be4e3dc49f3$export$25062201e9e25d76;
"use strict";

var $iawgr = parcelRequire("iawgr");
var $d84b4be4e3dc49f3$var$k = Symbol.for("react.element"), $d84b4be4e3dc49f3$var$l = Symbol.for("react.fragment"), $d84b4be4e3dc49f3$var$m = Object.prototype.hasOwnProperty, $d84b4be4e3dc49f3$var$n = $iawgr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d84b4be4e3dc49f3$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d84b4be4e3dc49f3$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d84b4be4e3dc49f3$var$m.call(a, b) && !$d84b4be4e3dc49f3$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d84b4be4e3dc49f3$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d84b4be4e3dc49f3$var$n.current
    };
}
$d84b4be4e3dc49f3$export$ffb0004e005737fa = $d84b4be4e3dc49f3$var$l;
$d84b4be4e3dc49f3$export$34b9dba7ce09269b = $d84b4be4e3dc49f3$var$q;
$d84b4be4e3dc49f3$export$25062201e9e25d76 = $d84b4be4e3dc49f3$var$q;

});
parcelRegister("iawgr", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kdbEb"));

});
parcelRegister("kdbEb", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $eb6e0e7013fa9bcd$export$dca3b0875bd9a954; }, function (v) { return $eb6e0e7013fa9bcd$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $eb6e0e7013fa9bcd$export$16fa2f45be04daa8; }, function (v) { return $eb6e0e7013fa9bcd$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $eb6e0e7013fa9bcd$export$ffb0004e005737fa; }, function (v) { return $eb6e0e7013fa9bcd$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $eb6e0e7013fa9bcd$export$e2c29f18771995cb; }, function (v) { return $eb6e0e7013fa9bcd$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $eb6e0e7013fa9bcd$export$221d75b3f55bb0bd; }, function (v) { return $eb6e0e7013fa9bcd$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $eb6e0e7013fa9bcd$export$5f8d39834fd61797; }, function (v) { return $eb6e0e7013fa9bcd$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $eb6e0e7013fa9bcd$export$74bf444e3cd11ea5; }, function (v) { return $eb6e0e7013fa9bcd$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $eb6e0e7013fa9bcd$export$ae55be85d98224ed; }, function (v) { return $eb6e0e7013fa9bcd$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $eb6e0e7013fa9bcd$export$e530037191fcd5d7; }, function (v) { return $eb6e0e7013fa9bcd$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $eb6e0e7013fa9bcd$export$fd42f52fd3ae1109; }, function (v) { return $eb6e0e7013fa9bcd$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $eb6e0e7013fa9bcd$export$c8a8987d4410bf2d; }, function (v) { return $eb6e0e7013fa9bcd$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $eb6e0e7013fa9bcd$export$d38cd72104c1f0e9; }, function (v) { return $eb6e0e7013fa9bcd$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $eb6e0e7013fa9bcd$export$7d1e3a5e95ceca43; }, function (v) { return $eb6e0e7013fa9bcd$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $eb6e0e7013fa9bcd$export$257a8862b851cb5b; }, function (v) { return $eb6e0e7013fa9bcd$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $eb6e0e7013fa9bcd$export$a8257692ac88316c; }, function (v) { return $eb6e0e7013fa9bcd$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $eb6e0e7013fa9bcd$export$488013bae63b21da; }, function (v) { return $eb6e0e7013fa9bcd$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $eb6e0e7013fa9bcd$export$7c73462e0d25e514; }, function (v) { return $eb6e0e7013fa9bcd$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $eb6e0e7013fa9bcd$export$7568632d0d33d16d; }, function (v) { return $eb6e0e7013fa9bcd$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $eb6e0e7013fa9bcd$export$88948ce120ea2619; }, function (v) { return $eb6e0e7013fa9bcd$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $eb6e0e7013fa9bcd$export$35808ee640e87ca7; }, function (v) { return $eb6e0e7013fa9bcd$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $eb6e0e7013fa9bcd$export$fae74005e78b1a27; }, function (v) { return $eb6e0e7013fa9bcd$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $eb6e0e7013fa9bcd$export$dc8fbce3eb94dc1e; }, function (v) { return $eb6e0e7013fa9bcd$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $eb6e0e7013fa9bcd$export$6a7bc4e911dc01cf; }, function (v) { return $eb6e0e7013fa9bcd$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $eb6e0e7013fa9bcd$export$6d9c69b0de29b591; }, function (v) { return $eb6e0e7013fa9bcd$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $eb6e0e7013fa9bcd$export$f680877a34711e37; }, function (v) { return $eb6e0e7013fa9bcd$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $eb6e0e7013fa9bcd$export$d5a552a76deda3c2; }, function (v) { return $eb6e0e7013fa9bcd$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $eb6e0e7013fa9bcd$export$aaabe4eda9ed9969; }, function (v) { return $eb6e0e7013fa9bcd$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $eb6e0e7013fa9bcd$export$e5c5a5f917a5871c; }, function (v) { return $eb6e0e7013fa9bcd$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $eb6e0e7013fa9bcd$export$1538c33de8887b59; }, function (v) { return $eb6e0e7013fa9bcd$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $eb6e0e7013fa9bcd$export$13e3392192263954; }, function (v) { return $eb6e0e7013fa9bcd$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $eb6e0e7013fa9bcd$export$b8f5890fc79d6aca; }, function (v) { return $eb6e0e7013fa9bcd$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $eb6e0e7013fa9bcd$export$60241385465d0a34; }, function (v) { return $eb6e0e7013fa9bcd$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $eb6e0e7013fa9bcd$export$306c0aa65ff9ec16; }, function (v) { return $eb6e0e7013fa9bcd$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $eb6e0e7013fa9bcd$export$7b286972b8d8ccbf; }, function (v) { return $eb6e0e7013fa9bcd$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $eb6e0e7013fa9bcd$export$83d89fbfd8236492; }, function (v) { return $eb6e0e7013fa9bcd$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $eb6e0e7013fa9bcd$export$dca3b0875bd9a954;
var $eb6e0e7013fa9bcd$export$16fa2f45be04daa8;
var $eb6e0e7013fa9bcd$export$ffb0004e005737fa;
var $eb6e0e7013fa9bcd$export$e2c29f18771995cb;
var $eb6e0e7013fa9bcd$export$221d75b3f55bb0bd;
var $eb6e0e7013fa9bcd$export$5f8d39834fd61797;
var $eb6e0e7013fa9bcd$export$74bf444e3cd11ea5;
var $eb6e0e7013fa9bcd$export$ae55be85d98224ed;
var $eb6e0e7013fa9bcd$export$e530037191fcd5d7;
var $eb6e0e7013fa9bcd$export$fd42f52fd3ae1109;
var $eb6e0e7013fa9bcd$export$c8a8987d4410bf2d;
var $eb6e0e7013fa9bcd$export$d38cd72104c1f0e9;
var $eb6e0e7013fa9bcd$export$7d1e3a5e95ceca43;
var $eb6e0e7013fa9bcd$export$257a8862b851cb5b;
var $eb6e0e7013fa9bcd$export$a8257692ac88316c;
var $eb6e0e7013fa9bcd$export$488013bae63b21da;
var $eb6e0e7013fa9bcd$export$7c73462e0d25e514;
var $eb6e0e7013fa9bcd$export$7568632d0d33d16d;
var $eb6e0e7013fa9bcd$export$88948ce120ea2619;
var $eb6e0e7013fa9bcd$export$35808ee640e87ca7;
var $eb6e0e7013fa9bcd$export$fae74005e78b1a27;
var $eb6e0e7013fa9bcd$export$dc8fbce3eb94dc1e;
var $eb6e0e7013fa9bcd$export$6a7bc4e911dc01cf;
var $eb6e0e7013fa9bcd$export$6d9c69b0de29b591;
var $eb6e0e7013fa9bcd$export$f680877a34711e37;
var $eb6e0e7013fa9bcd$export$d5a552a76deda3c2;
var $eb6e0e7013fa9bcd$export$aaabe4eda9ed9969;
var $eb6e0e7013fa9bcd$export$e5c5a5f917a5871c;
var $eb6e0e7013fa9bcd$export$1538c33de8887b59;
var $eb6e0e7013fa9bcd$export$13e3392192263954;
var $eb6e0e7013fa9bcd$export$b8f5890fc79d6aca;
var $eb6e0e7013fa9bcd$export$60241385465d0a34;
var $eb6e0e7013fa9bcd$export$306c0aa65ff9ec16;
var $eb6e0e7013fa9bcd$export$7b286972b8d8ccbf;
var $eb6e0e7013fa9bcd$export$83d89fbfd8236492;
"use strict";
var $eb6e0e7013fa9bcd$var$l = Symbol.for("react.element"), $eb6e0e7013fa9bcd$var$n = Symbol.for("react.portal"), $eb6e0e7013fa9bcd$var$p = Symbol.for("react.fragment"), $eb6e0e7013fa9bcd$var$q = Symbol.for("react.strict_mode"), $eb6e0e7013fa9bcd$var$r = Symbol.for("react.profiler"), $eb6e0e7013fa9bcd$var$t = Symbol.for("react.provider"), $eb6e0e7013fa9bcd$var$u = Symbol.for("react.context"), $eb6e0e7013fa9bcd$var$v = Symbol.for("react.forward_ref"), $eb6e0e7013fa9bcd$var$w = Symbol.for("react.suspense"), $eb6e0e7013fa9bcd$var$x = Symbol.for("react.memo"), $eb6e0e7013fa9bcd$var$y = Symbol.for("react.lazy"), $eb6e0e7013fa9bcd$var$z = Symbol.iterator;
function $eb6e0e7013fa9bcd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $eb6e0e7013fa9bcd$var$z && a[$eb6e0e7013fa9bcd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $eb6e0e7013fa9bcd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $eb6e0e7013fa9bcd$var$C = Object.assign, $eb6e0e7013fa9bcd$var$D = {};
function $eb6e0e7013fa9bcd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $eb6e0e7013fa9bcd$var$D;
    this.updater = e || $eb6e0e7013fa9bcd$var$B;
}
$eb6e0e7013fa9bcd$var$E.prototype.isReactComponent = {};
$eb6e0e7013fa9bcd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$eb6e0e7013fa9bcd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $eb6e0e7013fa9bcd$var$F() {}
$eb6e0e7013fa9bcd$var$F.prototype = $eb6e0e7013fa9bcd$var$E.prototype;
function $eb6e0e7013fa9bcd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $eb6e0e7013fa9bcd$var$D;
    this.updater = e || $eb6e0e7013fa9bcd$var$B;
}
var $eb6e0e7013fa9bcd$var$H = $eb6e0e7013fa9bcd$var$G.prototype = new $eb6e0e7013fa9bcd$var$F;
$eb6e0e7013fa9bcd$var$H.constructor = $eb6e0e7013fa9bcd$var$G;
$eb6e0e7013fa9bcd$var$C($eb6e0e7013fa9bcd$var$H, $eb6e0e7013fa9bcd$var$E.prototype);
$eb6e0e7013fa9bcd$var$H.isPureReactComponent = !0;
var $eb6e0e7013fa9bcd$var$I = Array.isArray, $eb6e0e7013fa9bcd$var$J = Object.prototype.hasOwnProperty, $eb6e0e7013fa9bcd$var$K = {
    current: null
}, $eb6e0e7013fa9bcd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $eb6e0e7013fa9bcd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$eb6e0e7013fa9bcd$var$J.call(b, d) && !$eb6e0e7013fa9bcd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $eb6e0e7013fa9bcd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $eb6e0e7013fa9bcd$var$K.current
    };
}
function $eb6e0e7013fa9bcd$var$N(a, b) {
    return {
        $$typeof: $eb6e0e7013fa9bcd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $eb6e0e7013fa9bcd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $eb6e0e7013fa9bcd$var$l;
}
function $eb6e0e7013fa9bcd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $eb6e0e7013fa9bcd$var$P = /\/+/g;
function $eb6e0e7013fa9bcd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $eb6e0e7013fa9bcd$var$escape("" + a.key) : b.toString(36);
}
function $eb6e0e7013fa9bcd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $eb6e0e7013fa9bcd$var$l:
                case $eb6e0e7013fa9bcd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $eb6e0e7013fa9bcd$var$Q(h, 0) : d, $eb6e0e7013fa9bcd$var$I(c) ? (e = "", null != a && (e = a.replace($eb6e0e7013fa9bcd$var$P, "$&/") + "/"), $eb6e0e7013fa9bcd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($eb6e0e7013fa9bcd$var$O(c) && (c = $eb6e0e7013fa9bcd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($eb6e0e7013fa9bcd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($eb6e0e7013fa9bcd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $eb6e0e7013fa9bcd$var$Q(k, g);
        h += $eb6e0e7013fa9bcd$var$R(k, b, e, f, c);
    }
    else if (f = $eb6e0e7013fa9bcd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $eb6e0e7013fa9bcd$var$Q(k, g++), h += $eb6e0e7013fa9bcd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $eb6e0e7013fa9bcd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $eb6e0e7013fa9bcd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $eb6e0e7013fa9bcd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $eb6e0e7013fa9bcd$var$U = {
    current: null
}, $eb6e0e7013fa9bcd$var$V = {
    transition: null
}, $eb6e0e7013fa9bcd$var$W = {
    ReactCurrentDispatcher: $eb6e0e7013fa9bcd$var$U,
    ReactCurrentBatchConfig: $eb6e0e7013fa9bcd$var$V,
    ReactCurrentOwner: $eb6e0e7013fa9bcd$var$K
};
$eb6e0e7013fa9bcd$export$dca3b0875bd9a954 = {
    map: $eb6e0e7013fa9bcd$var$S,
    forEach: function(a, b, e) {
        $eb6e0e7013fa9bcd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $eb6e0e7013fa9bcd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $eb6e0e7013fa9bcd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$eb6e0e7013fa9bcd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$eb6e0e7013fa9bcd$export$16fa2f45be04daa8 = $eb6e0e7013fa9bcd$var$E;
$eb6e0e7013fa9bcd$export$ffb0004e005737fa = $eb6e0e7013fa9bcd$var$p;
$eb6e0e7013fa9bcd$export$e2c29f18771995cb = $eb6e0e7013fa9bcd$var$r;
$eb6e0e7013fa9bcd$export$221d75b3f55bb0bd = $eb6e0e7013fa9bcd$var$G;
$eb6e0e7013fa9bcd$export$5f8d39834fd61797 = $eb6e0e7013fa9bcd$var$q;
$eb6e0e7013fa9bcd$export$74bf444e3cd11ea5 = $eb6e0e7013fa9bcd$var$w;
$eb6e0e7013fa9bcd$export$ae55be85d98224ed = $eb6e0e7013fa9bcd$var$W;
$eb6e0e7013fa9bcd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $eb6e0e7013fa9bcd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $eb6e0e7013fa9bcd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$eb6e0e7013fa9bcd$var$J.call(b, f) && !$eb6e0e7013fa9bcd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $eb6e0e7013fa9bcd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$eb6e0e7013fa9bcd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $eb6e0e7013fa9bcd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $eb6e0e7013fa9bcd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$eb6e0e7013fa9bcd$export$c8a8987d4410bf2d = $eb6e0e7013fa9bcd$var$M;
$eb6e0e7013fa9bcd$export$d38cd72104c1f0e9 = function(a) {
    var b = $eb6e0e7013fa9bcd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$eb6e0e7013fa9bcd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$eb6e0e7013fa9bcd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $eb6e0e7013fa9bcd$var$v,
        render: a
    };
};
$eb6e0e7013fa9bcd$export$a8257692ac88316c = $eb6e0e7013fa9bcd$var$O;
$eb6e0e7013fa9bcd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $eb6e0e7013fa9bcd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $eb6e0e7013fa9bcd$var$T
    };
};
$eb6e0e7013fa9bcd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $eb6e0e7013fa9bcd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$eb6e0e7013fa9bcd$export$7568632d0d33d16d = function(a) {
    var b = $eb6e0e7013fa9bcd$var$V.transition;
    $eb6e0e7013fa9bcd$var$V.transition = {};
    try {
        a();
    } finally{
        $eb6e0e7013fa9bcd$var$V.transition = b;
    }
};
$eb6e0e7013fa9bcd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$eb6e0e7013fa9bcd$export$35808ee640e87ca7 = function(a, b) {
    return $eb6e0e7013fa9bcd$var$U.current.useCallback(a, b);
};
$eb6e0e7013fa9bcd$export$fae74005e78b1a27 = function(a) {
    return $eb6e0e7013fa9bcd$var$U.current.useContext(a);
};
$eb6e0e7013fa9bcd$export$dc8fbce3eb94dc1e = function() {};
$eb6e0e7013fa9bcd$export$6a7bc4e911dc01cf = function(a) {
    return $eb6e0e7013fa9bcd$var$U.current.useDeferredValue(a);
};
$eb6e0e7013fa9bcd$export$6d9c69b0de29b591 = function(a, b) {
    return $eb6e0e7013fa9bcd$var$U.current.useEffect(a, b);
};
$eb6e0e7013fa9bcd$export$f680877a34711e37 = function() {
    return $eb6e0e7013fa9bcd$var$U.current.useId();
};
$eb6e0e7013fa9bcd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $eb6e0e7013fa9bcd$var$U.current.useImperativeHandle(a, b, e);
};
$eb6e0e7013fa9bcd$export$aaabe4eda9ed9969 = function(a, b) {
    return $eb6e0e7013fa9bcd$var$U.current.useInsertionEffect(a, b);
};
$eb6e0e7013fa9bcd$export$e5c5a5f917a5871c = function(a, b) {
    return $eb6e0e7013fa9bcd$var$U.current.useLayoutEffect(a, b);
};
$eb6e0e7013fa9bcd$export$1538c33de8887b59 = function(a, b) {
    return $eb6e0e7013fa9bcd$var$U.current.useMemo(a, b);
};
$eb6e0e7013fa9bcd$export$13e3392192263954 = function(a, b, e) {
    return $eb6e0e7013fa9bcd$var$U.current.useReducer(a, b, e);
};
$eb6e0e7013fa9bcd$export$b8f5890fc79d6aca = function(a) {
    return $eb6e0e7013fa9bcd$var$U.current.useRef(a);
};
$eb6e0e7013fa9bcd$export$60241385465d0a34 = function(a) {
    return $eb6e0e7013fa9bcd$var$U.current.useState(a);
};
$eb6e0e7013fa9bcd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $eb6e0e7013fa9bcd$var$U.current.useSyncExternalStore(a, b, e);
};
$eb6e0e7013fa9bcd$export$7b286972b8d8ccbf = function() {
    return $eb6e0e7013fa9bcd$var$U.current.useTransition();
};
$eb6e0e7013fa9bcd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("5NiZx", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $438042a7fad0109d$export$ae55be85d98224ed; }, function (v) { return $438042a7fad0109d$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $438042a7fad0109d$export$d39a5bbd09211389; }, function (v) { return $438042a7fad0109d$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $438042a7fad0109d$export$882461b6382ed46c; }, function (v) { return $438042a7fad0109d$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $438042a7fad0109d$export$466bfc07425424d5; }, function (v) { return $438042a7fad0109d$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $438042a7fad0109d$export$cd75ccfd720a3cd4; }, function (v) { return $438042a7fad0109d$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $438042a7fad0109d$export$fa8d919ba61d84db; }, function (v) { return $438042a7fad0109d$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $438042a7fad0109d$export$757ceba2d55c277e; }, function (v) { return $438042a7fad0109d$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $438042a7fad0109d$export$b3890eb0ae9dca99; }, function (v) { return $438042a7fad0109d$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $438042a7fad0109d$export$502457920280e6be; }, function (v) { return $438042a7fad0109d$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $438042a7fad0109d$export$c78a37762a8d58e1; }, function (v) { return $438042a7fad0109d$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $438042a7fad0109d$export$dc54d992c10e8a18; }, function (v) { return $438042a7fad0109d$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $438042a7fad0109d$export$83d89fbfd8236492; }, function (v) { return $438042a7fad0109d$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $438042a7fad0109d$export$ae55be85d98224ed;
var $438042a7fad0109d$export$d39a5bbd09211389;
var $438042a7fad0109d$export$882461b6382ed46c;
var $438042a7fad0109d$export$466bfc07425424d5;
var $438042a7fad0109d$export$cd75ccfd720a3cd4;
var $438042a7fad0109d$export$fa8d919ba61d84db;
var $438042a7fad0109d$export$757ceba2d55c277e;
var $438042a7fad0109d$export$b3890eb0ae9dca99;
var $438042a7fad0109d$export$502457920280e6be;
var $438042a7fad0109d$export$c78a37762a8d58e1;
var $438042a7fad0109d$export$dc54d992c10e8a18;
var $438042a7fad0109d$export$83d89fbfd8236492;
"use strict";

var $iawgr = parcelRequire("iawgr");

var $aqdX4 = parcelRequire("aqdX4");
function $438042a7fad0109d$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $438042a7fad0109d$var$da = new Set, $438042a7fad0109d$var$ea = {};
function $438042a7fad0109d$var$fa(a, b) {
    $438042a7fad0109d$var$ha(a, b);
    $438042a7fad0109d$var$ha(a + "Capture", b);
}
function $438042a7fad0109d$var$ha(a, b) {
    $438042a7fad0109d$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$438042a7fad0109d$var$da.add(b[a]);
}
var $438042a7fad0109d$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $438042a7fad0109d$var$ja = Object.prototype.hasOwnProperty, $438042a7fad0109d$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $438042a7fad0109d$var$la = {}, $438042a7fad0109d$var$ma = {};
function $438042a7fad0109d$var$oa(a) {
    if ($438042a7fad0109d$var$ja.call($438042a7fad0109d$var$ma, a)) return !0;
    if ($438042a7fad0109d$var$ja.call($438042a7fad0109d$var$la, a)) return !1;
    if ($438042a7fad0109d$var$ka.test(a)) return $438042a7fad0109d$var$ma[a] = !0;
    $438042a7fad0109d$var$la[a] = !0;
    return !1;
}
function $438042a7fad0109d$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $438042a7fad0109d$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $438042a7fad0109d$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $438042a7fad0109d$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $438042a7fad0109d$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $438042a7fad0109d$var$z[b] = new $438042a7fad0109d$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $438042a7fad0109d$var$ra = /[\-:]([a-z])/g;
function $438042a7fad0109d$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($438042a7fad0109d$var$ra, $438042a7fad0109d$var$sa);
    $438042a7fad0109d$var$z[b] = new $438042a7fad0109d$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($438042a7fad0109d$var$ra, $438042a7fad0109d$var$sa);
    $438042a7fad0109d$var$z[b] = new $438042a7fad0109d$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($438042a7fad0109d$var$ra, $438042a7fad0109d$var$sa);
    $438042a7fad0109d$var$z[b] = new $438042a7fad0109d$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$438042a7fad0109d$var$z.xlinkHref = new $438042a7fad0109d$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $438042a7fad0109d$var$z[a] = new $438042a7fad0109d$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $438042a7fad0109d$var$ta(a, b, c, d) {
    var e = $438042a7fad0109d$var$z.hasOwnProperty(b) ? $438042a7fad0109d$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $438042a7fad0109d$var$qa(b, c, e, d) && (c = null), d || null === e ? $438042a7fad0109d$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $438042a7fad0109d$var$ua = $iawgr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $438042a7fad0109d$var$va = Symbol.for("react.element"), $438042a7fad0109d$var$wa = Symbol.for("react.portal"), $438042a7fad0109d$var$ya = Symbol.for("react.fragment"), $438042a7fad0109d$var$za = Symbol.for("react.strict_mode"), $438042a7fad0109d$var$Aa = Symbol.for("react.profiler"), $438042a7fad0109d$var$Ba = Symbol.for("react.provider"), $438042a7fad0109d$var$Ca = Symbol.for("react.context"), $438042a7fad0109d$var$Da = Symbol.for("react.forward_ref"), $438042a7fad0109d$var$Ea = Symbol.for("react.suspense"), $438042a7fad0109d$var$Fa = Symbol.for("react.suspense_list"), $438042a7fad0109d$var$Ga = Symbol.for("react.memo"), $438042a7fad0109d$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $438042a7fad0109d$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $438042a7fad0109d$var$Ja = Symbol.iterator;
function $438042a7fad0109d$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $438042a7fad0109d$var$Ja && a[$438042a7fad0109d$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $438042a7fad0109d$var$A = Object.assign, $438042a7fad0109d$var$La;
function $438042a7fad0109d$var$Ma(a) {
    if (void 0 === $438042a7fad0109d$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $438042a7fad0109d$var$La = b && b[1] || "";
    }
    return "\n" + $438042a7fad0109d$var$La + a;
}
var $438042a7fad0109d$var$Na = !1;
function $438042a7fad0109d$var$Oa(a, b) {
    if (!a || $438042a7fad0109d$var$Na) return "";
    $438042a7fad0109d$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $438042a7fad0109d$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $438042a7fad0109d$var$Ma(a) : "";
}
function $438042a7fad0109d$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $438042a7fad0109d$var$Ma(a.type);
        case 16:
            return $438042a7fad0109d$var$Ma("Lazy");
        case 13:
            return $438042a7fad0109d$var$Ma("Suspense");
        case 19:
            return $438042a7fad0109d$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $438042a7fad0109d$var$Oa(a.type, !1), a;
        case 11:
            return a = $438042a7fad0109d$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $438042a7fad0109d$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $438042a7fad0109d$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $438042a7fad0109d$var$ya:
            return "Fragment";
        case $438042a7fad0109d$var$wa:
            return "Portal";
        case $438042a7fad0109d$var$Aa:
            return "Profiler";
        case $438042a7fad0109d$var$za:
            return "StrictMode";
        case $438042a7fad0109d$var$Ea:
            return "Suspense";
        case $438042a7fad0109d$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $438042a7fad0109d$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $438042a7fad0109d$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $438042a7fad0109d$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $438042a7fad0109d$var$Ga:
            return b = a.displayName || null, null !== b ? b : $438042a7fad0109d$var$Qa(a.type) || "Memo";
        case $438042a7fad0109d$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $438042a7fad0109d$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $438042a7fad0109d$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $438042a7fad0109d$var$Qa(b);
        case 8:
            return b === $438042a7fad0109d$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $438042a7fad0109d$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $438042a7fad0109d$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $438042a7fad0109d$var$Ua(a) {
    var b = $438042a7fad0109d$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $438042a7fad0109d$var$Va(a) {
    a._valueTracker || (a._valueTracker = $438042a7fad0109d$var$Ua(a));
}
function $438042a7fad0109d$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $438042a7fad0109d$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $438042a7fad0109d$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $438042a7fad0109d$var$Ya(a, b) {
    var c = b.checked;
    return $438042a7fad0109d$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $438042a7fad0109d$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $438042a7fad0109d$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $438042a7fad0109d$var$ab(a, b) {
    b = b.checked;
    null != b && $438042a7fad0109d$var$ta(a, "checked", b, !1);
}
function $438042a7fad0109d$var$bb(a, b) {
    $438042a7fad0109d$var$ab(a, b);
    var c = $438042a7fad0109d$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $438042a7fad0109d$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $438042a7fad0109d$var$cb(a, b.type, $438042a7fad0109d$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $438042a7fad0109d$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $438042a7fad0109d$var$cb(a, b, c) {
    if ("number" !== b || $438042a7fad0109d$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $438042a7fad0109d$var$eb = Array.isArray;
function $438042a7fad0109d$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $438042a7fad0109d$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $438042a7fad0109d$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($438042a7fad0109d$var$p(91));
    return $438042a7fad0109d$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $438042a7fad0109d$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($438042a7fad0109d$var$p(92));
            if ($438042a7fad0109d$var$eb(c)) {
                if (1 < c.length) throw Error($438042a7fad0109d$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $438042a7fad0109d$var$Sa(c)
    };
}
function $438042a7fad0109d$var$ib(a, b) {
    var c = $438042a7fad0109d$var$Sa(b.value), d = $438042a7fad0109d$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $438042a7fad0109d$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $438042a7fad0109d$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $438042a7fad0109d$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $438042a7fad0109d$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $438042a7fad0109d$var$mb, $438042a7fad0109d$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $438042a7fad0109d$var$mb = $438042a7fad0109d$var$mb || document.createElement("div");
        $438042a7fad0109d$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $438042a7fad0109d$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $438042a7fad0109d$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $438042a7fad0109d$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $438042a7fad0109d$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($438042a7fad0109d$var$pb).forEach(function(a) {
    $438042a7fad0109d$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $438042a7fad0109d$var$pb[b] = $438042a7fad0109d$var$pb[a];
    });
});
function $438042a7fad0109d$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $438042a7fad0109d$var$pb.hasOwnProperty(a) && $438042a7fad0109d$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $438042a7fad0109d$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $438042a7fad0109d$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $438042a7fad0109d$var$tb = $438042a7fad0109d$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $438042a7fad0109d$var$ub(a, b) {
    if (b) {
        if ($438042a7fad0109d$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($438042a7fad0109d$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($438042a7fad0109d$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($438042a7fad0109d$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($438042a7fad0109d$var$p(62));
    }
}
function $438042a7fad0109d$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $438042a7fad0109d$var$wb = null;
function $438042a7fad0109d$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $438042a7fad0109d$var$yb = null, $438042a7fad0109d$var$zb = null, $438042a7fad0109d$var$Ab = null;
function $438042a7fad0109d$var$Bb(a) {
    if (a = $438042a7fad0109d$var$Cb(a)) {
        if ("function" !== typeof $438042a7fad0109d$var$yb) throw Error($438042a7fad0109d$var$p(280));
        var b = a.stateNode;
        b && (b = $438042a7fad0109d$var$Db(b), $438042a7fad0109d$var$yb(a.stateNode, a.type, b));
    }
}
function $438042a7fad0109d$var$Eb(a) {
    $438042a7fad0109d$var$zb ? $438042a7fad0109d$var$Ab ? $438042a7fad0109d$var$Ab.push(a) : $438042a7fad0109d$var$Ab = [
        a
    ] : $438042a7fad0109d$var$zb = a;
}
function $438042a7fad0109d$var$Fb() {
    if ($438042a7fad0109d$var$zb) {
        var a = $438042a7fad0109d$var$zb, b = $438042a7fad0109d$var$Ab;
        $438042a7fad0109d$var$Ab = $438042a7fad0109d$var$zb = null;
        $438042a7fad0109d$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$438042a7fad0109d$var$Bb(b[a]);
    }
}
function $438042a7fad0109d$var$Gb(a, b) {
    return a(b);
}
function $438042a7fad0109d$var$Hb() {}
var $438042a7fad0109d$var$Ib = !1;
function $438042a7fad0109d$var$Jb(a, b, c) {
    if ($438042a7fad0109d$var$Ib) return a(b, c);
    $438042a7fad0109d$var$Ib = !0;
    try {
        return $438042a7fad0109d$var$Gb(a, b, c);
    } finally{
        if ($438042a7fad0109d$var$Ib = !1, null !== $438042a7fad0109d$var$zb || null !== $438042a7fad0109d$var$Ab) $438042a7fad0109d$var$Hb(), $438042a7fad0109d$var$Fb();
    }
}
function $438042a7fad0109d$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $438042a7fad0109d$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($438042a7fad0109d$var$p(231, b, typeof c));
    return c;
}
var $438042a7fad0109d$var$Lb = !1;
if ($438042a7fad0109d$var$ia) try {
    var $438042a7fad0109d$var$Mb = {};
    Object.defineProperty($438042a7fad0109d$var$Mb, "passive", {
        get: function() {
            $438042a7fad0109d$var$Lb = !0;
        }
    });
    window.addEventListener("test", $438042a7fad0109d$var$Mb, $438042a7fad0109d$var$Mb);
    window.removeEventListener("test", $438042a7fad0109d$var$Mb, $438042a7fad0109d$var$Mb);
} catch (a) {
    $438042a7fad0109d$var$Lb = !1;
}
function $438042a7fad0109d$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $438042a7fad0109d$var$Ob = !1, $438042a7fad0109d$var$Pb = null, $438042a7fad0109d$var$Qb = !1, $438042a7fad0109d$var$Rb = null, $438042a7fad0109d$var$Sb = {
    onError: function(a) {
        $438042a7fad0109d$var$Ob = !0;
        $438042a7fad0109d$var$Pb = a;
    }
};
function $438042a7fad0109d$var$Tb(a, b, c, d, e, f, g, h, k) {
    $438042a7fad0109d$var$Ob = !1;
    $438042a7fad0109d$var$Pb = null;
    $438042a7fad0109d$var$Nb.apply($438042a7fad0109d$var$Sb, arguments);
}
function $438042a7fad0109d$var$Ub(a, b, c, d, e, f, g, h, k) {
    $438042a7fad0109d$var$Tb.apply(this, arguments);
    if ($438042a7fad0109d$var$Ob) {
        if ($438042a7fad0109d$var$Ob) {
            var l = $438042a7fad0109d$var$Pb;
            $438042a7fad0109d$var$Ob = !1;
            $438042a7fad0109d$var$Pb = null;
        } else throw Error($438042a7fad0109d$var$p(198));
        $438042a7fad0109d$var$Qb || ($438042a7fad0109d$var$Qb = !0, $438042a7fad0109d$var$Rb = l);
    }
}
function $438042a7fad0109d$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $438042a7fad0109d$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $438042a7fad0109d$var$Xb(a) {
    if ($438042a7fad0109d$var$Vb(a) !== a) throw Error($438042a7fad0109d$var$p(188));
}
function $438042a7fad0109d$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $438042a7fad0109d$var$Vb(a);
        if (null === b) throw Error($438042a7fad0109d$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $438042a7fad0109d$var$Xb(e), a;
                if (f === d) return $438042a7fad0109d$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($438042a7fad0109d$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($438042a7fad0109d$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($438042a7fad0109d$var$p(190));
    }
    if (3 !== c.tag) throw Error($438042a7fad0109d$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $438042a7fad0109d$var$Zb(a) {
    a = $438042a7fad0109d$var$Yb(a);
    return null !== a ? $438042a7fad0109d$var$$b(a) : null;
}
function $438042a7fad0109d$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $438042a7fad0109d$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $438042a7fad0109d$var$ac = $aqdX4.unstable_scheduleCallback, $438042a7fad0109d$var$bc = $aqdX4.unstable_cancelCallback, $438042a7fad0109d$var$cc = $aqdX4.unstable_shouldYield, $438042a7fad0109d$var$dc = $aqdX4.unstable_requestPaint, $438042a7fad0109d$var$B = $aqdX4.unstable_now, $438042a7fad0109d$var$ec = $aqdX4.unstable_getCurrentPriorityLevel, $438042a7fad0109d$var$fc = $aqdX4.unstable_ImmediatePriority, $438042a7fad0109d$var$gc = $aqdX4.unstable_UserBlockingPriority, $438042a7fad0109d$var$hc = $aqdX4.unstable_NormalPriority, $438042a7fad0109d$var$ic = $aqdX4.unstable_LowPriority, $438042a7fad0109d$var$jc = $aqdX4.unstable_IdlePriority, $438042a7fad0109d$var$kc = null, $438042a7fad0109d$var$lc = null;
function $438042a7fad0109d$var$mc(a) {
    if ($438042a7fad0109d$var$lc && "function" === typeof $438042a7fad0109d$var$lc.onCommitFiberRoot) try {
        $438042a7fad0109d$var$lc.onCommitFiberRoot($438042a7fad0109d$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $438042a7fad0109d$var$oc = Math.clz32 ? Math.clz32 : $438042a7fad0109d$var$nc, $438042a7fad0109d$var$pc = Math.log, $438042a7fad0109d$var$qc = Math.LN2;
function $438042a7fad0109d$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($438042a7fad0109d$var$pc(a) / $438042a7fad0109d$var$qc | 0) | 0;
}
var $438042a7fad0109d$var$rc = 64, $438042a7fad0109d$var$sc = 4194304;
function $438042a7fad0109d$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $438042a7fad0109d$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $438042a7fad0109d$var$tc(h) : (f &= g, 0 !== f && (d = $438042a7fad0109d$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $438042a7fad0109d$var$tc(g) : 0 !== f && (d = $438042a7fad0109d$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $438042a7fad0109d$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $438042a7fad0109d$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $438042a7fad0109d$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $438042a7fad0109d$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $438042a7fad0109d$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $438042a7fad0109d$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $438042a7fad0109d$var$yc() {
    var a = $438042a7fad0109d$var$rc;
    $438042a7fad0109d$var$rc <<= 1;
    0 === ($438042a7fad0109d$var$rc & 4194240) && ($438042a7fad0109d$var$rc = 64);
    return a;
}
function $438042a7fad0109d$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $438042a7fad0109d$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $438042a7fad0109d$var$oc(b);
    a[b] = c;
}
function $438042a7fad0109d$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $438042a7fad0109d$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $438042a7fad0109d$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $438042a7fad0109d$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $438042a7fad0109d$var$C = 0;
function $438042a7fad0109d$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $438042a7fad0109d$var$Ec, $438042a7fad0109d$var$Fc, $438042a7fad0109d$var$Gc, $438042a7fad0109d$var$Hc, $438042a7fad0109d$var$Ic, $438042a7fad0109d$var$Jc = !1, $438042a7fad0109d$var$Kc = [], $438042a7fad0109d$var$Lc = null, $438042a7fad0109d$var$Mc = null, $438042a7fad0109d$var$Nc = null, $438042a7fad0109d$var$Oc = new Map, $438042a7fad0109d$var$Pc = new Map, $438042a7fad0109d$var$Qc = [], $438042a7fad0109d$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $438042a7fad0109d$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $438042a7fad0109d$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $438042a7fad0109d$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $438042a7fad0109d$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $438042a7fad0109d$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $438042a7fad0109d$var$Pc.delete(b.pointerId);
    }
}
function $438042a7fad0109d$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $438042a7fad0109d$var$Cb(b), null !== b && $438042a7fad0109d$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $438042a7fad0109d$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $438042a7fad0109d$var$Lc = $438042a7fad0109d$var$Tc($438042a7fad0109d$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $438042a7fad0109d$var$Mc = $438042a7fad0109d$var$Tc($438042a7fad0109d$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $438042a7fad0109d$var$Nc = $438042a7fad0109d$var$Tc($438042a7fad0109d$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $438042a7fad0109d$var$Oc.set(f, $438042a7fad0109d$var$Tc($438042a7fad0109d$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $438042a7fad0109d$var$Pc.set(f, $438042a7fad0109d$var$Tc($438042a7fad0109d$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $438042a7fad0109d$var$Vc(a) {
    var b = $438042a7fad0109d$var$Wc(a.target);
    if (null !== b) {
        var c = $438042a7fad0109d$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $438042a7fad0109d$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $438042a7fad0109d$var$Ic(a.priority, function() {
                        $438042a7fad0109d$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $438042a7fad0109d$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $438042a7fad0109d$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $438042a7fad0109d$var$wb = d;
            c.target.dispatchEvent(d);
            $438042a7fad0109d$var$wb = null;
        } else return b = $438042a7fad0109d$var$Cb(c), null !== b && $438042a7fad0109d$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $438042a7fad0109d$var$Zc(a, b, c) {
    $438042a7fad0109d$var$Xc(a) && c.delete(b);
}
function $438042a7fad0109d$var$$c() {
    $438042a7fad0109d$var$Jc = !1;
    null !== $438042a7fad0109d$var$Lc && $438042a7fad0109d$var$Xc($438042a7fad0109d$var$Lc) && ($438042a7fad0109d$var$Lc = null);
    null !== $438042a7fad0109d$var$Mc && $438042a7fad0109d$var$Xc($438042a7fad0109d$var$Mc) && ($438042a7fad0109d$var$Mc = null);
    null !== $438042a7fad0109d$var$Nc && $438042a7fad0109d$var$Xc($438042a7fad0109d$var$Nc) && ($438042a7fad0109d$var$Nc = null);
    $438042a7fad0109d$var$Oc.forEach($438042a7fad0109d$var$Zc);
    $438042a7fad0109d$var$Pc.forEach($438042a7fad0109d$var$Zc);
}
function $438042a7fad0109d$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $438042a7fad0109d$var$Jc || ($438042a7fad0109d$var$Jc = !0, $aqdX4.unstable_scheduleCallback($aqdX4.unstable_NormalPriority, $438042a7fad0109d$var$$c)));
}
function $438042a7fad0109d$var$bd(a) {
    function b(b) {
        return $438042a7fad0109d$var$ad(b, a);
    }
    if (0 < $438042a7fad0109d$var$Kc.length) {
        $438042a7fad0109d$var$ad($438042a7fad0109d$var$Kc[0], a);
        for(var c = 1; c < $438042a7fad0109d$var$Kc.length; c++){
            var d = $438042a7fad0109d$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $438042a7fad0109d$var$Lc && $438042a7fad0109d$var$ad($438042a7fad0109d$var$Lc, a);
    null !== $438042a7fad0109d$var$Mc && $438042a7fad0109d$var$ad($438042a7fad0109d$var$Mc, a);
    null !== $438042a7fad0109d$var$Nc && $438042a7fad0109d$var$ad($438042a7fad0109d$var$Nc, a);
    $438042a7fad0109d$var$Oc.forEach(b);
    $438042a7fad0109d$var$Pc.forEach(b);
    for(c = 0; c < $438042a7fad0109d$var$Qc.length; c++)d = $438042a7fad0109d$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $438042a7fad0109d$var$Qc.length && (c = $438042a7fad0109d$var$Qc[0], null === c.blockedOn);)$438042a7fad0109d$var$Vc(c), null === c.blockedOn && $438042a7fad0109d$var$Qc.shift();
}
var $438042a7fad0109d$var$cd = $438042a7fad0109d$var$ua.ReactCurrentBatchConfig, $438042a7fad0109d$var$dd = !0;
function $438042a7fad0109d$var$ed(a, b, c, d) {
    var e = $438042a7fad0109d$var$C, f = $438042a7fad0109d$var$cd.transition;
    $438042a7fad0109d$var$cd.transition = null;
    try {
        $438042a7fad0109d$var$C = 1, $438042a7fad0109d$var$fd(a, b, c, d);
    } finally{
        $438042a7fad0109d$var$C = e, $438042a7fad0109d$var$cd.transition = f;
    }
}
function $438042a7fad0109d$var$gd(a, b, c, d) {
    var e = $438042a7fad0109d$var$C, f = $438042a7fad0109d$var$cd.transition;
    $438042a7fad0109d$var$cd.transition = null;
    try {
        $438042a7fad0109d$var$C = 4, $438042a7fad0109d$var$fd(a, b, c, d);
    } finally{
        $438042a7fad0109d$var$C = e, $438042a7fad0109d$var$cd.transition = f;
    }
}
function $438042a7fad0109d$var$fd(a, b, c, d) {
    if ($438042a7fad0109d$var$dd) {
        var e = $438042a7fad0109d$var$Yc(a, b, c, d);
        if (null === e) $438042a7fad0109d$var$hd(a, b, d, $438042a7fad0109d$var$id, c), $438042a7fad0109d$var$Sc(a, d);
        else if ($438042a7fad0109d$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($438042a7fad0109d$var$Sc(a, d), b & 4 && -1 < $438042a7fad0109d$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $438042a7fad0109d$var$Cb(e);
                null !== f && $438042a7fad0109d$var$Ec(f);
                f = $438042a7fad0109d$var$Yc(a, b, c, d);
                null === f && $438042a7fad0109d$var$hd(a, b, d, $438042a7fad0109d$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $438042a7fad0109d$var$hd(a, b, d, null, c);
    }
}
var $438042a7fad0109d$var$id = null;
function $438042a7fad0109d$var$Yc(a, b, c, d) {
    $438042a7fad0109d$var$id = null;
    a = $438042a7fad0109d$var$xb(d);
    a = $438042a7fad0109d$var$Wc(a);
    if (null !== a) {
        if (b = $438042a7fad0109d$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $438042a7fad0109d$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $438042a7fad0109d$var$id = a;
    return null;
}
function $438042a7fad0109d$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($438042a7fad0109d$var$ec()){
                case $438042a7fad0109d$var$fc:
                    return 1;
                case $438042a7fad0109d$var$gc:
                    return 4;
                case $438042a7fad0109d$var$hc:
                case $438042a7fad0109d$var$ic:
                    return 16;
                case $438042a7fad0109d$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $438042a7fad0109d$var$kd = null, $438042a7fad0109d$var$ld = null, $438042a7fad0109d$var$md = null;
function $438042a7fad0109d$var$nd() {
    if ($438042a7fad0109d$var$md) return $438042a7fad0109d$var$md;
    var a, b = $438042a7fad0109d$var$ld, c = b.length, d, e = "value" in $438042a7fad0109d$var$kd ? $438042a7fad0109d$var$kd.value : $438042a7fad0109d$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $438042a7fad0109d$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $438042a7fad0109d$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $438042a7fad0109d$var$pd() {
    return !0;
}
function $438042a7fad0109d$var$qd() {
    return !1;
}
function $438042a7fad0109d$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $438042a7fad0109d$var$pd : $438042a7fad0109d$var$qd;
        this.isPropagationStopped = $438042a7fad0109d$var$qd;
        return this;
    }
    $438042a7fad0109d$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $438042a7fad0109d$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $438042a7fad0109d$var$pd);
        },
        persist: function() {},
        isPersistent: $438042a7fad0109d$var$pd
    });
    return b;
}
var $438042a7fad0109d$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $438042a7fad0109d$var$td = $438042a7fad0109d$var$rd($438042a7fad0109d$var$sd), $438042a7fad0109d$var$ud = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$sd, {
    view: 0,
    detail: 0
}), $438042a7fad0109d$var$vd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$ud), $438042a7fad0109d$var$wd, $438042a7fad0109d$var$xd, $438042a7fad0109d$var$yd, $438042a7fad0109d$var$Ad = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $438042a7fad0109d$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $438042a7fad0109d$var$yd && ($438042a7fad0109d$var$yd && "mousemove" === a.type ? ($438042a7fad0109d$var$wd = a.screenX - $438042a7fad0109d$var$yd.screenX, $438042a7fad0109d$var$xd = a.screenY - $438042a7fad0109d$var$yd.screenY) : $438042a7fad0109d$var$xd = $438042a7fad0109d$var$wd = 0, $438042a7fad0109d$var$yd = a);
        return $438042a7fad0109d$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $438042a7fad0109d$var$xd;
    }
}), $438042a7fad0109d$var$Bd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Ad), $438042a7fad0109d$var$Cd = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$Ad, {
    dataTransfer: 0
}), $438042a7fad0109d$var$Dd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Cd), $438042a7fad0109d$var$Ed = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$ud, {
    relatedTarget: 0
}), $438042a7fad0109d$var$Fd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Ed), $438042a7fad0109d$var$Gd = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $438042a7fad0109d$var$Hd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Gd), $438042a7fad0109d$var$Id = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $438042a7fad0109d$var$Jd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Id), $438042a7fad0109d$var$Kd = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$sd, {
    data: 0
}), $438042a7fad0109d$var$Ld = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Kd), $438042a7fad0109d$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $438042a7fad0109d$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $438042a7fad0109d$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $438042a7fad0109d$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $438042a7fad0109d$var$Od[a]) ? !!b[a] : !1;
}
function $438042a7fad0109d$var$zd() {
    return $438042a7fad0109d$var$Pd;
}
var $438042a7fad0109d$var$Qd = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $438042a7fad0109d$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $438042a7fad0109d$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $438042a7fad0109d$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $438042a7fad0109d$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $438042a7fad0109d$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $438042a7fad0109d$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $438042a7fad0109d$var$Rd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Qd), $438042a7fad0109d$var$Sd = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $438042a7fad0109d$var$Td = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Sd), $438042a7fad0109d$var$Ud = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $438042a7fad0109d$var$zd
}), $438042a7fad0109d$var$Vd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Ud), $438042a7fad0109d$var$Wd = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $438042a7fad0109d$var$Xd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Wd), $438042a7fad0109d$var$Yd = $438042a7fad0109d$var$A({}, $438042a7fad0109d$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $438042a7fad0109d$var$Zd = $438042a7fad0109d$var$rd($438042a7fad0109d$var$Yd), $438042a7fad0109d$var$$d = [
    9,
    13,
    27,
    32
], $438042a7fad0109d$var$ae = $438042a7fad0109d$var$ia && "CompositionEvent" in window, $438042a7fad0109d$var$be = null;
$438042a7fad0109d$var$ia && "documentMode" in document && ($438042a7fad0109d$var$be = document.documentMode);
var $438042a7fad0109d$var$ce = $438042a7fad0109d$var$ia && "TextEvent" in window && !$438042a7fad0109d$var$be, $438042a7fad0109d$var$de = $438042a7fad0109d$var$ia && (!$438042a7fad0109d$var$ae || $438042a7fad0109d$var$be && 8 < $438042a7fad0109d$var$be && 11 >= $438042a7fad0109d$var$be), $438042a7fad0109d$var$ee = String.fromCharCode(32), $438042a7fad0109d$var$fe = !1;
function $438042a7fad0109d$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $438042a7fad0109d$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $438042a7fad0109d$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $438042a7fad0109d$var$ie = !1;
function $438042a7fad0109d$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $438042a7fad0109d$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $438042a7fad0109d$var$fe = !0;
            return $438042a7fad0109d$var$ee;
        case "textInput":
            return a = b.data, a === $438042a7fad0109d$var$ee && $438042a7fad0109d$var$fe ? null : a;
        default:
            return null;
    }
}
function $438042a7fad0109d$var$ke(a, b) {
    if ($438042a7fad0109d$var$ie) return "compositionend" === a || !$438042a7fad0109d$var$ae && $438042a7fad0109d$var$ge(a, b) ? (a = $438042a7fad0109d$var$nd(), $438042a7fad0109d$var$md = $438042a7fad0109d$var$ld = $438042a7fad0109d$var$kd = null, $438042a7fad0109d$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $438042a7fad0109d$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $438042a7fad0109d$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $438042a7fad0109d$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$438042a7fad0109d$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $438042a7fad0109d$var$ne(a, b, c, d) {
    $438042a7fad0109d$var$Eb(d);
    b = $438042a7fad0109d$var$oe(b, "onChange");
    0 < b.length && (c = new $438042a7fad0109d$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $438042a7fad0109d$var$pe = null, $438042a7fad0109d$var$qe = null;
function $438042a7fad0109d$var$re(a) {
    $438042a7fad0109d$var$se(a, 0);
}
function $438042a7fad0109d$var$te(a) {
    var b = $438042a7fad0109d$var$ue(a);
    if ($438042a7fad0109d$var$Wa(b)) return a;
}
function $438042a7fad0109d$var$ve(a, b) {
    if ("change" === a) return b;
}
var $438042a7fad0109d$var$we = !1;
if ($438042a7fad0109d$var$ia) {
    var $438042a7fad0109d$var$xe;
    if ($438042a7fad0109d$var$ia) {
        var $438042a7fad0109d$var$ye = "oninput" in document;
        if (!$438042a7fad0109d$var$ye) {
            var $438042a7fad0109d$var$ze = document.createElement("div");
            $438042a7fad0109d$var$ze.setAttribute("oninput", "return;");
            $438042a7fad0109d$var$ye = "function" === typeof $438042a7fad0109d$var$ze.oninput;
        }
        $438042a7fad0109d$var$xe = $438042a7fad0109d$var$ye;
    } else $438042a7fad0109d$var$xe = !1;
    $438042a7fad0109d$var$we = $438042a7fad0109d$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $438042a7fad0109d$var$Ae() {
    $438042a7fad0109d$var$pe && ($438042a7fad0109d$var$pe.detachEvent("onpropertychange", $438042a7fad0109d$var$Be), $438042a7fad0109d$var$qe = $438042a7fad0109d$var$pe = null);
}
function $438042a7fad0109d$var$Be(a) {
    if ("value" === a.propertyName && $438042a7fad0109d$var$te($438042a7fad0109d$var$qe)) {
        var b = [];
        $438042a7fad0109d$var$ne(b, $438042a7fad0109d$var$qe, a, $438042a7fad0109d$var$xb(a));
        $438042a7fad0109d$var$Jb($438042a7fad0109d$var$re, b);
    }
}
function $438042a7fad0109d$var$Ce(a, b, c) {
    "focusin" === a ? ($438042a7fad0109d$var$Ae(), $438042a7fad0109d$var$pe = b, $438042a7fad0109d$var$qe = c, $438042a7fad0109d$var$pe.attachEvent("onpropertychange", $438042a7fad0109d$var$Be)) : "focusout" === a && $438042a7fad0109d$var$Ae();
}
function $438042a7fad0109d$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $438042a7fad0109d$var$te($438042a7fad0109d$var$qe);
}
function $438042a7fad0109d$var$Ee(a, b) {
    if ("click" === a) return $438042a7fad0109d$var$te(b);
}
function $438042a7fad0109d$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $438042a7fad0109d$var$te(b);
}
function $438042a7fad0109d$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $438042a7fad0109d$var$He = "function" === typeof Object.is ? Object.is : $438042a7fad0109d$var$Ge;
function $438042a7fad0109d$var$Ie(a, b) {
    if ($438042a7fad0109d$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$438042a7fad0109d$var$ja.call(b, e) || !$438042a7fad0109d$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $438042a7fad0109d$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $438042a7fad0109d$var$Ke(a, b) {
    var c = $438042a7fad0109d$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $438042a7fad0109d$var$Je(c);
    }
}
function $438042a7fad0109d$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $438042a7fad0109d$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $438042a7fad0109d$var$Me() {
    for(var a = window, b = $438042a7fad0109d$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $438042a7fad0109d$var$Xa(a.document);
    }
    return b;
}
function $438042a7fad0109d$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $438042a7fad0109d$var$Oe(a) {
    var b = $438042a7fad0109d$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $438042a7fad0109d$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $438042a7fad0109d$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $438042a7fad0109d$var$Ke(c, f);
                var g = $438042a7fad0109d$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $438042a7fad0109d$var$Pe = $438042a7fad0109d$var$ia && "documentMode" in document && 11 >= document.documentMode, $438042a7fad0109d$var$Qe = null, $438042a7fad0109d$var$Re = null, $438042a7fad0109d$var$Se = null, $438042a7fad0109d$var$Te = !1;
function $438042a7fad0109d$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $438042a7fad0109d$var$Te || null == $438042a7fad0109d$var$Qe || $438042a7fad0109d$var$Qe !== $438042a7fad0109d$var$Xa(d) || (d = $438042a7fad0109d$var$Qe, "selectionStart" in d && $438042a7fad0109d$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $438042a7fad0109d$var$Se && $438042a7fad0109d$var$Ie($438042a7fad0109d$var$Se, d) || ($438042a7fad0109d$var$Se = d, d = $438042a7fad0109d$var$oe($438042a7fad0109d$var$Re, "onSelect"), 0 < d.length && (b = new $438042a7fad0109d$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $438042a7fad0109d$var$Qe)));
}
function $438042a7fad0109d$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $438042a7fad0109d$var$We = {
    animationend: $438042a7fad0109d$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $438042a7fad0109d$var$Ve("Animation", "AnimationIteration"),
    animationstart: $438042a7fad0109d$var$Ve("Animation", "AnimationStart"),
    transitionend: $438042a7fad0109d$var$Ve("Transition", "TransitionEnd")
}, $438042a7fad0109d$var$Xe = {}, $438042a7fad0109d$var$Ye = {};
$438042a7fad0109d$var$ia && ($438042a7fad0109d$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $438042a7fad0109d$var$We.animationend.animation, delete $438042a7fad0109d$var$We.animationiteration.animation, delete $438042a7fad0109d$var$We.animationstart.animation), "TransitionEvent" in window || delete $438042a7fad0109d$var$We.transitionend.transition);
function $438042a7fad0109d$var$Ze(a) {
    if ($438042a7fad0109d$var$Xe[a]) return $438042a7fad0109d$var$Xe[a];
    if (!$438042a7fad0109d$var$We[a]) return a;
    var b = $438042a7fad0109d$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $438042a7fad0109d$var$Ye) return $438042a7fad0109d$var$Xe[a] = b[c];
    return a;
}
var $438042a7fad0109d$var$$e = $438042a7fad0109d$var$Ze("animationend"), $438042a7fad0109d$var$af = $438042a7fad0109d$var$Ze("animationiteration"), $438042a7fad0109d$var$bf = $438042a7fad0109d$var$Ze("animationstart"), $438042a7fad0109d$var$cf = $438042a7fad0109d$var$Ze("transitionend"), $438042a7fad0109d$var$df = new Map, $438042a7fad0109d$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $438042a7fad0109d$var$ff(a, b) {
    $438042a7fad0109d$var$df.set(a, b);
    $438042a7fad0109d$var$fa(b, [
        a
    ]);
}
for(var $438042a7fad0109d$var$gf = 0; $438042a7fad0109d$var$gf < $438042a7fad0109d$var$ef.length; $438042a7fad0109d$var$gf++){
    var $438042a7fad0109d$var$hf = $438042a7fad0109d$var$ef[$438042a7fad0109d$var$gf], $438042a7fad0109d$var$jf = $438042a7fad0109d$var$hf.toLowerCase(), $438042a7fad0109d$var$kf = $438042a7fad0109d$var$hf[0].toUpperCase() + $438042a7fad0109d$var$hf.slice(1);
    $438042a7fad0109d$var$ff($438042a7fad0109d$var$jf, "on" + $438042a7fad0109d$var$kf);
}
$438042a7fad0109d$var$ff($438042a7fad0109d$var$$e, "onAnimationEnd");
$438042a7fad0109d$var$ff($438042a7fad0109d$var$af, "onAnimationIteration");
$438042a7fad0109d$var$ff($438042a7fad0109d$var$bf, "onAnimationStart");
$438042a7fad0109d$var$ff("dblclick", "onDoubleClick");
$438042a7fad0109d$var$ff("focusin", "onFocus");
$438042a7fad0109d$var$ff("focusout", "onBlur");
$438042a7fad0109d$var$ff($438042a7fad0109d$var$cf, "onTransitionEnd");
$438042a7fad0109d$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$438042a7fad0109d$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$438042a7fad0109d$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$438042a7fad0109d$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$438042a7fad0109d$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$438042a7fad0109d$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$438042a7fad0109d$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$438042a7fad0109d$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$438042a7fad0109d$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$438042a7fad0109d$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $438042a7fad0109d$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $438042a7fad0109d$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($438042a7fad0109d$var$lf));
function $438042a7fad0109d$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $438042a7fad0109d$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $438042a7fad0109d$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $438042a7fad0109d$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $438042a7fad0109d$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($438042a7fad0109d$var$Qb) throw a = $438042a7fad0109d$var$Rb, $438042a7fad0109d$var$Qb = !1, $438042a7fad0109d$var$Rb = null, a;
}
function $438042a7fad0109d$var$D(a, b) {
    var c = b[$438042a7fad0109d$var$of];
    void 0 === c && (c = b[$438042a7fad0109d$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($438042a7fad0109d$var$pf(b, a, 2, !1), c.add(d));
}
function $438042a7fad0109d$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $438042a7fad0109d$var$pf(c, a, d, b);
}
var $438042a7fad0109d$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $438042a7fad0109d$var$sf(a) {
    if (!a[$438042a7fad0109d$var$rf]) {
        a[$438042a7fad0109d$var$rf] = !0;
        $438042a7fad0109d$var$da.forEach(function(b) {
            "selectionchange" !== b && ($438042a7fad0109d$var$mf.has(b) || $438042a7fad0109d$var$qf(b, !1, a), $438042a7fad0109d$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$438042a7fad0109d$var$rf] || (b[$438042a7fad0109d$var$rf] = !0, $438042a7fad0109d$var$qf("selectionchange", !1, b));
    }
}
function $438042a7fad0109d$var$pf(a, b, c, d) {
    switch($438042a7fad0109d$var$jd(b)){
        case 1:
            var e = $438042a7fad0109d$var$ed;
            break;
        case 4:
            e = $438042a7fad0109d$var$gd;
            break;
        default:
            e = $438042a7fad0109d$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$438042a7fad0109d$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $438042a7fad0109d$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $438042a7fad0109d$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $438042a7fad0109d$var$Jb(function() {
        var d = f, e = $438042a7fad0109d$var$xb(c), g = [];
        a: {
            var h = $438042a7fad0109d$var$df.get(a);
            if (void 0 !== h) {
                var k = $438042a7fad0109d$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $438042a7fad0109d$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $438042a7fad0109d$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $438042a7fad0109d$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $438042a7fad0109d$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $438042a7fad0109d$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $438042a7fad0109d$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $438042a7fad0109d$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $438042a7fad0109d$var$Vd;
                        break;
                    case $438042a7fad0109d$var$$e:
                    case $438042a7fad0109d$var$af:
                    case $438042a7fad0109d$var$bf:
                        k = $438042a7fad0109d$var$Hd;
                        break;
                    case $438042a7fad0109d$var$cf:
                        k = $438042a7fad0109d$var$Xd;
                        break;
                    case "scroll":
                        k = $438042a7fad0109d$var$vd;
                        break;
                    case "wheel":
                        k = $438042a7fad0109d$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $438042a7fad0109d$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $438042a7fad0109d$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $438042a7fad0109d$var$Kb(w, x), null != F && t.push($438042a7fad0109d$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $438042a7fad0109d$var$wb && (n = c.relatedTarget || c.fromElement) && ($438042a7fad0109d$var$Wc(n) || n[$438042a7fad0109d$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $438042a7fad0109d$var$Wc(n) : null, null !== n && (J = $438042a7fad0109d$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $438042a7fad0109d$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $438042a7fad0109d$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $438042a7fad0109d$var$ue(k);
                        u = null == n ? h : $438042a7fad0109d$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $438042a7fad0109d$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $438042a7fad0109d$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $438042a7fad0109d$var$vf(F))u++;
                            for(; 0 < w - u;)t = $438042a7fad0109d$var$vf(t), w--;
                            for(; 0 < u - w;)x = $438042a7fad0109d$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $438042a7fad0109d$var$vf(t);
                                x = $438042a7fad0109d$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $438042a7fad0109d$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $438042a7fad0109d$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $438042a7fad0109d$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $438042a7fad0109d$var$ve;
                else if ($438042a7fad0109d$var$me(h)) {
                    if ($438042a7fad0109d$var$we) na = $438042a7fad0109d$var$Fe;
                    else {
                        na = $438042a7fad0109d$var$De;
                        var xa = $438042a7fad0109d$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $438042a7fad0109d$var$Ee);
                if (na && (na = na(a, d))) {
                    $438042a7fad0109d$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $438042a7fad0109d$var$cb(h, "number", h.value);
            }
            xa = d ? $438042a7fad0109d$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($438042a7fad0109d$var$me(xa) || "true" === xa.contentEditable) $438042a7fad0109d$var$Qe = xa, $438042a7fad0109d$var$Re = d, $438042a7fad0109d$var$Se = null;
                    break;
                case "focusout":
                    $438042a7fad0109d$var$Se = $438042a7fad0109d$var$Re = $438042a7fad0109d$var$Qe = null;
                    break;
                case "mousedown":
                    $438042a7fad0109d$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $438042a7fad0109d$var$Te = !1;
                    $438042a7fad0109d$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($438042a7fad0109d$var$Pe) break;
                case "keydown":
                case "keyup":
                    $438042a7fad0109d$var$Ue(g, c, e);
            }
            var $a;
            if ($438042a7fad0109d$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $438042a7fad0109d$var$ie ? $438042a7fad0109d$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($438042a7fad0109d$var$de && "ko" !== c.locale && ($438042a7fad0109d$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $438042a7fad0109d$var$ie && ($a = $438042a7fad0109d$var$nd()) : ($438042a7fad0109d$var$kd = e, $438042a7fad0109d$var$ld = "value" in $438042a7fad0109d$var$kd ? $438042a7fad0109d$var$kd.value : $438042a7fad0109d$var$kd.textContent, $438042a7fad0109d$var$ie = !0)), xa = $438042a7fad0109d$var$oe(d, ba), 0 < xa.length && (ba = new $438042a7fad0109d$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $438042a7fad0109d$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $438042a7fad0109d$var$ce ? $438042a7fad0109d$var$je(a, c) : $438042a7fad0109d$var$ke(a, c)) d = $438042a7fad0109d$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $438042a7fad0109d$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $438042a7fad0109d$var$se(g, b);
    });
}
function $438042a7fad0109d$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $438042a7fad0109d$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $438042a7fad0109d$var$Kb(a, c), null != f && d.unshift($438042a7fad0109d$var$tf(a, f, e)), f = $438042a7fad0109d$var$Kb(a, b), null != f && d.push($438042a7fad0109d$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $438042a7fad0109d$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $438042a7fad0109d$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $438042a7fad0109d$var$Kb(c, f), null != k && g.unshift($438042a7fad0109d$var$tf(c, k, h))) : e || (k = $438042a7fad0109d$var$Kb(c, f), null != k && g.push($438042a7fad0109d$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $438042a7fad0109d$var$xf = /\r\n?/g, $438042a7fad0109d$var$yf = /\u0000|\uFFFD/g;
function $438042a7fad0109d$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($438042a7fad0109d$var$xf, "\n").replace($438042a7fad0109d$var$yf, "");
}
function $438042a7fad0109d$var$Af(a, b, c) {
    b = $438042a7fad0109d$var$zf(b);
    if ($438042a7fad0109d$var$zf(a) !== b && c) throw Error($438042a7fad0109d$var$p(425));
}
function $438042a7fad0109d$var$Bf() {}
var $438042a7fad0109d$var$Cf = null, $438042a7fad0109d$var$Df = null;
function $438042a7fad0109d$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $438042a7fad0109d$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $438042a7fad0109d$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $438042a7fad0109d$var$Hf = "function" === typeof Promise ? Promise : void 0, $438042a7fad0109d$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $438042a7fad0109d$var$Hf ? function(a) {
    return $438042a7fad0109d$var$Hf.resolve(null).then(a).catch($438042a7fad0109d$var$If);
} : $438042a7fad0109d$var$Ff;
function $438042a7fad0109d$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $438042a7fad0109d$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $438042a7fad0109d$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $438042a7fad0109d$var$bd(b);
}
function $438042a7fad0109d$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $438042a7fad0109d$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $438042a7fad0109d$var$Nf = Math.random().toString(36).slice(2), $438042a7fad0109d$var$Of = "__reactFiber$" + $438042a7fad0109d$var$Nf, $438042a7fad0109d$var$Pf = "__reactProps$" + $438042a7fad0109d$var$Nf, $438042a7fad0109d$var$uf = "__reactContainer$" + $438042a7fad0109d$var$Nf, $438042a7fad0109d$var$of = "__reactEvents$" + $438042a7fad0109d$var$Nf, $438042a7fad0109d$var$Qf = "__reactListeners$" + $438042a7fad0109d$var$Nf, $438042a7fad0109d$var$Rf = "__reactHandles$" + $438042a7fad0109d$var$Nf;
function $438042a7fad0109d$var$Wc(a) {
    var b = a[$438042a7fad0109d$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$438042a7fad0109d$var$uf] || c[$438042a7fad0109d$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $438042a7fad0109d$var$Mf(a); null !== a;){
                if (c = a[$438042a7fad0109d$var$Of]) return c;
                a = $438042a7fad0109d$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $438042a7fad0109d$var$Cb(a) {
    a = a[$438042a7fad0109d$var$Of] || a[$438042a7fad0109d$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $438042a7fad0109d$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($438042a7fad0109d$var$p(33));
}
function $438042a7fad0109d$var$Db(a) {
    return a[$438042a7fad0109d$var$Pf] || null;
}
var $438042a7fad0109d$var$Sf = [], $438042a7fad0109d$var$Tf = -1;
function $438042a7fad0109d$var$Uf(a) {
    return {
        current: a
    };
}
function $438042a7fad0109d$var$E(a) {
    0 > $438042a7fad0109d$var$Tf || (a.current = $438042a7fad0109d$var$Sf[$438042a7fad0109d$var$Tf], $438042a7fad0109d$var$Sf[$438042a7fad0109d$var$Tf] = null, $438042a7fad0109d$var$Tf--);
}
function $438042a7fad0109d$var$G(a, b) {
    $438042a7fad0109d$var$Tf++;
    $438042a7fad0109d$var$Sf[$438042a7fad0109d$var$Tf] = a.current;
    a.current = b;
}
var $438042a7fad0109d$var$Vf = {}, $438042a7fad0109d$var$H = $438042a7fad0109d$var$Uf($438042a7fad0109d$var$Vf), $438042a7fad0109d$var$Wf = $438042a7fad0109d$var$Uf(!1), $438042a7fad0109d$var$Xf = $438042a7fad0109d$var$Vf;
function $438042a7fad0109d$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $438042a7fad0109d$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $438042a7fad0109d$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $438042a7fad0109d$var$$f() {
    $438042a7fad0109d$var$E($438042a7fad0109d$var$Wf);
    $438042a7fad0109d$var$E($438042a7fad0109d$var$H);
}
function $438042a7fad0109d$var$ag(a, b, c) {
    if ($438042a7fad0109d$var$H.current !== $438042a7fad0109d$var$Vf) throw Error($438042a7fad0109d$var$p(168));
    $438042a7fad0109d$var$G($438042a7fad0109d$var$H, b);
    $438042a7fad0109d$var$G($438042a7fad0109d$var$Wf, c);
}
function $438042a7fad0109d$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($438042a7fad0109d$var$p(108, $438042a7fad0109d$var$Ra(a) || "Unknown", e));
    return $438042a7fad0109d$var$A({}, c, d);
}
function $438042a7fad0109d$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $438042a7fad0109d$var$Vf;
    $438042a7fad0109d$var$Xf = $438042a7fad0109d$var$H.current;
    $438042a7fad0109d$var$G($438042a7fad0109d$var$H, a);
    $438042a7fad0109d$var$G($438042a7fad0109d$var$Wf, $438042a7fad0109d$var$Wf.current);
    return !0;
}
function $438042a7fad0109d$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($438042a7fad0109d$var$p(169));
    c ? (a = $438042a7fad0109d$var$bg(a, b, $438042a7fad0109d$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $438042a7fad0109d$var$E($438042a7fad0109d$var$Wf), $438042a7fad0109d$var$E($438042a7fad0109d$var$H), $438042a7fad0109d$var$G($438042a7fad0109d$var$H, a)) : $438042a7fad0109d$var$E($438042a7fad0109d$var$Wf);
    $438042a7fad0109d$var$G($438042a7fad0109d$var$Wf, c);
}
var $438042a7fad0109d$var$eg = null, $438042a7fad0109d$var$fg = !1, $438042a7fad0109d$var$gg = !1;
function $438042a7fad0109d$var$hg(a) {
    null === $438042a7fad0109d$var$eg ? $438042a7fad0109d$var$eg = [
        a
    ] : $438042a7fad0109d$var$eg.push(a);
}
function $438042a7fad0109d$var$ig(a) {
    $438042a7fad0109d$var$fg = !0;
    $438042a7fad0109d$var$hg(a);
}
function $438042a7fad0109d$var$jg() {
    if (!$438042a7fad0109d$var$gg && null !== $438042a7fad0109d$var$eg) {
        $438042a7fad0109d$var$gg = !0;
        var a = 0, b = $438042a7fad0109d$var$C;
        try {
            var c = $438042a7fad0109d$var$eg;
            for($438042a7fad0109d$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $438042a7fad0109d$var$eg = null;
            $438042a7fad0109d$var$fg = !1;
        } catch (e) {
            throw null !== $438042a7fad0109d$var$eg && ($438042a7fad0109d$var$eg = $438042a7fad0109d$var$eg.slice(a + 1)), $438042a7fad0109d$var$ac($438042a7fad0109d$var$fc, $438042a7fad0109d$var$jg), e;
        } finally{
            $438042a7fad0109d$var$C = b, $438042a7fad0109d$var$gg = !1;
        }
    }
    return null;
}
var $438042a7fad0109d$var$kg = [], $438042a7fad0109d$var$lg = 0, $438042a7fad0109d$var$mg = null, $438042a7fad0109d$var$ng = 0, $438042a7fad0109d$var$og = [], $438042a7fad0109d$var$pg = 0, $438042a7fad0109d$var$qg = null, $438042a7fad0109d$var$rg = 1, $438042a7fad0109d$var$sg = "";
function $438042a7fad0109d$var$tg(a, b) {
    $438042a7fad0109d$var$kg[$438042a7fad0109d$var$lg++] = $438042a7fad0109d$var$ng;
    $438042a7fad0109d$var$kg[$438042a7fad0109d$var$lg++] = $438042a7fad0109d$var$mg;
    $438042a7fad0109d$var$mg = a;
    $438042a7fad0109d$var$ng = b;
}
function $438042a7fad0109d$var$ug(a, b, c) {
    $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg++] = $438042a7fad0109d$var$rg;
    $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg++] = $438042a7fad0109d$var$sg;
    $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg++] = $438042a7fad0109d$var$qg;
    $438042a7fad0109d$var$qg = a;
    var d = $438042a7fad0109d$var$rg;
    a = $438042a7fad0109d$var$sg;
    var e = 32 - $438042a7fad0109d$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $438042a7fad0109d$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $438042a7fad0109d$var$rg = 1 << 32 - $438042a7fad0109d$var$oc(b) + e | c << e | d;
        $438042a7fad0109d$var$sg = f + a;
    } else $438042a7fad0109d$var$rg = 1 << f | c << e | d, $438042a7fad0109d$var$sg = a;
}
function $438042a7fad0109d$var$vg(a) {
    null !== a.return && ($438042a7fad0109d$var$tg(a, 1), $438042a7fad0109d$var$ug(a, 1, 0));
}
function $438042a7fad0109d$var$wg(a) {
    for(; a === $438042a7fad0109d$var$mg;)$438042a7fad0109d$var$mg = $438042a7fad0109d$var$kg[--$438042a7fad0109d$var$lg], $438042a7fad0109d$var$kg[$438042a7fad0109d$var$lg] = null, $438042a7fad0109d$var$ng = $438042a7fad0109d$var$kg[--$438042a7fad0109d$var$lg], $438042a7fad0109d$var$kg[$438042a7fad0109d$var$lg] = null;
    for(; a === $438042a7fad0109d$var$qg;)$438042a7fad0109d$var$qg = $438042a7fad0109d$var$og[--$438042a7fad0109d$var$pg], $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg] = null, $438042a7fad0109d$var$sg = $438042a7fad0109d$var$og[--$438042a7fad0109d$var$pg], $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg] = null, $438042a7fad0109d$var$rg = $438042a7fad0109d$var$og[--$438042a7fad0109d$var$pg], $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg] = null;
}
var $438042a7fad0109d$var$xg = null, $438042a7fad0109d$var$yg = null, $438042a7fad0109d$var$I = !1, $438042a7fad0109d$var$zg = null;
function $438042a7fad0109d$var$Ag(a, b) {
    var c = $438042a7fad0109d$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $438042a7fad0109d$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $438042a7fad0109d$var$xg = a, $438042a7fad0109d$var$yg = $438042a7fad0109d$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $438042a7fad0109d$var$xg = a, $438042a7fad0109d$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $438042a7fad0109d$var$qg ? {
                id: $438042a7fad0109d$var$rg,
                overflow: $438042a7fad0109d$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $438042a7fad0109d$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $438042a7fad0109d$var$xg = a, $438042a7fad0109d$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $438042a7fad0109d$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $438042a7fad0109d$var$Eg(a) {
    if ($438042a7fad0109d$var$I) {
        var b = $438042a7fad0109d$var$yg;
        if (b) {
            var c = b;
            if (!$438042a7fad0109d$var$Cg(a, b)) {
                if ($438042a7fad0109d$var$Dg(a)) throw Error($438042a7fad0109d$var$p(418));
                b = $438042a7fad0109d$var$Lf(c.nextSibling);
                var d = $438042a7fad0109d$var$xg;
                b && $438042a7fad0109d$var$Cg(a, b) ? $438042a7fad0109d$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $438042a7fad0109d$var$I = !1, $438042a7fad0109d$var$xg = a);
            }
        } else {
            if ($438042a7fad0109d$var$Dg(a)) throw Error($438042a7fad0109d$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $438042a7fad0109d$var$I = !1;
            $438042a7fad0109d$var$xg = a;
        }
    }
}
function $438042a7fad0109d$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $438042a7fad0109d$var$xg = a;
}
function $438042a7fad0109d$var$Gg(a) {
    if (a !== $438042a7fad0109d$var$xg) return !1;
    if (!$438042a7fad0109d$var$I) return $438042a7fad0109d$var$Fg(a), $438042a7fad0109d$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$438042a7fad0109d$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $438042a7fad0109d$var$yg)) {
        if ($438042a7fad0109d$var$Dg(a)) throw $438042a7fad0109d$var$Hg(), Error($438042a7fad0109d$var$p(418));
        for(; b;)$438042a7fad0109d$var$Ag(a, b), b = $438042a7fad0109d$var$Lf(b.nextSibling);
    }
    $438042a7fad0109d$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($438042a7fad0109d$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $438042a7fad0109d$var$yg = $438042a7fad0109d$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $438042a7fad0109d$var$yg = null;
        }
    } else $438042a7fad0109d$var$yg = $438042a7fad0109d$var$xg ? $438042a7fad0109d$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $438042a7fad0109d$var$Hg() {
    for(var a = $438042a7fad0109d$var$yg; a;)a = $438042a7fad0109d$var$Lf(a.nextSibling);
}
function $438042a7fad0109d$var$Ig() {
    $438042a7fad0109d$var$yg = $438042a7fad0109d$var$xg = null;
    $438042a7fad0109d$var$I = !1;
}
function $438042a7fad0109d$var$Jg(a) {
    null === $438042a7fad0109d$var$zg ? $438042a7fad0109d$var$zg = [
        a
    ] : $438042a7fad0109d$var$zg.push(a);
}
var $438042a7fad0109d$var$Kg = $438042a7fad0109d$var$ua.ReactCurrentBatchConfig;
function $438042a7fad0109d$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $438042a7fad0109d$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $438042a7fad0109d$var$Mg = $438042a7fad0109d$var$Uf(null), $438042a7fad0109d$var$Ng = null, $438042a7fad0109d$var$Og = null, $438042a7fad0109d$var$Pg = null;
function $438042a7fad0109d$var$Qg() {
    $438042a7fad0109d$var$Pg = $438042a7fad0109d$var$Og = $438042a7fad0109d$var$Ng = null;
}
function $438042a7fad0109d$var$Rg(a) {
    var b = $438042a7fad0109d$var$Mg.current;
    $438042a7fad0109d$var$E($438042a7fad0109d$var$Mg);
    a._currentValue = b;
}
function $438042a7fad0109d$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $438042a7fad0109d$var$Tg(a, b) {
    $438042a7fad0109d$var$Ng = a;
    $438042a7fad0109d$var$Pg = $438042a7fad0109d$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($438042a7fad0109d$var$Ug = !0), a.firstContext = null);
}
function $438042a7fad0109d$var$Vg(a) {
    var b = a._currentValue;
    if ($438042a7fad0109d$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $438042a7fad0109d$var$Og) {
            if (null === $438042a7fad0109d$var$Ng) throw Error($438042a7fad0109d$var$p(308));
            $438042a7fad0109d$var$Og = a;
            $438042a7fad0109d$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $438042a7fad0109d$var$Og = $438042a7fad0109d$var$Og.next = a;
    }
    return b;
}
var $438042a7fad0109d$var$Wg = null;
function $438042a7fad0109d$var$Xg(a) {
    null === $438042a7fad0109d$var$Wg ? $438042a7fad0109d$var$Wg = [
        a
    ] : $438042a7fad0109d$var$Wg.push(a);
}
function $438042a7fad0109d$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $438042a7fad0109d$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $438042a7fad0109d$var$Zg(a, d);
}
function $438042a7fad0109d$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $438042a7fad0109d$var$$g = !1;
function $438042a7fad0109d$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $438042a7fad0109d$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $438042a7fad0109d$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $438042a7fad0109d$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($438042a7fad0109d$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $438042a7fad0109d$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $438042a7fad0109d$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $438042a7fad0109d$var$Zg(a, c);
}
function $438042a7fad0109d$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $438042a7fad0109d$var$Cc(a, c);
    }
}
function $438042a7fad0109d$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $438042a7fad0109d$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $438042a7fad0109d$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $438042a7fad0109d$var$A({}, q, r);
                            break a;
                        case 2:
                            $438042a7fad0109d$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $438042a7fad0109d$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $438042a7fad0109d$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($438042a7fad0109d$var$p(191, e));
            e.call(d);
        }
    }
}
var $438042a7fad0109d$var$jh = (new $iawgr.Component).refs;
function $438042a7fad0109d$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $438042a7fad0109d$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $438042a7fad0109d$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $438042a7fad0109d$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $438042a7fad0109d$var$L(), e = $438042a7fad0109d$var$lh(a), f = $438042a7fad0109d$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $438042a7fad0109d$var$dh(a, f, e);
        null !== b && ($438042a7fad0109d$var$mh(b, a, e, d), $438042a7fad0109d$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $438042a7fad0109d$var$L(), e = $438042a7fad0109d$var$lh(a), f = $438042a7fad0109d$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $438042a7fad0109d$var$dh(a, f, e);
        null !== b && ($438042a7fad0109d$var$mh(b, a, e, d), $438042a7fad0109d$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $438042a7fad0109d$var$L(), d = $438042a7fad0109d$var$lh(a), e = $438042a7fad0109d$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $438042a7fad0109d$var$dh(a, e, d);
        null !== b && ($438042a7fad0109d$var$mh(b, a, d, c), $438042a7fad0109d$var$eh(b, a, d));
    }
};
function $438042a7fad0109d$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$438042a7fad0109d$var$Ie(c, d) || !$438042a7fad0109d$var$Ie(e, f) : !0;
}
function $438042a7fad0109d$var$ph(a, b, c) {
    var d = !1, e = $438042a7fad0109d$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $438042a7fad0109d$var$Vg(f) : (e = $438042a7fad0109d$var$Zf(b) ? $438042a7fad0109d$var$Xf : $438042a7fad0109d$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $438042a7fad0109d$var$Yf(a, e) : $438042a7fad0109d$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $438042a7fad0109d$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $438042a7fad0109d$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $438042a7fad0109d$var$nh.enqueueReplaceState(b, b.state, null);
}
function $438042a7fad0109d$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $438042a7fad0109d$var$jh;
    $438042a7fad0109d$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $438042a7fad0109d$var$Vg(f) : (f = $438042a7fad0109d$var$Zf(b) ? $438042a7fad0109d$var$Xf : $438042a7fad0109d$var$H.current, e.context = $438042a7fad0109d$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($438042a7fad0109d$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $438042a7fad0109d$var$nh.enqueueReplaceState(e, e.state, null), $438042a7fad0109d$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $438042a7fad0109d$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($438042a7fad0109d$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($438042a7fad0109d$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $438042a7fad0109d$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($438042a7fad0109d$var$p(284));
        if (!c._owner) throw Error($438042a7fad0109d$var$p(290, a));
    }
    return a;
}
function $438042a7fad0109d$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($438042a7fad0109d$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $438042a7fad0109d$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $438042a7fad0109d$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $438042a7fad0109d$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $438042a7fad0109d$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $438042a7fad0109d$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $438042a7fad0109d$var$Ha && $438042a7fad0109d$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $438042a7fad0109d$var$sh(a, b, c), d.return = a, d;
        d = $438042a7fad0109d$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $438042a7fad0109d$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $438042a7fad0109d$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $438042a7fad0109d$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $438042a7fad0109d$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $438042a7fad0109d$var$va:
                    return c = $438042a7fad0109d$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $438042a7fad0109d$var$sh(a, null, b), c.return = a, c;
                case $438042a7fad0109d$var$wa:
                    return b = $438042a7fad0109d$var$zh(b, a.mode, c), b.return = a, b;
                case $438042a7fad0109d$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($438042a7fad0109d$var$eb(b) || $438042a7fad0109d$var$Ka(b)) return b = $438042a7fad0109d$var$Ah(b, a.mode, c, null), b.return = a, b;
            $438042a7fad0109d$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $438042a7fad0109d$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $438042a7fad0109d$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $438042a7fad0109d$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($438042a7fad0109d$var$eb(c) || $438042a7fad0109d$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $438042a7fad0109d$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $438042a7fad0109d$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $438042a7fad0109d$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $438042a7fad0109d$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($438042a7fad0109d$var$eb(d) || $438042a7fad0109d$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $438042a7fad0109d$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $438042a7fad0109d$var$I && $438042a7fad0109d$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $438042a7fad0109d$var$I && $438042a7fad0109d$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $438042a7fad0109d$var$I && $438042a7fad0109d$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $438042a7fad0109d$var$Ka(h);
        if ("function" !== typeof l) throw Error($438042a7fad0109d$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($438042a7fad0109d$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $438042a7fad0109d$var$I && $438042a7fad0109d$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $438042a7fad0109d$var$I && $438042a7fad0109d$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $438042a7fad0109d$var$I && $438042a7fad0109d$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $438042a7fad0109d$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $438042a7fad0109d$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $438042a7fad0109d$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $438042a7fad0109d$var$Ha && $438042a7fad0109d$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $438042a7fad0109d$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $438042a7fad0109d$var$ya ? (d = $438042a7fad0109d$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $438042a7fad0109d$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $438042a7fad0109d$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $438042a7fad0109d$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $438042a7fad0109d$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $438042a7fad0109d$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($438042a7fad0109d$var$eb(f)) return n(a, d, f, h);
            if ($438042a7fad0109d$var$Ka(f)) return t(a, d, f, h);
            $438042a7fad0109d$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $438042a7fad0109d$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $438042a7fad0109d$var$Bh = $438042a7fad0109d$var$vh(!0), $438042a7fad0109d$var$Ch = $438042a7fad0109d$var$vh(!1), $438042a7fad0109d$var$Dh = {}, $438042a7fad0109d$var$Eh = $438042a7fad0109d$var$Uf($438042a7fad0109d$var$Dh), $438042a7fad0109d$var$Fh = $438042a7fad0109d$var$Uf($438042a7fad0109d$var$Dh), $438042a7fad0109d$var$Gh = $438042a7fad0109d$var$Uf($438042a7fad0109d$var$Dh);
function $438042a7fad0109d$var$Hh(a) {
    if (a === $438042a7fad0109d$var$Dh) throw Error($438042a7fad0109d$var$p(174));
    return a;
}
function $438042a7fad0109d$var$Ih(a, b) {
    $438042a7fad0109d$var$G($438042a7fad0109d$var$Gh, b);
    $438042a7fad0109d$var$G($438042a7fad0109d$var$Fh, a);
    $438042a7fad0109d$var$G($438042a7fad0109d$var$Eh, $438042a7fad0109d$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $438042a7fad0109d$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $438042a7fad0109d$var$lb(b, a);
    }
    $438042a7fad0109d$var$E($438042a7fad0109d$var$Eh);
    $438042a7fad0109d$var$G($438042a7fad0109d$var$Eh, b);
}
function $438042a7fad0109d$var$Jh() {
    $438042a7fad0109d$var$E($438042a7fad0109d$var$Eh);
    $438042a7fad0109d$var$E($438042a7fad0109d$var$Fh);
    $438042a7fad0109d$var$E($438042a7fad0109d$var$Gh);
}
function $438042a7fad0109d$var$Kh(a) {
    $438042a7fad0109d$var$Hh($438042a7fad0109d$var$Gh.current);
    var b = $438042a7fad0109d$var$Hh($438042a7fad0109d$var$Eh.current);
    var c = $438042a7fad0109d$var$lb(b, a.type);
    b !== c && ($438042a7fad0109d$var$G($438042a7fad0109d$var$Fh, a), $438042a7fad0109d$var$G($438042a7fad0109d$var$Eh, c));
}
function $438042a7fad0109d$var$Lh(a) {
    $438042a7fad0109d$var$Fh.current === a && ($438042a7fad0109d$var$E($438042a7fad0109d$var$Eh), $438042a7fad0109d$var$E($438042a7fad0109d$var$Fh));
}
var $438042a7fad0109d$var$M = $438042a7fad0109d$var$Uf(0);
function $438042a7fad0109d$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $438042a7fad0109d$var$Nh = [];
function $438042a7fad0109d$var$Oh() {
    for(var a = 0; a < $438042a7fad0109d$var$Nh.length; a++)$438042a7fad0109d$var$Nh[a]._workInProgressVersionPrimary = null;
    $438042a7fad0109d$var$Nh.length = 0;
}
var $438042a7fad0109d$var$Ph = $438042a7fad0109d$var$ua.ReactCurrentDispatcher, $438042a7fad0109d$var$Qh = $438042a7fad0109d$var$ua.ReactCurrentBatchConfig, $438042a7fad0109d$var$Rh = 0, $438042a7fad0109d$var$N = null, $438042a7fad0109d$var$O = null, $438042a7fad0109d$var$P = null, $438042a7fad0109d$var$Sh = !1, $438042a7fad0109d$var$Th = !1, $438042a7fad0109d$var$Uh = 0, $438042a7fad0109d$var$Vh = 0;
function $438042a7fad0109d$var$Q() {
    throw Error($438042a7fad0109d$var$p(321));
}
function $438042a7fad0109d$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$438042a7fad0109d$var$He(a[c], b[c])) return !1;
    return !0;
}
function $438042a7fad0109d$var$Xh(a, b, c, d, e, f) {
    $438042a7fad0109d$var$Rh = f;
    $438042a7fad0109d$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $438042a7fad0109d$var$Ph.current = null === a || null === a.memoizedState ? $438042a7fad0109d$var$Yh : $438042a7fad0109d$var$Zh;
    a = c(d, e);
    if ($438042a7fad0109d$var$Th) {
        f = 0;
        do {
            $438042a7fad0109d$var$Th = !1;
            $438042a7fad0109d$var$Uh = 0;
            if (25 <= f) throw Error($438042a7fad0109d$var$p(301));
            f += 1;
            $438042a7fad0109d$var$P = $438042a7fad0109d$var$O = null;
            b.updateQueue = null;
            $438042a7fad0109d$var$Ph.current = $438042a7fad0109d$var$$h;
            a = c(d, e);
        }while ($438042a7fad0109d$var$Th);
    }
    $438042a7fad0109d$var$Ph.current = $438042a7fad0109d$var$ai;
    b = null !== $438042a7fad0109d$var$O && null !== $438042a7fad0109d$var$O.next;
    $438042a7fad0109d$var$Rh = 0;
    $438042a7fad0109d$var$P = $438042a7fad0109d$var$O = $438042a7fad0109d$var$N = null;
    $438042a7fad0109d$var$Sh = !1;
    if (b) throw Error($438042a7fad0109d$var$p(300));
    return a;
}
function $438042a7fad0109d$var$bi() {
    var a = 0 !== $438042a7fad0109d$var$Uh;
    $438042a7fad0109d$var$Uh = 0;
    return a;
}
function $438042a7fad0109d$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $438042a7fad0109d$var$P ? $438042a7fad0109d$var$N.memoizedState = $438042a7fad0109d$var$P = a : $438042a7fad0109d$var$P = $438042a7fad0109d$var$P.next = a;
    return $438042a7fad0109d$var$P;
}
function $438042a7fad0109d$var$di() {
    if (null === $438042a7fad0109d$var$O) {
        var a = $438042a7fad0109d$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $438042a7fad0109d$var$O.next;
    var b = null === $438042a7fad0109d$var$P ? $438042a7fad0109d$var$N.memoizedState : $438042a7fad0109d$var$P.next;
    if (null !== b) $438042a7fad0109d$var$P = b, $438042a7fad0109d$var$O = a;
    else {
        if (null === a) throw Error($438042a7fad0109d$var$p(310));
        $438042a7fad0109d$var$O = a;
        a = {
            memoizedState: $438042a7fad0109d$var$O.memoizedState,
            baseState: $438042a7fad0109d$var$O.baseState,
            baseQueue: $438042a7fad0109d$var$O.baseQueue,
            queue: $438042a7fad0109d$var$O.queue,
            next: null
        };
        null === $438042a7fad0109d$var$P ? $438042a7fad0109d$var$N.memoizedState = $438042a7fad0109d$var$P = a : $438042a7fad0109d$var$P = $438042a7fad0109d$var$P.next = a;
    }
    return $438042a7fad0109d$var$P;
}
function $438042a7fad0109d$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $438042a7fad0109d$var$fi(a) {
    var b = $438042a7fad0109d$var$di(), c = b.queue;
    if (null === c) throw Error($438042a7fad0109d$var$p(311));
    c.lastRenderedReducer = a;
    var d = $438042a7fad0109d$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($438042a7fad0109d$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $438042a7fad0109d$var$N.lanes |= m;
                $438042a7fad0109d$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $438042a7fad0109d$var$He(d, b.memoizedState) || ($438042a7fad0109d$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $438042a7fad0109d$var$N.lanes |= f, $438042a7fad0109d$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $438042a7fad0109d$var$gi(a) {
    var b = $438042a7fad0109d$var$di(), c = b.queue;
    if (null === c) throw Error($438042a7fad0109d$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $438042a7fad0109d$var$He(f, b.memoizedState) || ($438042a7fad0109d$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $438042a7fad0109d$var$hi() {}
function $438042a7fad0109d$var$ii(a, b) {
    var c = $438042a7fad0109d$var$N, d = $438042a7fad0109d$var$di(), e = b(), f = !$438042a7fad0109d$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $438042a7fad0109d$var$Ug = !0);
    d = d.queue;
    $438042a7fad0109d$var$ji($438042a7fad0109d$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $438042a7fad0109d$var$P && $438042a7fad0109d$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $438042a7fad0109d$var$li(9, $438042a7fad0109d$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $438042a7fad0109d$var$R) throw Error($438042a7fad0109d$var$p(349));
        0 !== ($438042a7fad0109d$var$Rh & 30) || $438042a7fad0109d$var$ni(c, b, e);
    }
    return e;
}
function $438042a7fad0109d$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $438042a7fad0109d$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $438042a7fad0109d$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $438042a7fad0109d$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $438042a7fad0109d$var$oi(b) && $438042a7fad0109d$var$pi(a);
}
function $438042a7fad0109d$var$ki(a, b, c) {
    return c(function() {
        $438042a7fad0109d$var$oi(b) && $438042a7fad0109d$var$pi(a);
    });
}
function $438042a7fad0109d$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$438042a7fad0109d$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $438042a7fad0109d$var$pi(a) {
    var b = $438042a7fad0109d$var$Zg(a, 1);
    null !== b && $438042a7fad0109d$var$mh(b, a, 1, -1);
}
function $438042a7fad0109d$var$qi(a) {
    var b = $438042a7fad0109d$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $438042a7fad0109d$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $438042a7fad0109d$var$ri.bind(null, $438042a7fad0109d$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $438042a7fad0109d$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $438042a7fad0109d$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $438042a7fad0109d$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $438042a7fad0109d$var$si() {
    return $438042a7fad0109d$var$di().memoizedState;
}
function $438042a7fad0109d$var$ti(a, b, c, d) {
    var e = $438042a7fad0109d$var$ci();
    $438042a7fad0109d$var$N.flags |= a;
    e.memoizedState = $438042a7fad0109d$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $438042a7fad0109d$var$ui(a, b, c, d) {
    var e = $438042a7fad0109d$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $438042a7fad0109d$var$O) {
        var g = $438042a7fad0109d$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $438042a7fad0109d$var$Wh(d, g.deps)) {
            e.memoizedState = $438042a7fad0109d$var$li(b, c, f, d);
            return;
        }
    }
    $438042a7fad0109d$var$N.flags |= a;
    e.memoizedState = $438042a7fad0109d$var$li(1 | b, c, f, d);
}
function $438042a7fad0109d$var$vi(a, b) {
    return $438042a7fad0109d$var$ti(8390656, 8, a, b);
}
function $438042a7fad0109d$var$ji(a, b) {
    return $438042a7fad0109d$var$ui(2048, 8, a, b);
}
function $438042a7fad0109d$var$wi(a, b) {
    return $438042a7fad0109d$var$ui(4, 2, a, b);
}
function $438042a7fad0109d$var$xi(a, b) {
    return $438042a7fad0109d$var$ui(4, 4, a, b);
}
function $438042a7fad0109d$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $438042a7fad0109d$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $438042a7fad0109d$var$ui(4, 4, $438042a7fad0109d$var$yi.bind(null, b, a), c);
}
function $438042a7fad0109d$var$Ai() {}
function $438042a7fad0109d$var$Bi(a, b) {
    var c = $438042a7fad0109d$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $438042a7fad0109d$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $438042a7fad0109d$var$Ci(a, b) {
    var c = $438042a7fad0109d$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $438042a7fad0109d$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $438042a7fad0109d$var$Di(a, b, c) {
    if (0 === ($438042a7fad0109d$var$Rh & 21)) return a.baseState && (a.baseState = !1, $438042a7fad0109d$var$Ug = !0), a.memoizedState = c;
    $438042a7fad0109d$var$He(c, b) || (c = $438042a7fad0109d$var$yc(), $438042a7fad0109d$var$N.lanes |= c, $438042a7fad0109d$var$hh |= c, a.baseState = !0);
    return b;
}
function $438042a7fad0109d$var$Ei(a, b) {
    var c = $438042a7fad0109d$var$C;
    $438042a7fad0109d$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $438042a7fad0109d$var$Qh.transition;
    $438042a7fad0109d$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $438042a7fad0109d$var$C = c, $438042a7fad0109d$var$Qh.transition = d;
    }
}
function $438042a7fad0109d$var$Fi() {
    return $438042a7fad0109d$var$di().memoizedState;
}
function $438042a7fad0109d$var$Gi(a, b, c) {
    var d = $438042a7fad0109d$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($438042a7fad0109d$var$Hi(a)) $438042a7fad0109d$var$Ii(b, c);
    else if (c = $438042a7fad0109d$var$Yg(a, b, c, d), null !== c) {
        var e = $438042a7fad0109d$var$L();
        $438042a7fad0109d$var$mh(c, a, d, e);
        $438042a7fad0109d$var$Ji(c, b, d);
    }
}
function $438042a7fad0109d$var$ri(a, b, c) {
    var d = $438042a7fad0109d$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($438042a7fad0109d$var$Hi(a)) $438042a7fad0109d$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($438042a7fad0109d$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $438042a7fad0109d$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $438042a7fad0109d$var$Yg(a, b, e, d);
        null !== c && (e = $438042a7fad0109d$var$L(), $438042a7fad0109d$var$mh(c, a, d, e), $438042a7fad0109d$var$Ji(c, b, d));
    }
}
function $438042a7fad0109d$var$Hi(a) {
    var b = a.alternate;
    return a === $438042a7fad0109d$var$N || null !== b && b === $438042a7fad0109d$var$N;
}
function $438042a7fad0109d$var$Ii(a, b) {
    $438042a7fad0109d$var$Th = $438042a7fad0109d$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $438042a7fad0109d$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $438042a7fad0109d$var$Cc(a, c);
    }
}
var $438042a7fad0109d$var$ai = {
    readContext: $438042a7fad0109d$var$Vg,
    useCallback: $438042a7fad0109d$var$Q,
    useContext: $438042a7fad0109d$var$Q,
    useEffect: $438042a7fad0109d$var$Q,
    useImperativeHandle: $438042a7fad0109d$var$Q,
    useInsertionEffect: $438042a7fad0109d$var$Q,
    useLayoutEffect: $438042a7fad0109d$var$Q,
    useMemo: $438042a7fad0109d$var$Q,
    useReducer: $438042a7fad0109d$var$Q,
    useRef: $438042a7fad0109d$var$Q,
    useState: $438042a7fad0109d$var$Q,
    useDebugValue: $438042a7fad0109d$var$Q,
    useDeferredValue: $438042a7fad0109d$var$Q,
    useTransition: $438042a7fad0109d$var$Q,
    useMutableSource: $438042a7fad0109d$var$Q,
    useSyncExternalStore: $438042a7fad0109d$var$Q,
    useId: $438042a7fad0109d$var$Q,
    unstable_isNewReconciler: !1
}, $438042a7fad0109d$var$Yh = {
    readContext: $438042a7fad0109d$var$Vg,
    useCallback: function(a, b) {
        $438042a7fad0109d$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $438042a7fad0109d$var$Vg,
    useEffect: $438042a7fad0109d$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $438042a7fad0109d$var$ti(4194308, 4, $438042a7fad0109d$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $438042a7fad0109d$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $438042a7fad0109d$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $438042a7fad0109d$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $438042a7fad0109d$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $438042a7fad0109d$var$Gi.bind(null, $438042a7fad0109d$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $438042a7fad0109d$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $438042a7fad0109d$var$qi,
    useDebugValue: $438042a7fad0109d$var$Ai,
    useDeferredValue: function(a) {
        return $438042a7fad0109d$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $438042a7fad0109d$var$qi(!1), b = a[0];
        a = $438042a7fad0109d$var$Ei.bind(null, a[1]);
        $438042a7fad0109d$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $438042a7fad0109d$var$N, e = $438042a7fad0109d$var$ci();
        if ($438042a7fad0109d$var$I) {
            if (void 0 === c) throw Error($438042a7fad0109d$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $438042a7fad0109d$var$R) throw Error($438042a7fad0109d$var$p(349));
            0 !== ($438042a7fad0109d$var$Rh & 30) || $438042a7fad0109d$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $438042a7fad0109d$var$vi($438042a7fad0109d$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $438042a7fad0109d$var$li(9, $438042a7fad0109d$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $438042a7fad0109d$var$ci(), b = $438042a7fad0109d$var$R.identifierPrefix;
        if ($438042a7fad0109d$var$I) {
            var c = $438042a7fad0109d$var$sg;
            var d = $438042a7fad0109d$var$rg;
            c = (d & ~(1 << 32 - $438042a7fad0109d$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $438042a7fad0109d$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $438042a7fad0109d$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $438042a7fad0109d$var$Zh = {
    readContext: $438042a7fad0109d$var$Vg,
    useCallback: $438042a7fad0109d$var$Bi,
    useContext: $438042a7fad0109d$var$Vg,
    useEffect: $438042a7fad0109d$var$ji,
    useImperativeHandle: $438042a7fad0109d$var$zi,
    useInsertionEffect: $438042a7fad0109d$var$wi,
    useLayoutEffect: $438042a7fad0109d$var$xi,
    useMemo: $438042a7fad0109d$var$Ci,
    useReducer: $438042a7fad0109d$var$fi,
    useRef: $438042a7fad0109d$var$si,
    useState: function() {
        return $438042a7fad0109d$var$fi($438042a7fad0109d$var$ei);
    },
    useDebugValue: $438042a7fad0109d$var$Ai,
    useDeferredValue: function(a) {
        var b = $438042a7fad0109d$var$di();
        return $438042a7fad0109d$var$Di(b, $438042a7fad0109d$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $438042a7fad0109d$var$fi($438042a7fad0109d$var$ei)[0], b = $438042a7fad0109d$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $438042a7fad0109d$var$hi,
    useSyncExternalStore: $438042a7fad0109d$var$ii,
    useId: $438042a7fad0109d$var$Fi,
    unstable_isNewReconciler: !1
}, $438042a7fad0109d$var$$h = {
    readContext: $438042a7fad0109d$var$Vg,
    useCallback: $438042a7fad0109d$var$Bi,
    useContext: $438042a7fad0109d$var$Vg,
    useEffect: $438042a7fad0109d$var$ji,
    useImperativeHandle: $438042a7fad0109d$var$zi,
    useInsertionEffect: $438042a7fad0109d$var$wi,
    useLayoutEffect: $438042a7fad0109d$var$xi,
    useMemo: $438042a7fad0109d$var$Ci,
    useReducer: $438042a7fad0109d$var$gi,
    useRef: $438042a7fad0109d$var$si,
    useState: function() {
        return $438042a7fad0109d$var$gi($438042a7fad0109d$var$ei);
    },
    useDebugValue: $438042a7fad0109d$var$Ai,
    useDeferredValue: function(a) {
        var b = $438042a7fad0109d$var$di();
        return null === $438042a7fad0109d$var$O ? b.memoizedState = a : $438042a7fad0109d$var$Di(b, $438042a7fad0109d$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $438042a7fad0109d$var$gi($438042a7fad0109d$var$ei)[0], b = $438042a7fad0109d$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $438042a7fad0109d$var$hi,
    useSyncExternalStore: $438042a7fad0109d$var$ii,
    useId: $438042a7fad0109d$var$Fi,
    unstable_isNewReconciler: !1
};
function $438042a7fad0109d$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $438042a7fad0109d$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $438042a7fad0109d$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $438042a7fad0109d$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $438042a7fad0109d$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $438042a7fad0109d$var$Oi(a, b, c) {
    c = $438042a7fad0109d$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $438042a7fad0109d$var$Pi || ($438042a7fad0109d$var$Pi = !0, $438042a7fad0109d$var$Qi = d);
        $438042a7fad0109d$var$Mi(a, b);
    };
    return c;
}
function $438042a7fad0109d$var$Ri(a, b, c) {
    c = $438042a7fad0109d$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $438042a7fad0109d$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $438042a7fad0109d$var$Mi(a, b);
        "function" !== typeof d && (null === $438042a7fad0109d$var$Si ? $438042a7fad0109d$var$Si = new Set([
            this
        ]) : $438042a7fad0109d$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $438042a7fad0109d$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $438042a7fad0109d$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $438042a7fad0109d$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $438042a7fad0109d$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $438042a7fad0109d$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $438042a7fad0109d$var$ch(-1, 1), b.tag = 2, $438042a7fad0109d$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $438042a7fad0109d$var$Xi = $438042a7fad0109d$var$ua.ReactCurrentOwner, $438042a7fad0109d$var$Ug = !1;
function $438042a7fad0109d$var$Yi(a, b, c, d) {
    b.child = null === a ? $438042a7fad0109d$var$Ch(b, null, c, d) : $438042a7fad0109d$var$Bh(b, a.child, c, d);
}
function $438042a7fad0109d$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $438042a7fad0109d$var$Tg(b, e);
    d = $438042a7fad0109d$var$Xh(a, b, c, d, f, e);
    c = $438042a7fad0109d$var$bi();
    if (null !== a && !$438042a7fad0109d$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $438042a7fad0109d$var$$i(a, b, e);
    $438042a7fad0109d$var$I && c && $438042a7fad0109d$var$vg(b);
    b.flags |= 1;
    $438042a7fad0109d$var$Yi(a, b, d, e);
    return b.child;
}
function $438042a7fad0109d$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$438042a7fad0109d$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $438042a7fad0109d$var$cj(a, b, f, d, e);
        a = $438042a7fad0109d$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $438042a7fad0109d$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $438042a7fad0109d$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $438042a7fad0109d$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $438042a7fad0109d$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($438042a7fad0109d$var$Ie(f, d) && a.ref === b.ref) {
            if ($438042a7fad0109d$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($438042a7fad0109d$var$Ug = !0);
            else return b.lanes = a.lanes, $438042a7fad0109d$var$$i(a, b, e);
        }
    }
    return $438042a7fad0109d$var$dj(a, b, c, d, e);
}
function $438042a7fad0109d$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $438042a7fad0109d$var$G($438042a7fad0109d$var$fj, $438042a7fad0109d$var$gj), $438042a7fad0109d$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $438042a7fad0109d$var$G($438042a7fad0109d$var$fj, $438042a7fad0109d$var$gj), $438042a7fad0109d$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $438042a7fad0109d$var$G($438042a7fad0109d$var$fj, $438042a7fad0109d$var$gj);
            $438042a7fad0109d$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $438042a7fad0109d$var$G($438042a7fad0109d$var$fj, $438042a7fad0109d$var$gj), $438042a7fad0109d$var$gj |= d;
    $438042a7fad0109d$var$Yi(a, b, e, c);
    return b.child;
}
function $438042a7fad0109d$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $438042a7fad0109d$var$dj(a, b, c, d, e) {
    var f = $438042a7fad0109d$var$Zf(c) ? $438042a7fad0109d$var$Xf : $438042a7fad0109d$var$H.current;
    f = $438042a7fad0109d$var$Yf(b, f);
    $438042a7fad0109d$var$Tg(b, e);
    c = $438042a7fad0109d$var$Xh(a, b, c, d, f, e);
    d = $438042a7fad0109d$var$bi();
    if (null !== a && !$438042a7fad0109d$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $438042a7fad0109d$var$$i(a, b, e);
    $438042a7fad0109d$var$I && d && $438042a7fad0109d$var$vg(b);
    b.flags |= 1;
    $438042a7fad0109d$var$Yi(a, b, c, e);
    return b.child;
}
function $438042a7fad0109d$var$ij(a, b, c, d, e) {
    if ($438042a7fad0109d$var$Zf(c)) {
        var f = !0;
        $438042a7fad0109d$var$cg(b);
    } else f = !1;
    $438042a7fad0109d$var$Tg(b, e);
    if (null === b.stateNode) $438042a7fad0109d$var$jj(a, b), $438042a7fad0109d$var$ph(b, c, d), $438042a7fad0109d$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $438042a7fad0109d$var$Vg(l) : (l = $438042a7fad0109d$var$Zf(c) ? $438042a7fad0109d$var$Xf : $438042a7fad0109d$var$H.current, l = $438042a7fad0109d$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $438042a7fad0109d$var$qh(b, g, d, l);
        $438042a7fad0109d$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $438042a7fad0109d$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $438042a7fad0109d$var$Wf.current || $438042a7fad0109d$var$$g ? ("function" === typeof m && ($438042a7fad0109d$var$kh(b, c, m, d), k = b.memoizedState), (h = $438042a7fad0109d$var$$g || $438042a7fad0109d$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $438042a7fad0109d$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $438042a7fad0109d$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $438042a7fad0109d$var$Vg(k) : (k = $438042a7fad0109d$var$Zf(c) ? $438042a7fad0109d$var$Xf : $438042a7fad0109d$var$H.current, k = $438042a7fad0109d$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $438042a7fad0109d$var$qh(b, g, d, k);
        $438042a7fad0109d$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $438042a7fad0109d$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $438042a7fad0109d$var$Wf.current || $438042a7fad0109d$var$$g ? ("function" === typeof y && ($438042a7fad0109d$var$kh(b, c, y, d), n = b.memoizedState), (l = $438042a7fad0109d$var$$g || $438042a7fad0109d$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $438042a7fad0109d$var$kj(a, b, c, d, f, e);
}
function $438042a7fad0109d$var$kj(a, b, c, d, e, f) {
    $438042a7fad0109d$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $438042a7fad0109d$var$dg(b, c, !1), $438042a7fad0109d$var$$i(a, b, f);
    d = b.stateNode;
    $438042a7fad0109d$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $438042a7fad0109d$var$Bh(b, a.child, null, f), b.child = $438042a7fad0109d$var$Bh(b, null, h, f)) : $438042a7fad0109d$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $438042a7fad0109d$var$dg(b, c, !0);
    return b.child;
}
function $438042a7fad0109d$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $438042a7fad0109d$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $438042a7fad0109d$var$ag(a, b.context, !1);
    $438042a7fad0109d$var$Ih(a, b.containerInfo);
}
function $438042a7fad0109d$var$mj(a, b, c, d, e) {
    $438042a7fad0109d$var$Ig();
    $438042a7fad0109d$var$Jg(e);
    b.flags |= 256;
    $438042a7fad0109d$var$Yi(a, b, c, d);
    return b.child;
}
var $438042a7fad0109d$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $438042a7fad0109d$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $438042a7fad0109d$var$pj(a, b, c) {
    var d = b.pendingProps, e = $438042a7fad0109d$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $438042a7fad0109d$var$G($438042a7fad0109d$var$M, e & 1);
    if (null === a) {
        $438042a7fad0109d$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $438042a7fad0109d$var$qj(g, d, 0, null), a = $438042a7fad0109d$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $438042a7fad0109d$var$oj(c), b.memoizedState = $438042a7fad0109d$var$nj, a) : $438042a7fad0109d$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $438042a7fad0109d$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $438042a7fad0109d$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $438042a7fad0109d$var$wh(h, f) : (f = $438042a7fad0109d$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $438042a7fad0109d$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $438042a7fad0109d$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $438042a7fad0109d$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $438042a7fad0109d$var$rj(a, b) {
    b = $438042a7fad0109d$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $438042a7fad0109d$var$tj(a, b, c, d) {
    null !== d && $438042a7fad0109d$var$Jg(d);
    $438042a7fad0109d$var$Bh(b, a.child, null, c);
    a = $438042a7fad0109d$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $438042a7fad0109d$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $438042a7fad0109d$var$Li(Error($438042a7fad0109d$var$p(422))), $438042a7fad0109d$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $438042a7fad0109d$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $438042a7fad0109d$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $438042a7fad0109d$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $438042a7fad0109d$var$oj(g);
        b.memoizedState = $438042a7fad0109d$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $438042a7fad0109d$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($438042a7fad0109d$var$p(419));
        d = $438042a7fad0109d$var$Li(f, d, void 0);
        return $438042a7fad0109d$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($438042a7fad0109d$var$Ug || h) {
        d = $438042a7fad0109d$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $438042a7fad0109d$var$Zg(a, e), $438042a7fad0109d$var$mh(d, a, e, -1));
        }
        $438042a7fad0109d$var$uj();
        d = $438042a7fad0109d$var$Li(Error($438042a7fad0109d$var$p(421)));
        return $438042a7fad0109d$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $438042a7fad0109d$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $438042a7fad0109d$var$yg = $438042a7fad0109d$var$Lf(e.nextSibling);
    $438042a7fad0109d$var$xg = b;
    $438042a7fad0109d$var$I = !0;
    $438042a7fad0109d$var$zg = null;
    null !== a && ($438042a7fad0109d$var$og[$438042a7fad0109d$var$pg++] = $438042a7fad0109d$var$rg, $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg++] = $438042a7fad0109d$var$sg, $438042a7fad0109d$var$og[$438042a7fad0109d$var$pg++] = $438042a7fad0109d$var$qg, $438042a7fad0109d$var$rg = a.id, $438042a7fad0109d$var$sg = a.overflow, $438042a7fad0109d$var$qg = b);
    b = $438042a7fad0109d$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $438042a7fad0109d$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $438042a7fad0109d$var$Sg(a.return, b, c);
}
function $438042a7fad0109d$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $438042a7fad0109d$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $438042a7fad0109d$var$Yi(a, b, d.children, c);
    d = $438042a7fad0109d$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $438042a7fad0109d$var$wj(a, c, b);
            else if (19 === a.tag) $438042a7fad0109d$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $438042a7fad0109d$var$G($438042a7fad0109d$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $438042a7fad0109d$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $438042a7fad0109d$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $438042a7fad0109d$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $438042a7fad0109d$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $438042a7fad0109d$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $438042a7fad0109d$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $438042a7fad0109d$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $438042a7fad0109d$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($438042a7fad0109d$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $438042a7fad0109d$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $438042a7fad0109d$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $438042a7fad0109d$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $438042a7fad0109d$var$lj(b);
            $438042a7fad0109d$var$Ig();
            break;
        case 5:
            $438042a7fad0109d$var$Kh(b);
            break;
        case 1:
            $438042a7fad0109d$var$Zf(b.type) && $438042a7fad0109d$var$cg(b);
            break;
        case 4:
            $438042a7fad0109d$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $438042a7fad0109d$var$G($438042a7fad0109d$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $438042a7fad0109d$var$G($438042a7fad0109d$var$M, $438042a7fad0109d$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $438042a7fad0109d$var$pj(a, b, c);
                $438042a7fad0109d$var$G($438042a7fad0109d$var$M, $438042a7fad0109d$var$M.current & 1);
                a = $438042a7fad0109d$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $438042a7fad0109d$var$G($438042a7fad0109d$var$M, $438042a7fad0109d$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $438042a7fad0109d$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $438042a7fad0109d$var$G($438042a7fad0109d$var$M, $438042a7fad0109d$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $438042a7fad0109d$var$ej(a, b, c);
    }
    return $438042a7fad0109d$var$$i(a, b, c);
}
var $438042a7fad0109d$var$Aj, $438042a7fad0109d$var$Bj, $438042a7fad0109d$var$Cj, $438042a7fad0109d$var$Dj;
$438042a7fad0109d$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$438042a7fad0109d$var$Bj = function() {};
$438042a7fad0109d$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $438042a7fad0109d$var$Hh($438042a7fad0109d$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $438042a7fad0109d$var$Ya(a, e);
                d = $438042a7fad0109d$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $438042a7fad0109d$var$A({}, e, {
                    value: void 0
                });
                d = $438042a7fad0109d$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $438042a7fad0109d$var$gb(a, e);
                d = $438042a7fad0109d$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $438042a7fad0109d$var$Bf);
        }
        $438042a7fad0109d$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($438042a7fad0109d$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($438042a7fad0109d$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $438042a7fad0109d$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$438042a7fad0109d$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $438042a7fad0109d$var$Ej(a, b) {
    if (!$438042a7fad0109d$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $438042a7fad0109d$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $438042a7fad0109d$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $438042a7fad0109d$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $438042a7fad0109d$var$S(b), null;
        case 1:
            return $438042a7fad0109d$var$Zf(b.type) && $438042a7fad0109d$var$$f(), $438042a7fad0109d$var$S(b), null;
        case 3:
            d = b.stateNode;
            $438042a7fad0109d$var$Jh();
            $438042a7fad0109d$var$E($438042a7fad0109d$var$Wf);
            $438042a7fad0109d$var$E($438042a7fad0109d$var$H);
            $438042a7fad0109d$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $438042a7fad0109d$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $438042a7fad0109d$var$zg && ($438042a7fad0109d$var$Gj($438042a7fad0109d$var$zg), $438042a7fad0109d$var$zg = null));
            $438042a7fad0109d$var$Bj(a, b);
            $438042a7fad0109d$var$S(b);
            return null;
        case 5:
            $438042a7fad0109d$var$Lh(b);
            var e = $438042a7fad0109d$var$Hh($438042a7fad0109d$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $438042a7fad0109d$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($438042a7fad0109d$var$p(166));
                    $438042a7fad0109d$var$S(b);
                    return null;
                }
                a = $438042a7fad0109d$var$Hh($438042a7fad0109d$var$Eh.current);
                if ($438042a7fad0109d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$438042a7fad0109d$var$Of] = b;
                    d[$438042a7fad0109d$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $438042a7fad0109d$var$D("cancel", d);
                            $438042a7fad0109d$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $438042a7fad0109d$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $438042a7fad0109d$var$lf.length; e++)$438042a7fad0109d$var$D($438042a7fad0109d$var$lf[e], d);
                            break;
                        case "source":
                            $438042a7fad0109d$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $438042a7fad0109d$var$D("error", d);
                            $438042a7fad0109d$var$D("load", d);
                            break;
                        case "details":
                            $438042a7fad0109d$var$D("toggle", d);
                            break;
                        case "input":
                            $438042a7fad0109d$var$Za(d, f);
                            $438042a7fad0109d$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $438042a7fad0109d$var$D("invalid", d);
                            break;
                        case "textarea":
                            $438042a7fad0109d$var$hb(d, f), $438042a7fad0109d$var$D("invalid", d);
                    }
                    $438042a7fad0109d$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $438042a7fad0109d$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $438042a7fad0109d$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $438042a7fad0109d$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $438042a7fad0109d$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $438042a7fad0109d$var$Va(d);
                            $438042a7fad0109d$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $438042a7fad0109d$var$Va(d);
                            $438042a7fad0109d$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $438042a7fad0109d$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $438042a7fad0109d$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$438042a7fad0109d$var$Of] = b;
                    a[$438042a7fad0109d$var$Pf] = d;
                    $438042a7fad0109d$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $438042a7fad0109d$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $438042a7fad0109d$var$D("cancel", a);
                                $438042a7fad0109d$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $438042a7fad0109d$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $438042a7fad0109d$var$lf.length; e++)$438042a7fad0109d$var$D($438042a7fad0109d$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $438042a7fad0109d$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $438042a7fad0109d$var$D("error", a);
                                $438042a7fad0109d$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $438042a7fad0109d$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $438042a7fad0109d$var$Za(a, d);
                                e = $438042a7fad0109d$var$Ya(a, d);
                                $438042a7fad0109d$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $438042a7fad0109d$var$A({}, d, {
                                    value: void 0
                                });
                                $438042a7fad0109d$var$D("invalid", a);
                                break;
                            case "textarea":
                                $438042a7fad0109d$var$hb(a, d);
                                e = $438042a7fad0109d$var$gb(a, d);
                                $438042a7fad0109d$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $438042a7fad0109d$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $438042a7fad0109d$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $438042a7fad0109d$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $438042a7fad0109d$var$ob(a, k) : "number" === typeof k && $438042a7fad0109d$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($438042a7fad0109d$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $438042a7fad0109d$var$D("scroll", a) : null != k && $438042a7fad0109d$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $438042a7fad0109d$var$Va(a);
                                $438042a7fad0109d$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $438042a7fad0109d$var$Va(a);
                                $438042a7fad0109d$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $438042a7fad0109d$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $438042a7fad0109d$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $438042a7fad0109d$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $438042a7fad0109d$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $438042a7fad0109d$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $438042a7fad0109d$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($438042a7fad0109d$var$p(166));
                c = $438042a7fad0109d$var$Hh($438042a7fad0109d$var$Gh.current);
                $438042a7fad0109d$var$Hh($438042a7fad0109d$var$Eh.current);
                if ($438042a7fad0109d$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$438042a7fad0109d$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $438042a7fad0109d$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $438042a7fad0109d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $438042a7fad0109d$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$438042a7fad0109d$var$Of] = b, b.stateNode = d;
            }
            $438042a7fad0109d$var$S(b);
            return null;
        case 13:
            $438042a7fad0109d$var$E($438042a7fad0109d$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($438042a7fad0109d$var$I && null !== $438042a7fad0109d$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $438042a7fad0109d$var$Hg(), $438042a7fad0109d$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $438042a7fad0109d$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($438042a7fad0109d$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($438042a7fad0109d$var$p(317));
                        f[$438042a7fad0109d$var$Of] = b;
                    } else $438042a7fad0109d$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $438042a7fad0109d$var$S(b);
                    f = !1;
                } else null !== $438042a7fad0109d$var$zg && ($438042a7fad0109d$var$Gj($438042a7fad0109d$var$zg), $438042a7fad0109d$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($438042a7fad0109d$var$M.current & 1) ? 0 === $438042a7fad0109d$var$T && ($438042a7fad0109d$var$T = 3) : $438042a7fad0109d$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $438042a7fad0109d$var$S(b);
            return null;
        case 4:
            return $438042a7fad0109d$var$Jh(), $438042a7fad0109d$var$Bj(a, b), null === a && $438042a7fad0109d$var$sf(b.stateNode.containerInfo), $438042a7fad0109d$var$S(b), null;
        case 10:
            return $438042a7fad0109d$var$Rg(b.type._context), $438042a7fad0109d$var$S(b), null;
        case 17:
            return $438042a7fad0109d$var$Zf(b.type) && $438042a7fad0109d$var$$f(), $438042a7fad0109d$var$S(b), null;
        case 19:
            $438042a7fad0109d$var$E($438042a7fad0109d$var$M);
            f = b.memoizedState;
            if (null === f) return $438042a7fad0109d$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $438042a7fad0109d$var$Ej(f, !1);
                else {
                    if (0 !== $438042a7fad0109d$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $438042a7fad0109d$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $438042a7fad0109d$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $438042a7fad0109d$var$G($438042a7fad0109d$var$M, $438042a7fad0109d$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $438042a7fad0109d$var$B() > $438042a7fad0109d$var$Hj && (b.flags |= 128, d = !0, $438042a7fad0109d$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $438042a7fad0109d$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $438042a7fad0109d$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$438042a7fad0109d$var$I) return $438042a7fad0109d$var$S(b), null;
                    } else 2 * $438042a7fad0109d$var$B() - f.renderingStartTime > $438042a7fad0109d$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $438042a7fad0109d$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $438042a7fad0109d$var$B(), b.sibling = null, c = $438042a7fad0109d$var$M.current, $438042a7fad0109d$var$G($438042a7fad0109d$var$M, d ? c & 1 | 2 : c & 1), b;
            $438042a7fad0109d$var$S(b);
            return null;
        case 22:
        case 23:
            return $438042a7fad0109d$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($438042a7fad0109d$var$gj & 1073741824) && ($438042a7fad0109d$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $438042a7fad0109d$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($438042a7fad0109d$var$p(156, b.tag));
}
function $438042a7fad0109d$var$Jj(a, b) {
    $438042a7fad0109d$var$wg(b);
    switch(b.tag){
        case 1:
            return $438042a7fad0109d$var$Zf(b.type) && $438042a7fad0109d$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $438042a7fad0109d$var$Jh(), $438042a7fad0109d$var$E($438042a7fad0109d$var$Wf), $438042a7fad0109d$var$E($438042a7fad0109d$var$H), $438042a7fad0109d$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $438042a7fad0109d$var$Lh(b), null;
        case 13:
            $438042a7fad0109d$var$E($438042a7fad0109d$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($438042a7fad0109d$var$p(340));
                $438042a7fad0109d$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $438042a7fad0109d$var$E($438042a7fad0109d$var$M), null;
        case 4:
            return $438042a7fad0109d$var$Jh(), null;
        case 10:
            return $438042a7fad0109d$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $438042a7fad0109d$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $438042a7fad0109d$var$Kj = !1, $438042a7fad0109d$var$U = !1, $438042a7fad0109d$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $438042a7fad0109d$var$V = null;
function $438042a7fad0109d$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $438042a7fad0109d$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $438042a7fad0109d$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $438042a7fad0109d$var$W(a, b, d);
    }
}
var $438042a7fad0109d$var$Oj = !1;
function $438042a7fad0109d$var$Pj(a, b) {
    $438042a7fad0109d$var$Cf = $438042a7fad0109d$var$dd;
    a = $438042a7fad0109d$var$Me();
    if ($438042a7fad0109d$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $438042a7fad0109d$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $438042a7fad0109d$var$dd = !1;
    for($438042a7fad0109d$var$V = b; null !== $438042a7fad0109d$var$V;)if (b = $438042a7fad0109d$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $438042a7fad0109d$var$V = a;
    else for(; null !== $438042a7fad0109d$var$V;){
        b = $438042a7fad0109d$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $438042a7fad0109d$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($438042a7fad0109d$var$p(163));
            }
        } catch (F) {
            $438042a7fad0109d$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $438042a7fad0109d$var$V = a;
            break;
        }
        $438042a7fad0109d$var$V = b.return;
    }
    n = $438042a7fad0109d$var$Oj;
    $438042a7fad0109d$var$Oj = !1;
    return n;
}
function $438042a7fad0109d$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $438042a7fad0109d$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $438042a7fad0109d$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $438042a7fad0109d$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $438042a7fad0109d$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $438042a7fad0109d$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$438042a7fad0109d$var$Of], delete b[$438042a7fad0109d$var$Pf], delete b[$438042a7fad0109d$var$of], delete b[$438042a7fad0109d$var$Qf], delete b[$438042a7fad0109d$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $438042a7fad0109d$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $438042a7fad0109d$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $438042a7fad0109d$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $438042a7fad0109d$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $438042a7fad0109d$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($438042a7fad0109d$var$Wj(a, b, c), a = a.sibling; null !== a;)$438042a7fad0109d$var$Wj(a, b, c), a = a.sibling;
}
function $438042a7fad0109d$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($438042a7fad0109d$var$Xj(a, b, c), a = a.sibling; null !== a;)$438042a7fad0109d$var$Xj(a, b, c), a = a.sibling;
}
var $438042a7fad0109d$var$X = null, $438042a7fad0109d$var$Yj = !1;
function $438042a7fad0109d$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$438042a7fad0109d$var$ak(a, b, c), c = c.sibling;
}
function $438042a7fad0109d$var$ak(a, b, c) {
    if ($438042a7fad0109d$var$lc && "function" === typeof $438042a7fad0109d$var$lc.onCommitFiberUnmount) try {
        $438042a7fad0109d$var$lc.onCommitFiberUnmount($438042a7fad0109d$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $438042a7fad0109d$var$U || $438042a7fad0109d$var$Mj(c, b);
        case 6:
            var d = $438042a7fad0109d$var$X, e = $438042a7fad0109d$var$Yj;
            $438042a7fad0109d$var$X = null;
            $438042a7fad0109d$var$Zj(a, b, c);
            $438042a7fad0109d$var$X = d;
            $438042a7fad0109d$var$Yj = e;
            null !== $438042a7fad0109d$var$X && ($438042a7fad0109d$var$Yj ? (a = $438042a7fad0109d$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $438042a7fad0109d$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $438042a7fad0109d$var$X && ($438042a7fad0109d$var$Yj ? (a = $438042a7fad0109d$var$X, c = c.stateNode, 8 === a.nodeType ? $438042a7fad0109d$var$Kf(a.parentNode, c) : 1 === a.nodeType && $438042a7fad0109d$var$Kf(a, c), $438042a7fad0109d$var$bd(a)) : $438042a7fad0109d$var$Kf($438042a7fad0109d$var$X, c.stateNode));
            break;
        case 4:
            d = $438042a7fad0109d$var$X;
            e = $438042a7fad0109d$var$Yj;
            $438042a7fad0109d$var$X = c.stateNode.containerInfo;
            $438042a7fad0109d$var$Yj = !0;
            $438042a7fad0109d$var$Zj(a, b, c);
            $438042a7fad0109d$var$X = d;
            $438042a7fad0109d$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$438042a7fad0109d$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $438042a7fad0109d$var$Nj(c, b, g) : 0 !== (f & 4) && $438042a7fad0109d$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $438042a7fad0109d$var$Zj(a, b, c);
            break;
        case 1:
            if (!$438042a7fad0109d$var$U && ($438042a7fad0109d$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $438042a7fad0109d$var$W(c, b, h);
            }
            $438042a7fad0109d$var$Zj(a, b, c);
            break;
        case 21:
            $438042a7fad0109d$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($438042a7fad0109d$var$U = (d = $438042a7fad0109d$var$U) || null !== c.memoizedState, $438042a7fad0109d$var$Zj(a, b, c), $438042a7fad0109d$var$U = d) : $438042a7fad0109d$var$Zj(a, b, c);
            break;
        default:
            $438042a7fad0109d$var$Zj(a, b, c);
    }
}
function $438042a7fad0109d$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $438042a7fad0109d$var$Lj);
        b.forEach(function(b) {
            var d = $438042a7fad0109d$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $438042a7fad0109d$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $438042a7fad0109d$var$X = h.stateNode;
                        $438042a7fad0109d$var$Yj = !1;
                        break a;
                    case 3:
                        $438042a7fad0109d$var$X = h.stateNode.containerInfo;
                        $438042a7fad0109d$var$Yj = !0;
                        break a;
                    case 4:
                        $438042a7fad0109d$var$X = h.stateNode.containerInfo;
                        $438042a7fad0109d$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $438042a7fad0109d$var$X) throw Error($438042a7fad0109d$var$p(160));
            $438042a7fad0109d$var$ak(f, g, e);
            $438042a7fad0109d$var$X = null;
            $438042a7fad0109d$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $438042a7fad0109d$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$438042a7fad0109d$var$ek(b, a), b = b.sibling;
}
function $438042a7fad0109d$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            if (d & 4) {
                try {
                    $438042a7fad0109d$var$Qj(3, a, a.return), $438042a7fad0109d$var$Rj(3, a);
                } catch (t) {
                    $438042a7fad0109d$var$W(a, a.return, t);
                }
                try {
                    $438042a7fad0109d$var$Qj(5, a, a.return);
                } catch (t) {
                    $438042a7fad0109d$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            d & 512 && null !== c && $438042a7fad0109d$var$Mj(c, c.return);
            break;
        case 5:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            d & 512 && null !== c && $438042a7fad0109d$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $438042a7fad0109d$var$ob(e, "");
                } catch (t) {
                    $438042a7fad0109d$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $438042a7fad0109d$var$ab(e, f);
                    $438042a7fad0109d$var$vb(h, g);
                    var l = $438042a7fad0109d$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $438042a7fad0109d$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $438042a7fad0109d$var$nb(e, q) : "children" === m ? $438042a7fad0109d$var$ob(e, q) : $438042a7fad0109d$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $438042a7fad0109d$var$bb(e, f);
                            break;
                        case "textarea":
                            $438042a7fad0109d$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $438042a7fad0109d$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $438042a7fad0109d$var$fb(e, !!f.multiple, f.defaultValue, !0) : $438042a7fad0109d$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$438042a7fad0109d$var$Pf] = f;
                } catch (t) {
                    $438042a7fad0109d$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($438042a7fad0109d$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $438042a7fad0109d$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $438042a7fad0109d$var$bd(b.containerInfo);
            } catch (t) {
                $438042a7fad0109d$var$W(a, a.return, t);
            }
            break;
        case 4:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            break;
        case 13:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($438042a7fad0109d$var$gk = $438042a7fad0109d$var$B()));
            d & 4 && $438042a7fad0109d$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($438042a7fad0109d$var$U = (l = $438042a7fad0109d$var$U) || m, $438042a7fad0109d$var$dk(b, a), $438042a7fad0109d$var$U = l) : $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($438042a7fad0109d$var$V = a, m = a.child; null !== m;){
                    for(q = $438042a7fad0109d$var$V = m; null !== $438042a7fad0109d$var$V;){
                        r = $438042a7fad0109d$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $438042a7fad0109d$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $438042a7fad0109d$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $438042a7fad0109d$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $438042a7fad0109d$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $438042a7fad0109d$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $438042a7fad0109d$var$V = y) : $438042a7fad0109d$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $438042a7fad0109d$var$rb("display", g));
                            } catch (t) {
                                $438042a7fad0109d$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $438042a7fad0109d$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $438042a7fad0109d$var$dk(b, a);
            $438042a7fad0109d$var$fk(a);
            d & 4 && $438042a7fad0109d$var$bk(a);
            break;
        case 21:
            break;
        default:
            $438042a7fad0109d$var$dk(b, a), $438042a7fad0109d$var$fk(a);
    }
}
function $438042a7fad0109d$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($438042a7fad0109d$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($438042a7fad0109d$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($438042a7fad0109d$var$ob(e, ""), d.flags &= -33);
                    var f = $438042a7fad0109d$var$Vj(a);
                    $438042a7fad0109d$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $438042a7fad0109d$var$Vj(a);
                    $438042a7fad0109d$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($438042a7fad0109d$var$p(161));
            }
        } catch (k) {
            $438042a7fad0109d$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $438042a7fad0109d$var$ik(a, b, c) {
    $438042a7fad0109d$var$V = a;
    $438042a7fad0109d$var$jk(a, b, c);
}
function $438042a7fad0109d$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $438042a7fad0109d$var$V;){
        var e = $438042a7fad0109d$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $438042a7fad0109d$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $438042a7fad0109d$var$U;
                h = $438042a7fad0109d$var$Kj;
                var l = $438042a7fad0109d$var$U;
                $438042a7fad0109d$var$Kj = g;
                if (($438042a7fad0109d$var$U = k) && !l) for($438042a7fad0109d$var$V = e; null !== $438042a7fad0109d$var$V;)g = $438042a7fad0109d$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $438042a7fad0109d$var$kk(e) : null !== k ? (k.return = g, $438042a7fad0109d$var$V = k) : $438042a7fad0109d$var$kk(e);
                for(; null !== f;)$438042a7fad0109d$var$V = f, $438042a7fad0109d$var$jk(f, b, c), f = f.sibling;
                $438042a7fad0109d$var$V = e;
                $438042a7fad0109d$var$Kj = h;
                $438042a7fad0109d$var$U = l;
            }
            $438042a7fad0109d$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $438042a7fad0109d$var$V = f) : $438042a7fad0109d$var$lk(a, b, c);
    }
}
function $438042a7fad0109d$var$lk(a) {
    for(; null !== $438042a7fad0109d$var$V;){
        var b = $438042a7fad0109d$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $438042a7fad0109d$var$U || $438042a7fad0109d$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$438042a7fad0109d$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $438042a7fad0109d$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $438042a7fad0109d$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $438042a7fad0109d$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $438042a7fad0109d$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($438042a7fad0109d$var$p(163));
                }
                $438042a7fad0109d$var$U || b.flags & 512 && $438042a7fad0109d$var$Sj(b);
            } catch (r) {
                $438042a7fad0109d$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $438042a7fad0109d$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $438042a7fad0109d$var$V = c;
            break;
        }
        $438042a7fad0109d$var$V = b.return;
    }
}
function $438042a7fad0109d$var$hk(a) {
    for(; null !== $438042a7fad0109d$var$V;){
        var b = $438042a7fad0109d$var$V;
        if (b === a) {
            $438042a7fad0109d$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $438042a7fad0109d$var$V = c;
            break;
        }
        $438042a7fad0109d$var$V = b.return;
    }
}
function $438042a7fad0109d$var$kk(a) {
    for(; null !== $438042a7fad0109d$var$V;){
        var b = $438042a7fad0109d$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $438042a7fad0109d$var$Rj(4, b);
                    } catch (k) {
                        $438042a7fad0109d$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $438042a7fad0109d$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $438042a7fad0109d$var$Sj(b);
                    } catch (k) {
                        $438042a7fad0109d$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $438042a7fad0109d$var$Sj(b);
                    } catch (k) {
                        $438042a7fad0109d$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $438042a7fad0109d$var$W(b, b.return, k);
        }
        if (b === a) {
            $438042a7fad0109d$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $438042a7fad0109d$var$V = h;
            break;
        }
        $438042a7fad0109d$var$V = b.return;
    }
}
var $438042a7fad0109d$var$mk = Math.ceil, $438042a7fad0109d$var$nk = $438042a7fad0109d$var$ua.ReactCurrentDispatcher, $438042a7fad0109d$var$ok = $438042a7fad0109d$var$ua.ReactCurrentOwner, $438042a7fad0109d$var$pk = $438042a7fad0109d$var$ua.ReactCurrentBatchConfig, $438042a7fad0109d$var$K = 0, $438042a7fad0109d$var$R = null, $438042a7fad0109d$var$Y = null, $438042a7fad0109d$var$Z = 0, $438042a7fad0109d$var$gj = 0, $438042a7fad0109d$var$fj = $438042a7fad0109d$var$Uf(0), $438042a7fad0109d$var$T = 0, $438042a7fad0109d$var$qk = null, $438042a7fad0109d$var$hh = 0, $438042a7fad0109d$var$rk = 0, $438042a7fad0109d$var$sk = 0, $438042a7fad0109d$var$tk = null, $438042a7fad0109d$var$uk = null, $438042a7fad0109d$var$gk = 0, $438042a7fad0109d$var$Hj = Infinity, $438042a7fad0109d$var$vk = null, $438042a7fad0109d$var$Pi = !1, $438042a7fad0109d$var$Qi = null, $438042a7fad0109d$var$Si = null, $438042a7fad0109d$var$wk = !1, $438042a7fad0109d$var$xk = null, $438042a7fad0109d$var$yk = 0, $438042a7fad0109d$var$zk = 0, $438042a7fad0109d$var$Ak = null, $438042a7fad0109d$var$Bk = -1, $438042a7fad0109d$var$Ck = 0;
function $438042a7fad0109d$var$L() {
    return 0 !== ($438042a7fad0109d$var$K & 6) ? $438042a7fad0109d$var$B() : -1 !== $438042a7fad0109d$var$Bk ? $438042a7fad0109d$var$Bk : $438042a7fad0109d$var$Bk = $438042a7fad0109d$var$B();
}
function $438042a7fad0109d$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($438042a7fad0109d$var$K & 2) && 0 !== $438042a7fad0109d$var$Z) return $438042a7fad0109d$var$Z & -$438042a7fad0109d$var$Z;
    if (null !== $438042a7fad0109d$var$Kg.transition) return 0 === $438042a7fad0109d$var$Ck && ($438042a7fad0109d$var$Ck = $438042a7fad0109d$var$yc()), $438042a7fad0109d$var$Ck;
    a = $438042a7fad0109d$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $438042a7fad0109d$var$jd(a.type);
    return a;
}
function $438042a7fad0109d$var$mh(a, b, c, d) {
    if (50 < $438042a7fad0109d$var$zk) throw $438042a7fad0109d$var$zk = 0, $438042a7fad0109d$var$Ak = null, Error($438042a7fad0109d$var$p(185));
    $438042a7fad0109d$var$Ac(a, c, d);
    if (0 === ($438042a7fad0109d$var$K & 2) || a !== $438042a7fad0109d$var$R) a === $438042a7fad0109d$var$R && (0 === ($438042a7fad0109d$var$K & 2) && ($438042a7fad0109d$var$rk |= c), 4 === $438042a7fad0109d$var$T && $438042a7fad0109d$var$Dk(a, $438042a7fad0109d$var$Z)), $438042a7fad0109d$var$Ek(a, d), 1 === c && 0 === $438042a7fad0109d$var$K && 0 === (b.mode & 1) && ($438042a7fad0109d$var$Hj = $438042a7fad0109d$var$B() + 500, $438042a7fad0109d$var$fg && $438042a7fad0109d$var$jg());
}
function $438042a7fad0109d$var$Ek(a, b) {
    var c = a.callbackNode;
    $438042a7fad0109d$var$wc(a, b);
    var d = $438042a7fad0109d$var$uc(a, a === $438042a7fad0109d$var$R ? $438042a7fad0109d$var$Z : 0);
    if (0 === d) null !== c && $438042a7fad0109d$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $438042a7fad0109d$var$bc(c);
        if (1 === b) 0 === a.tag ? $438042a7fad0109d$var$ig($438042a7fad0109d$var$Fk.bind(null, a)) : $438042a7fad0109d$var$hg($438042a7fad0109d$var$Fk.bind(null, a)), $438042a7fad0109d$var$Jf(function() {
            0 === ($438042a7fad0109d$var$K & 6) && $438042a7fad0109d$var$jg();
        }), c = null;
        else {
            switch($438042a7fad0109d$var$Dc(d)){
                case 1:
                    c = $438042a7fad0109d$var$fc;
                    break;
                case 4:
                    c = $438042a7fad0109d$var$gc;
                    break;
                case 16:
                    c = $438042a7fad0109d$var$hc;
                    break;
                case 536870912:
                    c = $438042a7fad0109d$var$jc;
                    break;
                default:
                    c = $438042a7fad0109d$var$hc;
            }
            c = $438042a7fad0109d$var$Gk(c, $438042a7fad0109d$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $438042a7fad0109d$var$Hk(a, b) {
    $438042a7fad0109d$var$Bk = -1;
    $438042a7fad0109d$var$Ck = 0;
    if (0 !== ($438042a7fad0109d$var$K & 6)) throw Error($438042a7fad0109d$var$p(327));
    var c = a.callbackNode;
    if ($438042a7fad0109d$var$Ik() && a.callbackNode !== c) return null;
    var d = $438042a7fad0109d$var$uc(a, a === $438042a7fad0109d$var$R ? $438042a7fad0109d$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $438042a7fad0109d$var$Jk(a, d);
    else {
        b = d;
        var e = $438042a7fad0109d$var$K;
        $438042a7fad0109d$var$K |= 2;
        var f = $438042a7fad0109d$var$Kk();
        if ($438042a7fad0109d$var$R !== a || $438042a7fad0109d$var$Z !== b) $438042a7fad0109d$var$vk = null, $438042a7fad0109d$var$Hj = $438042a7fad0109d$var$B() + 500, $438042a7fad0109d$var$Lk(a, b);
        for(;;)try {
            $438042a7fad0109d$var$Mk();
            break;
        } catch (h) {
            $438042a7fad0109d$var$Nk(a, h);
        }
        $438042a7fad0109d$var$Qg();
        $438042a7fad0109d$var$nk.current = f;
        $438042a7fad0109d$var$K = e;
        null !== $438042a7fad0109d$var$Y ? b = 0 : ($438042a7fad0109d$var$R = null, $438042a7fad0109d$var$Z = 0, b = $438042a7fad0109d$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $438042a7fad0109d$var$xc(a), 0 !== e && (d = e, b = $438042a7fad0109d$var$Ok(a, e)));
        if (1 === b) throw c = $438042a7fad0109d$var$qk, $438042a7fad0109d$var$Lk(a, 0), $438042a7fad0109d$var$Dk(a, d), $438042a7fad0109d$var$Ek(a, $438042a7fad0109d$var$B()), c;
        if (6 === b) $438042a7fad0109d$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$438042a7fad0109d$var$Pk(e) && (b = $438042a7fad0109d$var$Jk(a, d), 2 === b && (f = $438042a7fad0109d$var$xc(a), 0 !== f && (d = f, b = $438042a7fad0109d$var$Ok(a, f))), 1 === b)) throw c = $438042a7fad0109d$var$qk, $438042a7fad0109d$var$Lk(a, 0), $438042a7fad0109d$var$Dk(a, d), $438042a7fad0109d$var$Ek(a, $438042a7fad0109d$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($438042a7fad0109d$var$p(345));
                case 2:
                    $438042a7fad0109d$var$Qk(a, $438042a7fad0109d$var$uk, $438042a7fad0109d$var$vk);
                    break;
                case 3:
                    $438042a7fad0109d$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $438042a7fad0109d$var$gk + 500 - $438042a7fad0109d$var$B(), 10 < b)) {
                        if (0 !== $438042a7fad0109d$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $438042a7fad0109d$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $438042a7fad0109d$var$Ff($438042a7fad0109d$var$Qk.bind(null, a, $438042a7fad0109d$var$uk, $438042a7fad0109d$var$vk), b);
                        break;
                    }
                    $438042a7fad0109d$var$Qk(a, $438042a7fad0109d$var$uk, $438042a7fad0109d$var$vk);
                    break;
                case 4:
                    $438042a7fad0109d$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $438042a7fad0109d$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $438042a7fad0109d$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $438042a7fad0109d$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $438042a7fad0109d$var$Ff($438042a7fad0109d$var$Qk.bind(null, a, $438042a7fad0109d$var$uk, $438042a7fad0109d$var$vk), d);
                        break;
                    }
                    $438042a7fad0109d$var$Qk(a, $438042a7fad0109d$var$uk, $438042a7fad0109d$var$vk);
                    break;
                case 5:
                    $438042a7fad0109d$var$Qk(a, $438042a7fad0109d$var$uk, $438042a7fad0109d$var$vk);
                    break;
                default:
                    throw Error($438042a7fad0109d$var$p(329));
            }
        }
    }
    $438042a7fad0109d$var$Ek(a, $438042a7fad0109d$var$B());
    return a.callbackNode === c ? $438042a7fad0109d$var$Hk.bind(null, a) : null;
}
function $438042a7fad0109d$var$Ok(a, b) {
    var c = $438042a7fad0109d$var$tk;
    a.current.memoizedState.isDehydrated && ($438042a7fad0109d$var$Lk(a, b).flags |= 256);
    a = $438042a7fad0109d$var$Jk(a, b);
    2 !== a && (b = $438042a7fad0109d$var$uk, $438042a7fad0109d$var$uk = c, null !== b && $438042a7fad0109d$var$Gj(b));
    return a;
}
function $438042a7fad0109d$var$Gj(a) {
    null === $438042a7fad0109d$var$uk ? $438042a7fad0109d$var$uk = a : $438042a7fad0109d$var$uk.push.apply($438042a7fad0109d$var$uk, a);
}
function $438042a7fad0109d$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$438042a7fad0109d$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $438042a7fad0109d$var$Dk(a, b) {
    b &= ~$438042a7fad0109d$var$sk;
    b &= ~$438042a7fad0109d$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $438042a7fad0109d$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $438042a7fad0109d$var$Fk(a) {
    if (0 !== ($438042a7fad0109d$var$K & 6)) throw Error($438042a7fad0109d$var$p(327));
    $438042a7fad0109d$var$Ik();
    var b = $438042a7fad0109d$var$uc(a, 0);
    if (0 === (b & 1)) return $438042a7fad0109d$var$Ek(a, $438042a7fad0109d$var$B()), null;
    var c = $438042a7fad0109d$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $438042a7fad0109d$var$xc(a);
        0 !== d && (b = d, c = $438042a7fad0109d$var$Ok(a, d));
    }
    if (1 === c) throw c = $438042a7fad0109d$var$qk, $438042a7fad0109d$var$Lk(a, 0), $438042a7fad0109d$var$Dk(a, b), $438042a7fad0109d$var$Ek(a, $438042a7fad0109d$var$B()), c;
    if (6 === c) throw Error($438042a7fad0109d$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $438042a7fad0109d$var$Qk(a, $438042a7fad0109d$var$uk, $438042a7fad0109d$var$vk);
    $438042a7fad0109d$var$Ek(a, $438042a7fad0109d$var$B());
    return null;
}
function $438042a7fad0109d$var$Rk(a, b) {
    var c = $438042a7fad0109d$var$K;
    $438042a7fad0109d$var$K |= 1;
    try {
        return a(b);
    } finally{
        $438042a7fad0109d$var$K = c, 0 === $438042a7fad0109d$var$K && ($438042a7fad0109d$var$Hj = $438042a7fad0109d$var$B() + 500, $438042a7fad0109d$var$fg && $438042a7fad0109d$var$jg());
    }
}
function $438042a7fad0109d$var$Sk(a) {
    null !== $438042a7fad0109d$var$xk && 0 === $438042a7fad0109d$var$xk.tag && 0 === ($438042a7fad0109d$var$K & 6) && $438042a7fad0109d$var$Ik();
    var b = $438042a7fad0109d$var$K;
    $438042a7fad0109d$var$K |= 1;
    var c = $438042a7fad0109d$var$pk.transition, d = $438042a7fad0109d$var$C;
    try {
        if ($438042a7fad0109d$var$pk.transition = null, $438042a7fad0109d$var$C = 1, a) return a();
    } finally{
        $438042a7fad0109d$var$C = d, $438042a7fad0109d$var$pk.transition = c, $438042a7fad0109d$var$K = b, 0 === ($438042a7fad0109d$var$K & 6) && $438042a7fad0109d$var$jg();
    }
}
function $438042a7fad0109d$var$Ij() {
    $438042a7fad0109d$var$gj = $438042a7fad0109d$var$fj.current;
    $438042a7fad0109d$var$E($438042a7fad0109d$var$fj);
}
function $438042a7fad0109d$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $438042a7fad0109d$var$Gf(c));
    if (null !== $438042a7fad0109d$var$Y) for(c = $438042a7fad0109d$var$Y.return; null !== c;){
        var d = c;
        $438042a7fad0109d$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $438042a7fad0109d$var$$f();
                break;
            case 3:
                $438042a7fad0109d$var$Jh();
                $438042a7fad0109d$var$E($438042a7fad0109d$var$Wf);
                $438042a7fad0109d$var$E($438042a7fad0109d$var$H);
                $438042a7fad0109d$var$Oh();
                break;
            case 5:
                $438042a7fad0109d$var$Lh(d);
                break;
            case 4:
                $438042a7fad0109d$var$Jh();
                break;
            case 13:
                $438042a7fad0109d$var$E($438042a7fad0109d$var$M);
                break;
            case 19:
                $438042a7fad0109d$var$E($438042a7fad0109d$var$M);
                break;
            case 10:
                $438042a7fad0109d$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $438042a7fad0109d$var$Ij();
        }
        c = c.return;
    }
    $438042a7fad0109d$var$R = a;
    $438042a7fad0109d$var$Y = a = $438042a7fad0109d$var$wh(a.current, null);
    $438042a7fad0109d$var$Z = $438042a7fad0109d$var$gj = b;
    $438042a7fad0109d$var$T = 0;
    $438042a7fad0109d$var$qk = null;
    $438042a7fad0109d$var$sk = $438042a7fad0109d$var$rk = $438042a7fad0109d$var$hh = 0;
    $438042a7fad0109d$var$uk = $438042a7fad0109d$var$tk = null;
    if (null !== $438042a7fad0109d$var$Wg) {
        for(b = 0; b < $438042a7fad0109d$var$Wg.length; b++)if (c = $438042a7fad0109d$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $438042a7fad0109d$var$Wg = null;
    }
    return a;
}
function $438042a7fad0109d$var$Nk(a, b) {
    do {
        var c = $438042a7fad0109d$var$Y;
        try {
            $438042a7fad0109d$var$Qg();
            $438042a7fad0109d$var$Ph.current = $438042a7fad0109d$var$ai;
            if ($438042a7fad0109d$var$Sh) {
                for(var d = $438042a7fad0109d$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $438042a7fad0109d$var$Sh = !1;
            }
            $438042a7fad0109d$var$Rh = 0;
            $438042a7fad0109d$var$P = $438042a7fad0109d$var$O = $438042a7fad0109d$var$N = null;
            $438042a7fad0109d$var$Th = !1;
            $438042a7fad0109d$var$Uh = 0;
            $438042a7fad0109d$var$ok.current = null;
            if (null === c || null === c.return) {
                $438042a7fad0109d$var$T = 1;
                $438042a7fad0109d$var$qk = b;
                $438042a7fad0109d$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $438042a7fad0109d$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $438042a7fad0109d$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $438042a7fad0109d$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $438042a7fad0109d$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $438042a7fad0109d$var$Ti(f, l, b);
                            $438042a7fad0109d$var$uj();
                            break a;
                        }
                        k = Error($438042a7fad0109d$var$p(426));
                    }
                } else if ($438042a7fad0109d$var$I && h.mode & 1) {
                    var J = $438042a7fad0109d$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $438042a7fad0109d$var$Wi(J, g, h, f, b);
                        $438042a7fad0109d$var$Jg($438042a7fad0109d$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $438042a7fad0109d$var$Ki(k, h);
                4 !== $438042a7fad0109d$var$T && ($438042a7fad0109d$var$T = 2);
                null === $438042a7fad0109d$var$tk ? $438042a7fad0109d$var$tk = [
                    f
                ] : $438042a7fad0109d$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $438042a7fad0109d$var$Oi(f, k, b);
                            $438042a7fad0109d$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $438042a7fad0109d$var$Si || !$438042a7fad0109d$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $438042a7fad0109d$var$Ri(f, h, b);
                                $438042a7fad0109d$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $438042a7fad0109d$var$Tk(c);
        } catch (na) {
            b = na;
            $438042a7fad0109d$var$Y === c && null !== c && ($438042a7fad0109d$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $438042a7fad0109d$var$Kk() {
    var a = $438042a7fad0109d$var$nk.current;
    $438042a7fad0109d$var$nk.current = $438042a7fad0109d$var$ai;
    return null === a ? $438042a7fad0109d$var$ai : a;
}
function $438042a7fad0109d$var$uj() {
    if (0 === $438042a7fad0109d$var$T || 3 === $438042a7fad0109d$var$T || 2 === $438042a7fad0109d$var$T) $438042a7fad0109d$var$T = 4;
    null === $438042a7fad0109d$var$R || 0 === ($438042a7fad0109d$var$hh & 268435455) && 0 === ($438042a7fad0109d$var$rk & 268435455) || $438042a7fad0109d$var$Dk($438042a7fad0109d$var$R, $438042a7fad0109d$var$Z);
}
function $438042a7fad0109d$var$Jk(a, b) {
    var c = $438042a7fad0109d$var$K;
    $438042a7fad0109d$var$K |= 2;
    var d = $438042a7fad0109d$var$Kk();
    if ($438042a7fad0109d$var$R !== a || $438042a7fad0109d$var$Z !== b) $438042a7fad0109d$var$vk = null, $438042a7fad0109d$var$Lk(a, b);
    for(;;)try {
        $438042a7fad0109d$var$Uk();
        break;
    } catch (e) {
        $438042a7fad0109d$var$Nk(a, e);
    }
    $438042a7fad0109d$var$Qg();
    $438042a7fad0109d$var$K = c;
    $438042a7fad0109d$var$nk.current = d;
    if (null !== $438042a7fad0109d$var$Y) throw Error($438042a7fad0109d$var$p(261));
    $438042a7fad0109d$var$R = null;
    $438042a7fad0109d$var$Z = 0;
    return $438042a7fad0109d$var$T;
}
function $438042a7fad0109d$var$Uk() {
    for(; null !== $438042a7fad0109d$var$Y;)$438042a7fad0109d$var$Vk($438042a7fad0109d$var$Y);
}
function $438042a7fad0109d$var$Mk() {
    for(; null !== $438042a7fad0109d$var$Y && !$438042a7fad0109d$var$cc();)$438042a7fad0109d$var$Vk($438042a7fad0109d$var$Y);
}
function $438042a7fad0109d$var$Vk(a) {
    var b = $438042a7fad0109d$var$Wk(a.alternate, a, $438042a7fad0109d$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $438042a7fad0109d$var$Tk(a) : $438042a7fad0109d$var$Y = b;
    $438042a7fad0109d$var$ok.current = null;
}
function $438042a7fad0109d$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $438042a7fad0109d$var$Fj(c, b, $438042a7fad0109d$var$gj), null !== c) {
                $438042a7fad0109d$var$Y = c;
                return;
            }
        } else {
            c = $438042a7fad0109d$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $438042a7fad0109d$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $438042a7fad0109d$var$T = 6;
                $438042a7fad0109d$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $438042a7fad0109d$var$Y = b;
            return;
        }
        $438042a7fad0109d$var$Y = b = a;
    }while (null !== b);
    0 === $438042a7fad0109d$var$T && ($438042a7fad0109d$var$T = 5);
}
function $438042a7fad0109d$var$Qk(a, b, c) {
    var d = $438042a7fad0109d$var$C, e = $438042a7fad0109d$var$pk.transition;
    try {
        $438042a7fad0109d$var$pk.transition = null, $438042a7fad0109d$var$C = 1, $438042a7fad0109d$var$Xk(a, b, c, d);
    } finally{
        $438042a7fad0109d$var$pk.transition = e, $438042a7fad0109d$var$C = d;
    }
    return null;
}
function $438042a7fad0109d$var$Xk(a, b, c, d) {
    do $438042a7fad0109d$var$Ik();
    while (null !== $438042a7fad0109d$var$xk);
    if (0 !== ($438042a7fad0109d$var$K & 6)) throw Error($438042a7fad0109d$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($438042a7fad0109d$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $438042a7fad0109d$var$Bc(a, f);
    a === $438042a7fad0109d$var$R && ($438042a7fad0109d$var$Y = $438042a7fad0109d$var$R = null, $438042a7fad0109d$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $438042a7fad0109d$var$wk || ($438042a7fad0109d$var$wk = !0, $438042a7fad0109d$var$Gk($438042a7fad0109d$var$hc, function() {
        $438042a7fad0109d$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $438042a7fad0109d$var$pk.transition;
        $438042a7fad0109d$var$pk.transition = null;
        var g = $438042a7fad0109d$var$C;
        $438042a7fad0109d$var$C = 1;
        var h = $438042a7fad0109d$var$K;
        $438042a7fad0109d$var$K |= 4;
        $438042a7fad0109d$var$ok.current = null;
        $438042a7fad0109d$var$Pj(a, c);
        $438042a7fad0109d$var$ek(c, a);
        $438042a7fad0109d$var$Oe($438042a7fad0109d$var$Df);
        $438042a7fad0109d$var$dd = !!$438042a7fad0109d$var$Cf;
        $438042a7fad0109d$var$Df = $438042a7fad0109d$var$Cf = null;
        a.current = c;
        $438042a7fad0109d$var$ik(c, a, e);
        $438042a7fad0109d$var$dc();
        $438042a7fad0109d$var$K = h;
        $438042a7fad0109d$var$C = g;
        $438042a7fad0109d$var$pk.transition = f;
    } else a.current = c;
    $438042a7fad0109d$var$wk && ($438042a7fad0109d$var$wk = !1, $438042a7fad0109d$var$xk = a, $438042a7fad0109d$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($438042a7fad0109d$var$Si = null);
    $438042a7fad0109d$var$mc(c.stateNode, d);
    $438042a7fad0109d$var$Ek(a, $438042a7fad0109d$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($438042a7fad0109d$var$Pi) throw $438042a7fad0109d$var$Pi = !1, a = $438042a7fad0109d$var$Qi, $438042a7fad0109d$var$Qi = null, a;
    0 !== ($438042a7fad0109d$var$yk & 1) && 0 !== a.tag && $438042a7fad0109d$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $438042a7fad0109d$var$Ak ? $438042a7fad0109d$var$zk++ : ($438042a7fad0109d$var$zk = 0, $438042a7fad0109d$var$Ak = a) : $438042a7fad0109d$var$zk = 0;
    $438042a7fad0109d$var$jg();
    return null;
}
function $438042a7fad0109d$var$Ik() {
    if (null !== $438042a7fad0109d$var$xk) {
        var a = $438042a7fad0109d$var$Dc($438042a7fad0109d$var$yk), b = $438042a7fad0109d$var$pk.transition, c = $438042a7fad0109d$var$C;
        try {
            $438042a7fad0109d$var$pk.transition = null;
            $438042a7fad0109d$var$C = 16 > a ? 16 : a;
            if (null === $438042a7fad0109d$var$xk) var d = !1;
            else {
                a = $438042a7fad0109d$var$xk;
                $438042a7fad0109d$var$xk = null;
                $438042a7fad0109d$var$yk = 0;
                if (0 !== ($438042a7fad0109d$var$K & 6)) throw Error($438042a7fad0109d$var$p(331));
                var e = $438042a7fad0109d$var$K;
                $438042a7fad0109d$var$K |= 4;
                for($438042a7fad0109d$var$V = a.current; null !== $438042a7fad0109d$var$V;){
                    var f = $438042a7fad0109d$var$V, g = f.child;
                    if (0 !== ($438042a7fad0109d$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($438042a7fad0109d$var$V = l; null !== $438042a7fad0109d$var$V;){
                                    var m = $438042a7fad0109d$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $438042a7fad0109d$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $438042a7fad0109d$var$V = q;
                                    else for(; null !== $438042a7fad0109d$var$V;){
                                        m = $438042a7fad0109d$var$V;
                                        var r = m.sibling, y = m.return;
                                        $438042a7fad0109d$var$Tj(m);
                                        if (m === l) {
                                            $438042a7fad0109d$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $438042a7fad0109d$var$V = r;
                                            break;
                                        }
                                        $438042a7fad0109d$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $438042a7fad0109d$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $438042a7fad0109d$var$V = g;
                    else b: for(; null !== $438042a7fad0109d$var$V;){
                        f = $438042a7fad0109d$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $438042a7fad0109d$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $438042a7fad0109d$var$V = x;
                            break b;
                        }
                        $438042a7fad0109d$var$V = f.return;
                    }
                }
                var w = a.current;
                for($438042a7fad0109d$var$V = w; null !== $438042a7fad0109d$var$V;){
                    g = $438042a7fad0109d$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $438042a7fad0109d$var$V = u;
                    else b: for(g = w; null !== $438042a7fad0109d$var$V;){
                        h = $438042a7fad0109d$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $438042a7fad0109d$var$Rj(9, h);
                            }
                        } catch (na) {
                            $438042a7fad0109d$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $438042a7fad0109d$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $438042a7fad0109d$var$V = F;
                            break b;
                        }
                        $438042a7fad0109d$var$V = h.return;
                    }
                }
                $438042a7fad0109d$var$K = e;
                $438042a7fad0109d$var$jg();
                if ($438042a7fad0109d$var$lc && "function" === typeof $438042a7fad0109d$var$lc.onPostCommitFiberRoot) try {
                    $438042a7fad0109d$var$lc.onPostCommitFiberRoot($438042a7fad0109d$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $438042a7fad0109d$var$C = c, $438042a7fad0109d$var$pk.transition = b;
        }
    }
    return !1;
}
function $438042a7fad0109d$var$Yk(a, b, c) {
    b = $438042a7fad0109d$var$Ki(c, b);
    b = $438042a7fad0109d$var$Oi(a, b, 1);
    a = $438042a7fad0109d$var$dh(a, b, 1);
    b = $438042a7fad0109d$var$L();
    null !== a && ($438042a7fad0109d$var$Ac(a, 1, b), $438042a7fad0109d$var$Ek(a, b));
}
function $438042a7fad0109d$var$W(a, b, c) {
    if (3 === a.tag) $438042a7fad0109d$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $438042a7fad0109d$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $438042a7fad0109d$var$Si || !$438042a7fad0109d$var$Si.has(d))) {
                a = $438042a7fad0109d$var$Ki(c, a);
                a = $438042a7fad0109d$var$Ri(b, a, 1);
                b = $438042a7fad0109d$var$dh(b, a, 1);
                a = $438042a7fad0109d$var$L();
                null !== b && ($438042a7fad0109d$var$Ac(b, 1, a), $438042a7fad0109d$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $438042a7fad0109d$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $438042a7fad0109d$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $438042a7fad0109d$var$R === a && ($438042a7fad0109d$var$Z & c) === c && (4 === $438042a7fad0109d$var$T || 3 === $438042a7fad0109d$var$T && ($438042a7fad0109d$var$Z & 130023424) === $438042a7fad0109d$var$Z && 500 > $438042a7fad0109d$var$B() - $438042a7fad0109d$var$gk ? $438042a7fad0109d$var$Lk(a, 0) : $438042a7fad0109d$var$sk |= c);
    $438042a7fad0109d$var$Ek(a, b);
}
function $438042a7fad0109d$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $438042a7fad0109d$var$sc, $438042a7fad0109d$var$sc <<= 1, 0 === ($438042a7fad0109d$var$sc & 130023424) && ($438042a7fad0109d$var$sc = 4194304)));
    var c = $438042a7fad0109d$var$L();
    a = $438042a7fad0109d$var$Zg(a, b);
    null !== a && ($438042a7fad0109d$var$Ac(a, b, c), $438042a7fad0109d$var$Ek(a, c));
}
function $438042a7fad0109d$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $438042a7fad0109d$var$Zk(a, c);
}
function $438042a7fad0109d$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($438042a7fad0109d$var$p(314));
    }
    null !== d && d.delete(b);
    $438042a7fad0109d$var$Zk(a, c);
}
var $438042a7fad0109d$var$Wk;
$438042a7fad0109d$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $438042a7fad0109d$var$Wf.current) $438042a7fad0109d$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $438042a7fad0109d$var$Ug = !1, $438042a7fad0109d$var$zj(a, b, c);
            $438042a7fad0109d$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $438042a7fad0109d$var$Ug = !1, $438042a7fad0109d$var$I && 0 !== (b.flags & 1048576) && $438042a7fad0109d$var$ug(b, $438042a7fad0109d$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $438042a7fad0109d$var$jj(a, b);
            a = b.pendingProps;
            var e = $438042a7fad0109d$var$Yf(b, $438042a7fad0109d$var$H.current);
            $438042a7fad0109d$var$Tg(b, c);
            e = $438042a7fad0109d$var$Xh(null, b, d, a, e, c);
            var f = $438042a7fad0109d$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $438042a7fad0109d$var$Zf(d) ? (f = !0, $438042a7fad0109d$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $438042a7fad0109d$var$ah(b), e.updater = $438042a7fad0109d$var$nh, b.stateNode = e, e._reactInternals = b, $438042a7fad0109d$var$rh(b, d, a, c), b = $438042a7fad0109d$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $438042a7fad0109d$var$I && f && $438042a7fad0109d$var$vg(b), $438042a7fad0109d$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $438042a7fad0109d$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $438042a7fad0109d$var$$k(d);
                a = $438042a7fad0109d$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $438042a7fad0109d$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $438042a7fad0109d$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $438042a7fad0109d$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $438042a7fad0109d$var$aj(null, b, d, $438042a7fad0109d$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($438042a7fad0109d$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $438042a7fad0109d$var$Lg(d, e), $438042a7fad0109d$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $438042a7fad0109d$var$Lg(d, e), $438042a7fad0109d$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $438042a7fad0109d$var$lj(b);
                if (null === a) throw Error($438042a7fad0109d$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $438042a7fad0109d$var$bh(a, b);
                $438042a7fad0109d$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $438042a7fad0109d$var$Ki(Error($438042a7fad0109d$var$p(423)), b);
                        b = $438042a7fad0109d$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $438042a7fad0109d$var$Ki(Error($438042a7fad0109d$var$p(424)), b);
                        b = $438042a7fad0109d$var$mj(a, b, d, c, e);
                        break a;
                    } else for($438042a7fad0109d$var$yg = $438042a7fad0109d$var$Lf(b.stateNode.containerInfo.firstChild), $438042a7fad0109d$var$xg = b, $438042a7fad0109d$var$I = !0, $438042a7fad0109d$var$zg = null, c = $438042a7fad0109d$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $438042a7fad0109d$var$Ig();
                    if (d === e) {
                        b = $438042a7fad0109d$var$$i(a, b, c);
                        break a;
                    }
                    $438042a7fad0109d$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $438042a7fad0109d$var$Kh(b), null === a && $438042a7fad0109d$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $438042a7fad0109d$var$Ef(d, e) ? g = null : null !== f && $438042a7fad0109d$var$Ef(d, f) && (b.flags |= 32), $438042a7fad0109d$var$hj(a, b), $438042a7fad0109d$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $438042a7fad0109d$var$Eg(b), null;
        case 13:
            return $438042a7fad0109d$var$pj(a, b, c);
        case 4:
            return $438042a7fad0109d$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $438042a7fad0109d$var$Bh(b, null, d, c) : $438042a7fad0109d$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $438042a7fad0109d$var$Lg(d, e), $438042a7fad0109d$var$Zi(a, b, d, e, c);
        case 7:
            return $438042a7fad0109d$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $438042a7fad0109d$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $438042a7fad0109d$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $438042a7fad0109d$var$G($438042a7fad0109d$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($438042a7fad0109d$var$He(f.value, g)) {
                        if (f.children === e.children && !$438042a7fad0109d$var$Wf.current) {
                            b = $438042a7fad0109d$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $438042a7fad0109d$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $438042a7fad0109d$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($438042a7fad0109d$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $438042a7fad0109d$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $438042a7fad0109d$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $438042a7fad0109d$var$Tg(b, c), e = $438042a7fad0109d$var$Vg(e), d = d(e), b.flags |= 1, $438042a7fad0109d$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $438042a7fad0109d$var$Lg(d, b.pendingProps), e = $438042a7fad0109d$var$Lg(d.type, e), $438042a7fad0109d$var$aj(a, b, d, e, c);
        case 15:
            return $438042a7fad0109d$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $438042a7fad0109d$var$Lg(d, e), $438042a7fad0109d$var$jj(a, b), b.tag = 1, $438042a7fad0109d$var$Zf(d) ? (a = !0, $438042a7fad0109d$var$cg(b)) : a = !1, $438042a7fad0109d$var$Tg(b, c), $438042a7fad0109d$var$ph(b, d, e), $438042a7fad0109d$var$rh(b, d, e, c), $438042a7fad0109d$var$kj(null, b, d, !0, a, c);
        case 19:
            return $438042a7fad0109d$var$yj(a, b, c);
        case 22:
            return $438042a7fad0109d$var$ej(a, b, c);
    }
    throw Error($438042a7fad0109d$var$p(156, b.tag));
};
function $438042a7fad0109d$var$Gk(a, b) {
    return $438042a7fad0109d$var$ac(a, b);
}
function $438042a7fad0109d$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $438042a7fad0109d$var$Bg(a, b, c, d) {
    return new $438042a7fad0109d$var$al(a, b, c, d);
}
function $438042a7fad0109d$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $438042a7fad0109d$var$$k(a) {
    if ("function" === typeof a) return $438042a7fad0109d$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $438042a7fad0109d$var$Da) return 11;
        if (a === $438042a7fad0109d$var$Ga) return 14;
    }
    return 2;
}
function $438042a7fad0109d$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $438042a7fad0109d$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $438042a7fad0109d$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $438042a7fad0109d$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $438042a7fad0109d$var$ya:
            return $438042a7fad0109d$var$Ah(c.children, e, f, b);
        case $438042a7fad0109d$var$za:
            g = 8;
            e |= 8;
            break;
        case $438042a7fad0109d$var$Aa:
            return a = $438042a7fad0109d$var$Bg(12, c, b, e | 2), a.elementType = $438042a7fad0109d$var$Aa, a.lanes = f, a;
        case $438042a7fad0109d$var$Ea:
            return a = $438042a7fad0109d$var$Bg(13, c, b, e), a.elementType = $438042a7fad0109d$var$Ea, a.lanes = f, a;
        case $438042a7fad0109d$var$Fa:
            return a = $438042a7fad0109d$var$Bg(19, c, b, e), a.elementType = $438042a7fad0109d$var$Fa, a.lanes = f, a;
        case $438042a7fad0109d$var$Ia:
            return $438042a7fad0109d$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $438042a7fad0109d$var$Ba:
                    g = 10;
                    break a;
                case $438042a7fad0109d$var$Ca:
                    g = 9;
                    break a;
                case $438042a7fad0109d$var$Da:
                    g = 11;
                    break a;
                case $438042a7fad0109d$var$Ga:
                    g = 14;
                    break a;
                case $438042a7fad0109d$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($438042a7fad0109d$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $438042a7fad0109d$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $438042a7fad0109d$var$Ah(a, b, c, d) {
    a = $438042a7fad0109d$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $438042a7fad0109d$var$qj(a, b, c, d) {
    a = $438042a7fad0109d$var$Bg(22, a, d, b);
    a.elementType = $438042a7fad0109d$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $438042a7fad0109d$var$xh(a, b, c) {
    a = $438042a7fad0109d$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $438042a7fad0109d$var$zh(a, b, c) {
    b = $438042a7fad0109d$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $438042a7fad0109d$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $438042a7fad0109d$var$zc(0);
    this.expirationTimes = $438042a7fad0109d$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $438042a7fad0109d$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $438042a7fad0109d$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $438042a7fad0109d$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $438042a7fad0109d$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $438042a7fad0109d$var$ah(f);
    return a;
}
function $438042a7fad0109d$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $438042a7fad0109d$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $438042a7fad0109d$var$el(a) {
    if (!a) return $438042a7fad0109d$var$Vf;
    a = a._reactInternals;
    a: {
        if ($438042a7fad0109d$var$Vb(a) !== a || 1 !== a.tag) throw Error($438042a7fad0109d$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($438042a7fad0109d$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($438042a7fad0109d$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($438042a7fad0109d$var$Zf(c)) return $438042a7fad0109d$var$bg(a, c, b);
    }
    return b;
}
function $438042a7fad0109d$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $438042a7fad0109d$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $438042a7fad0109d$var$el(null);
    c = a.current;
    d = $438042a7fad0109d$var$L();
    e = $438042a7fad0109d$var$lh(c);
    f = $438042a7fad0109d$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $438042a7fad0109d$var$dh(c, f, e);
    a.current.lanes = e;
    $438042a7fad0109d$var$Ac(a, e, d);
    $438042a7fad0109d$var$Ek(a, d);
    return a;
}
function $438042a7fad0109d$var$gl(a, b, c, d) {
    var e = b.current, f = $438042a7fad0109d$var$L(), g = $438042a7fad0109d$var$lh(e);
    c = $438042a7fad0109d$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $438042a7fad0109d$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $438042a7fad0109d$var$dh(e, b, g);
    null !== a && ($438042a7fad0109d$var$mh(a, e, g, f), $438042a7fad0109d$var$eh(a, e, g));
    return g;
}
function $438042a7fad0109d$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $438042a7fad0109d$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $438042a7fad0109d$var$jl(a, b) {
    $438042a7fad0109d$var$il(a, b);
    (a = a.alternate) && $438042a7fad0109d$var$il(a, b);
}
function $438042a7fad0109d$var$kl() {
    return null;
}
var $438042a7fad0109d$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $438042a7fad0109d$var$ml(a) {
    this._internalRoot = a;
}
$438042a7fad0109d$var$nl.prototype.render = $438042a7fad0109d$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($438042a7fad0109d$var$p(409));
    $438042a7fad0109d$var$gl(a, b, null, null);
};
$438042a7fad0109d$var$nl.prototype.unmount = $438042a7fad0109d$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $438042a7fad0109d$var$Sk(function() {
            $438042a7fad0109d$var$gl(null, a, null, null);
        });
        b[$438042a7fad0109d$var$uf] = null;
    }
};
function $438042a7fad0109d$var$nl(a) {
    this._internalRoot = a;
}
$438042a7fad0109d$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $438042a7fad0109d$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $438042a7fad0109d$var$Qc.length && 0 !== b && b < $438042a7fad0109d$var$Qc[c].priority; c++);
        $438042a7fad0109d$var$Qc.splice(c, 0, a);
        0 === c && $438042a7fad0109d$var$Vc(a);
    }
};
function $438042a7fad0109d$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $438042a7fad0109d$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $438042a7fad0109d$var$ql() {}
function $438042a7fad0109d$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $438042a7fad0109d$var$hl(g);
                f.call(a);
            };
        }
        var g = $438042a7fad0109d$var$fl(b, d, a, 0, null, !1, !1, "", $438042a7fad0109d$var$ql);
        a._reactRootContainer = g;
        a[$438042a7fad0109d$var$uf] = g.current;
        $438042a7fad0109d$var$sf(8 === a.nodeType ? a.parentNode : a);
        $438042a7fad0109d$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $438042a7fad0109d$var$hl(k);
            h.call(a);
        };
    }
    var k = $438042a7fad0109d$var$cl(a, 0, !1, null, null, !1, !1, "", $438042a7fad0109d$var$ql);
    a._reactRootContainer = k;
    a[$438042a7fad0109d$var$uf] = k.current;
    $438042a7fad0109d$var$sf(8 === a.nodeType ? a.parentNode : a);
    $438042a7fad0109d$var$Sk(function() {
        $438042a7fad0109d$var$gl(b, k, c, d);
    });
    return k;
}
function $438042a7fad0109d$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $438042a7fad0109d$var$hl(g);
                h.call(a);
            };
        }
        $438042a7fad0109d$var$gl(b, g, a, e);
    } else g = $438042a7fad0109d$var$rl(c, b, a, e, d);
    return $438042a7fad0109d$var$hl(g);
}
$438042a7fad0109d$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $438042a7fad0109d$var$tc(b.pendingLanes);
                0 !== c && ($438042a7fad0109d$var$Cc(b, c | 1), $438042a7fad0109d$var$Ek(b, $438042a7fad0109d$var$B()), 0 === ($438042a7fad0109d$var$K & 6) && ($438042a7fad0109d$var$Hj = $438042a7fad0109d$var$B() + 500, $438042a7fad0109d$var$jg()));
            }
            break;
        case 13:
            $438042a7fad0109d$var$Sk(function() {
                var b = $438042a7fad0109d$var$Zg(a, 1);
                if (null !== b) {
                    var c = $438042a7fad0109d$var$L();
                    $438042a7fad0109d$var$mh(b, a, 1, c);
                }
            }), $438042a7fad0109d$var$jl(a, 1);
    }
};
$438042a7fad0109d$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $438042a7fad0109d$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $438042a7fad0109d$var$L();
            $438042a7fad0109d$var$mh(b, a, 134217728, c);
        }
        $438042a7fad0109d$var$jl(a, 134217728);
    }
};
$438042a7fad0109d$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $438042a7fad0109d$var$lh(a), c = $438042a7fad0109d$var$Zg(a, b);
        if (null !== c) {
            var d = $438042a7fad0109d$var$L();
            $438042a7fad0109d$var$mh(c, a, b, d);
        }
        $438042a7fad0109d$var$jl(a, b);
    }
};
$438042a7fad0109d$var$Hc = function() {
    return $438042a7fad0109d$var$C;
};
$438042a7fad0109d$var$Ic = function(a, b) {
    var c = $438042a7fad0109d$var$C;
    try {
        return $438042a7fad0109d$var$C = a, b();
    } finally{
        $438042a7fad0109d$var$C = c;
    }
};
$438042a7fad0109d$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $438042a7fad0109d$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $438042a7fad0109d$var$Db(d);
                        if (!e) throw Error($438042a7fad0109d$var$p(90));
                        $438042a7fad0109d$var$Wa(d);
                        $438042a7fad0109d$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $438042a7fad0109d$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $438042a7fad0109d$var$fb(a, !!c.multiple, b, !1);
    }
};
$438042a7fad0109d$var$Gb = $438042a7fad0109d$var$Rk;
$438042a7fad0109d$var$Hb = $438042a7fad0109d$var$Sk;
var $438042a7fad0109d$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $438042a7fad0109d$var$Cb,
        $438042a7fad0109d$var$ue,
        $438042a7fad0109d$var$Db,
        $438042a7fad0109d$var$Eb,
        $438042a7fad0109d$var$Fb,
        $438042a7fad0109d$var$Rk
    ]
}, $438042a7fad0109d$var$ul = {
    findFiberByHostInstance: $438042a7fad0109d$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $438042a7fad0109d$var$vl = {
    bundleType: $438042a7fad0109d$var$ul.bundleType,
    version: $438042a7fad0109d$var$ul.version,
    rendererPackageName: $438042a7fad0109d$var$ul.rendererPackageName,
    rendererConfig: $438042a7fad0109d$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $438042a7fad0109d$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $438042a7fad0109d$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $438042a7fad0109d$var$ul.findFiberByHostInstance || $438042a7fad0109d$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $438042a7fad0109d$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$438042a7fad0109d$var$wl.isDisabled && $438042a7fad0109d$var$wl.supportsFiber) try {
        $438042a7fad0109d$var$kc = $438042a7fad0109d$var$wl.inject($438042a7fad0109d$var$vl), $438042a7fad0109d$var$lc = $438042a7fad0109d$var$wl;
    } catch (a) {}
}
$438042a7fad0109d$export$ae55be85d98224ed = $438042a7fad0109d$var$tl;
$438042a7fad0109d$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$438042a7fad0109d$var$ol(b)) throw Error($438042a7fad0109d$var$p(200));
    return $438042a7fad0109d$var$dl(a, b, null, c);
};
$438042a7fad0109d$export$882461b6382ed46c = function(a, b) {
    if (!$438042a7fad0109d$var$ol(a)) throw Error($438042a7fad0109d$var$p(299));
    var c = !1, d = "", e = $438042a7fad0109d$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $438042a7fad0109d$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$438042a7fad0109d$var$uf] = b.current;
    $438042a7fad0109d$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $438042a7fad0109d$var$ml(b);
};
$438042a7fad0109d$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($438042a7fad0109d$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($438042a7fad0109d$var$p(268, a));
    }
    a = $438042a7fad0109d$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$438042a7fad0109d$export$cd75ccfd720a3cd4 = function(a) {
    return $438042a7fad0109d$var$Sk(a);
};
$438042a7fad0109d$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$438042a7fad0109d$var$pl(b)) throw Error($438042a7fad0109d$var$p(200));
    return $438042a7fad0109d$var$sl(null, a, b, !0, c);
};
$438042a7fad0109d$export$757ceba2d55c277e = function(a, b, c) {
    if (!$438042a7fad0109d$var$ol(a)) throw Error($438042a7fad0109d$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $438042a7fad0109d$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $438042a7fad0109d$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$438042a7fad0109d$var$uf] = b.current;
    $438042a7fad0109d$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $438042a7fad0109d$var$nl(b);
};
$438042a7fad0109d$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$438042a7fad0109d$var$pl(b)) throw Error($438042a7fad0109d$var$p(200));
    return $438042a7fad0109d$var$sl(null, a, b, !1, c);
};
$438042a7fad0109d$export$502457920280e6be = function(a) {
    if (!$438042a7fad0109d$var$pl(a)) throw Error($438042a7fad0109d$var$p(40));
    return a._reactRootContainer ? ($438042a7fad0109d$var$Sk(function() {
        $438042a7fad0109d$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$438042a7fad0109d$var$uf] = null;
        });
    }), !0) : !1;
};
$438042a7fad0109d$export$c78a37762a8d58e1 = $438042a7fad0109d$var$Rk;
$438042a7fad0109d$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$438042a7fad0109d$var$pl(c)) throw Error($438042a7fad0109d$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($438042a7fad0109d$var$p(38));
    return $438042a7fad0109d$var$sl(a, b, c, !1, d);
};
$438042a7fad0109d$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("aqdX4", function(module, exports) {
"use strict";

module.exports = (parcelRequire("kDeqk"));

});
parcelRegister("kDeqk", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $f052a3653a89761d$export$c4744153514ff05d; }, function (v) { return $f052a3653a89761d$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $f052a3653a89761d$export$3e506c1ccc9cc1a7; }, function (v) { return $f052a3653a89761d$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $f052a3653a89761d$export$e26fe2ed2fa76875; }, function (v) { return $f052a3653a89761d$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $f052a3653a89761d$export$502329bbf4b505b1; }, function (v) { return $f052a3653a89761d$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $f052a3653a89761d$export$6e3807111c4874c4; }, function (v) { return $f052a3653a89761d$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $f052a3653a89761d$export$c27134553091fb3a; }, function (v) { return $f052a3653a89761d$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $f052a3653a89761d$export$33ee1acdc04fd2a2; }, function (v) { return $f052a3653a89761d$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $f052a3653a89761d$export$b00a404bbd5edef2; }, function (v) { return $f052a3653a89761d$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $f052a3653a89761d$export$8352ce38b91d0c62; }, function (v) { return $f052a3653a89761d$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $f052a3653a89761d$export$d66a1c1c77bd778b; }, function (v) { return $f052a3653a89761d$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $f052a3653a89761d$export$d3dfb8e4810cb555; }, function (v) { return $f052a3653a89761d$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $f052a3653a89761d$export$839f9183b0465a69; }, function (v) { return $f052a3653a89761d$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $f052a3653a89761d$export$72fdf0e06517287b; }, function (v) { return $f052a3653a89761d$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $f052a3653a89761d$export$4b844e58a3e414b4; }, function (v) { return $f052a3653a89761d$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $f052a3653a89761d$export$816d2913ae6b83b1; }, function (v) { return $f052a3653a89761d$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $f052a3653a89761d$export$61bcfe829111a1d0; }, function (v) { return $f052a3653a89761d$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $f052a3653a89761d$export$7ee8c9beb337bc3f; }, function (v) { return $f052a3653a89761d$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $f052a3653a89761d$export$b5836b71941fa3ed; }, function (v) { return $f052a3653a89761d$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $f052a3653a89761d$export$cf845f2c119da08a; }, function (v) { return $f052a3653a89761d$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f052a3653a89761d$export$c4744153514ff05d;
var $f052a3653a89761d$export$3e506c1ccc9cc1a7;
var $f052a3653a89761d$export$e26fe2ed2fa76875;
var $f052a3653a89761d$export$502329bbf4b505b1;
var $f052a3653a89761d$export$6e3807111c4874c4;
var $f052a3653a89761d$export$c27134553091fb3a;
var $f052a3653a89761d$export$33ee1acdc04fd2a2;
var $f052a3653a89761d$export$b00a404bbd5edef2;
var $f052a3653a89761d$export$8352ce38b91d0c62;
var $f052a3653a89761d$export$d66a1c1c77bd778b;
var $f052a3653a89761d$export$d3dfb8e4810cb555;
var $f052a3653a89761d$export$839f9183b0465a69;
var $f052a3653a89761d$export$72fdf0e06517287b;
var $f052a3653a89761d$export$4b844e58a3e414b4;
var $f052a3653a89761d$export$816d2913ae6b83b1;
var $f052a3653a89761d$export$61bcfe829111a1d0;
var $f052a3653a89761d$export$7ee8c9beb337bc3f;
var $f052a3653a89761d$export$b5836b71941fa3ed;
var $f052a3653a89761d$export$cf845f2c119da08a;
"use strict";
function $f052a3653a89761d$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $f052a3653a89761d$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $f052a3653a89761d$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $f052a3653a89761d$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $f052a3653a89761d$var$g(C, c)) n < e && 0 > $f052a3653a89761d$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $f052a3653a89761d$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $f052a3653a89761d$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $f052a3653a89761d$var$l = performance;
    $f052a3653a89761d$export$c4744153514ff05d = function() {
        return $f052a3653a89761d$var$l.now();
    };
} else {
    var $f052a3653a89761d$var$p = Date, $f052a3653a89761d$var$q = $f052a3653a89761d$var$p.now();
    $f052a3653a89761d$export$c4744153514ff05d = function() {
        return $f052a3653a89761d$var$p.now() - $f052a3653a89761d$var$q;
    };
}
var $f052a3653a89761d$var$r = [], $f052a3653a89761d$var$t = [], $f052a3653a89761d$var$u = 1, $f052a3653a89761d$var$v = null, $f052a3653a89761d$var$y = 3, $f052a3653a89761d$var$z = !1, $f052a3653a89761d$var$A = !1, $f052a3653a89761d$var$B = !1, $f052a3653a89761d$var$D = "function" === typeof setTimeout ? setTimeout : null, $f052a3653a89761d$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $f052a3653a89761d$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $f052a3653a89761d$var$G(a) {
    for(var b = $f052a3653a89761d$var$h($f052a3653a89761d$var$t); null !== b;){
        if (null === b.callback) $f052a3653a89761d$var$k($f052a3653a89761d$var$t);
        else if (b.startTime <= a) $f052a3653a89761d$var$k($f052a3653a89761d$var$t), b.sortIndex = b.expirationTime, $f052a3653a89761d$var$f($f052a3653a89761d$var$r, b);
        else break;
        b = $f052a3653a89761d$var$h($f052a3653a89761d$var$t);
    }
}
function $f052a3653a89761d$var$H(a) {
    $f052a3653a89761d$var$B = !1;
    $f052a3653a89761d$var$G(a);
    if (!$f052a3653a89761d$var$A) {
        if (null !== $f052a3653a89761d$var$h($f052a3653a89761d$var$r)) $f052a3653a89761d$var$A = !0, $f052a3653a89761d$var$I($f052a3653a89761d$var$J);
        else {
            var b = $f052a3653a89761d$var$h($f052a3653a89761d$var$t);
            null !== b && $f052a3653a89761d$var$K($f052a3653a89761d$var$H, b.startTime - a);
        }
    }
}
function $f052a3653a89761d$var$J(a, b) {
    $f052a3653a89761d$var$A = !1;
    $f052a3653a89761d$var$B && ($f052a3653a89761d$var$B = !1, $f052a3653a89761d$var$E($f052a3653a89761d$var$L), $f052a3653a89761d$var$L = -1);
    $f052a3653a89761d$var$z = !0;
    var c = $f052a3653a89761d$var$y;
    try {
        $f052a3653a89761d$var$G(b);
        for($f052a3653a89761d$var$v = $f052a3653a89761d$var$h($f052a3653a89761d$var$r); null !== $f052a3653a89761d$var$v && (!($f052a3653a89761d$var$v.expirationTime > b) || a && !$f052a3653a89761d$var$M());){
            var d = $f052a3653a89761d$var$v.callback;
            if ("function" === typeof d) {
                $f052a3653a89761d$var$v.callback = null;
                $f052a3653a89761d$var$y = $f052a3653a89761d$var$v.priorityLevel;
                var e = d($f052a3653a89761d$var$v.expirationTime <= b);
                b = $f052a3653a89761d$export$c4744153514ff05d();
                "function" === typeof e ? $f052a3653a89761d$var$v.callback = e : $f052a3653a89761d$var$v === $f052a3653a89761d$var$h($f052a3653a89761d$var$r) && $f052a3653a89761d$var$k($f052a3653a89761d$var$r);
                $f052a3653a89761d$var$G(b);
            } else $f052a3653a89761d$var$k($f052a3653a89761d$var$r);
            $f052a3653a89761d$var$v = $f052a3653a89761d$var$h($f052a3653a89761d$var$r);
        }
        if (null !== $f052a3653a89761d$var$v) var w = !0;
        else {
            var m = $f052a3653a89761d$var$h($f052a3653a89761d$var$t);
            null !== m && $f052a3653a89761d$var$K($f052a3653a89761d$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $f052a3653a89761d$var$v = null, $f052a3653a89761d$var$y = c, $f052a3653a89761d$var$z = !1;
    }
}
var $f052a3653a89761d$var$N = !1, $f052a3653a89761d$var$O = null, $f052a3653a89761d$var$L = -1, $f052a3653a89761d$var$P = 5, $f052a3653a89761d$var$Q = -1;
function $f052a3653a89761d$var$M() {
    return $f052a3653a89761d$export$c4744153514ff05d() - $f052a3653a89761d$var$Q < $f052a3653a89761d$var$P ? !1 : !0;
}
function $f052a3653a89761d$var$R() {
    if (null !== $f052a3653a89761d$var$O) {
        var a = $f052a3653a89761d$export$c4744153514ff05d();
        $f052a3653a89761d$var$Q = a;
        var b = !0;
        try {
            b = $f052a3653a89761d$var$O(!0, a);
        } finally{
            b ? $f052a3653a89761d$var$S() : ($f052a3653a89761d$var$N = !1, $f052a3653a89761d$var$O = null);
        }
    } else $f052a3653a89761d$var$N = !1;
}
var $f052a3653a89761d$var$S;
if ("function" === typeof $f052a3653a89761d$var$F) $f052a3653a89761d$var$S = function() {
    $f052a3653a89761d$var$F($f052a3653a89761d$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $f052a3653a89761d$var$T = new MessageChannel, $f052a3653a89761d$var$U = $f052a3653a89761d$var$T.port2;
    $f052a3653a89761d$var$T.port1.onmessage = $f052a3653a89761d$var$R;
    $f052a3653a89761d$var$S = function() {
        $f052a3653a89761d$var$U.postMessage(null);
    };
} else $f052a3653a89761d$var$S = function() {
    $f052a3653a89761d$var$D($f052a3653a89761d$var$R, 0);
};
function $f052a3653a89761d$var$I(a) {
    $f052a3653a89761d$var$O = a;
    $f052a3653a89761d$var$N || ($f052a3653a89761d$var$N = !0, $f052a3653a89761d$var$S());
}
function $f052a3653a89761d$var$K(a, b) {
    $f052a3653a89761d$var$L = $f052a3653a89761d$var$D(function() {
        a($f052a3653a89761d$export$c4744153514ff05d());
    }, b);
}
$f052a3653a89761d$export$3e506c1ccc9cc1a7 = 5;
$f052a3653a89761d$export$e26fe2ed2fa76875 = 1;
$f052a3653a89761d$export$502329bbf4b505b1 = 4;
$f052a3653a89761d$export$6e3807111c4874c4 = 3;
$f052a3653a89761d$export$c27134553091fb3a = null;
$f052a3653a89761d$export$33ee1acdc04fd2a2 = 2;
$f052a3653a89761d$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$f052a3653a89761d$export$8352ce38b91d0c62 = function() {
    $f052a3653a89761d$var$A || $f052a3653a89761d$var$z || ($f052a3653a89761d$var$A = !0, $f052a3653a89761d$var$I($f052a3653a89761d$var$J));
};
$f052a3653a89761d$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $f052a3653a89761d$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$f052a3653a89761d$export$d3dfb8e4810cb555 = function() {
    return $f052a3653a89761d$var$y;
};
$f052a3653a89761d$export$839f9183b0465a69 = function() {
    return $f052a3653a89761d$var$h($f052a3653a89761d$var$r);
};
$f052a3653a89761d$export$72fdf0e06517287b = function(a) {
    switch($f052a3653a89761d$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $f052a3653a89761d$var$y;
    }
    var c = $f052a3653a89761d$var$y;
    $f052a3653a89761d$var$y = b;
    try {
        return a();
    } finally{
        $f052a3653a89761d$var$y = c;
    }
};
$f052a3653a89761d$export$4b844e58a3e414b4 = function() {};
$f052a3653a89761d$export$816d2913ae6b83b1 = function() {};
$f052a3653a89761d$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $f052a3653a89761d$var$y;
    $f052a3653a89761d$var$y = a;
    try {
        return b();
    } finally{
        $f052a3653a89761d$var$y = c;
    }
};
$f052a3653a89761d$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $f052a3653a89761d$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $f052a3653a89761d$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $f052a3653a89761d$var$f($f052a3653a89761d$var$t, a), null === $f052a3653a89761d$var$h($f052a3653a89761d$var$r) && a === $f052a3653a89761d$var$h($f052a3653a89761d$var$t) && ($f052a3653a89761d$var$B ? ($f052a3653a89761d$var$E($f052a3653a89761d$var$L), $f052a3653a89761d$var$L = -1) : $f052a3653a89761d$var$B = !0, $f052a3653a89761d$var$K($f052a3653a89761d$var$H, c - d))) : (a.sortIndex = e, $f052a3653a89761d$var$f($f052a3653a89761d$var$r, a), $f052a3653a89761d$var$A || $f052a3653a89761d$var$z || ($f052a3653a89761d$var$A = !0, $f052a3653a89761d$var$I($f052a3653a89761d$var$J)));
    return a;
};
$f052a3653a89761d$export$b5836b71941fa3ed = $f052a3653a89761d$var$M;
$f052a3653a89761d$export$cf845f2c119da08a = function(a) {
    var b = $f052a3653a89761d$var$y;
    return function() {
        var c = $f052a3653a89761d$var$y;
        $f052a3653a89761d$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $f052a3653a89761d$var$y = c;
        }
    };
};

});



parcelRegister("6Swur", function(module, exports) {

var $9GFX7 = parcelRequire("9GFX7");

var $8uEuL = parcelRequire("8uEuL");
var $5020fd099f12a947$require$agents = $8uEuL.agents;

var $hZDcp = parcelRequire("hZDcp");

var $2Qnzd = parcelRequire("2Qnzd");

var $cBucY = parcelRequire("cBucY");

var $hvjyX = parcelRequire("hvjyX");

var $hXbIm = parcelRequire("hXbIm");

var $6ealC = parcelRequire("6ealC");
var $5020fd099f12a947$var$YEAR = 365.259641 * 86400000;
var $5020fd099f12a947$var$ANDROID_EVERGREEN_FIRST = "37";
var $5020fd099f12a947$var$OP_MOB_BLINK_FIRST = 14;
// Helpers
function $5020fd099f12a947$var$isVersionsMatch(versionA, versionB) {
    return (versionA + ".").indexOf(versionB + ".") === 0;
}
function $5020fd099f12a947$var$isEolReleased(name) {
    var version = name.slice(1);
    return $5020fd099f12a947$var$browserslist.nodeVersions.some(function(i) {
        return $5020fd099f12a947$var$isVersionsMatch(i, version);
    });
}
function $5020fd099f12a947$var$normalize(versions) {
    return versions.filter(function(version) {
        return typeof version === "string";
    });
}
function $5020fd099f12a947$var$normalizeElectron(version) {
    var versionToUse = version;
    if (version.split(".").length === 3) versionToUse = version.split(".").slice(0, -1).join(".");
    return versionToUse;
}
function $5020fd099f12a947$var$nameMapper(name) {
    return function mapName(version) {
        return name + " " + version;
    };
}
function $5020fd099f12a947$var$getMajor(version) {
    return parseInt(version.split(".")[0]);
}
function $5020fd099f12a947$var$getMajorVersions(released, number) {
    if (released.length === 0) return [];
    var majorVersions = $5020fd099f12a947$var$uniq(released.map($5020fd099f12a947$var$getMajor));
    var minimum = majorVersions[majorVersions.length - number];
    if (!minimum) return released;
    var selected = [];
    for(var i = released.length - 1; i >= 0; i--){
        if (minimum > $5020fd099f12a947$var$getMajor(released[i])) break;
        selected.unshift(released[i]);
    }
    return selected;
}
function $5020fd099f12a947$var$uniq(array) {
    var filtered = [];
    for(var i = 0; i < array.length; i++)if (filtered.indexOf(array[i]) === -1) filtered.push(array[i]);
    return filtered;
}
function $5020fd099f12a947$var$fillUsage(result, name, data) {
    for(var i in data)result[name + " " + i] = data[i];
}
function $5020fd099f12a947$var$generateFilter(sign, version) {
    version = parseFloat(version);
    if (sign === ">") return function(v) {
        return parseFloat(v) > version;
    };
    else if (sign === ">=") return function(v) {
        return parseFloat(v) >= version;
    };
    else if (sign === "<") return function(v) {
        return parseFloat(v) < version;
    };
    else return function(v) {
        return parseFloat(v) <= version;
    };
}
function $5020fd099f12a947$var$generateSemverFilter(sign, version) {
    version = version.split(".").map($5020fd099f12a947$var$parseSimpleInt);
    version[1] = version[1] || 0;
    version[2] = version[2] || 0;
    if (sign === ">") return function(v) {
        v = v.split(".").map($5020fd099f12a947$var$parseSimpleInt);
        return $5020fd099f12a947$var$compareSemver(v, version) > 0;
    };
    else if (sign === ">=") return function(v) {
        v = v.split(".").map($5020fd099f12a947$var$parseSimpleInt);
        return $5020fd099f12a947$var$compareSemver(v, version) >= 0;
    };
    else if (sign === "<") return function(v) {
        v = v.split(".").map($5020fd099f12a947$var$parseSimpleInt);
        return $5020fd099f12a947$var$compareSemver(version, v) > 0;
    };
    else return function(v) {
        v = v.split(".").map($5020fd099f12a947$var$parseSimpleInt);
        return $5020fd099f12a947$var$compareSemver(version, v) >= 0;
    };
}
function $5020fd099f12a947$var$parseSimpleInt(x) {
    return parseInt(x);
}
function $5020fd099f12a947$var$compare(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $5020fd099f12a947$var$compareSemver(a, b) {
    return $5020fd099f12a947$var$compare(parseInt(a[0]), parseInt(b[0])) || $5020fd099f12a947$var$compare(parseInt(a[1] || "0"), parseInt(b[1] || "0")) || $5020fd099f12a947$var$compare(parseInt(a[2] || "0"), parseInt(b[2] || "0"));
}
// this follows the npm-like semver behavior
function $5020fd099f12a947$var$semverFilterLoose(operator, range) {
    range = range.split(".").map($5020fd099f12a947$var$parseSimpleInt);
    if (typeof range[1] === "undefined") range[1] = "x";
    // ignore any patch version because we only return minor versions
    // range[2] = 'x'
    switch(operator){
        case "<=":
            return function(version) {
                version = version.split(".").map($5020fd099f12a947$var$parseSimpleInt);
                return $5020fd099f12a947$var$compareSemverLoose(version, range) <= 0;
            };
        case ">=":
        default:
            return function(version) {
                version = version.split(".").map($5020fd099f12a947$var$parseSimpleInt);
                return $5020fd099f12a947$var$compareSemverLoose(version, range) >= 0;
            };
    }
}
// this follows the npm-like semver behavior
function $5020fd099f12a947$var$compareSemverLoose(version, range) {
    if (version[0] !== range[0]) return version[0] < range[0] ? -1 : 1;
    if (range[1] === "x") return 0;
    if (version[1] !== range[1]) return version[1] < range[1] ? -1 : 1;
    return 0;
}
function $5020fd099f12a947$var$resolveVersion(data, version) {
    if (data.versions.indexOf(version) !== -1) return version;
    else if ($5020fd099f12a947$var$browserslist.versionAliases[data.name][version]) return $5020fd099f12a947$var$browserslist.versionAliases[data.name][version];
    else return false;
}
function $5020fd099f12a947$var$normalizeVersion(data, version) {
    var resolved = $5020fd099f12a947$var$resolveVersion(data, version);
    if (resolved) return resolved;
    else if (data.versions.length === 1) return data.versions[0];
    else return false;
}
function $5020fd099f12a947$var$filterByYear(since, context) {
    since = since / 1000;
    return Object.keys($5020fd099f12a947$require$agents).reduce(function(selected, name) {
        var data = $5020fd099f12a947$var$byName(name, context);
        if (!data) return selected;
        var versions = Object.keys(data.releaseDate).filter(function(v) {
            var date = data.releaseDate[v];
            return date !== null && date >= since;
        });
        return selected.concat(versions.map($5020fd099f12a947$var$nameMapper(data.name)));
    }, []);
}
function $5020fd099f12a947$var$cloneData(data) {
    return {
        name: data.name,
        versions: data.versions,
        released: data.released,
        releaseDate: data.releaseDate
    };
}
function $5020fd099f12a947$var$byName(name, context) {
    name = name.toLowerCase();
    name = $5020fd099f12a947$var$browserslist.aliases[name] || name;
    if (context.mobileToDesktop && $5020fd099f12a947$var$browserslist.desktopNames[name]) {
        var desktop = $5020fd099f12a947$var$browserslist.data[$5020fd099f12a947$var$browserslist.desktopNames[name]];
        if (name === "android") return $5020fd099f12a947$var$normalizeAndroidData($5020fd099f12a947$var$cloneData($5020fd099f12a947$var$browserslist.data[name]), desktop);
        else {
            var cloned = $5020fd099f12a947$var$cloneData(desktop);
            cloned.name = name;
            return cloned;
        }
    }
    return $5020fd099f12a947$var$browserslist.data[name];
}
function $5020fd099f12a947$var$normalizeAndroidVersions(androidVersions, chromeVersions) {
    var iFirstEvergreen = chromeVersions.indexOf($5020fd099f12a947$var$ANDROID_EVERGREEN_FIRST);
    return androidVersions.filter(function(version) {
        return /^(?:[2-4]\.|[34]$)/.test(version);
    }).concat(chromeVersions.slice(iFirstEvergreen));
}
function $5020fd099f12a947$var$normalizeAndroidData(android, chrome) {
    android.released = $5020fd099f12a947$var$normalizeAndroidVersions(android.released, chrome.released);
    android.versions = $5020fd099f12a947$var$normalizeAndroidVersions(android.versions, chrome.versions);
    android.released.forEach(function(v) {
        if (android.releaseDate[v] === undefined) android.releaseDate[v] = chrome.releaseDate[v];
    });
    return android;
}
function $5020fd099f12a947$var$checkName(name, context) {
    var data = $5020fd099f12a947$var$byName(name, context);
    if (!data) throw new $hvjyX("Unknown browser " + name);
    return data;
}
function $5020fd099f12a947$var$unknownQuery(query) {
    return new $hvjyX("Unknown browser query `" + query + "`. " + "Maybe you are using old Browserslist or made typo in query.");
}
// Adjusts last X versions queries for some mobile browsers,
// where caniuse data jumps from a legacy version to the latest
function $5020fd099f12a947$var$filterJumps(list, name, nVersions, context) {
    var jump = 1;
    switch(name){
        case "android":
            if (context.mobileToDesktop) return list;
            var released = $5020fd099f12a947$var$browserslist.data.chrome.released;
            jump = released.length - released.indexOf($5020fd099f12a947$var$ANDROID_EVERGREEN_FIRST);
            break;
        case "op_mob":
            var latest = $5020fd099f12a947$var$browserslist.data.op_mob.released.slice(-1)[0];
            jump = $5020fd099f12a947$var$getMajor(latest) - $5020fd099f12a947$var$OP_MOB_BLINK_FIRST + 1;
            break;
        default:
            return list;
    }
    if (nVersions <= jump) return list.slice(-1);
    return list.slice(jump - 1 - nVersions);
}
function $5020fd099f12a947$var$isSupported(flags, withPartial) {
    return typeof flags === "string" && (flags.indexOf("y") >= 0 || withPartial && flags.indexOf("a") >= 0);
}
function $5020fd099f12a947$var$resolve(queries, context) {
    return $hXbIm($5020fd099f12a947$var$QUERIES, queries).reduce(function(result, node, index) {
        if (node.not && index === 0) throw new $hvjyX("Write any browsers query (for instance, `defaults`) before `" + node.query + "`");
        var type = $5020fd099f12a947$var$QUERIES[node.type];
        var array = type.select.call($5020fd099f12a947$var$browserslist, context, node).map(function(j) {
            var parts = j.split(" ");
            if (parts[1] === "0") return parts[0] + " " + $5020fd099f12a947$var$byName(parts[0], context).versions[0];
            else return j;
        });
        if (node.compose === "and") {
            if (node.not) return result.filter(function(j) {
                return array.indexOf(j) === -1;
            });
            else return result.filter(function(j) {
                return array.indexOf(j) !== -1;
            });
        } else {
            if (node.not) {
                var filter = {};
                array.forEach(function(j) {
                    filter[j] = true;
                });
                return result.filter(function(j) {
                    return !filter[j];
                });
            }
            return result.concat(array);
        }
    }, []);
}
function $5020fd099f12a947$var$prepareOpts(opts) {
    if (typeof opts === "undefined") opts = {};
    if (typeof opts.path === "undefined") opts.path = $2Qnzd.resolve ? $2Qnzd.resolve(".") : ".";
    return opts;
}
function $5020fd099f12a947$var$prepareQueries(queries, opts) {
    if (typeof queries === "undefined" || queries === null) {
        var config = $5020fd099f12a947$var$browserslist.loadConfig(opts);
        if (config) queries = config;
        else queries = $5020fd099f12a947$var$browserslist.defaults;
    }
    return queries;
}
function $5020fd099f12a947$var$checkQueries(queries) {
    if (!(typeof queries === "string" || Array.isArray(queries))) throw new $hvjyX("Browser queries must be an array or string. Got " + typeof queries + ".");
}
var $5020fd099f12a947$var$cache = {};
function $5020fd099f12a947$var$browserslist(queries, opts) {
    opts = $5020fd099f12a947$var$prepareOpts(opts);
    queries = $5020fd099f12a947$var$prepareQueries(queries, opts);
    $5020fd099f12a947$var$checkQueries(queries);
    var context = {
        ignoreUnknownVersions: opts.ignoreUnknownVersions,
        dangerousExtend: opts.dangerousExtend,
        mobileToDesktop: opts.mobileToDesktop,
        path: opts.path,
        env: opts.env
    };
    $6ealC.oldDataWarning($5020fd099f12a947$var$browserslist.data);
    var stats = $6ealC.getStat(opts, $5020fd099f12a947$var$browserslist.data);
    if (stats) {
        context.customUsage = {};
        for(var browser in stats)$5020fd099f12a947$var$fillUsage(context.customUsage, browser, stats[browser]);
    }
    var cacheKey = JSON.stringify([
        queries,
        context
    ]);
    if ($5020fd099f12a947$var$cache[cacheKey]) return $5020fd099f12a947$var$cache[cacheKey];
    var result = $5020fd099f12a947$var$uniq($5020fd099f12a947$var$resolve(queries, context)).sort(function(name1, name2) {
        name1 = name1.split(" ");
        name2 = name2.split(" ");
        if (name1[0] === name2[0]) {
            // assumptions on caniuse data
            // 1) version ranges never overlaps
            // 2) if version is not a range, it never contains `-`
            var version1 = name1[1].split("-")[0];
            var version2 = name2[1].split("-")[0];
            return $5020fd099f12a947$var$compareSemver(version2.split("."), version1.split("."));
        } else return $5020fd099f12a947$var$compare(name1[0], name2[0]);
    });
    if (!$6ealC.env.BROWSERSLIST_DISABLE_CACHE) $5020fd099f12a947$var$cache[cacheKey] = result;
    return result;
}
$5020fd099f12a947$var$browserslist.parse = function(queries, opts) {
    opts = $5020fd099f12a947$var$prepareOpts(opts);
    queries = $5020fd099f12a947$var$prepareQueries(queries, opts);
    $5020fd099f12a947$var$checkQueries(queries);
    return $hXbIm($5020fd099f12a947$var$QUERIES, queries);
};
// Will be filled by Can I Use data below
$5020fd099f12a947$var$browserslist.cache = {};
$5020fd099f12a947$var$browserslist.data = {};
$5020fd099f12a947$var$browserslist.usage = {
    global: {},
    custom: null
};
// Default browsers query
$5020fd099f12a947$var$browserslist.defaults = [
    "> 0.5%",
    "last 2 versions",
    "Firefox ESR",
    "not dead"
];
// Browser names aliases
$5020fd099f12a947$var$browserslist.aliases = {
    fx: "firefox",
    ff: "firefox",
    ios: "ios_saf",
    explorer: "ie",
    blackberry: "bb",
    explorermobile: "ie_mob",
    operamini: "op_mini",
    operamobile: "op_mob",
    chromeandroid: "and_chr",
    firefoxandroid: "and_ff",
    ucandroid: "and_uc",
    qqandroid: "and_qq"
};
// Can I Use only provides a few versions for some browsers (e.g. and_chr).
// Fallback to a similar browser for unknown versions
// Note op_mob is not included as its chromium versions are not in sync with Opera desktop
$5020fd099f12a947$var$browserslist.desktopNames = {
    and_chr: "chrome",
    and_ff: "firefox",
    ie_mob: "ie",
    android: "chrome" // has extra processing logic
};
// Aliases to work with joined versions like `ios_saf 7.0-7.1`
$5020fd099f12a947$var$browserslist.versionAliases = {};
$5020fd099f12a947$var$browserslist.clearCaches = $6ealC.clearCaches;
$5020fd099f12a947$var$browserslist.parseConfig = $6ealC.parseConfig;
$5020fd099f12a947$var$browserslist.readConfig = $6ealC.readConfig;
$5020fd099f12a947$var$browserslist.findConfig = $6ealC.findConfig;
$5020fd099f12a947$var$browserslist.loadConfig = $6ealC.loadConfig;
$5020fd099f12a947$var$browserslist.coverage = function(browsers, stats) {
    var data;
    if (typeof stats === "undefined") data = $5020fd099f12a947$var$browserslist.usage.global;
    else if (stats === "my stats") {
        var opts = {};
        opts.path = $2Qnzd.resolve ? $2Qnzd.resolve(".") : ".";
        var customStats = $6ealC.getStat(opts);
        if (!customStats) throw new $hvjyX("Custom usage statistics was not provided");
        data = {};
        for(var browser in customStats)$5020fd099f12a947$var$fillUsage(data, browser, customStats[browser]);
    } else if (typeof stats === "string") {
        if (stats.length > 2) stats = stats.toLowerCase();
        else stats = stats.toUpperCase();
        $6ealC.loadCountry($5020fd099f12a947$var$browserslist.usage, stats, $5020fd099f12a947$var$browserslist.data);
        data = $5020fd099f12a947$var$browserslist.usage[stats];
    } else {
        if ("dataByBrowser" in stats) stats = stats.dataByBrowser;
        data = {};
        for(var name in stats)for(var version in stats[name])data[name + " " + version] = stats[name][version];
    }
    return browsers.reduce(function(all, i) {
        var usage = data[i];
        if (usage === undefined) usage = data[i.replace(/ \S+$/, " 0")];
        return all + (usage || 0);
    }, 0);
};
function $5020fd099f12a947$var$nodeQuery(context, node) {
    var matched = $5020fd099f12a947$var$browserslist.nodeVersions.filter(function(i) {
        return $5020fd099f12a947$var$isVersionsMatch(i, node.version);
    });
    if (matched.length === 0) {
        if (context.ignoreUnknownVersions) return [];
        else throw new $hvjyX("Unknown version " + node.version + " of Node.js");
    }
    return [
        "node " + matched[matched.length - 1]
    ];
}
function $5020fd099f12a947$var$sinceQuery(context, node) {
    var year = parseInt(node.year);
    var month = parseInt(node.month || "01") - 1;
    var day = parseInt(node.day || "01");
    return $5020fd099f12a947$var$filterByYear(Date.UTC(year, month, day, 0, 0, 0), context);
}
function $5020fd099f12a947$var$coverQuery(context, node) {
    var coverage = parseFloat(node.coverage);
    var usage = $5020fd099f12a947$var$browserslist.usage.global;
    if (node.place) {
        if (node.place.match(/^my\s+stats$/i)) {
            if (!context.customUsage) throw new $hvjyX("Custom usage statistics was not provided");
            usage = context.customUsage;
        } else {
            var place;
            if (node.place.length === 2) place = node.place.toUpperCase();
            else place = node.place.toLowerCase();
            $6ealC.loadCountry($5020fd099f12a947$var$browserslist.usage, place, $5020fd099f12a947$var$browserslist.data);
            usage = $5020fd099f12a947$var$browserslist.usage[place];
        }
    }
    var versions = Object.keys(usage).sort(function(a, b) {
        return usage[b] - usage[a];
    });
    var coveraged = 0;
    var result = [];
    var version;
    for(var i = 0; i < versions.length; i++){
        version = versions[i];
        if (usage[version] === 0) break;
        coveraged += usage[version];
        result.push(version);
        if (coveraged >= coverage) break;
    }
    return result;
}
var $5020fd099f12a947$var$QUERIES = {
    last_major_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+major\s+versions?$/i,
        select: function(context, node) {
            return Object.keys($5020fd099f12a947$require$agents).reduce(function(selected, name) {
                var data = $5020fd099f12a947$var$byName(name, context);
                if (!data) return selected;
                var list = $5020fd099f12a947$var$getMajorVersions(data.released, node.versions);
                list = list.map($5020fd099f12a947$var$nameMapper(data.name));
                list = $5020fd099f12a947$var$filterJumps(list, data.name, node.versions, context);
                return selected.concat(list);
            }, []);
        }
    },
    last_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+versions?$/i,
        select: function(context, node) {
            return Object.keys($5020fd099f12a947$require$agents).reduce(function(selected, name) {
                var data = $5020fd099f12a947$var$byName(name, context);
                if (!data) return selected;
                var list = data.released.slice(-node.versions);
                list = list.map($5020fd099f12a947$var$nameMapper(data.name));
                list = $5020fd099f12a947$var$filterJumps(list, data.name, node.versions, context);
                return selected.concat(list);
            }, []);
        }
    },
    last_electron_major_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+electron\s+major\s+versions?$/i,
        select: function(context, node) {
            var validVersions = $5020fd099f12a947$var$getMajorVersions(Object.keys($cBucY), node.versions);
            return validVersions.map(function(i) {
                return "chrome " + $cBucY[i];
            });
        }
    },
    last_node_major_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+node\s+major\s+versions?$/i,
        select: function(context, node) {
            return $5020fd099f12a947$var$getMajorVersions($5020fd099f12a947$var$browserslist.nodeVersions, node.versions).map(function(version) {
                return "node " + version;
            });
        }
    },
    last_browser_major_versions: {
        matches: [
            "versions",
            "browser"
        ],
        regexp: /^last\s+(\d+)\s+(\w+)\s+major\s+versions?$/i,
        select: function(context, node) {
            var data = $5020fd099f12a947$var$checkName(node.browser, context);
            var validVersions = $5020fd099f12a947$var$getMajorVersions(data.released, node.versions);
            var list = validVersions.map($5020fd099f12a947$var$nameMapper(data.name));
            list = $5020fd099f12a947$var$filterJumps(list, data.name, node.versions, context);
            return list;
        }
    },
    last_electron_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+electron\s+versions?$/i,
        select: function(context, node) {
            return Object.keys($cBucY).slice(-node.versions).map(function(i) {
                return "chrome " + $cBucY[i];
            });
        }
    },
    last_node_versions: {
        matches: [
            "versions"
        ],
        regexp: /^last\s+(\d+)\s+node\s+versions?$/i,
        select: function(context, node) {
            return $5020fd099f12a947$var$browserslist.nodeVersions.slice(-node.versions).map(function(version) {
                return "node " + version;
            });
        }
    },
    last_browser_versions: {
        matches: [
            "versions",
            "browser"
        ],
        regexp: /^last\s+(\d+)\s+(\w+)\s+versions?$/i,
        select: function(context, node) {
            var data = $5020fd099f12a947$var$checkName(node.browser, context);
            var list = data.released.slice(-node.versions).map($5020fd099f12a947$var$nameMapper(data.name));
            list = $5020fd099f12a947$var$filterJumps(list, data.name, node.versions, context);
            return list;
        }
    },
    unreleased_versions: {
        matches: [],
        regexp: /^unreleased\s+versions$/i,
        select: function(context) {
            return Object.keys($5020fd099f12a947$require$agents).reduce(function(selected, name) {
                var data = $5020fd099f12a947$var$byName(name, context);
                if (!data) return selected;
                var list = data.versions.filter(function(v) {
                    return data.released.indexOf(v) === -1;
                });
                list = list.map($5020fd099f12a947$var$nameMapper(data.name));
                return selected.concat(list);
            }, []);
        }
    },
    unreleased_electron_versions: {
        matches: [],
        regexp: /^unreleased\s+electron\s+versions?$/i,
        select: function() {
            return [];
        }
    },
    unreleased_browser_versions: {
        matches: [
            "browser"
        ],
        regexp: /^unreleased\s+(\w+)\s+versions?$/i,
        select: function(context, node) {
            var data = $5020fd099f12a947$var$checkName(node.browser, context);
            return data.versions.filter(function(v) {
                return data.released.indexOf(v) === -1;
            }).map($5020fd099f12a947$var$nameMapper(data.name));
        }
    },
    last_years: {
        matches: [
            "years"
        ],
        regexp: /^last\s+(\d*.?\d+)\s+years?$/i,
        select: function(context, node) {
            return $5020fd099f12a947$var$filterByYear(Date.now() - $5020fd099f12a947$var$YEAR * node.years, context);
        }
    },
    since_y: {
        matches: [
            "year"
        ],
        regexp: /^since (\d+)$/i,
        select: $5020fd099f12a947$var$sinceQuery
    },
    since_y_m: {
        matches: [
            "year",
            "month"
        ],
        regexp: /^since (\d+)-(\d+)$/i,
        select: $5020fd099f12a947$var$sinceQuery
    },
    since_y_m_d: {
        matches: [
            "year",
            "month",
            "day"
        ],
        regexp: /^since (\d+)-(\d+)-(\d+)$/i,
        select: $5020fd099f12a947$var$sinceQuery
    },
    popularity: {
        matches: [
            "sign",
            "popularity"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            var usage = $5020fd099f12a947$var$browserslist.usage.global;
            return Object.keys(usage).reduce(function(result, version) {
                if (node.sign === ">") {
                    if (usage[version] > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (usage[version] < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (usage[version] <= popularity) result.push(version);
                } else if (usage[version] >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_my_stats: {
        matches: [
            "sign",
            "popularity"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+my\s+stats$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            if (!context.customUsage) throw new $hvjyX("Custom usage statistics was not provided");
            var usage = context.customUsage;
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === ">") {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_config_stats: {
        matches: [
            "sign",
            "popularity",
            "config"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+(\S+)\s+stats$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            var stats = $6ealC.loadStat(context, node.config, $5020fd099f12a947$var$browserslist.data);
            if (stats) {
                context.customUsage = {};
                for(var browser in stats)$5020fd099f12a947$var$fillUsage(context.customUsage, browser, stats[browser]);
            }
            if (!context.customUsage) throw new $hvjyX("Custom usage statistics was not provided");
            var usage = context.customUsage;
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === ">") {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    popularity_in_place: {
        matches: [
            "sign",
            "popularity",
            "place"
        ],
        regexp: /^(>=?|<=?)\s*(\d+|\d+\.\d+|\.\d+)%\s+in\s+((alt-)?\w\w)$/,
        select: function(context, node) {
            var popularity = parseFloat(node.popularity);
            var place = node.place;
            if (place.length === 2) place = place.toUpperCase();
            else place = place.toLowerCase();
            $6ealC.loadCountry($5020fd099f12a947$var$browserslist.usage, place, $5020fd099f12a947$var$browserslist.data);
            var usage = $5020fd099f12a947$var$browserslist.usage[place];
            return Object.keys(usage).reduce(function(result, version) {
                var percentage = usage[version];
                if (percentage == null) return result;
                if (node.sign === ">") {
                    if (percentage > popularity) result.push(version);
                } else if (node.sign === "<") {
                    if (percentage < popularity) result.push(version);
                } else if (node.sign === "<=") {
                    if (percentage <= popularity) result.push(version);
                } else if (percentage >= popularity) result.push(version);
                return result;
            }, []);
        }
    },
    cover: {
        matches: [
            "coverage"
        ],
        regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%$/i,
        select: $5020fd099f12a947$var$coverQuery
    },
    cover_in: {
        matches: [
            "coverage",
            "place"
        ],
        regexp: /^cover\s+(\d+|\d+\.\d+|\.\d+)%\s+in\s+(my\s+stats|(alt-)?\w\w)$/i,
        select: $5020fd099f12a947$var$coverQuery
    },
    supports: {
        matches: [
            "supportType",
            "feature"
        ],
        regexp: /^(?:(fully|partially) )?supports\s+([\w-]+)$/,
        select: function(context, node) {
            $6ealC.loadFeature($5020fd099f12a947$var$browserslist.cache, node.feature);
            var withPartial = node.supportType !== "fully";
            var features = $5020fd099f12a947$var$browserslist.cache[node.feature];
            var result = [];
            for(var name in features){
                var data = $5020fd099f12a947$var$byName(name, context);
                // Only check desktop when latest released mobile has support
                var checkDesktop = context.mobileToDesktop && name in $5020fd099f12a947$var$browserslist.desktopNames && $5020fd099f12a947$var$isSupported(features[name][data.released.slice(-1)[0]], withPartial);
                data.versions.forEach(function(version) {
                    var flags = features[name][version];
                    if (flags === undefined && checkDesktop) flags = features[$5020fd099f12a947$var$browserslist.desktopNames[name]][version];
                    if ($5020fd099f12a947$var$isSupported(flags, withPartial)) result.push(name + " " + version);
                });
            }
            return result;
        }
    },
    electron_range: {
        matches: [
            "from",
            "to"
        ],
        regexp: /^electron\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function(context, node) {
            var fromToUse = $5020fd099f12a947$var$normalizeElectron(node.from);
            var toToUse = $5020fd099f12a947$var$normalizeElectron(node.to);
            var from = parseFloat(node.from);
            var to = parseFloat(node.to);
            if (!$cBucY[fromToUse]) throw new $hvjyX("Unknown version " + from + " of electron");
            if (!$cBucY[toToUse]) throw new $hvjyX("Unknown version " + to + " of electron");
            return Object.keys($cBucY).filter(function(i) {
                var parsed = parseFloat(i);
                return parsed >= from && parsed <= to;
            }).map(function(i) {
                return "chrome " + $cBucY[i];
            });
        }
    },
    node_range: {
        matches: [
            "from",
            "to"
        ],
        regexp: /^node\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function(context, node) {
            return $5020fd099f12a947$var$browserslist.nodeVersions.filter($5020fd099f12a947$var$semverFilterLoose(">=", node.from)).filter($5020fd099f12a947$var$semverFilterLoose("<=", node.to)).map(function(v) {
                return "node " + v;
            });
        }
    },
    browser_range: {
        matches: [
            "browser",
            "from",
            "to"
        ],
        regexp: /^(\w+)\s+([\d.]+)\s*-\s*([\d.]+)$/i,
        select: function(context, node) {
            var data = $5020fd099f12a947$var$checkName(node.browser, context);
            var from = parseFloat($5020fd099f12a947$var$normalizeVersion(data, node.from) || node.from);
            var to = parseFloat($5020fd099f12a947$var$normalizeVersion(data, node.to) || node.to);
            function filter(v) {
                var parsed = parseFloat(v);
                return parsed >= from && parsed <= to;
            }
            return data.released.filter(filter).map($5020fd099f12a947$var$nameMapper(data.name));
        }
    },
    electron_ray: {
        matches: [
            "sign",
            "version"
        ],
        regexp: /^electron\s*(>=?|<=?)\s*([\d.]+)$/i,
        select: function(context, node) {
            var versionToUse = $5020fd099f12a947$var$normalizeElectron(node.version);
            return Object.keys($cBucY).filter($5020fd099f12a947$var$generateFilter(node.sign, versionToUse)).map(function(i) {
                return "chrome " + $cBucY[i];
            });
        }
    },
    node_ray: {
        matches: [
            "sign",
            "version"
        ],
        regexp: /^node\s*(>=?|<=?)\s*([\d.]+)$/i,
        select: function(context, node) {
            return $5020fd099f12a947$var$browserslist.nodeVersions.filter($5020fd099f12a947$var$generateSemverFilter(node.sign, node.version)).map(function(v) {
                return "node " + v;
            });
        }
    },
    browser_ray: {
        matches: [
            "browser",
            "sign",
            "version"
        ],
        regexp: /^(\w+)\s*(>=?|<=?)\s*([\d.]+)$/,
        select: function(context, node) {
            var version = node.version;
            var data = $5020fd099f12a947$var$checkName(node.browser, context);
            var alias = $5020fd099f12a947$var$browserslist.versionAliases[data.name][version];
            if (alias) version = alias;
            return data.released.filter($5020fd099f12a947$var$generateFilter(node.sign, version)).map(function(v) {
                return data.name + " " + v;
            });
        }
    },
    firefox_esr: {
        matches: [],
        regexp: /^(firefox|ff|fx)\s+esr$/i,
        select: function() {
            return [
                "firefox 115"
            ];
        }
    },
    opera_mini_all: {
        matches: [],
        regexp: /(operamini|op_mini)\s+all/i,
        select: function() {
            return [
                "op_mini all"
            ];
        }
    },
    electron_version: {
        matches: [
            "version"
        ],
        regexp: /^electron\s+([\d.]+)$/i,
        select: function(context, node) {
            var versionToUse = $5020fd099f12a947$var$normalizeElectron(node.version);
            var chrome = $cBucY[versionToUse];
            if (!chrome) throw new $hvjyX("Unknown version " + node.version + " of electron");
            return [
                "chrome " + chrome
            ];
        }
    },
    node_major_version: {
        matches: [
            "version"
        ],
        regexp: /^node\s+(\d+)$/i,
        select: $5020fd099f12a947$var$nodeQuery
    },
    node_minor_version: {
        matches: [
            "version"
        ],
        regexp: /^node\s+(\d+\.\d+)$/i,
        select: $5020fd099f12a947$var$nodeQuery
    },
    node_patch_version: {
        matches: [
            "version"
        ],
        regexp: /^node\s+(\d+\.\d+\.\d+)$/i,
        select: $5020fd099f12a947$var$nodeQuery
    },
    current_node: {
        matches: [],
        regexp: /^current\s+node$/i,
        select: function(context) {
            return [
                $6ealC.currentNode($5020fd099f12a947$var$resolve, context)
            ];
        }
    },
    maintained_node: {
        matches: [],
        regexp: /^maintained\s+node\s+versions$/i,
        select: function(context) {
            var now = Date.now();
            var queries = Object.keys($hZDcp).filter(function(key) {
                return now < Date.parse($hZDcp[key].end) && now > Date.parse($hZDcp[key].start) && $5020fd099f12a947$var$isEolReleased(key);
            }).map(function(key) {
                return "node " + key.slice(1);
            });
            return $5020fd099f12a947$var$resolve(queries, context);
        }
    },
    phantomjs_1_9: {
        matches: [],
        regexp: /^phantomjs\s+1.9$/i,
        select: function() {
            return [
                "safari 5"
            ];
        }
    },
    phantomjs_2_1: {
        matches: [],
        regexp: /^phantomjs\s+2.1$/i,
        select: function() {
            return [
                "safari 6"
            ];
        }
    },
    browser_version: {
        matches: [
            "browser",
            "version"
        ],
        regexp: /^(\w+)\s+(tp|[\d.]+)$/i,
        select: function(context, node) {
            var version = node.version;
            if (/^tp$/i.test(version)) version = "TP";
            var data = $5020fd099f12a947$var$checkName(node.browser, context);
            var alias = $5020fd099f12a947$var$normalizeVersion(data, version);
            if (alias) version = alias;
            else {
                if (version.indexOf(".") === -1) alias = version + ".0";
                else alias = version.replace(/\.0$/, "");
                alias = $5020fd099f12a947$var$normalizeVersion(data, alias);
                if (alias) version = alias;
                else if (context.ignoreUnknownVersions) return [];
                else throw new $hvjyX("Unknown version " + version + " of " + node.browser);
            }
            return [
                data.name + " " + version
            ];
        }
    },
    browserslist_config: {
        matches: [],
        regexp: /^browserslist config$/i,
        select: function(context) {
            return $5020fd099f12a947$var$browserslist(undefined, context);
        }
    },
    extends: {
        matches: [
            "config"
        ],
        regexp: /^extends (.+)$/i,
        select: function(context, node) {
            return $5020fd099f12a947$var$resolve($6ealC.loadQueries(context, node.config), context);
        }
    },
    defaults: {
        matches: [],
        regexp: /^defaults$/i,
        select: function(context) {
            return $5020fd099f12a947$var$resolve($5020fd099f12a947$var$browserslist.defaults, context);
        }
    },
    dead: {
        matches: [],
        regexp: /^dead$/i,
        select: function(context) {
            var dead = [
                "Baidu >= 0",
                "ie <= 11",
                "ie_mob <= 11",
                "bb <= 10",
                "op_mob <= 12.1",
                "samsung 4"
            ];
            return $5020fd099f12a947$var$resolve(dead, context);
        }
    },
    unknown: {
        matches: [],
        regexp: /^(\w+)$/i,
        select: function(context, node) {
            if ($5020fd099f12a947$var$byName(node.query, context)) throw new $hvjyX("Specify versions in Browserslist query for browser " + node.query);
            else throw $5020fd099f12a947$var$unknownQuery(node.query);
        }
    }
};
(function() {
    for(var name in $5020fd099f12a947$require$agents){
        var browser = $5020fd099f12a947$require$agents[name];
        $5020fd099f12a947$var$browserslist.data[name] = {
            name: name,
            versions: $5020fd099f12a947$var$normalize($5020fd099f12a947$require$agents[name].versions),
            released: $5020fd099f12a947$var$normalize($5020fd099f12a947$require$agents[name].versions.slice(0, -3)),
            releaseDate: $5020fd099f12a947$require$agents[name].release_date
        };
        $5020fd099f12a947$var$fillUsage($5020fd099f12a947$var$browserslist.usage.global, name, browser.usage_global);
        $5020fd099f12a947$var$browserslist.versionAliases[name] = {};
        for(var i = 0; i < browser.versions.length; i++){
            var full = browser.versions[i];
            if (!full) continue;
            if (full.indexOf("-") !== -1) {
                var interval = full.split("-");
                for(var j = 0; j < interval.length; j++)$5020fd099f12a947$var$browserslist.versionAliases[name][interval[j]] = full;
            }
        }
    }
    $5020fd099f12a947$var$browserslist.nodeVersions = $9GFX7.map(function(release) {
        return release.version;
    });
})();
module.exports = $5020fd099f12a947$var$browserslist;

});
parcelRegister("9GFX7", function(module, exports) {
module.exports = JSON.parse('[{"name":"nodejs","version":"0.2.0","date":"2011-08-26","lts":false,"security":false,"v8":"2.3.8.0"},{"name":"nodejs","version":"0.3.0","date":"2011-08-26","lts":false,"security":false,"v8":"2.5.1.0"},{"name":"nodejs","version":"0.4.0","date":"2011-08-26","lts":false,"security":false,"v8":"3.1.2.0"},{"name":"nodejs","version":"0.5.0","date":"2011-08-26","lts":false,"security":false,"v8":"3.1.8.25"},{"name":"nodejs","version":"0.6.0","date":"2011-11-04","lts":false,"security":false,"v8":"3.6.6.6"},{"name":"nodejs","version":"0.7.0","date":"2012-01-17","lts":false,"security":false,"v8":"3.8.6.0"},{"name":"nodejs","version":"0.8.0","date":"2012-06-22","lts":false,"security":false,"v8":"3.11.10.10"},{"name":"nodejs","version":"0.9.0","date":"2012-07-20","lts":false,"security":false,"v8":"3.11.10.15"},{"name":"nodejs","version":"0.10.0","date":"2013-03-11","lts":false,"security":false,"v8":"3.14.5.8"},{"name":"nodejs","version":"0.11.0","date":"2013-03-28","lts":false,"security":false,"v8":"3.17.13.0"},{"name":"nodejs","version":"0.12.0","date":"2015-02-06","lts":false,"security":false,"v8":"3.28.73.0"},{"name":"nodejs","version":"4.0.0","date":"2015-09-08","lts":false,"security":false,"v8":"4.5.103.30"},{"name":"nodejs","version":"4.1.0","date":"2015-09-17","lts":false,"security":false,"v8":"4.5.103.33"},{"name":"nodejs","version":"4.2.0","date":"2015-10-12","lts":"Argon","security":false,"v8":"4.5.103.35"},{"name":"nodejs","version":"4.3.0","date":"2016-02-09","lts":"Argon","security":false,"v8":"4.5.103.35"},{"name":"nodejs","version":"4.4.0","date":"2016-03-08","lts":"Argon","security":false,"v8":"4.5.103.35"},{"name":"nodejs","version":"4.5.0","date":"2016-08-16","lts":"Argon","security":false,"v8":"4.5.103.37"},{"name":"nodejs","version":"4.6.0","date":"2016-09-27","lts":"Argon","security":true,"v8":"4.5.103.37"},{"name":"nodejs","version":"4.7.0","date":"2016-12-06","lts":"Argon","security":false,"v8":"4.5.103.43"},{"name":"nodejs","version":"4.8.0","date":"2017-02-21","lts":"Argon","security":false,"v8":"4.5.103.45"},{"name":"nodejs","version":"4.9.0","date":"2018-03-28","lts":"Argon","security":true,"v8":"4.5.103.53"},{"name":"nodejs","version":"5.0.0","date":"2015-10-29","lts":false,"security":false,"v8":"4.6.85.28"},{"name":"nodejs","version":"5.1.0","date":"2015-11-17","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.2.0","date":"2015-12-09","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.3.0","date":"2015-12-15","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.4.0","date":"2016-01-06","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.5.0","date":"2016-01-21","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.6.0","date":"2016-02-09","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.7.0","date":"2016-02-23","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.8.0","date":"2016-03-09","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.9.0","date":"2016-03-16","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.10.0","date":"2016-04-01","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.11.0","date":"2016-04-21","lts":false,"security":false,"v8":"4.6.85.31"},{"name":"nodejs","version":"5.12.0","date":"2016-06-23","lts":false,"security":false,"v8":"4.6.85.32"},{"name":"nodejs","version":"6.0.0","date":"2016-04-26","lts":false,"security":false,"v8":"5.0.71.35"},{"name":"nodejs","version":"6.1.0","date":"2016-05-05","lts":false,"security":false,"v8":"5.0.71.35"},{"name":"nodejs","version":"6.2.0","date":"2016-05-17","lts":false,"security":false,"v8":"5.0.71.47"},{"name":"nodejs","version":"6.3.0","date":"2016-07-06","lts":false,"security":false,"v8":"5.0.71.52"},{"name":"nodejs","version":"6.4.0","date":"2016-08-12","lts":false,"security":false,"v8":"5.0.71.60"},{"name":"nodejs","version":"6.5.0","date":"2016-08-26","lts":false,"security":false,"v8":"5.1.281.81"},{"name":"nodejs","version":"6.6.0","date":"2016-09-14","lts":false,"security":false,"v8":"5.1.281.83"},{"name":"nodejs","version":"6.7.0","date":"2016-09-27","lts":false,"security":true,"v8":"5.1.281.83"},{"name":"nodejs","version":"6.8.0","date":"2016-10-12","lts":false,"security":false,"v8":"5.1.281.84"},{"name":"nodejs","version":"6.9.0","date":"2016-10-18","lts":"Boron","security":false,"v8":"5.1.281.84"},{"name":"nodejs","version":"6.10.0","date":"2017-02-21","lts":"Boron","security":false,"v8":"5.1.281.93"},{"name":"nodejs","version":"6.11.0","date":"2017-06-06","lts":"Boron","security":false,"v8":"5.1.281.102"},{"name":"nodejs","version":"6.12.0","date":"2017-11-06","lts":"Boron","security":false,"v8":"5.1.281.108"},{"name":"nodejs","version":"6.13.0","date":"2018-02-10","lts":"Boron","security":false,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.14.0","date":"2018-03-28","lts":"Boron","security":true,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.15.0","date":"2018-11-27","lts":"Boron","security":true,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.16.0","date":"2018-12-26","lts":"Boron","security":false,"v8":"5.1.281.111"},{"name":"nodejs","version":"6.17.0","date":"2019-02-28","lts":"Boron","security":true,"v8":"5.1.281.111"},{"name":"nodejs","version":"7.0.0","date":"2016-10-25","lts":false,"security":false,"v8":"5.4.500.36"},{"name":"nodejs","version":"7.1.0","date":"2016-11-08","lts":false,"security":false,"v8":"5.4.500.36"},{"name":"nodejs","version":"7.2.0","date":"2016-11-22","lts":false,"security":false,"v8":"5.4.500.43"},{"name":"nodejs","version":"7.3.0","date":"2016-12-20","lts":false,"security":false,"v8":"5.4.500.45"},{"name":"nodejs","version":"7.4.0","date":"2017-01-04","lts":false,"security":false,"v8":"5.4.500.45"},{"name":"nodejs","version":"7.5.0","date":"2017-01-31","lts":false,"security":false,"v8":"5.4.500.48"},{"name":"nodejs","version":"7.6.0","date":"2017-02-21","lts":false,"security":false,"v8":"5.5.372.40"},{"name":"nodejs","version":"7.7.0","date":"2017-02-28","lts":false,"security":false,"v8":"5.5.372.41"},{"name":"nodejs","version":"7.8.0","date":"2017-03-29","lts":false,"security":false,"v8":"5.5.372.43"},{"name":"nodejs","version":"7.9.0","date":"2017-04-11","lts":false,"security":false,"v8":"5.5.372.43"},{"name":"nodejs","version":"7.10.0","date":"2017-05-02","lts":false,"security":false,"v8":"5.5.372.43"},{"name":"nodejs","version":"8.0.0","date":"2017-05-30","lts":false,"security":false,"v8":"5.8.283.41"},{"name":"nodejs","version":"8.1.0","date":"2017-06-08","lts":false,"security":false,"v8":"5.8.283.41"},{"name":"nodejs","version":"8.2.0","date":"2017-07-19","lts":false,"security":false,"v8":"5.8.283.41"},{"name":"nodejs","version":"8.3.0","date":"2017-08-08","lts":false,"security":false,"v8":"6.0.286.52"},{"name":"nodejs","version":"8.4.0","date":"2017-08-15","lts":false,"security":false,"v8":"6.0.286.52"},{"name":"nodejs","version":"8.5.0","date":"2017-09-12","lts":false,"security":false,"v8":"6.0.287.53"},{"name":"nodejs","version":"8.6.0","date":"2017-09-26","lts":false,"security":false,"v8":"6.0.287.53"},{"name":"nodejs","version":"8.7.0","date":"2017-10-11","lts":false,"security":false,"v8":"6.1.534.42"},{"name":"nodejs","version":"8.8.0","date":"2017-10-24","lts":false,"security":false,"v8":"6.1.534.42"},{"name":"nodejs","version":"8.9.0","date":"2017-10-31","lts":"Carbon","security":false,"v8":"6.1.534.46"},{"name":"nodejs","version":"8.10.0","date":"2018-03-06","lts":"Carbon","security":false,"v8":"6.2.414.50"},{"name":"nodejs","version":"8.11.0","date":"2018-03-28","lts":"Carbon","security":true,"v8":"6.2.414.50"},{"name":"nodejs","version":"8.12.0","date":"2018-09-10","lts":"Carbon","security":false,"v8":"6.2.414.66"},{"name":"nodejs","version":"8.13.0","date":"2018-11-20","lts":"Carbon","security":false,"v8":"6.2.414.72"},{"name":"nodejs","version":"8.14.0","date":"2018-11-27","lts":"Carbon","security":true,"v8":"6.2.414.72"},{"name":"nodejs","version":"8.15.0","date":"2018-12-26","lts":"Carbon","security":false,"v8":"6.2.414.75"},{"name":"nodejs","version":"8.16.0","date":"2019-04-16","lts":"Carbon","security":false,"v8":"6.2.414.77"},{"name":"nodejs","version":"8.17.0","date":"2019-12-17","lts":"Carbon","security":true,"v8":"6.2.414.78"},{"name":"nodejs","version":"9.0.0","date":"2017-10-31","lts":false,"security":false,"v8":"6.2.414.32"},{"name":"nodejs","version":"9.1.0","date":"2017-11-07","lts":false,"security":false,"v8":"6.2.414.32"},{"name":"nodejs","version":"9.2.0","date":"2017-11-14","lts":false,"security":false,"v8":"6.2.414.44"},{"name":"nodejs","version":"9.3.0","date":"2017-12-12","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.4.0","date":"2018-01-10","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.5.0","date":"2018-01-31","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.6.0","date":"2018-02-21","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.7.0","date":"2018-03-01","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.8.0","date":"2018-03-07","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.9.0","date":"2018-03-21","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.10.0","date":"2018-03-28","lts":false,"security":true,"v8":"6.2.414.46"},{"name":"nodejs","version":"9.11.0","date":"2018-04-04","lts":false,"security":false,"v8":"6.2.414.46"},{"name":"nodejs","version":"10.0.0","date":"2018-04-24","lts":false,"security":false,"v8":"6.6.346.24"},{"name":"nodejs","version":"10.1.0","date":"2018-05-08","lts":false,"security":false,"v8":"6.6.346.27"},{"name":"nodejs","version":"10.2.0","date":"2018-05-23","lts":false,"security":false,"v8":"6.6.346.32"},{"name":"nodejs","version":"10.3.0","date":"2018-05-29","lts":false,"security":false,"v8":"6.6.346.32"},{"name":"nodejs","version":"10.4.0","date":"2018-06-06","lts":false,"security":false,"v8":"6.7.288.43"},{"name":"nodejs","version":"10.5.0","date":"2018-06-20","lts":false,"security":false,"v8":"6.7.288.46"},{"name":"nodejs","version":"10.6.0","date":"2018-07-04","lts":false,"security":false,"v8":"6.7.288.46"},{"name":"nodejs","version":"10.7.0","date":"2018-07-18","lts":false,"security":false,"v8":"6.7.288.49"},{"name":"nodejs","version":"10.8.0","date":"2018-08-01","lts":false,"security":false,"v8":"6.7.288.49"},{"name":"nodejs","version":"10.9.0","date":"2018-08-15","lts":false,"security":false,"v8":"6.8.275.24"},{"name":"nodejs","version":"10.10.0","date":"2018-09-06","lts":false,"security":false,"v8":"6.8.275.30"},{"name":"nodejs","version":"10.11.0","date":"2018-09-19","lts":false,"security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.12.0","date":"2018-10-10","lts":false,"security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.13.0","date":"2018-10-30","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.14.0","date":"2018-11-27","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.15.0","date":"2018-12-26","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.16.0","date":"2019-05-28","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.17.0","date":"2019-10-22","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.18.0","date":"2019-12-17","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.19.0","date":"2020-02-05","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.20.0","date":"2020-03-26","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.21.0","date":"2020-06-02","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.22.0","date":"2020-07-21","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.23.0","date":"2020-10-27","lts":"Dubnium","security":false,"v8":"6.8.275.32"},{"name":"nodejs","version":"10.24.0","date":"2021-02-23","lts":"Dubnium","security":true,"v8":"6.8.275.32"},{"name":"nodejs","version":"11.0.0","date":"2018-10-23","lts":false,"security":false,"v8":"7.0.276.28"},{"name":"nodejs","version":"11.1.0","date":"2018-10-30","lts":false,"security":false,"v8":"7.0.276.32"},{"name":"nodejs","version":"11.2.0","date":"2018-11-15","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.3.0","date":"2018-11-27","lts":false,"security":true,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.4.0","date":"2018-12-07","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.5.0","date":"2018-12-18","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.6.0","date":"2018-12-26","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.7.0","date":"2019-01-17","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.8.0","date":"2019-01-24","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.9.0","date":"2019-01-30","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.10.0","date":"2019-02-14","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.11.0","date":"2019-03-05","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.12.0","date":"2019-03-14","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.13.0","date":"2019-03-28","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.14.0","date":"2019-04-10","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"11.15.0","date":"2019-04-30","lts":false,"security":false,"v8":"7.0.276.38"},{"name":"nodejs","version":"12.0.0","date":"2019-04-23","lts":false,"security":false,"v8":"7.4.288.21"},{"name":"nodejs","version":"12.1.0","date":"2019-04-29","lts":false,"security":false,"v8":"7.4.288.21"},{"name":"nodejs","version":"12.2.0","date":"2019-05-07","lts":false,"security":false,"v8":"7.4.288.21"},{"name":"nodejs","version":"12.3.0","date":"2019-05-21","lts":false,"security":false,"v8":"7.4.288.27"},{"name":"nodejs","version":"12.4.0","date":"2019-06-04","lts":false,"security":false,"v8":"7.4.288.27"},{"name":"nodejs","version":"12.5.0","date":"2019-06-26","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.6.0","date":"2019-07-03","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.7.0","date":"2019-07-23","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.8.0","date":"2019-08-06","lts":false,"security":false,"v8":"7.5.288.22"},{"name":"nodejs","version":"12.9.0","date":"2019-08-20","lts":false,"security":false,"v8":"7.6.303.29"},{"name":"nodejs","version":"12.10.0","date":"2019-09-04","lts":false,"security":false,"v8":"7.6.303.29"},{"name":"nodejs","version":"12.11.0","date":"2019-09-25","lts":false,"security":false,"v8":"7.7.299.11"},{"name":"nodejs","version":"12.12.0","date":"2019-10-11","lts":false,"security":false,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.13.0","date":"2019-10-21","lts":"Erbium","security":false,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.14.0","date":"2019-12-17","lts":"Erbium","security":true,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.15.0","date":"2020-02-05","lts":"Erbium","security":true,"v8":"7.7.299.13"},{"name":"nodejs","version":"12.16.0","date":"2020-02-11","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.17.0","date":"2020-05-26","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.18.0","date":"2020-06-02","lts":"Erbium","security":true,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.19.0","date":"2020-10-06","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.20.0","date":"2020-11-24","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.21.0","date":"2021-02-23","lts":"Erbium","security":true,"v8":"7.8.279.23"},{"name":"nodejs","version":"12.22.0","date":"2021-03-30","lts":"Erbium","security":false,"v8":"7.8.279.23"},{"name":"nodejs","version":"13.0.0","date":"2019-10-22","lts":false,"security":false,"v8":"7.8.279.17"},{"name":"nodejs","version":"13.1.0","date":"2019-11-05","lts":false,"security":false,"v8":"7.8.279.17"},{"name":"nodejs","version":"13.2.0","date":"2019-11-21","lts":false,"security":false,"v8":"7.9.317.23"},{"name":"nodejs","version":"13.3.0","date":"2019-12-03","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.4.0","date":"2019-12-17","lts":false,"security":true,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.5.0","date":"2019-12-18","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.6.0","date":"2020-01-07","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.7.0","date":"2020-01-21","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.8.0","date":"2020-02-05","lts":false,"security":true,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.9.0","date":"2020-02-18","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.10.0","date":"2020-03-04","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.11.0","date":"2020-03-12","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.12.0","date":"2020-03-26","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.13.0","date":"2020-04-14","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"13.14.0","date":"2020-04-29","lts":false,"security":false,"v8":"7.9.317.25"},{"name":"nodejs","version":"14.0.0","date":"2020-04-21","lts":false,"security":false,"v8":"8.1.307.30"},{"name":"nodejs","version":"14.1.0","date":"2020-04-29","lts":false,"security":false,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.2.0","date":"2020-05-05","lts":false,"security":false,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.3.0","date":"2020-05-19","lts":false,"security":false,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.4.0","date":"2020-06-02","lts":false,"security":true,"v8":"8.1.307.31"},{"name":"nodejs","version":"14.5.0","date":"2020-06-30","lts":false,"security":false,"v8":"8.3.110.9"},{"name":"nodejs","version":"14.6.0","date":"2020-07-20","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.7.0","date":"2020-07-29","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.8.0","date":"2020-08-11","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.9.0","date":"2020-08-27","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.10.0","date":"2020-09-08","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.11.0","date":"2020-09-15","lts":false,"security":true,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.12.0","date":"2020-09-22","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.13.0","date":"2020-09-29","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.14.0","date":"2020-10-15","lts":false,"security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.15.0","date":"2020-10-27","lts":"Fermium","security":false,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.16.0","date":"2021-02-23","lts":"Fermium","security":true,"v8":"8.4.371.19"},{"name":"nodejs","version":"14.17.0","date":"2021-05-11","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.18.0","date":"2021-09-28","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.19.0","date":"2022-02-01","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.20.0","date":"2022-07-07","lts":"Fermium","security":true,"v8":"8.4.371.23"},{"name":"nodejs","version":"14.21.0","date":"2022-11-01","lts":"Fermium","security":false,"v8":"8.4.371.23"},{"name":"nodejs","version":"15.0.0","date":"2020-10-20","lts":false,"security":false,"v8":"8.6.395.16"},{"name":"nodejs","version":"15.1.0","date":"2020-11-04","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.2.0","date":"2020-11-10","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.3.0","date":"2020-11-24","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.4.0","date":"2020-12-09","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.5.0","date":"2020-12-22","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.6.0","date":"2021-01-14","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.7.0","date":"2021-01-25","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.8.0","date":"2021-02-02","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.9.0","date":"2021-02-18","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.10.0","date":"2021-02-23","lts":false,"security":true,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.11.0","date":"2021-03-03","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.12.0","date":"2021-03-17","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.13.0","date":"2021-03-31","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"15.14.0","date":"2021-04-06","lts":false,"security":false,"v8":"8.6.395.17"},{"name":"nodejs","version":"16.0.0","date":"2021-04-20","lts":false,"security":false,"v8":"9.0.257.17"},{"name":"nodejs","version":"16.1.0","date":"2021-05-04","lts":false,"security":false,"v8":"9.0.257.24"},{"name":"nodejs","version":"16.2.0","date":"2021-05-19","lts":false,"security":false,"v8":"9.0.257.25"},{"name":"nodejs","version":"16.3.0","date":"2021-06-03","lts":false,"security":false,"v8":"9.0.257.25"},{"name":"nodejs","version":"16.4.0","date":"2021-06-23","lts":false,"security":false,"v8":"9.1.269.36"},{"name":"nodejs","version":"16.5.0","date":"2021-07-14","lts":false,"security":false,"v8":"9.1.269.38"},{"name":"nodejs","version":"16.6.0","date":"2021-07-29","lts":false,"security":true,"v8":"9.2.230.21"},{"name":"nodejs","version":"16.7.0","date":"2021-08-18","lts":false,"security":false,"v8":"9.2.230.21"},{"name":"nodejs","version":"16.8.0","date":"2021-08-25","lts":false,"security":false,"v8":"9.2.230.21"},{"name":"nodejs","version":"16.9.0","date":"2021-09-07","lts":false,"security":false,"v8":"9.3.345.16"},{"name":"nodejs","version":"16.10.0","date":"2021-09-22","lts":false,"security":false,"v8":"9.3.345.19"},{"name":"nodejs","version":"16.11.0","date":"2021-10-08","lts":false,"security":false,"v8":"9.4.146.19"},{"name":"nodejs","version":"16.12.0","date":"2021-10-20","lts":false,"security":false,"v8":"9.4.146.19"},{"name":"nodejs","version":"16.13.0","date":"2021-10-26","lts":"Gallium","security":false,"v8":"9.4.146.19"},{"name":"nodejs","version":"16.14.0","date":"2022-02-08","lts":"Gallium","security":false,"v8":"9.4.146.24"},{"name":"nodejs","version":"16.15.0","date":"2022-04-26","lts":"Gallium","security":false,"v8":"9.4.146.24"},{"name":"nodejs","version":"16.16.0","date":"2022-07-07","lts":"Gallium","security":true,"v8":"9.4.146.24"},{"name":"nodejs","version":"16.17.0","date":"2022-08-16","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"16.18.0","date":"2022-10-12","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"16.19.0","date":"2022-12-13","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"16.20.0","date":"2023-03-28","lts":"Gallium","security":false,"v8":"9.4.146.26"},{"name":"nodejs","version":"17.0.0","date":"2021-10-19","lts":false,"security":false,"v8":"9.5.172.21"},{"name":"nodejs","version":"17.1.0","date":"2021-11-09","lts":false,"security":false,"v8":"9.5.172.25"},{"name":"nodejs","version":"17.2.0","date":"2021-11-30","lts":false,"security":false,"v8":"9.6.180.14"},{"name":"nodejs","version":"17.3.0","date":"2021-12-17","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.4.0","date":"2022-01-18","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.5.0","date":"2022-02-10","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.6.0","date":"2022-02-22","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.7.0","date":"2022-03-09","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.8.0","date":"2022-03-22","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"17.9.0","date":"2022-04-07","lts":false,"security":false,"v8":"9.6.180.15"},{"name":"nodejs","version":"18.0.0","date":"2022-04-18","lts":false,"security":false,"v8":"10.1.124.8"},{"name":"nodejs","version":"18.1.0","date":"2022-05-03","lts":false,"security":false,"v8":"10.1.124.8"},{"name":"nodejs","version":"18.2.0","date":"2022-05-17","lts":false,"security":false,"v8":"10.1.124.8"},{"name":"nodejs","version":"18.3.0","date":"2022-06-02","lts":false,"security":false,"v8":"10.2.154.4"},{"name":"nodejs","version":"18.4.0","date":"2022-06-16","lts":false,"security":false,"v8":"10.2.154.4"},{"name":"nodejs","version":"18.5.0","date":"2022-07-06","lts":false,"security":true,"v8":"10.2.154.4"},{"name":"nodejs","version":"18.6.0","date":"2022-07-13","lts":false,"security":false,"v8":"10.2.154.13"},{"name":"nodejs","version":"18.7.0","date":"2022-07-26","lts":false,"security":false,"v8":"10.2.154.13"},{"name":"nodejs","version":"18.8.0","date":"2022-08-24","lts":false,"security":false,"v8":"10.2.154.13"},{"name":"nodejs","version":"18.9.0","date":"2022-09-07","lts":false,"security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.10.0","date":"2022-09-28","lts":false,"security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.11.0","date":"2022-10-13","lts":false,"security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.12.0","date":"2022-10-25","lts":"Hydrogen","security":false,"v8":"10.2.154.15"},{"name":"nodejs","version":"18.13.0","date":"2023-01-05","lts":"Hydrogen","security":false,"v8":"10.2.154.23"},{"name":"nodejs","version":"18.14.0","date":"2023-02-01","lts":"Hydrogen","security":false,"v8":"10.2.154.23"},{"name":"nodejs","version":"18.15.0","date":"2023-03-05","lts":"Hydrogen","security":false,"v8":"10.2.154.26"},{"name":"nodejs","version":"18.16.0","date":"2023-04-12","lts":"Hydrogen","security":false,"v8":"10.2.154.26"},{"name":"nodejs","version":"19.0.0","date":"2022-10-17","lts":false,"security":false,"v8":"10.7.193.13"},{"name":"nodejs","version":"19.1.0","date":"2022-11-14","lts":false,"security":false,"v8":"10.7.193.20"},{"name":"nodejs","version":"19.2.0","date":"2022-11-29","lts":false,"security":false,"v8":"10.8.168.20"},{"name":"nodejs","version":"19.3.0","date":"2022-12-14","lts":false,"security":false,"v8":"10.8.168.21"},{"name":"nodejs","version":"19.4.0","date":"2023-01-05","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.5.0","date":"2023-01-24","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.6.0","date":"2023-02-01","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.7.0","date":"2023-02-21","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.8.0","date":"2023-03-14","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"19.9.0","date":"2023-04-10","lts":false,"security":false,"v8":"10.8.168.25"},{"name":"nodejs","version":"20.0.0","date":"2023-04-17","lts":false,"security":false,"v8":"11.3.244.4"},{"name":"nodejs","version":"20.1.0","date":"2023-05-03","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.2.0","date":"2023-05-16","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.3.0","date":"2023-06-08","lts":false,"security":false,"v8":"11.3.244.8"},{"name":"nodejs","version":"20.4.0","date":"2023-07-04","lts":false,"security":false,"v8":"11.3.244.8"}]');

});

parcelRegister("8uEuL", function(module, exports) {

$parcel$export(module.exports, "agents", function () { return $62f0898dc277ba87$export$ac5be7df5fa52a3c; }, function (v) { return $62f0898dc277ba87$export$ac5be7df5fa52a3c = v; });
var $62f0898dc277ba87$export$ac5be7df5fa52a3c;
"use strict";

var $i45OM = parcelRequire("i45OM");
var $62f0898dc277ba87$require$browsers = $i45OM.browsers;

var $dyHUy = parcelRequire("dyHUy");
var $62f0898dc277ba87$require$versions = $dyHUy.browserVersions;

var $57XJg = parcelRequire("57XJg");
function $62f0898dc277ba87$var$unpackBrowserVersions(versionsData) {
    return Object.keys(versionsData).reduce((usage, version)=>{
        usage[$62f0898dc277ba87$require$versions[version]] = versionsData[version];
        return usage;
    }, {});
}
$62f0898dc277ba87$export$ac5be7df5fa52a3c = Object.keys($57XJg).reduce((map, key)=>{
    let versionsData = $57XJg[key];
    map[$62f0898dc277ba87$require$browsers[key]] = Object.keys(versionsData).reduce((data, entry)=>{
        if (entry === "A") data.usage_global = $62f0898dc277ba87$var$unpackBrowserVersions(versionsData[entry]);
        else if (entry === "C") data.versions = versionsData[entry].reduce((list, version)=>{
            if (version === "") list.push(null);
            else list.push($62f0898dc277ba87$require$versions[version]);
            return list;
        }, []);
        else if (entry === "D") data.prefix_exceptions = $62f0898dc277ba87$var$unpackBrowserVersions(versionsData[entry]);
        else if (entry === "E") data.browser = versionsData[entry];
        else if (entry === "F") data.release_date = Object.keys(versionsData[entry]).reduce((map2, key2)=>{
            map2[$62f0898dc277ba87$require$versions[key2]] = versionsData[entry][key2];
            return map2;
        }, {});
        else // entry is B
        data.prefix = versionsData[entry];
        return data;
    }, {});
    return map;
}, {});

});
parcelRegister("i45OM", function(module, exports) {

$parcel$export(module.exports, "browsers", function () { return $d26d1d0a224cb3b6$export$804348712f697b1b; }, function (v) { return $d26d1d0a224cb3b6$export$804348712f697b1b = v; });
var $d26d1d0a224cb3b6$export$804348712f697b1b;

$d26d1d0a224cb3b6$export$804348712f697b1b = (parcelRequire("2rjQ4"));

});
parcelRegister("2rjQ4", function(module, exports) {
module.exports = {
    A: "ie",
    B: "edge",
    C: "firefox",
    D: "chrome",
    E: "safari",
    F: "opera",
    G: "ios_saf",
    H: "op_mini",
    I: "android",
    J: "bb",
    K: "op_mob",
    L: "and_chr",
    M: "and_ff",
    N: "ie_mob",
    O: "and_uc",
    P: "samsung",
    Q: "and_qq",
    R: "baidu",
    S: "kaios"
};

});


parcelRegister("dyHUy", function(module, exports) {

$parcel$export(module.exports, "browserVersions", function () { return $9df0832e6e9756f0$export$e0222f875ebd697e; }, function (v) { return $9df0832e6e9756f0$export$e0222f875ebd697e = v; });
var $9df0832e6e9756f0$export$e0222f875ebd697e;

$9df0832e6e9756f0$export$e0222f875ebd697e = (parcelRequire("eohAp"));

});
parcelRegister("eohAp", function(module, exports) {
module.exports = {
    "0": "113",
    "1": "114",
    "2": "115",
    "3": "116",
    "4": "117",
    "5": "5",
    "6": "19",
    "7": "23",
    "8": "24",
    "9": "25",
    A: "10",
    B: "11",
    C: "12",
    D: "118",
    E: "7",
    F: "8",
    G: "9",
    H: "15",
    I: "4",
    J: "6",
    K: "13",
    L: "14",
    M: "16",
    N: "17",
    O: "18",
    P: "79",
    Q: "80",
    R: "81",
    S: "83",
    T: "84",
    U: "85",
    V: "86",
    W: "87",
    X: "88",
    Y: "89",
    Z: "90",
    a: "91",
    b: "92",
    c: "93",
    d: "94",
    e: "95",
    f: "96",
    g: "97",
    h: "98",
    i: "99",
    j: "100",
    k: "101",
    l: "102",
    m: "103",
    n: "20",
    o: "21",
    p: "22",
    q: "73",
    r: "104",
    s: "105",
    t: "106",
    u: "107",
    v: "108",
    w: "109",
    x: "110",
    y: "111",
    z: "112",
    AB: "26",
    BB: "27",
    CB: "28",
    DB: "29",
    EB: "30",
    FB: "31",
    GB: "32",
    HB: "33",
    IB: "34",
    JB: "35",
    KB: "36",
    LB: "37",
    MB: "38",
    NB: "39",
    OB: "40",
    PB: "41",
    QB: "42",
    RB: "43",
    SB: "44",
    TB: "45",
    UB: "46",
    VB: "47",
    WB: "48",
    XB: "49",
    YB: "50",
    ZB: "51",
    aB: "52",
    bB: "53",
    cB: "54",
    dB: "55",
    eB: "56",
    fB: "57",
    gB: "58",
    hB: "60",
    iB: "62",
    jB: "63",
    kB: "64",
    lB: "65",
    mB: "66",
    nB: "67",
    oB: "68",
    pB: "69",
    qB: "70",
    rB: "71",
    sB: "72",
    tB: "74",
    uB: "75",
    vB: "76",
    wB: "77",
    xB: "78",
    yB: "11.1",
    zB: "12.1",
    "0B": "15.5",
    "1B": "16.0",
    "2B": "17.0",
    "3B": "3",
    "4B": "59",
    "5B": "61",
    "6B": "82",
    "7B": "119",
    "8B": "120",
    "9B": "121",
    AC: "3.2",
    BC: "10.1",
    CC: "13.1",
    DC: "15.2-15.3",
    EC: "15.4",
    FC: "16.1",
    GC: "16.2",
    HC: "16.3",
    IC: "16.4",
    JC: "16.5",
    KC: "16.6",
    LC: "17.1",
    MC: "17.2",
    NC: "11.5",
    OC: "4.2-4.3",
    PC: "5.5",
    QC: "2",
    RC: "3.5",
    SC: "3.6",
    TC: "3.1",
    UC: "5.1",
    VC: "6.1",
    WC: "7.1",
    XC: "9.1",
    YC: "14.1",
    ZC: "15.1",
    aC: "15.6",
    bC: "TP",
    cC: "9.5-9.6",
    dC: "10.0-10.1",
    eC: "10.5",
    fC: "10.6",
    gC: "11.6",
    hC: "4.0-4.1",
    iC: "5.0-5.1",
    jC: "6.0-6.1",
    kC: "7.0-7.1",
    lC: "8.1-8.4",
    mC: "9.0-9.2",
    nC: "9.3",
    oC: "10.0-10.2",
    pC: "10.3",
    qC: "11.0-11.2",
    rC: "11.3-11.4",
    sC: "12.0-12.1",
    tC: "12.2-12.5",
    uC: "13.0-13.1",
    vC: "13.2",
    wC: "13.3",
    xC: "13.4-13.7",
    yC: "14.0-14.4",
    zC: "14.5-14.8",
    "0C": "15.0-15.1",
    "1C": "15.6-15.7",
    "2C": "all",
    "3C": "2.1",
    "4C": "2.2",
    "5C": "2.3",
    "6C": "4.1",
    "7C": "4.4",
    "8C": "4.4.3-4.4.4",
    "9C": "5.0-5.4",
    AD: "6.2-6.4",
    BD: "7.2-7.4",
    CD: "8.2",
    DD: "9.2",
    ED: "11.1-11.2",
    FD: "12.0",
    GD: "13.0",
    HD: "14.0",
    ID: "15.0",
    JD: "18.0",
    KD: "19.0",
    LD: "13.18",
    MD: "2.5",
    ND: "3.0-3.1"
};

});


parcelRegister("57XJg", function(module, exports) {
module.exports = {
    A: {
        A: {
            J: 0,
            E: 0,
            F: 0.0259843,
            G: 0.0649608,
            A: 0,
            B: 0.389765,
            PC: 0
        },
        B: "ms",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "PC",
            "J",
            "E",
            "F",
            "G",
            "A",
            "B",
            "",
            "",
            ""
        ],
        E: "IE",
        F: {
            PC: 962323200,
            J: 998870400,
            E: 1161129600,
            F: 1237420800,
            G: 1300060800,
            A: 1346716800,
            B: 1381968000
        }
    },
    B: {
        A: {
            "0": 0.02721,
            "1": 0.176865,
            "2": 0.14512,
            "3": 2.54867,
            "4": 1.76865,
            C: 0.004535,
            K: 0.004535,
            L: 0.004535,
            H: 0.004535,
            M: 0,
            N: 0.004535,
            O: 0.013605,
            P: 0,
            Q: 0.00907,
            R: 0.00907,
            S: 0.00907,
            T: 0.00907,
            U: 0.004535,
            V: 0.00907,
            W: 0.004535,
            X: 0.004535,
            Y: 0.004535,
            Z: 0.00907,
            a: 0,
            b: 0.013605,
            c: 0,
            d: 0,
            e: 0,
            f: 0,
            g: 0,
            h: 0,
            i: 0.013605,
            j: 0,
            k: 0,
            l: 0,
            m: 0,
            r: 0,
            s: 0,
            t: 0,
            u: 0.00907,
            v: 0.00907,
            w: 0.07256,
            x: 0.013605,
            y: 0.12698,
            z: 0.12698,
            D: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "C",
            "K",
            "L",
            "H",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "D",
            "",
            "",
            ""
        ],
        E: "Edge",
        F: {
            "0": 1683158400,
            "1": 1685664000,
            "2": 1689897600,
            "3": 1692576000,
            "4": 1694649600,
            C: 1438128000,
            K: 1447286400,
            L: 1470096000,
            H: 1491868800,
            M: 1508198400,
            N: 1525046400,
            O: 1542067200,
            P: 1579046400,
            Q: 1581033600,
            R: 1586736000,
            S: 1590019200,
            T: 1594857600,
            U: 1598486400,
            V: 1602201600,
            W: 1605830400,
            X: 1611360000,
            Y: 1614816000,
            Z: 1618358400,
            a: 1622073600,
            b: 1626912000,
            c: 1630627200,
            d: 1632441600,
            e: 1634774400,
            f: 1637539200,
            g: 1641427200,
            h: 1643932800,
            i: 1646265600,
            j: 1649635200,
            k: 1651190400,
            l: 1653955200,
            m: 1655942400,
            r: 1659657600,
            s: 1661990400,
            t: 1664755200,
            u: 1666915200,
            v: 1670198400,
            w: 1673481600,
            x: 1675900800,
            y: 1678665600,
            z: 1680825600,
            D: 1697155200
        },
        D: {
            C: "ms",
            K: "ms",
            L: "ms",
            H: "ms",
            M: "ms",
            N: "ms",
            O: "ms"
        }
    },
    C: {
        A: {
            "0": 0.01814,
            "1": 0.01814,
            "2": 0.31745,
            "3": 0.113375,
            "4": 1.56457,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            QC: 0,
            "3B": 0,
            I: 0,
            J: 0,
            E: 0,
            F: 0,
            G: 0,
            A: 0,
            B: 0.00907,
            C: 0,
            K: 0,
            L: 0,
            H: 0,
            M: 0,
            N: 0,
            O: 0,
            n: 0,
            o: 0,
            p: 0,
            AB: 0,
            BB: 0,
            CB: 0,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            KB: 0,
            LB: 0,
            MB: 0,
            NB: 0,
            OB: 0,
            PB: 0,
            QB: 0,
            RB: 0.004535,
            SB: 0.004535,
            TB: 0.004535,
            UB: 0,
            VB: 0,
            WB: 0.01814,
            XB: 0,
            YB: 0.00907,
            ZB: 0,
            aB: 0.05442,
            bB: 0.00907,
            cB: 0.00907,
            dB: 0,
            eB: 0.013605,
            fB: 0,
            gB: 0,
            "4B": 0.004535,
            hB: 0,
            "5B": 0,
            iB: 0,
            jB: 0,
            kB: 0,
            lB: 0,
            mB: 0,
            nB: 0,
            oB: 0,
            pB: 0,
            qB: 0,
            rB: 0,
            sB: 0.013605,
            q: 0,
            tB: 0,
            uB: 0,
            vB: 0,
            wB: 0,
            xB: 0.03628,
            P: 0,
            Q: 0,
            R: 0,
            "6B": 0,
            S: 0.004535,
            T: 0,
            U: 0,
            V: 0,
            W: 0,
            X: 0.004535,
            Y: 0.004535,
            Z: 0,
            a: 0.004535,
            b: 0,
            c: 0,
            d: 0.004535,
            e: 0,
            f: 0,
            g: 0,
            h: 0,
            i: 0,
            j: 0,
            k: 0,
            l: 0.11791,
            m: 0.022675,
            r: 0,
            s: 0.004535,
            t: 0.004535,
            u: 0.004535,
            v: 0.00907,
            w: 0.00907,
            x: 0.00907,
            y: 0.00907,
            z: 0.06349,
            D: 0.13605,
            "7B": 0,
            "8B": 0,
            "9B": 0,
            RC: 0,
            SC: 0
        },
        B: "moz",
        C: [
            "QC",
            "3B",
            "RC",
            "SC",
            "I",
            "5",
            "J",
            "E",
            "F",
            "G",
            "A",
            "B",
            "C",
            "K",
            "L",
            "H",
            "M",
            "N",
            "O",
            "6",
            "n",
            "o",
            "p",
            "7",
            "8",
            "9",
            "AB",
            "BB",
            "CB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "KB",
            "LB",
            "MB",
            "NB",
            "OB",
            "PB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "4B",
            "hB",
            "5B",
            "iB",
            "jB",
            "kB",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "q",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "P",
            "Q",
            "R",
            "6B",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "D",
            "7B",
            "8B",
            "9B"
        ],
        E: "Firefox",
        F: {
            "0": 1683590400,
            "1": 1686009600,
            "2": 1688428800,
            "3": 1690848000,
            "4": 1693267200,
            "5": 1308614400,
            "6": 1357603200,
            "7": 1372118400,
            "8": 1375747200,
            "9": 1379376000,
            QC: 1161648000,
            "3B": 1213660800,
            RC: 1246320000,
            SC: 1264032000,
            I: 1300752000,
            J: 1313452800,
            E: 1317081600,
            F: 1317081600,
            G: 1320710400,
            A: 1324339200,
            B: 1327968000,
            C: 1331596800,
            K: 1335225600,
            L: 1338854400,
            H: 1342483200,
            M: 1346112000,
            N: 1349740800,
            O: 1353628800,
            n: 1361232000,
            o: 1364860800,
            p: 1368489600,
            AB: 1386633600,
            BB: 1391472000,
            CB: 1395100800,
            DB: 1398729600,
            EB: 1402358400,
            FB: 1405987200,
            GB: 1409616000,
            HB: 1413244800,
            IB: 1417392000,
            JB: 1421107200,
            KB: 1424736000,
            LB: 1428278400,
            MB: 1431475200,
            NB: 1435881600,
            OB: 1439251200,
            PB: 1442880000,
            QB: 1446508800,
            RB: 1450137600,
            SB: 1453852800,
            TB: 1457395200,
            UB: 1461628800,
            VB: 1465257600,
            WB: 1470096000,
            XB: 1474329600,
            YB: 1479168000,
            ZB: 1485216000,
            aB: 1488844800,
            bB: 1492560000,
            cB: 1497312000,
            dB: 1502150400,
            eB: 1506556800,
            fB: 1510617600,
            gB: 1516665600,
            "4B": 1520985600,
            hB: 1525824000,
            "5B": 1529971200,
            iB: 1536105600,
            jB: 1540252800,
            kB: 1544486400,
            lB: 1548720000,
            mB: 1552953600,
            nB: 1558396800,
            oB: 1562630400,
            pB: 1567468800,
            qB: 1571788800,
            rB: 1575331200,
            sB: 1578355200,
            q: 1581379200,
            tB: 1583798400,
            uB: 1586304000,
            vB: 1588636800,
            wB: 1591056000,
            xB: 1593475200,
            P: 1595894400,
            Q: 1598313600,
            R: 1600732800,
            "6B": 1603152000,
            S: 1605571200,
            T: 1607990400,
            U: 1611619200,
            V: 1614038400,
            W: 1616457600,
            X: 1618790400,
            Y: 1622505600,
            Z: 1626134400,
            a: 1628553600,
            b: 1630972800,
            c: 1633392000,
            d: 1635811200,
            e: 1638835200,
            f: 1641859200,
            g: 1644364800,
            h: 1646697600,
            i: 1649116800,
            j: 1651536000,
            k: 1653955200,
            l: 1656374400,
            m: 1658793600,
            r: 1661212800,
            s: 1663632000,
            t: 1666051200,
            u: 1668470400,
            v: 1670889600,
            w: 1673913600,
            x: 1676332800,
            y: 1678752000,
            z: 1681171200,
            D: 1695686400,
            "7B": null,
            "8B": null,
            "9B": null
        }
    },
    D: {
        A: {
            "0": 0.15419,
            "1": 0.829905,
            "2": 1.44213,
            "3": 15.3691,
            "4": 3.86382,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            I: 0,
            J: 0,
            E: 0,
            F: 0,
            G: 0,
            A: 0,
            B: 0,
            C: 0,
            K: 0,
            L: 0,
            H: 0,
            M: 0,
            N: 0,
            O: 0,
            n: 0,
            o: 0,
            p: 0,
            AB: 0,
            BB: 0,
            CB: 0,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0.004535,
            JB: 0,
            KB: 0,
            LB: 0,
            MB: 0.013605,
            NB: 0,
            OB: 0,
            PB: 0,
            QB: 0,
            RB: 0,
            SB: 0,
            TB: 0,
            UB: 0,
            VB: 0.00907,
            WB: 0.01814,
            XB: 0.03628,
            YB: 0.00907,
            ZB: 0.004535,
            aB: 0,
            bB: 0.00907,
            cB: 0,
            dB: 0.00907,
            eB: 0.031745,
            fB: 0.00907,
            gB: 0.00907,
            "4B": 0,
            hB: 0.02721,
            "5B": 0.004535,
            iB: 0.004535,
            jB: 0.004535,
            kB: 0,
            lB: 0.013605,
            mB: 0.022675,
            nB: 0.004535,
            oB: 0.031745,
            pB: 0.06349,
            qB: 0.077095,
            rB: 0.022675,
            sB: 0.031745,
            q: 0.040815,
            tB: 0.040815,
            uB: 0.040815,
            vB: 0.104305,
            wB: 0.03628,
            xB: 0.04535,
            P: 0.204075,
            Q: 0.068025,
            R: 0.06349,
            S: 0.113375,
            T: 0.03628,
            U: 0.086165,
            V: 0.0907,
            W: 0.09977,
            X: 0.058955,
            Y: 0.04535,
            Z: 0.068025,
            a: 0.07256,
            b: 0.02721,
            c: 0.131515,
            d: 0.02721,
            e: 0.013605,
            f: 0.022675,
            g: 0.02721,
            h: 0.068025,
            i: 0.04535,
            j: 0.031745,
            k: 0.03628,
            l: 0.040815,
            m: 0.21768,
            r: 0.04535,
            s: 0.049885,
            t: 0.05442,
            u: 0.17233,
            v: 0.213145,
            w: 1.78679,
            x: 0.185935,
            y: 0.32652,
            z: 0.24489,
            D: 0.022675,
            "7B": 0.013605,
            "8B": 0,
            "9B": 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "I",
            "5",
            "J",
            "E",
            "F",
            "G",
            "A",
            "B",
            "C",
            "K",
            "L",
            "H",
            "M",
            "N",
            "O",
            "6",
            "n",
            "o",
            "p",
            "7",
            "8",
            "9",
            "AB",
            "BB",
            "CB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "KB",
            "LB",
            "MB",
            "NB",
            "OB",
            "PB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "4B",
            "hB",
            "5B",
            "iB",
            "jB",
            "kB",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "q",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "r",
            "s",
            "t",
            "u",
            "v",
            "w",
            "x",
            "y",
            "z",
            "0",
            "1",
            "2",
            "3",
            "4",
            "D",
            "7B",
            "8B",
            "9B"
        ],
        E: "Chrome",
        F: {
            "0": 1682985600,
            "1": 1685404800,
            "2": 1689724800,
            "3": 1692057600,
            "4": 1694476800,
            "5": 1274745600,
            "6": 1332892800,
            "7": 1348531200,
            "8": 1352246400,
            "9": 1357862400,
            I: 1264377600,
            J: 1283385600,
            E: 1287619200,
            F: 1291248000,
            G: 1296777600,
            A: 1299542400,
            B: 1303862400,
            C: 1307404800,
            K: 1312243200,
            L: 1316131200,
            H: 1316131200,
            M: 1319500800,
            N: 1323734400,
            O: 1328659200,
            n: 1337040000,
            o: 1340668800,
            p: 1343692800,
            AB: 1361404800,
            BB: 1364428800,
            CB: 1369094400,
            DB: 1374105600,
            EB: 1376956800,
            FB: 1384214400,
            GB: 1389657600,
            HB: 1392940800,
            IB: 1397001600,
            JB: 1400544000,
            KB: 1405468800,
            LB: 1409011200,
            MB: 1412640000,
            NB: 1416268800,
            OB: 1421798400,
            PB: 1425513600,
            QB: 1429401600,
            RB: 1432080000,
            SB: 1437523200,
            TB: 1441152000,
            UB: 1444780800,
            VB: 1449014400,
            WB: 1453248000,
            XB: 1456963200,
            YB: 1460592000,
            ZB: 1464134400,
            aB: 1469059200,
            bB: 1472601600,
            cB: 1476230400,
            dB: 1480550400,
            eB: 1485302400,
            fB: 1489017600,
            gB: 1492560000,
            "4B": 1496707200,
            hB: 1500940800,
            "5B": 1504569600,
            iB: 1508198400,
            jB: 1512518400,
            kB: 1516752000,
            lB: 1520294400,
            mB: 1523923200,
            nB: 1527552000,
            oB: 1532390400,
            pB: 1536019200,
            qB: 1539648000,
            rB: 1543968000,
            sB: 1548720000,
            q: 1552348800,
            tB: 1555977600,
            uB: 1559606400,
            vB: 1564444800,
            wB: 1568073600,
            xB: 1571702400,
            P: 1575936000,
            Q: 1580860800,
            R: 1586304000,
            S: 1589846400,
            T: 1594684800,
            U: 1598313600,
            V: 1601942400,
            W: 1605571200,
            X: 1611014400,
            Y: 1614556800,
            Z: 1618272000,
            a: 1621987200,
            b: 1626739200,
            c: 1630368000,
            d: 1632268800,
            e: 1634601600,
            f: 1637020800,
            g: 1641340800,
            h: 1643673600,
            i: 1646092800,
            j: 1648512000,
            k: 1650931200,
            l: 1653350400,
            m: 1655769600,
            r: 1659398400,
            s: 1661817600,
            t: 1664236800,
            u: 1666656000,
            v: 1669680000,
            w: 1673308800,
            x: 1675728000,
            y: 1678147200,
            z: 1680566400,
            D: 1696896000,
            "7B": null,
            "8B": null,
            "9B": null
        }
    },
    E: {
        A: {
            "5": 0,
            I: 0,
            J: 0,
            E: 0,
            F: 0,
            G: 0,
            A: 0,
            B: 0,
            C: 0,
            K: 0.01814,
            L: 0.0907,
            H: 0.01814,
            TC: 0,
            AC: 0,
            UC: 0.00907,
            VC: 0,
            WC: 0,
            XC: 0.1814,
            BC: 0,
            yB: 0.004535,
            zB: 0.02721,
            CC: 0.131515,
            YC: 0.240355,
            ZC: 0.040815,
            DC: 0.03628,
            EC: 0.068025,
            "0B": 0.10884,
            aC: 0.5442,
            "1B": 0.068025,
            FC: 0.158725,
            GC: 0.15419,
            HC: 0.3628,
            IC: 0.185935,
            JC: 0.44443,
            KC: 2.50332,
            "2B": 0.09977,
            LC: 0,
            MC: 0,
            bC: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "TC",
            "AC",
            "I",
            "5",
            "UC",
            "J",
            "VC",
            "E",
            "WC",
            "F",
            "G",
            "XC",
            "A",
            "BC",
            "B",
            "yB",
            "C",
            "zB",
            "K",
            "CC",
            "L",
            "YC",
            "H",
            "ZC",
            "DC",
            "EC",
            "0B",
            "aC",
            "1B",
            "FC",
            "GC",
            "HC",
            "IC",
            "JC",
            "KC",
            "2B",
            "LC",
            "MC",
            "bC",
            ""
        ],
        E: "Safari",
        F: {
            "5": 1275868800,
            TC: 1205798400,
            AC: 1226534400,
            I: 1244419200,
            UC: 1311120000,
            J: 1343174400,
            VC: 1382400000,
            E: 1382400000,
            WC: 1410998400,
            F: 1413417600,
            G: 1443657600,
            XC: 1458518400,
            A: 1474329600,
            BC: 1490572800,
            B: 1505779200,
            yB: 1522281600,
            C: 1537142400,
            zB: 1553472000,
            K: 1568851200,
            CC: 1585008000,
            L: 1600214400,
            YC: 1619395200,
            H: 1632096000,
            ZC: 1635292800,
            DC: 1639353600,
            EC: 1647216000,
            "0B": 1652745600,
            aC: 1658275200,
            "1B": 1662940800,
            FC: 1666569600,
            GC: 1670889600,
            HC: 1674432000,
            IC: 1679875200,
            JC: 1684368000,
            KC: 1690156800,
            "2B": 1695686400,
            LC: 1698192000,
            MC: null,
            bC: null
        }
    },
    F: {
        A: {
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            G: 0,
            B: 0,
            C: 0,
            H: 0,
            M: 0,
            N: 0,
            O: 0,
            n: 0,
            o: 0,
            p: 0,
            AB: 0,
            BB: 0,
            CB: 0.004535,
            DB: 0,
            EB: 0,
            FB: 0,
            GB: 0,
            HB: 0,
            IB: 0,
            JB: 0,
            KB: 0,
            LB: 0,
            MB: 0,
            NB: 0,
            OB: 0,
            PB: 0,
            QB: 0,
            RB: 0,
            SB: 0,
            TB: 0,
            UB: 0.013605,
            VB: 0,
            WB: 0,
            XB: 0,
            YB: 0,
            ZB: 0,
            aB: 0,
            bB: 0,
            cB: 0.004535,
            dB: 0.004535,
            eB: 0,
            fB: 0,
            gB: 0,
            hB: 0,
            iB: 0,
            jB: 0,
            kB: 0,
            lB: 0,
            mB: 0,
            nB: 0,
            oB: 0,
            pB: 0,
            qB: 0,
            rB: 0,
            sB: 0,
            q: 0,
            tB: 0,
            uB: 0,
            vB: 0,
            wB: 0.004535,
            xB: 0,
            P: 0,
            Q: 0,
            R: 0,
            "6B": 0,
            S: 0,
            T: 0,
            U: 0.004535,
            V: 0,
            W: 0,
            X: 0,
            Y: 0.004535,
            Z: 0,
            a: 0,
            b: 0,
            c: 0,
            d: 0,
            e: 0.05442,
            f: 0,
            g: 0.11791,
            h: 0,
            i: 0.022675,
            j: 0.26303,
            k: 0.58048,
            l: 0.64397,
            m: 0,
            cC: 0,
            dC: 0,
            eC: 0,
            fC: 0,
            yB: 0,
            NC: 0,
            gC: 0,
            zB: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "G",
            "cC",
            "dC",
            "eC",
            "fC",
            "B",
            "yB",
            "NC",
            "gC",
            "C",
            "zB",
            "H",
            "M",
            "N",
            "O",
            "6",
            "n",
            "o",
            "p",
            "7",
            "8",
            "9",
            "AB",
            "BB",
            "CB",
            "DB",
            "EB",
            "FB",
            "GB",
            "HB",
            "IB",
            "JB",
            "KB",
            "LB",
            "MB",
            "NB",
            "OB",
            "PB",
            "QB",
            "RB",
            "SB",
            "TB",
            "UB",
            "VB",
            "WB",
            "XB",
            "YB",
            "ZB",
            "aB",
            "bB",
            "cB",
            "dB",
            "eB",
            "fB",
            "gB",
            "hB",
            "iB",
            "jB",
            "kB",
            "lB",
            "mB",
            "nB",
            "oB",
            "pB",
            "qB",
            "rB",
            "sB",
            "q",
            "tB",
            "uB",
            "vB",
            "wB",
            "xB",
            "P",
            "Q",
            "R",
            "6B",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
            "a",
            "b",
            "c",
            "d",
            "e",
            "f",
            "g",
            "h",
            "i",
            "j",
            "k",
            "l",
            "m",
            "",
            "",
            ""
        ],
        E: "Opera",
        F: {
            "6": 1390867200,
            "7": 1405987200,
            "8": 1409616000,
            "9": 1413331200,
            G: 1150761600,
            cC: 1223424000,
            dC: 1251763200,
            eC: 1267488000,
            fC: 1277942400,
            B: 1292457600,
            yB: 1302566400,
            NC: 1309219200,
            gC: 1323129600,
            C: 1323129600,
            zB: 1352073600,
            H: 1372723200,
            M: 1377561600,
            N: 1381104000,
            O: 1386288000,
            n: 1393891200,
            o: 1399334400,
            p: 1401753600,
            AB: 1417132800,
            BB: 1422316800,
            CB: 1425945600,
            DB: 1430179200,
            EB: 1433808000,
            FB: 1438646400,
            GB: 1442448000,
            HB: 1445904000,
            IB: 1449100800,
            JB: 1454371200,
            KB: 1457308800,
            LB: 1462320000,
            MB: 1465344000,
            NB: 1470096000,
            OB: 1474329600,
            PB: 1477267200,
            QB: 1481587200,
            RB: 1486425600,
            SB: 1490054400,
            TB: 1494374400,
            UB: 1498003200,
            VB: 1502236800,
            WB: 1506470400,
            XB: 1510099200,
            YB: 1515024000,
            ZB: 1517961600,
            aB: 1521676800,
            bB: 1525910400,
            cB: 1530144000,
            dB: 1534982400,
            eB: 1537833600,
            fB: 1543363200,
            gB: 1548201600,
            hB: 1554768000,
            iB: 1561593600,
            jB: 1566259200,
            kB: 1570406400,
            lB: 1573689600,
            mB: 1578441600,
            nB: 1583971200,
            oB: 1587513600,
            pB: 1592956800,
            qB: 1595894400,
            rB: 1600128000,
            sB: 1603238400,
            q: 1613520000,
            tB: 1612224000,
            uB: 1616544000,
            vB: 1619568000,
            wB: 1623715200,
            xB: 1627948800,
            P: 1631577600,
            Q: 1633392000,
            R: 1635984000,
            "6B": 1638403200,
            S: 1642550400,
            T: 1644969600,
            U: 1647993600,
            V: 1650412800,
            W: 1652745600,
            X: 1654646400,
            Y: 1657152000,
            Z: 1660780800,
            a: 1663113600,
            b: 1668816000,
            c: 1668643200,
            d: 1671062400,
            e: 1675209600,
            f: 1677024000,
            g: 1679529600,
            h: 1681948800,
            i: 1684195200,
            j: 1687219200,
            k: 1690329600,
            l: 1692748800,
            m: 1696204800
        },
        D: {
            G: "o",
            B: "o",
            C: "o",
            cC: "o",
            dC: "o",
            eC: "o",
            fC: "o",
            yB: "o",
            NC: "o",
            gC: "o",
            zB: "o"
        }
    },
    G: {
        A: {
            F: 0,
            AC: 0,
            hC: 0,
            OC: 0.00285607,
            iC: 0.00285607,
            jC: 0.00285607,
            kC: 0.00999624,
            lC: 0.00285607,
            mC: 0.00999624,
            nC: 0.0342728,
            oC: 0.00142803,
            pC: 0.0514092,
            qC: 0.0214205,
            rC: 0.0157084,
            sC: 0.0142803,
            tC: 0.238482,
            uC: 0.00714017,
            vC: 0.0128523,
            wC: 0.155656,
            xC: 0.0499812,
            yC: 0.135663,
            zC: 0.225629,
            "0C": 0.0899662,
            DC: 0.0985344,
            EC: 0.112815,
            "0B": 0.157084,
            "1C": 1.03961,
            "1B": 0.411274,
            FC: 0.761142,
            GC: 0.386997,
            HC: 0.722585,
            IC: 0.164224,
            JC: 0.489816,
            KC: 7.98414,
            "2B": 0.704021,
            LC: 0.00142803,
            MC: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "AC",
            "hC",
            "OC",
            "iC",
            "jC",
            "kC",
            "F",
            "lC",
            "mC",
            "nC",
            "oC",
            "pC",
            "qC",
            "rC",
            "sC",
            "tC",
            "uC",
            "vC",
            "wC",
            "xC",
            "yC",
            "zC",
            "0C",
            "DC",
            "EC",
            "0B",
            "1C",
            "1B",
            "FC",
            "GC",
            "HC",
            "IC",
            "JC",
            "KC",
            "2B",
            "LC",
            "MC",
            "",
            ""
        ],
        E: "Safari on iOS",
        F: {
            AC: 1270252800,
            hC: 1283904000,
            OC: 1299628800,
            iC: 1331078400,
            jC: 1359331200,
            kC: 1394409600,
            F: 1410912000,
            lC: 1413763200,
            mC: 1442361600,
            nC: 1458518400,
            oC: 1473724800,
            pC: 1490572800,
            qC: 1505779200,
            rC: 1522281600,
            sC: 1537142400,
            tC: 1553472000,
            uC: 1568851200,
            vC: 1572220800,
            wC: 1580169600,
            xC: 1585008000,
            yC: 1600214400,
            zC: 1619395200,
            "0C": 1632096000,
            DC: 1639353600,
            EC: 1647216000,
            "0B": 1652659200,
            "1C": 1658275200,
            "1B": 1662940800,
            FC: 1666569600,
            GC: 1670889600,
            HC: 1674432000,
            IC: 1679875200,
            JC: 1684368000,
            KC: 1690156800,
            "2B": 1694995200,
            LC: 1698192000,
            MC: null
        }
    },
    H: {
        A: {
            "2C": 1.02942
        },
        B: "o",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "2C",
            "",
            "",
            ""
        ],
        E: "Opera Mini",
        F: {
            "2C": 1426464000
        }
    },
    I: {
        A: {
            "3B": 0,
            I: 0.0156469,
            D: 0,
            "3C": 0,
            "4C": 0.0156469,
            "5C": 0,
            "6C": 0.0156469,
            OC: 0.0547642,
            "7C": 0,
            "8C": 0.242527
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "3C",
            "4C",
            "5C",
            "3B",
            "I",
            "6C",
            "OC",
            "7C",
            "8C",
            "D",
            "",
            "",
            ""
        ],
        E: "Android Browser",
        F: {
            "3C": 1256515200,
            "4C": 1274313600,
            "5C": 1291593600,
            "3B": 1298332800,
            I: 1318896000,
            "6C": 1341792000,
            OC: 1374624000,
            "7C": 1386547200,
            "8C": 1401667200,
            D: 1697587200
        }
    },
    J: {
        A: {
            E: 0,
            A: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "E",
            "A",
            "",
            "",
            ""
        ],
        E: "Blackberry Browser",
        F: {
            E: 1325376000,
            A: 1359504000
        }
    },
    K: {
        A: {
            A: 0,
            B: 0,
            C: 0,
            q: 0,
            yB: 0,
            NC: 0,
            zB: 0
        },
        B: "o",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A",
            "B",
            "yB",
            "NC",
            "C",
            "zB",
            "q",
            "",
            "",
            ""
        ],
        E: "Opera Mobile",
        F: {
            A: 1287100800,
            B: 1300752000,
            yB: 1314835200,
            NC: 1318291200,
            C: 1330300800,
            zB: 1349740800,
            q: 1673827200
        },
        D: {
            q: "webkit"
        }
    },
    L: {
        A: {
            D: 36.3803
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "D",
            "",
            "",
            ""
        ],
        E: "Chrome for Android",
        F: {
            D: 1697587200
        }
    },
    M: {
        A: {
            D: 0.278664
        },
        B: "moz",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "D",
            "",
            "",
            ""
        ],
        E: "Firefox for Android",
        F: {
            D: 1695686400
        }
    },
    N: {
        A: {
            A: 0,
            B: 0
        },
        B: "ms",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "A",
            "B",
            "",
            "",
            ""
        ],
        E: "IE Mobile",
        F: {
            A: 1340150400,
            B: 1353456000
        }
    },
    O: {
        A: {
            "0B": 0.890632
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "0B",
            "",
            "",
            ""
        ],
        E: "UC Browser for Android",
        F: {
            "0B": 1687132800
        },
        D: {
            "0B": "webkit"
        }
    },
    P: {
        A: {
            I: 0.107075,
            n: 0.0642449,
            o: 0.139197,
            p: 1.87381,
            "9C": 0,
            AD: 0,
            BD: 0.0321224,
            CD: 0,
            DD: 0,
            BC: 0,
            ED: 0.0107075,
            FD: 0,
            GD: 0.021415,
            HD: 0.0107075,
            ID: 0,
            "1B": 0.021415,
            "2B": 0.0321224,
            JD: 0.021415,
            KD: 0.0535374
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "I",
            "9C",
            "AD",
            "BD",
            "CD",
            "DD",
            "BC",
            "ED",
            "FD",
            "GD",
            "HD",
            "ID",
            "1B",
            "2B",
            "JD",
            "KD",
            "n",
            "o",
            "p",
            "",
            "",
            ""
        ],
        E: "Samsung Internet",
        F: {
            I: 1461024000,
            "9C": 1481846400,
            AD: 1509408000,
            BD: 1528329600,
            CD: 1546128000,
            DD: 1554163200,
            BC: 1567900800,
            ED: 1582588800,
            FD: 1593475200,
            GD: 1605657600,
            HD: 1618531200,
            ID: 1629072000,
            "1B": 1640736000,
            "2B": 1651708800,
            JD: 1659657600,
            KD: 1667260800,
            n: 1677369600,
            o: 1684454400,
            p: 1689292800
        }
    },
    Q: {
        A: {
            CC: 0.16392
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "CC",
            "",
            "",
            ""
        ],
        E: "QQ Browser",
        F: {
            CC: 1663718400
        }
    },
    R: {
        A: {
            LD: 0
        },
        B: "webkit",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "LD",
            "",
            "",
            ""
        ],
        E: "Baidu Browser",
        F: {
            LD: 1663027200
        }
    },
    S: {
        A: {
            MD: 0.05464,
            ND: 0
        },
        B: "moz",
        C: [
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "MD",
            "ND",
            "",
            "",
            ""
        ],
        E: "KaiOS Browser",
        F: {
            MD: 1527811200,
            ND: 1631664000
        }
    }
};

});


parcelRegister("hZDcp", function(module, exports) {
module.exports = JSON.parse('{"v0.8":{"start":"2012-06-25","end":"2014-07-31"},"v0.10":{"start":"2013-03-11","end":"2016-10-31"},"v0.12":{"start":"2015-02-06","end":"2016-12-31"},"v4":{"start":"2015-09-08","lts":"2015-10-12","maintenance":"2017-04-01","end":"2018-04-30","codename":"Argon"},"v5":{"start":"2015-10-29","maintenance":"2016-04-30","end":"2016-06-30"},"v6":{"start":"2016-04-26","lts":"2016-10-18","maintenance":"2018-04-30","end":"2019-04-30","codename":"Boron"},"v7":{"start":"2016-10-25","maintenance":"2017-04-30","end":"2017-06-30"},"v8":{"start":"2017-05-30","lts":"2017-10-31","maintenance":"2019-01-01","end":"2019-12-31","codename":"Carbon"},"v9":{"start":"2017-10-01","maintenance":"2018-04-01","end":"2018-06-30"},"v10":{"start":"2018-04-24","lts":"2018-10-30","maintenance":"2020-05-19","end":"2021-04-30","codename":"Dubnium"},"v11":{"start":"2018-10-23","maintenance":"2019-04-22","end":"2019-06-01"},"v12":{"start":"2019-04-23","lts":"2019-10-21","maintenance":"2020-11-30","end":"2022-04-30","codename":"Erbium"},"v13":{"start":"2019-10-22","maintenance":"2020-04-01","end":"2020-06-01"},"v14":{"start":"2020-04-21","lts":"2020-10-27","maintenance":"2021-10-19","end":"2023-04-30","codename":"Fermium"},"v15":{"start":"2020-10-20","maintenance":"2021-04-01","end":"2021-06-01"},"v16":{"start":"2021-04-20","lts":"2021-10-26","maintenance":"2022-10-18","end":"2023-09-11","codename":"Gallium"},"v17":{"start":"2021-10-19","maintenance":"2022-04-01","end":"2022-06-01"},"v18":{"start":"2022-04-19","lts":"2022-10-25","maintenance":"2023-10-18","end":"2025-04-30","codename":"Hydrogen"},"v19":{"start":"2022-10-18","maintenance":"2023-04-01","end":"2023-06-01"},"v20":{"start":"2023-04-18","lts":"2023-10-24","maintenance":"2024-10-22","end":"2026-04-30","codename":""}}');

});

parcelRegister("2Qnzd", function(module, exports) {
"use strict";

});

parcelRegister("cBucY", function(module, exports) {
module.exports = {
    "0.20": "39",
    "0.21": "41",
    "0.22": "41",
    "0.23": "41",
    "0.24": "41",
    "0.25": "42",
    "0.26": "42",
    "0.27": "43",
    "0.28": "43",
    "0.29": "43",
    "0.30": "44",
    "0.31": "45",
    "0.32": "45",
    "0.33": "45",
    "0.34": "45",
    "0.35": "45",
    "0.36": "47",
    "0.37": "49",
    "1.0": "49",
    "1.1": "50",
    "1.2": "51",
    "1.3": "52",
    "1.4": "53",
    "1.5": "54",
    "1.6": "56",
    "1.7": "58",
    "1.8": "59",
    "2.0": "61",
    "2.1": "61",
    "3.0": "66",
    "3.1": "66",
    "4.0": "69",
    "4.1": "69",
    "4.2": "69",
    "5.0": "73",
    "6.0": "76",
    "6.1": "76",
    "7.0": "78",
    "7.1": "78",
    "7.2": "78",
    "7.3": "78",
    "8.0": "80",
    "8.1": "80",
    "8.2": "80",
    "8.3": "80",
    "8.4": "80",
    "8.5": "80",
    "9.0": "83",
    "9.1": "83",
    "9.2": "83",
    "9.3": "83",
    "9.4": "83",
    "10.0": "85",
    "10.1": "85",
    "10.2": "85",
    "10.3": "85",
    "10.4": "85",
    "11.0": "87",
    "11.1": "87",
    "11.2": "87",
    "11.3": "87",
    "11.4": "87",
    "11.5": "87",
    "12.0": "89",
    "12.1": "89",
    "12.2": "89",
    "13.0": "91",
    "13.1": "91",
    "13.2": "91",
    "13.3": "91",
    "13.4": "91",
    "13.5": "91",
    "13.6": "91",
    "14.0": "93",
    "14.1": "93",
    "14.2": "93",
    "15.0": "94",
    "15.1": "94",
    "15.2": "94",
    "15.3": "94",
    "15.4": "94",
    "15.5": "94",
    "16.0": "96",
    "16.1": "96",
    "16.2": "96",
    "17.0": "98",
    "17.1": "98",
    "17.2": "98",
    "17.3": "98",
    "17.4": "98",
    "18.0": "100",
    "18.1": "100",
    "18.2": "100",
    "18.3": "100",
    "19.0": "102",
    "19.1": "102",
    "20.0": "104",
    "20.1": "104",
    "20.2": "104",
    "20.3": "104",
    "21.0": "106",
    "21.1": "106",
    "21.2": "106",
    "21.3": "106",
    "21.4": "106",
    "22.0": "108",
    "22.1": "108",
    "22.2": "108",
    "22.3": "108",
    "23.0": "110",
    "23.1": "110",
    "23.2": "110",
    "23.3": "110",
    "24.0": "112",
    "24.1": "112",
    "24.2": "112",
    "24.3": "112",
    "24.4": "112",
    "24.5": "112",
    "24.6": "112",
    "24.7": "112",
    "24.8": "112",
    "25.0": "114",
    "25.1": "114",
    "25.2": "114",
    "25.3": "114",
    "25.4": "114",
    "25.5": "114",
    "25.6": "114",
    "25.7": "114",
    "25.8": "114",
    "25.9": "114",
    "26.0": "116",
    "26.1": "116",
    "26.2": "116",
    "26.3": "116",
    "26.4": "116",
    "27.0": "118",
    "28.0": "119"
};

});

parcelRegister("hvjyX", function(module, exports) {
function $cbe481b5f87cf606$var$BrowserslistError(message) {
    this.name = "BrowserslistError";
    this.message = message;
    this.browserslist = true;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $cbe481b5f87cf606$var$BrowserslistError);
}
$cbe481b5f87cf606$var$BrowserslistError.prototype = Error.prototype;
module.exports = $cbe481b5f87cf606$var$BrowserslistError;

});

parcelRegister("hXbIm", function(module, exports) {
var $d12108a1d5b153b0$var$AND_REGEXP = /^\s+and\s+(.*)/i;
var $d12108a1d5b153b0$var$OR_REGEXP = /^(?:,\s*|\s+or\s+)(.*)/i;
function $d12108a1d5b153b0$var$flatten(array) {
    if (!Array.isArray(array)) return [
        array
    ];
    return array.reduce(function(a, b) {
        return a.concat($d12108a1d5b153b0$var$flatten(b));
    }, []);
}
function $d12108a1d5b153b0$var$find(string, predicate) {
    for(var n = 1, max = string.length; n <= max; n++){
        var parsed = string.substr(-n, n);
        if (predicate(parsed, n, max)) return string.slice(0, -n);
    }
    return "";
}
function $d12108a1d5b153b0$var$matchQuery(all, query) {
    var node = {
        query: query
    };
    if (query.indexOf("not ") === 0) {
        node.not = true;
        query = query.slice(4);
    }
    for(var name in all){
        var type = all[name];
        var match = query.match(type.regexp);
        if (match) {
            node.type = name;
            for(var i = 0; i < type.matches.length; i++)node[type.matches[i]] = match[i + 1];
            return node;
        }
    }
    node.type = "unknown";
    return node;
}
function $d12108a1d5b153b0$var$matchBlock(all, string, qs) {
    var node;
    return $d12108a1d5b153b0$var$find(string, function(parsed, n, max) {
        if ($d12108a1d5b153b0$var$AND_REGEXP.test(parsed)) {
            node = $d12108a1d5b153b0$var$matchQuery(all, parsed.match($d12108a1d5b153b0$var$AND_REGEXP)[1]);
            node.compose = "and";
            qs.unshift(node);
            return true;
        } else if ($d12108a1d5b153b0$var$OR_REGEXP.test(parsed)) {
            node = $d12108a1d5b153b0$var$matchQuery(all, parsed.match($d12108a1d5b153b0$var$OR_REGEXP)[1]);
            node.compose = "or";
            qs.unshift(node);
            return true;
        } else if (n === max) {
            node = $d12108a1d5b153b0$var$matchQuery(all, parsed.trim());
            node.compose = "or";
            qs.unshift(node);
            return true;
        }
        return false;
    });
}
module.exports = function parse(all, queries) {
    if (!Array.isArray(queries)) queries = [
        queries
    ];
    return $d12108a1d5b153b0$var$flatten(queries.map(function(block) {
        var qs = [];
        do block = $d12108a1d5b153b0$var$matchBlock(all, block, qs);
        while (block);
        return qs;
    }));
};

});

parcelRegister("6ealC", function(module, exports) {

var $hvjyX = parcelRequire("hvjyX");
function $488c13b8748edd4d$var$noop() {}
module.exports = {
    loadQueries: function loadQueries() {
        throw new $hvjyX("Sharable configs are not supported in client-side build of Browserslist");
    },
    getStat: function getStat(opts) {
        return opts.stats;
    },
    loadConfig: function loadConfig(opts) {
        if (opts.config) throw new $hvjyX("Browserslist config are not supported in client-side build");
    },
    loadCountry: function loadCountry() {
        throw new $hvjyX("Country statistics are not supported in client-side build of Browserslist");
    },
    loadFeature: function loadFeature() {
        throw new $hvjyX("Supports queries are not available in client-side build of Browserslist");
    },
    currentNode: function currentNode(resolve, context) {
        return resolve([
            "maintained node versions"
        ], context)[0];
    },
    parseConfig: $488c13b8748edd4d$var$noop,
    readConfig: $488c13b8748edd4d$var$noop,
    findConfig: $488c13b8748edd4d$var$noop,
    clearCaches: $488c13b8748edd4d$var$noop,
    oldDataWarning: $488c13b8748edd4d$var$noop,
    env: {}
};

});


parcelRegister("5QpTL", function(module, exports) {
// just pre-load all the stuff that index.js lazily exports

var $cFp8R = parcelRequire("cFp8R");

var $dI3mn = parcelRequire("dI3mn");

var $4HX32 = parcelRequire("4HX32");

var $eLANf = parcelRequire("eLANf");

var $fLjPi = parcelRequire("fLjPi");

var $a0QNF = parcelRequire("a0QNF");

var $8as5Z = parcelRequire("8as5Z");

var $cNkRs = parcelRequire("cNkRs");

var $4Zb5y = parcelRequire("4Zb5y");

var $2Bsl2 = parcelRequire("2Bsl2");

var $lMbc2 = parcelRequire("lMbc2");

var $iMRtb = parcelRequire("iMRtb");

var $2uroD = parcelRequire("2uroD");

var $kh2xb = parcelRequire("kh2xb");

var $hB4qs = parcelRequire("hB4qs");

var $i8lqn = parcelRequire("i8lqn");

var $fFC1p = parcelRequire("fFC1p");

var $3Ab2P = parcelRequire("3Ab2P");

var $4fIM5 = parcelRequire("4fIM5");

var $fgtv7 = parcelRequire("fgtv7");

var $9qhoW = parcelRequire("9qhoW");

var $7lAdr = parcelRequire("7lAdr");

var $dZEeM = parcelRequire("dZEeM");

var $aW5yP = parcelRequire("aW5yP");

var $bq3RM = parcelRequire("bq3RM");

var $8lBOO = parcelRequire("8lBOO");

var $5xbuD = parcelRequire("5xbuD");

var $iZsHJ = parcelRequire("iZsHJ");

var $b6sFB = parcelRequire("b6sFB");

var $2Tcur = parcelRequire("2Tcur");

var $amrSW = parcelRequire("amrSW");

var $j01th = parcelRequire("j01th");

var $8fzmh = parcelRequire("8fzmh");

var $dqt8z = parcelRequire("dqt8z");

var $8sIWg = parcelRequire("8sIWg");

var $lPfbh = parcelRequire("lPfbh");

var $4ZPf6 = parcelRequire("4ZPf6");

var $gRhS3 = parcelRequire("gRhS3");

var $lWfo0 = parcelRequire("lWfo0");

var $5HOZL = parcelRequire("5HOZL");

var $fvORW = parcelRequire("fvORW");
module.exports = {
    parse: $fLjPi,
    valid: $a0QNF,
    clean: $8as5Z,
    inc: $cNkRs,
    diff: $4Zb5y,
    major: $2Bsl2,
    minor: $lMbc2,
    patch: $iMRtb,
    prerelease: $2uroD,
    compare: $kh2xb,
    rcompare: $hB4qs,
    compareLoose: $i8lqn,
    compareBuild: $fFC1p,
    sort: $3Ab2P,
    rsort: $4fIM5,
    gt: $fgtv7,
    lt: $9qhoW,
    eq: $7lAdr,
    neq: $dZEeM,
    gte: $aW5yP,
    lte: $bq3RM,
    cmp: $8lBOO,
    coerce: $5xbuD,
    Comparator: $iZsHJ,
    Range: $b6sFB,
    satisfies: $2Tcur,
    toComparators: $amrSW,
    maxSatisfying: $j01th,
    minSatisfying: $8fzmh,
    minVersion: $dqt8z,
    validRange: $8sIWg,
    outside: $lPfbh,
    gtr: $4ZPf6,
    ltr: $gRhS3,
    intersects: $lWfo0,
    simplifyRange: $5HOZL,
    subset: $fvORW,
    SemVer: $4HX32,
    re: $cFp8R.re,
    src: $cFp8R.src,
    tokens: $cFp8R.t,
    SEMVER_SPEC_VERSION: $dI3mn.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $dI3mn.RELEASE_TYPES,
    compareIdentifiers: $eLANf.compareIdentifiers,
    rcompareIdentifiers: $eLANf.rcompareIdentifiers
};

});
parcelRegister("cFp8R", function(module, exports) {

var $dI3mn = parcelRequire("dI3mn");
var $938cd10a67fec3fe$require$MAX_SAFE_COMPONENT_LENGTH = $dI3mn.MAX_SAFE_COMPONENT_LENGTH;
var $938cd10a67fec3fe$require$MAX_SAFE_BUILD_LENGTH = $dI3mn.MAX_SAFE_BUILD_LENGTH;
var $938cd10a67fec3fe$require$MAX_LENGTH = $dI3mn.MAX_LENGTH;

var $75d4P = parcelRequire("75d4P");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $938cd10a67fec3fe$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $938cd10a67fec3fe$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $75d4P(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${$938cd10a67fec3fe$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$938cd10a67fec3fe$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$938cd10a67fec3fe$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("dI3mn", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $9fb1fda334ff9b62$var$SEMVER_SPEC_VERSION = "2.0.0";
const $9fb1fda334ff9b62$var$MAX_LENGTH = 256;
const $9fb1fda334ff9b62$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $9fb1fda334ff9b62$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $9fb1fda334ff9b62$var$MAX_SAFE_BUILD_LENGTH = $9fb1fda334ff9b62$var$MAX_LENGTH - 6;
const $9fb1fda334ff9b62$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $9fb1fda334ff9b62$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $9fb1fda334ff9b62$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $9fb1fda334ff9b62$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $9fb1fda334ff9b62$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $9fb1fda334ff9b62$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $9fb1fda334ff9b62$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("75d4P", function(module, exports) {

var $8NqU9 = parcelRequire("8NqU9");
const $528324d0c1ca6ef5$var$debug = (typeof $8NqU9 === "object" && $8NqU9.env && undefined, ()=>{});
module.exports = $528324d0c1ca6ef5$var$debug;

});
parcelRegister("8NqU9", function(module, exports) {
// shim for using process in browser
var $6677c508dffc4d62$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $6677c508dffc4d62$var$cachedSetTimeout;
var $6677c508dffc4d62$var$cachedClearTimeout;
function $6677c508dffc4d62$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $6677c508dffc4d62$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $6677c508dffc4d62$var$cachedSetTimeout = setTimeout;
        else $6677c508dffc4d62$var$cachedSetTimeout = $6677c508dffc4d62$var$defaultSetTimout;
    } catch (e) {
        $6677c508dffc4d62$var$cachedSetTimeout = $6677c508dffc4d62$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $6677c508dffc4d62$var$cachedClearTimeout = clearTimeout;
        else $6677c508dffc4d62$var$cachedClearTimeout = $6677c508dffc4d62$var$defaultClearTimeout;
    } catch (e) {
        $6677c508dffc4d62$var$cachedClearTimeout = $6677c508dffc4d62$var$defaultClearTimeout;
    }
})();
function $6677c508dffc4d62$var$runTimeout(fun) {
    if ($6677c508dffc4d62$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($6677c508dffc4d62$var$cachedSetTimeout === $6677c508dffc4d62$var$defaultSetTimout || !$6677c508dffc4d62$var$cachedSetTimeout) && setTimeout) {
        $6677c508dffc4d62$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6677c508dffc4d62$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $6677c508dffc4d62$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $6677c508dffc4d62$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $6677c508dffc4d62$var$runClearTimeout(marker) {
    if ($6677c508dffc4d62$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($6677c508dffc4d62$var$cachedClearTimeout === $6677c508dffc4d62$var$defaultClearTimeout || !$6677c508dffc4d62$var$cachedClearTimeout) && clearTimeout) {
        $6677c508dffc4d62$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $6677c508dffc4d62$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $6677c508dffc4d62$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $6677c508dffc4d62$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $6677c508dffc4d62$var$queue = [];
var $6677c508dffc4d62$var$draining = false;
var $6677c508dffc4d62$var$currentQueue;
var $6677c508dffc4d62$var$queueIndex = -1;
function $6677c508dffc4d62$var$cleanUpNextTick() {
    if (!$6677c508dffc4d62$var$draining || !$6677c508dffc4d62$var$currentQueue) return;
    $6677c508dffc4d62$var$draining = false;
    if ($6677c508dffc4d62$var$currentQueue.length) $6677c508dffc4d62$var$queue = $6677c508dffc4d62$var$currentQueue.concat($6677c508dffc4d62$var$queue);
    else $6677c508dffc4d62$var$queueIndex = -1;
    if ($6677c508dffc4d62$var$queue.length) $6677c508dffc4d62$var$drainQueue();
}
function $6677c508dffc4d62$var$drainQueue() {
    if ($6677c508dffc4d62$var$draining) return;
    var timeout = $6677c508dffc4d62$var$runTimeout($6677c508dffc4d62$var$cleanUpNextTick);
    $6677c508dffc4d62$var$draining = true;
    var len = $6677c508dffc4d62$var$queue.length;
    while(len){
        $6677c508dffc4d62$var$currentQueue = $6677c508dffc4d62$var$queue;
        $6677c508dffc4d62$var$queue = [];
        while(++$6677c508dffc4d62$var$queueIndex < len)if ($6677c508dffc4d62$var$currentQueue) $6677c508dffc4d62$var$currentQueue[$6677c508dffc4d62$var$queueIndex].run();
        $6677c508dffc4d62$var$queueIndex = -1;
        len = $6677c508dffc4d62$var$queue.length;
    }
    $6677c508dffc4d62$var$currentQueue = null;
    $6677c508dffc4d62$var$draining = false;
    $6677c508dffc4d62$var$runClearTimeout(timeout);
}
$6677c508dffc4d62$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $6677c508dffc4d62$var$queue.push(new $6677c508dffc4d62$var$Item(fun, args));
    if ($6677c508dffc4d62$var$queue.length === 1 && !$6677c508dffc4d62$var$draining) $6677c508dffc4d62$var$runTimeout($6677c508dffc4d62$var$drainQueue);
};
// v8 likes predictible objects
function $6677c508dffc4d62$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$6677c508dffc4d62$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$6677c508dffc4d62$var$process.title = "browser";
$6677c508dffc4d62$var$process.browser = true;
$6677c508dffc4d62$var$process.env = {};
$6677c508dffc4d62$var$process.argv = [];
$6677c508dffc4d62$var$process.version = ""; // empty string to avoid regexp issues
$6677c508dffc4d62$var$process.versions = {};
function $6677c508dffc4d62$var$noop() {}
$6677c508dffc4d62$var$process.on = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.addListener = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.once = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.off = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.removeListener = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.removeAllListeners = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.emit = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.prependListener = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.prependOnceListener = $6677c508dffc4d62$var$noop;
$6677c508dffc4d62$var$process.listeners = function(name) {
    return [];
};
$6677c508dffc4d62$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$6677c508dffc4d62$var$process.cwd = function() {
    return "/";
};
$6677c508dffc4d62$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$6677c508dffc4d62$var$process.umask = function() {
    return 0;
};

});



parcelRegister("4HX32", function(module, exports) {

var $75d4P = parcelRequire("75d4P");

var $dI3mn = parcelRequire("dI3mn");
var $36d8fb4d23365ded$require$MAX_LENGTH = $dI3mn.MAX_LENGTH;
var $36d8fb4d23365ded$require$MAX_SAFE_INTEGER = $dI3mn.MAX_SAFE_INTEGER;

var $cFp8R = parcelRequire("cFp8R");
var $36d8fb4d23365ded$require$re = $cFp8R.safeRe;
var $36d8fb4d23365ded$require$t = $cFp8R.t;

var $aOQwm = parcelRequire("aOQwm");

var $eLANf = parcelRequire("eLANf");
var $36d8fb4d23365ded$require$compareIdentifiers = $eLANf.compareIdentifiers;
class $36d8fb4d23365ded$var$SemVer {
    constructor(version, options){
        options = $aOQwm(options);
        if (version instanceof $36d8fb4d23365ded$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $36d8fb4d23365ded$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$36d8fb4d23365ded$require$MAX_LENGTH} characters`);
        $75d4P("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $36d8fb4d23365ded$require$re[$36d8fb4d23365ded$require$t.LOOSE] : $36d8fb4d23365ded$require$re[$36d8fb4d23365ded$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $36d8fb4d23365ded$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $36d8fb4d23365ded$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $36d8fb4d23365ded$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $36d8fb4d23365ded$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $75d4P("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $36d8fb4d23365ded$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $36d8fb4d23365ded$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $36d8fb4d23365ded$var$SemVer)) other = new $36d8fb4d23365ded$var$SemVer(other, this.options);
        return $36d8fb4d23365ded$require$compareIdentifiers(this.major, other.major) || $36d8fb4d23365ded$require$compareIdentifiers(this.minor, other.minor) || $36d8fb4d23365ded$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $36d8fb4d23365ded$var$SemVer)) other = new $36d8fb4d23365ded$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $75d4P("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $36d8fb4d23365ded$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $36d8fb4d23365ded$var$SemVer)) other = new $36d8fb4d23365ded$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $75d4P("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $36d8fb4d23365ded$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($36d8fb4d23365ded$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
module.exports = $36d8fb4d23365ded$var$SemVer;

});
parcelRegister("aOQwm", function(module, exports) {
// parse out just the options we care about
const $7e075075ef3db770$var$looseOption = Object.freeze({
    loose: true
});
const $7e075075ef3db770$var$emptyOpts = Object.freeze({});
const $7e075075ef3db770$var$parseOptions = (options)=>{
    if (!options) return $7e075075ef3db770$var$emptyOpts;
    if (typeof options !== "object") return $7e075075ef3db770$var$looseOption;
    return options;
};
module.exports = $7e075075ef3db770$var$parseOptions;

});

parcelRegister("eLANf", function(module, exports) {
const $ac01fed8bc6b0981$var$numeric = /^[0-9]+$/;
const $ac01fed8bc6b0981$var$compareIdentifiers = (a, b)=>{
    const anum = $ac01fed8bc6b0981$var$numeric.test(a);
    const bnum = $ac01fed8bc6b0981$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ac01fed8bc6b0981$var$rcompareIdentifiers = (a, b)=>$ac01fed8bc6b0981$var$compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers: $ac01fed8bc6b0981$var$compareIdentifiers,
    rcompareIdentifiers: $ac01fed8bc6b0981$var$rcompareIdentifiers
};

});


parcelRegister("fLjPi", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");
const $b79a9fe1239750ae$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $4HX32) return version;
    try {
        return new $4HX32(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = $b79a9fe1239750ae$var$parse;

});

parcelRegister("a0QNF", function(module, exports) {

var $fLjPi = parcelRequire("fLjPi");
const $74a2dc7b33fd1970$var$valid = (version, options)=>{
    const v = $fLjPi(version, options);
    return v ? v.version : null;
};
module.exports = $74a2dc7b33fd1970$var$valid;

});

parcelRegister("8as5Z", function(module, exports) {

var $fLjPi = parcelRequire("fLjPi");
const $5f250d15d9e15ee0$var$clean = (version, options)=>{
    const s = $fLjPi(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
module.exports = $5f250d15d9e15ee0$var$clean;

});

parcelRegister("cNkRs", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");
const $950a3e383fd45292$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === "string") {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $4HX32(version instanceof $4HX32 ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = $950a3e383fd45292$var$inc;

});

parcelRegister("4Zb5y", function(module, exports) {

var $fLjPi = parcelRequire("fLjPi");
const $3a1575e32a55e7e7$var$diff = (version1, version2)=>{
    const v1 = $fLjPi(version1, null, true);
    const v2 = $fLjPi(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return "major";
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return "patch";
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return "minor";
        // bumping major/minor/patch all have same result
        return "major";
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? "pre" : "";
    if (v1.major !== v2.major) return prefix + "major";
    if (v1.minor !== v2.minor) return prefix + "minor";
    if (v1.patch !== v2.patch) return prefix + "patch";
    // high and low are preleases
    return "prerelease";
};
module.exports = $3a1575e32a55e7e7$var$diff;

});

parcelRegister("2Bsl2", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");
const $1e5504dd1570e18b$var$major = (a, loose)=>new $4HX32(a, loose).major;
module.exports = $1e5504dd1570e18b$var$major;

});

parcelRegister("lMbc2", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");
const $fda6c362dcdd9f36$var$minor = (a, loose)=>new $4HX32(a, loose).minor;
module.exports = $fda6c362dcdd9f36$var$minor;

});

parcelRegister("iMRtb", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");
const $dad62fabe08177a6$var$patch = (a, loose)=>new $4HX32(a, loose).patch;
module.exports = $dad62fabe08177a6$var$patch;

});

parcelRegister("2uroD", function(module, exports) {

var $fLjPi = parcelRequire("fLjPi");
const $1d03a26f61e3be5f$var$prerelease = (version, options)=>{
    const parsed = $fLjPi(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = $1d03a26f61e3be5f$var$prerelease;

});

parcelRegister("kh2xb", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");
const $ec275c6daacda31d$var$compare = (a, b, loose)=>new $4HX32(a, loose).compare(new $4HX32(b, loose));
module.exports = $ec275c6daacda31d$var$compare;

});

parcelRegister("hB4qs", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $ccf953391bb196be$var$rcompare = (a, b, loose)=>$kh2xb(b, a, loose);
module.exports = $ccf953391bb196be$var$rcompare;

});

parcelRegister("i8lqn", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $d33997d0e3b1a823$var$compareLoose = (a, b)=>$kh2xb(a, b, true);
module.exports = $d33997d0e3b1a823$var$compareLoose;

});

parcelRegister("fFC1p", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");
const $b6882da5f02f6f8a$var$compareBuild = (a, b, loose)=>{
    const versionA = new $4HX32(a, loose);
    const versionB = new $4HX32(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = $b6882da5f02f6f8a$var$compareBuild;

});

parcelRegister("3Ab2P", function(module, exports) {

var $fFC1p = parcelRequire("fFC1p");
const $29bd4d1a68f5e994$var$sort = (list, loose)=>list.sort((a, b)=>$fFC1p(a, b, loose));
module.exports = $29bd4d1a68f5e994$var$sort;

});

parcelRegister("4fIM5", function(module, exports) {

var $fFC1p = parcelRequire("fFC1p");
const $318b4b7549bc5ab9$var$rsort = (list, loose)=>list.sort((a, b)=>$fFC1p(b, a, loose));
module.exports = $318b4b7549bc5ab9$var$rsort;

});

parcelRegister("fgtv7", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $b1cf3be74c2e6c06$var$gt = (a, b, loose)=>$kh2xb(a, b, loose) > 0;
module.exports = $b1cf3be74c2e6c06$var$gt;

});

parcelRegister("9qhoW", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $6dc40a4a73a36d10$var$lt = (a, b, loose)=>$kh2xb(a, b, loose) < 0;
module.exports = $6dc40a4a73a36d10$var$lt;

});

parcelRegister("7lAdr", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $5596964868278240$var$eq = (a, b, loose)=>$kh2xb(a, b, loose) === 0;
module.exports = $5596964868278240$var$eq;

});

parcelRegister("dZEeM", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $a3002f297acd6eea$var$neq = (a, b, loose)=>$kh2xb(a, b, loose) !== 0;
module.exports = $a3002f297acd6eea$var$neq;

});

parcelRegister("aW5yP", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $7f63a26b2e4c15aa$var$gte = (a, b, loose)=>$kh2xb(a, b, loose) >= 0;
module.exports = $7f63a26b2e4c15aa$var$gte;

});

parcelRegister("bq3RM", function(module, exports) {

var $kh2xb = parcelRequire("kh2xb");
const $85051f2f58d002cd$var$lte = (a, b, loose)=>$kh2xb(a, b, loose) <= 0;
module.exports = $85051f2f58d002cd$var$lte;

});

parcelRegister("8lBOO", function(module, exports) {

var $7lAdr = parcelRequire("7lAdr");

var $dZEeM = parcelRequire("dZEeM");

var $fgtv7 = parcelRequire("fgtv7");

var $aW5yP = parcelRequire("aW5yP");

var $9qhoW = parcelRequire("9qhoW");

var $bq3RM = parcelRequire("bq3RM");
const $613d9edeec1621fa$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $7lAdr(a, b, loose);
        case "!=":
            return $dZEeM(a, b, loose);
        case ">":
            return $fgtv7(a, b, loose);
        case ">=":
            return $aW5yP(a, b, loose);
        case "<":
            return $9qhoW(a, b, loose);
        case "<=":
            return $bq3RM(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = $613d9edeec1621fa$var$cmp;

});

parcelRegister("5xbuD", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");

var $fLjPi = parcelRequire("fLjPi");

var $cFp8R = parcelRequire("cFp8R");
var $4078f31a0dd12237$require$re = $cFp8R.safeRe;
var $4078f31a0dd12237$require$t = $cFp8R.t;
const $4078f31a0dd12237$var$coerce = (version, options)=>{
    if (version instanceof $4HX32) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match($4078f31a0dd12237$require$re[$4078f31a0dd12237$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        let next;
        while((next = $4078f31a0dd12237$require$re[$4078f31a0dd12237$require$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $4078f31a0dd12237$require$re[$4078f31a0dd12237$require$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $4078f31a0dd12237$require$re[$4078f31a0dd12237$require$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $fLjPi(`${match[2]}.${match[3] || "0"}.${match[4] || "0"}`, options);
};
module.exports = $4078f31a0dd12237$var$coerce;

});

parcelRegister("iZsHJ", function(module, exports) {
const $dd34309531947e52$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
class $dd34309531947e52$var$Comparator {
    static get ANY() {
        return $dd34309531947e52$var$ANY;
    }
    constructor(comp, options){
        options = $aOQwm(options);
        if (comp instanceof $dd34309531947e52$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(" ");
        $75d4P("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $dd34309531947e52$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $75d4P("comp", this);
    }
    parse(comp) {
        const r = this.options.loose ? $dd34309531947e52$require$re[$dd34309531947e52$require$t.COMPARATORLOOSE] : $dd34309531947e52$require$re[$dd34309531947e52$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : "";
        if (this.operator === "=") this.operator = "";
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $dd34309531947e52$var$ANY;
        else this.semver = new $4HX32(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $75d4P("Comparator.test", version, this.options.loose);
        if (this.semver === $dd34309531947e52$var$ANY || version === $dd34309531947e52$var$ANY) return true;
        if (typeof version === "string") try {
            version = new $4HX32(version, this.options);
        } catch (er) {
            return false;
        }
        return $8lBOO(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $dd34309531947e52$var$Comparator)) throw new TypeError("a Comparator is required");
        if (this.operator === "") {
            if (this.value === "") return true;
            return new $b6sFB(comp.value, options).test(this.value);
        } else if (comp.operator === "") {
            if (comp.value === "") return true;
            return new $b6sFB(this.value, options).test(comp.semver);
        }
        options = $aOQwm(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) return false;
        if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith(">") && comp.operator.startsWith(">")) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith("<") && comp.operator.startsWith("<")) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) return true;
        // opposite directions less than
        if ($8lBOO(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) return true;
        // opposite directions greater than
        if ($8lBOO(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) return true;
        return false;
    }
}
module.exports = $dd34309531947e52$var$Comparator;

var $aOQwm = parcelRequire("aOQwm");

var $cFp8R = parcelRequire("cFp8R");
var $dd34309531947e52$require$re = $cFp8R.safeRe;
var $dd34309531947e52$require$t = $cFp8R.t;

var $8lBOO = parcelRequire("8lBOO");

var $75d4P = parcelRequire("75d4P");

var $4HX32 = parcelRequire("4HX32");

var $b6sFB = parcelRequire("b6sFB");

});
parcelRegister("b6sFB", function(module, exports) {
// hoisted class for cyclic dependency
class $81567e807da8ba05$var$Range {
    constructor(range, options){
        options = $aOQwm(options);
        if (range instanceof $81567e807da8ba05$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $81567e807da8ba05$var$Range(range.raw, options);
        }
        if (range instanceof $iZsHJ) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().split(/\s+/).join(" ");
        // First, split on ||
        this.set = this.raw.split("||")// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$81567e807da8ba05$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $81567e807da8ba05$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.format();
    }
    format() {
        this.range = this.set.map((comps)=>comps.join(" ").trim()).join("||").trim();
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $81567e807da8ba05$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $81567e807da8ba05$require$FLAG_LOOSE);
        const memoKey = memoOpts + ":" + range;
        const cached = $81567e807da8ba05$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.HYPHENRANGELOOSE] : $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.HYPHENRANGE];
        range = range.replace(hr, $81567e807da8ba05$var$hyphenReplace(this.options.includePrerelease));
        $75d4P("hyphen replace", range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($81567e807da8ba05$require$re[$81567e807da8ba05$require$t.COMPARATORTRIM], $81567e807da8ba05$require$comparatorTrimReplace);
        $75d4P("comparator trim", range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($81567e807da8ba05$require$re[$81567e807da8ba05$require$t.TILDETRIM], $81567e807da8ba05$require$tildeTrimReplace);
        $75d4P("tilde trim", range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($81567e807da8ba05$require$re[$81567e807da8ba05$require$t.CARETTRIM], $81567e807da8ba05$require$caretTrimReplace);
        $75d4P("caret trim", range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(" ").map((comp)=>$81567e807da8ba05$var$parseComparator(comp, this.options)).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$81567e807da8ba05$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $75d4P("loose invalid filter", comp, this.options);
            return !!comp.match($81567e807da8ba05$require$re[$81567e807da8ba05$require$t.COMPARATORLOOSE]);
        });
        $75d4P("range list", rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $iZsHJ(comp, this.options));
        for (const comp of comparators){
            if ($81567e807da8ba05$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
        const result = [
            ...rangeMap.values()
        ];
        $81567e807da8ba05$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $81567e807da8ba05$var$Range)) throw new TypeError("a Range is required");
        return this.set.some((thisComparators)=>{
            return $81567e807da8ba05$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $81567e807da8ba05$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === "string") try {
            version = new $4HX32(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($81567e807da8ba05$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = $81567e807da8ba05$var$Range;

var $lvp2R = parcelRequire("lvp2R");
const $81567e807da8ba05$var$cache = new $lvp2R({
    max: 1000
});

var $aOQwm = parcelRequire("aOQwm");

var $iZsHJ = parcelRequire("iZsHJ");

var $75d4P = parcelRequire("75d4P");

var $4HX32 = parcelRequire("4HX32");

var $cFp8R = parcelRequire("cFp8R");
var $81567e807da8ba05$require$re = $cFp8R.safeRe;
var $81567e807da8ba05$require$t = $cFp8R.t;
var $81567e807da8ba05$require$comparatorTrimReplace = $cFp8R.comparatorTrimReplace;
var $81567e807da8ba05$require$tildeTrimReplace = $cFp8R.tildeTrimReplace;
var $81567e807da8ba05$require$caretTrimReplace = $cFp8R.caretTrimReplace;

var $dI3mn = parcelRequire("dI3mn");
var $81567e807da8ba05$require$FLAG_INCLUDE_PRERELEASE = $dI3mn.FLAG_INCLUDE_PRERELEASE;
var $81567e807da8ba05$require$FLAG_LOOSE = $dI3mn.FLAG_LOOSE;
const $81567e807da8ba05$var$isNullSet = (c)=>c.value === "<0.0.0-0";
const $81567e807da8ba05$var$isAny = (c)=>c.value === "";
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $81567e807da8ba05$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $81567e807da8ba05$var$parseComparator = (comp, options)=>{
    $75d4P("comp", comp, options);
    comp = $81567e807da8ba05$var$replaceCarets(comp, options);
    $75d4P("caret", comp);
    comp = $81567e807da8ba05$var$replaceTildes(comp, options);
    $75d4P("tildes", comp);
    comp = $81567e807da8ba05$var$replaceXRanges(comp, options);
    $75d4P("xrange", comp);
    comp = $81567e807da8ba05$var$replaceStars(comp, options);
    $75d4P("stars", comp);
    return comp;
};
const $81567e807da8ba05$var$isX = (id)=>!id || id.toLowerCase() === "x" || id === "*";
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $81567e807da8ba05$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$81567e807da8ba05$var$replaceTilde(c, options)).join(" ");
};
const $81567e807da8ba05$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.TILDELOOSE] : $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $75d4P("tilde", comp, _, M, m, p, pr);
        let ret;
        if ($81567e807da8ba05$var$isX(M)) ret = "";
        else if ($81567e807da8ba05$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($81567e807da8ba05$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $75d4P("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $75d4P("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $81567e807da8ba05$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$81567e807da8ba05$var$replaceCaret(c, options)).join(" ");
};
const $81567e807da8ba05$var$replaceCaret = (comp, options)=>{
    $75d4P("caret", comp, options);
    const r = options.loose ? $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.CARETLOOSE] : $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.CARET];
    const z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, (_, M, m, p, pr)=>{
        $75d4P("caret", comp, _, M, m, p, pr);
        let ret;
        if ($81567e807da8ba05$var$isX(M)) ret = "";
        else if ($81567e807da8ba05$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($81567e807da8ba05$var$isX(p)) {
            if (M === "0") ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $75d4P("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $75d4P("no pr");
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $75d4P("caret return", ret);
        return ret;
    });
};
const $81567e807da8ba05$var$replaceXRanges = (comp, options)=>{
    $75d4P("replaceXRanges", comp, options);
    return comp.split(/\s+/).map((c)=>$81567e807da8ba05$var$replaceXRange(c, options)).join(" ");
};
const $81567e807da8ba05$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.XRANGELOOSE] : $81567e807da8ba05$require$re[$81567e807da8ba05$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $75d4P("xRange", comp, ret, gtlt, M, m, p, pr);
        const xM = $81567e807da8ba05$var$isX(M);
        const xm = xM || $81567e807da8ba05$var$isX(m);
        const xp = xm || $81567e807da8ba05$var$isX(p);
        const anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $75d4P("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $81567e807da8ba05$var$replaceStars = (comp, options)=>{
    $75d4P("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($81567e807da8ba05$require$re[$81567e807da8ba05$require$t.STAR], "");
};
const $81567e807da8ba05$var$replaceGTE0 = (comp, options)=>{
    $75d4P("replaceGTE0", comp, options);
    return comp.trim().replace($81567e807da8ba05$require$re[options.includePrerelease ? $81567e807da8ba05$require$t.GTE0PRE : $81567e807da8ba05$require$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
const $81567e807da8ba05$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb)=>{
        if ($81567e807da8ba05$var$isX(fM)) from = "";
        else if ($81567e807da8ba05$var$isX(fm)) from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        else if ($81567e807da8ba05$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? "-0" : ""}`;
        if ($81567e807da8ba05$var$isX(tM)) to = "";
        else if ($81567e807da8ba05$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($81567e807da8ba05$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $81567e807da8ba05$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $75d4P(set[i].semver);
            if (set[i].semver === $iZsHJ.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

});
parcelRegister("lvp2R", function(module, exports) {
"use strict";

var $gHyCs = parcelRequire("gHyCs");
const $fa7febb082593fa9$var$MAX = Symbol("max");
const $fa7febb082593fa9$var$LENGTH = Symbol("length");
const $fa7febb082593fa9$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
const $fa7febb082593fa9$var$ALLOW_STALE = Symbol("allowStale");
const $fa7febb082593fa9$var$MAX_AGE = Symbol("maxAge");
const $fa7febb082593fa9$var$DISPOSE = Symbol("dispose");
const $fa7febb082593fa9$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const $fa7febb082593fa9$var$LRU_LIST = Symbol("lruList");
const $fa7febb082593fa9$var$CACHE = Symbol("cache");
const $fa7febb082593fa9$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const $fa7febb082593fa9$var$naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class $fa7febb082593fa9$var$LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[$fa7febb082593fa9$var$MAX] = options.max || Infinity;
        const lc = options.length || $fa7febb082593fa9$var$naiveLength;
        this[$fa7febb082593fa9$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $fa7febb082593fa9$var$naiveLength : lc;
        this[$fa7febb082593fa9$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$fa7febb082593fa9$var$MAX_AGE] = options.maxAge || 0;
        this[$fa7febb082593fa9$var$DISPOSE] = options.dispose;
        this[$fa7febb082593fa9$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$fa7febb082593fa9$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[$fa7febb082593fa9$var$MAX] = mL || Infinity;
        $fa7febb082593fa9$var$trim(this);
    }
    get max() {
        return this[$fa7febb082593fa9$var$MAX];
    }
    set allowStale(allowStale) {
        this[$fa7febb082593fa9$var$ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[$fa7febb082593fa9$var$ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[$fa7febb082593fa9$var$MAX_AGE] = mA;
        $fa7febb082593fa9$var$trim(this);
    }
    get maxAge() {
        return this[$fa7febb082593fa9$var$MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = $fa7febb082593fa9$var$naiveLength;
        if (lC !== this[$fa7febb082593fa9$var$LENGTH_CALCULATOR]) {
            this[$fa7febb082593fa9$var$LENGTH_CALCULATOR] = lC;
            this[$fa7febb082593fa9$var$LENGTH] = 0;
            this[$fa7febb082593fa9$var$LRU_LIST].forEach((hit)=>{
                hit.length = this[$fa7febb082593fa9$var$LENGTH_CALCULATOR](hit.value, hit.key);
                this[$fa7febb082593fa9$var$LENGTH] += hit.length;
            });
        }
        $fa7febb082593fa9$var$trim(this);
    }
    get lengthCalculator() {
        return this[$fa7febb082593fa9$var$LENGTH_CALCULATOR];
    }
    get length() {
        return this[$fa7febb082593fa9$var$LENGTH];
    }
    get itemCount() {
        return this[$fa7febb082593fa9$var$LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$fa7febb082593fa9$var$LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            $fa7febb082593fa9$var$forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$fa7febb082593fa9$var$LRU_LIST].head; walker !== null;){
            const next = walker.next;
            $fa7febb082593fa9$var$forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[$fa7febb082593fa9$var$LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[$fa7febb082593fa9$var$LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[$fa7febb082593fa9$var$DISPOSE] && this[$fa7febb082593fa9$var$LRU_LIST] && this[$fa7febb082593fa9$var$LRU_LIST].length) this[$fa7febb082593fa9$var$LRU_LIST].forEach((hit)=>this[$fa7febb082593fa9$var$DISPOSE](hit.key, hit.value));
        this[$fa7febb082593fa9$var$CACHE] = new Map() // hash of items by key
        ;
        this[$fa7febb082593fa9$var$LRU_LIST] = new $gHyCs() // list of items in order of use recency
        ;
        this[$fa7febb082593fa9$var$LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[$fa7febb082593fa9$var$LRU_LIST].map((hit)=>$fa7febb082593fa9$var$isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[$fa7febb082593fa9$var$LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[$fa7febb082593fa9$var$MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[$fa7febb082593fa9$var$LENGTH_CALCULATOR](value, key);
        if (this[$fa7febb082593fa9$var$CACHE].has(key)) {
            if (len > this[$fa7febb082593fa9$var$MAX]) {
                $fa7febb082593fa9$var$del(this, this[$fa7febb082593fa9$var$CACHE].get(key));
                return false;
            }
            const node = this[$fa7febb082593fa9$var$CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[$fa7febb082593fa9$var$DISPOSE]) {
                if (!this[$fa7febb082593fa9$var$NO_DISPOSE_ON_SET]) this[$fa7febb082593fa9$var$DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[$fa7febb082593fa9$var$LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            $fa7febb082593fa9$var$trim(this);
            return true;
        }
        const hit = new $fa7febb082593fa9$var$Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[$fa7febb082593fa9$var$MAX]) {
            if (this[$fa7febb082593fa9$var$DISPOSE]) this[$fa7febb082593fa9$var$DISPOSE](key, value);
            return false;
        }
        this[$fa7febb082593fa9$var$LENGTH] += hit.length;
        this[$fa7febb082593fa9$var$LRU_LIST].unshift(hit);
        this[$fa7febb082593fa9$var$CACHE].set(key, this[$fa7febb082593fa9$var$LRU_LIST].head);
        $fa7febb082593fa9$var$trim(this);
        return true;
    }
    has(key) {
        if (!this[$fa7febb082593fa9$var$CACHE].has(key)) return false;
        const hit = this[$fa7febb082593fa9$var$CACHE].get(key).value;
        return !$fa7febb082593fa9$var$isStale(this, hit);
    }
    get(key) {
        return $fa7febb082593fa9$var$get(this, key, true);
    }
    peek(key) {
        return $fa7febb082593fa9$var$get(this, key, false);
    }
    pop() {
        const node = this[$fa7febb082593fa9$var$LRU_LIST].tail;
        if (!node) return null;
        $fa7febb082593fa9$var$del(this, node);
        return node.value;
    }
    del(key) {
        $fa7febb082593fa9$var$del(this, this[$fa7febb082593fa9$var$CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[$fa7febb082593fa9$var$CACHE].forEach((value, key)=>$fa7febb082593fa9$var$get(this, key, false));
    }
}
const $fa7febb082593fa9$var$get = (self, key, doUse)=>{
    const node = self[$fa7febb082593fa9$var$CACHE].get(key);
    if (node) {
        const hit = node.value;
        if ($fa7febb082593fa9$var$isStale(self, hit)) {
            $fa7febb082593fa9$var$del(self, node);
            if (!self[$fa7febb082593fa9$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$fa7febb082593fa9$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$fa7febb082593fa9$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const $fa7febb082593fa9$var$isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[$fa7febb082593fa9$var$MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$fa7febb082593fa9$var$MAX_AGE] && diff > self[$fa7febb082593fa9$var$MAX_AGE];
};
const $fa7febb082593fa9$var$trim = (self)=>{
    if (self[$fa7febb082593fa9$var$LENGTH] > self[$fa7febb082593fa9$var$MAX]) for(let walker = self[$fa7febb082593fa9$var$LRU_LIST].tail; self[$fa7febb082593fa9$var$LENGTH] > self[$fa7febb082593fa9$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        $fa7febb082593fa9$var$del(self, walker);
        walker = prev;
    }
};
const $fa7febb082593fa9$var$del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[$fa7febb082593fa9$var$DISPOSE]) self[$fa7febb082593fa9$var$DISPOSE](hit.key, hit.value);
        self[$fa7febb082593fa9$var$LENGTH] -= hit.length;
        self[$fa7febb082593fa9$var$CACHE].delete(hit.key);
        self[$fa7febb082593fa9$var$LRU_LIST].removeNode(node);
    }
};
class $fa7febb082593fa9$var$Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const $fa7febb082593fa9$var$forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if ($fa7febb082593fa9$var$isStale(self, hit)) {
        $fa7febb082593fa9$var$del(self, node);
        if (!self[$fa7febb082593fa9$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
module.exports = $fa7febb082593fa9$var$LRUCache;

});
parcelRegister("gHyCs", function(module, exports) {
"use strict";
module.exports = $c28b8429a3e75f6b$var$Yallist;
$c28b8429a3e75f6b$var$Yallist.Node = $c28b8429a3e75f6b$var$Node;
$c28b8429a3e75f6b$var$Yallist.create = $c28b8429a3e75f6b$var$Yallist;
function $c28b8429a3e75f6b$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $c28b8429a3e75f6b$var$Yallist)) self = new $c28b8429a3e75f6b$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$c28b8429a3e75f6b$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$c28b8429a3e75f6b$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$c28b8429a3e75f6b$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$c28b8429a3e75f6b$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$c28b8429a3e75f6b$var$push(this, arguments[i]);
    return this.length;
};
$c28b8429a3e75f6b$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$c28b8429a3e75f6b$var$unshift(this, arguments[i]);
    return this.length;
};
$c28b8429a3e75f6b$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$c28b8429a3e75f6b$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$c28b8429a3e75f6b$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$c28b8429a3e75f6b$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$c28b8429a3e75f6b$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$c28b8429a3e75f6b$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$c28b8429a3e75f6b$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $c28b8429a3e75f6b$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$c28b8429a3e75f6b$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $c28b8429a3e75f6b$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$c28b8429a3e75f6b$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$c28b8429a3e75f6b$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$c28b8429a3e75f6b$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$c28b8429a3e75f6b$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$c28b8429a3e75f6b$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $c28b8429a3e75f6b$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$c28b8429a3e75f6b$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $c28b8429a3e75f6b$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$c28b8429a3e75f6b$var$Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 0; i < nodes.length; i++)walker = $c28b8429a3e75f6b$var$insert(this, walker, nodes[i]);
    return ret;
};
$c28b8429a3e75f6b$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $c28b8429a3e75f6b$var$insert(self, node, value) {
    var inserted = node === self.head ? new $c28b8429a3e75f6b$var$Node(value, null, node, self) : new $c28b8429a3e75f6b$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $c28b8429a3e75f6b$var$push(self, item) {
    self.tail = new $c28b8429a3e75f6b$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $c28b8429a3e75f6b$var$unshift(self, item) {
    self.head = new $c28b8429a3e75f6b$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $c28b8429a3e75f6b$var$Node(value, prev, next, list) {
    if (!(this instanceof $c28b8429a3e75f6b$var$Node)) return new $c28b8429a3e75f6b$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("c4lz9"))($c28b8429a3e75f6b$var$Yallist);
} catch (er) {}

});
parcelRegister("c4lz9", function(module, exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

});





parcelRegister("2Tcur", function(module, exports) {

var $b6sFB = parcelRequire("b6sFB");
const $21aa6819e8d75bb3$var$satisfies = (version, range, options)=>{
    try {
        range = new $b6sFB(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = $21aa6819e8d75bb3$var$satisfies;

});

parcelRegister("amrSW", function(module, exports) {

var $b6sFB = parcelRequire("b6sFB");
// Mostly just for testing and legacy API reasons
const $78b196dcceabeddc$var$toComparators = (range, options)=>new $b6sFB(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
module.exports = $78b196dcceabeddc$var$toComparators;

});

parcelRegister("j01th", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");

var $b6sFB = parcelRequire("b6sFB");
const $dd4f2891185cf756$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $b6sFB(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $4HX32(max, options);
            }
        }
    });
    return max;
};
module.exports = $dd4f2891185cf756$var$maxSatisfying;

});

parcelRegister("8fzmh", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");

var $b6sFB = parcelRequire("b6sFB");
const $601b26e2fcf2b67d$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $b6sFB(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $4HX32(min, options);
            }
        }
    });
    return min;
};
module.exports = $601b26e2fcf2b67d$var$minSatisfying;

});

parcelRegister("dqt8z", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");

var $b6sFB = parcelRequire("b6sFB");

var $fgtv7 = parcelRequire("fgtv7");
const $9c644e242bc94047$var$minVersion = (range, loose)=>{
    range = new $b6sFB(range, loose);
    let minver = new $4HX32("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $4HX32("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $4HX32(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $fgtv7(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $fgtv7(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = $9c644e242bc94047$var$minVersion;

});

parcelRegister("8sIWg", function(module, exports) {

var $b6sFB = parcelRequire("b6sFB");
const $6293cc2c7196ab29$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $b6sFB(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
module.exports = $6293cc2c7196ab29$var$validRange;

});

parcelRegister("lPfbh", function(module, exports) {

var $4HX32 = parcelRequire("4HX32");

var $iZsHJ = parcelRequire("iZsHJ");
const { ANY: $fe3a23010c84bac7$var$ANY } = $iZsHJ;

var $b6sFB = parcelRequire("b6sFB");

var $2Tcur = parcelRequire("2Tcur");

var $fgtv7 = parcelRequire("fgtv7");

var $9qhoW = parcelRequire("9qhoW");

var $bq3RM = parcelRequire("bq3RM");

var $aW5yP = parcelRequire("aW5yP");
const $fe3a23010c84bac7$var$outside = (version, range, hilo, options)=>{
    version = new $4HX32(version, options);
    range = new $b6sFB(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $fgtv7;
            ltefn = $bq3RM;
            ltfn = $9qhoW;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $9qhoW;
            ltefn = $aW5yP;
            ltfn = $fgtv7;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($2Tcur(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $fe3a23010c84bac7$var$ANY) comparator = new $iZsHJ(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = $fe3a23010c84bac7$var$outside;

});

parcelRegister("4ZPf6", function(module, exports) {
// Determine if version is greater than all the versions possible in the range.

var $lPfbh = parcelRequire("lPfbh");
const $3a349ba5ce689d26$var$gtr = (version, range, options)=>$lPfbh(version, range, ">", options);
module.exports = $3a349ba5ce689d26$var$gtr;

});

parcelRegister("gRhS3", function(module, exports) {

var $lPfbh = parcelRequire("lPfbh");
// Determine if version is less than all the versions possible in the range
const $c45f755c6ecc2812$var$ltr = (version, range, options)=>$lPfbh(version, range, "<", options);
module.exports = $c45f755c6ecc2812$var$ltr;

});

parcelRegister("lWfo0", function(module, exports) {

var $b6sFB = parcelRequire("b6sFB");
const $ff8af32694ecb571$var$intersects = (r1, r2, options)=>{
    r1 = new $b6sFB(r1, options);
    r2 = new $b6sFB(r2, options);
    return r1.intersects(r2, options);
};
module.exports = $ff8af32694ecb571$var$intersects;

});

parcelRegister("5HOZL", function(module, exports) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.

var $2Tcur = parcelRequire("2Tcur");

var $kh2xb = parcelRequire("kh2xb");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$kh2xb(a, b, options));
    for (const version of v){
        const included = $2Tcur(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push("*");
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(" || ");
    const original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

});

parcelRegister("fvORW", function(module, exports) {

var $b6sFB = parcelRequire("b6sFB");

var $iZsHJ = parcelRequire("iZsHJ");
const { ANY: $b4b135c7e22ab50b$var$ANY } = $iZsHJ;

var $2Tcur = parcelRequire("2Tcur");

var $kh2xb = parcelRequire("kh2xb");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $b4b135c7e22ab50b$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $b6sFB(sub, options);
    dom = new $b6sFB(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $b4b135c7e22ab50b$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $b4b135c7e22ab50b$var$minimumVersionWithPreRelease = [
    new $iZsHJ(">=0.0.0-0")
];
const $b4b135c7e22ab50b$var$minimumVersion = [
    new $iZsHJ(">=0.0.0")
];
const $b4b135c7e22ab50b$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $b4b135c7e22ab50b$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $b4b135c7e22ab50b$var$ANY) return true;
        else if (options.includePrerelease) sub = $b4b135c7e22ab50b$var$minimumVersionWithPreRelease;
        else sub = $b4b135c7e22ab50b$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $b4b135c7e22ab50b$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $b4b135c7e22ab50b$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === ">" || c.operator === ">=") gt = $b4b135c7e22ab50b$var$higherGT(gt, c, options);
        else if (c.operator === "<" || c.operator === "<=") lt = $b4b135c7e22ab50b$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $kh2xb(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$2Tcur(eq, String(gt), options)) return null;
        if (lt && !$2Tcur(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$2Tcur(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
        hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === ">" || c.operator === ">=") {
                higher = $b4b135c7e22ab50b$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === ">=" && !$2Tcur(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === "<" || c.operator === "<=") {
                lower = $b4b135c7e22ab50b$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === "<=" && !$2Tcur(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $b4b135c7e22ab50b$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $kh2xb(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $b4b135c7e22ab50b$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $kh2xb(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
module.exports = $b4b135c7e22ab50b$var$subset;

});


parcelRegister("63lQb", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    "use strict";
    //////////////
    // Constants
    /////////////
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        "1.0": "/8",
        "1.2": "/1",
        "1.3": "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        "ME": "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        "2000": "NT 5.0",
        "XP": [
            "NT 5.1",
            "NT 5.2"
        ],
        "Vista": "NT 6.0",
        "7": "NT 6.1",
        "8": "NT 6.2",
        "8.1": "NT 6.3",
        "10": [
            "NT 6.4",
            "NT 10.0"
        ],
        "RT": "ARM"
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                // Trident based
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i // 360
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i // Comodo Dragon
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i // QQBrowser/2345 Browser
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i // Panasonic Viera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

var $d6a3100aa477035c$exports = {};
"use strict";

$d6a3100aa477035c$exports = (parcelRequire("izkmZ"));


parcelRequire("iawgr");
var $26cdf06a4340f785$exports = {};
"use strict";
function $26cdf06a4340f785$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($26cdf06a4340f785$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$26cdf06a4340f785$var$checkDCE();

$26cdf06a4340f785$exports = (parcelRequire("5NiZx"));


var $e6396f5ab52e7921$export$882461b6382ed46c;
var $e6396f5ab52e7921$export$757ceba2d55c277e;
"use strict";

var $e6396f5ab52e7921$var$i;
$e6396f5ab52e7921$export$882461b6382ed46c = $26cdf06a4340f785$exports.createRoot;
$e6396f5ab52e7921$export$757ceba2d55c277e = $26cdf06a4340f785$exports.hydrateRoot;




var $iawgr = parcelRequire("iawgr");



var $iawgr = parcelRequire("iawgr");

function $ad12973d6e24df39$export$188d75d71883854a(...args) {
    if (arguments.length > 0) return args.join(" ");
    return "";
}
function $ad12973d6e24df39$export$ea88ded4304fba08(event) {
    const animationName = event.animationName.split("--")[1];
    return animationName ? animationName : undefined;
}
let $ad12973d6e24df39$var$newIdCounter = 0;
function $ad12973d6e24df39$export$71a94539e79257f0(prefix = "id") {
    $ad12973d6e24df39$var$newIdCounter++;
    return `${prefix}${$ad12973d6e24df39$var$newIdCounter}`;
}
function $ad12973d6e24df39$export$b141de964f0a90c1(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * max * 2) + min;
}
function $ad12973d6e24df39$export$2ffdd0f7af684998(transition, transform, refs) {
    for(let i = 0; i < refs.length; i++)if (refs[i].current !== null) {
        transition && (refs[i].current.style.transition = transition);
        transform && (refs[i].current.style.transform = transform);
    }
}
function $ad12973d6e24df39$export$a1d0d20ee9546562() {
    const prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
    const mq = function(query) {
        return window.matchMedia(query).matches;
    };
    if ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch) return true;
    const query = [
        "(",
        prefixes.join("touch-enabled),("),
        "heartz",
        ")"
    ].join("");
    return mq(query);
}
const $ad12973d6e24df39$export$f3f8da4197e92521 = (event)=>event.stopPropagation();
function $ad12973d6e24df39$export$4e9e2e79518e2524(rawStr) {
    return rawStr.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
        return "&#" + i.charCodeAt(0) + ";";
    });
}
function $ad12973d6e24df39$export$728a6effeb7267c1(prefix) {
    const baseTitle = "Leon Dietsch // Web- und App-Entwicklung";
    if (prefix === null) document.title = baseTitle;
    else document.title = `${prefix} | ${baseTitle}`;
}
function $ad12973d6e24df39$export$ae1d0d62f31e3240(mediaQuery, callback) {
    if (window.hasOwnProperty("matchMedia")) {
        if (window.matchMedia.hasOwnProperty("addEventListener")) window.matchMedia(mediaQuery).addEventListener("change", callback);
        else window.matchMedia(mediaQuery).addListener(callback);
    }
}


var $cd2d5d6c9f4e8362$exports = {};

var $8NqU9 = parcelRequire("8NqU9");
"use strict";
var $cd2d5d6c9f4e8362$var$__importDefault = $cd2d5d6c9f4e8362$exports && $cd2d5d6c9f4e8362$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($cd2d5d6c9f4e8362$exports, "__esModule", {
    value: true
});
$cd2d5d6c9f4e8362$exports.normalizeQuery = $cd2d5d6c9f4e8362$exports.resolveUserAgent = $cd2d5d6c9f4e8362$exports.matchesUA = void 0;

const $cd2d5d6c9f4e8362$var$browserslist_1 = $cd2d5d6c9f4e8362$var$__importDefault((parcelRequire("6Swur")));

const $cd2d5d6c9f4e8362$var$semver_1 = $cd2d5d6c9f4e8362$var$__importDefault((parcelRequire("5QpTL")));

const $cd2d5d6c9f4e8362$var$ua_parser_js_1 = $cd2d5d6c9f4e8362$var$__importDefault((parcelRequire("63lQb")));
// @see https://github.com/ai/browserslist#browsers
// map of equivalent browsers,
// see https://github.com/ai/browserslist/issues/156
const $cd2d5d6c9f4e8362$var$browserNameMap = {
    bb: "BlackBerry",
    and_chr: "Chrome",
    ChromeAndroid: "Chrome",
    FirefoxAndroid: "Firefox",
    ff: "Firefox",
    ie_mob: "ExplorerMobile",
    ie: "Explorer",
    and_ff: "Firefox",
    ios_saf: "iOS",
    op_mini: "OperaMini",
    op_mob: "OperaMobile",
    and_qq: "QQAndroid",
    and_uc: "UCAndroid"
};
function $cd2d5d6c9f4e8362$var$resolveUserAgent(uaString) {
    const parsedUA = (0, $cd2d5d6c9f4e8362$var$ua_parser_js_1.default)(uaString);
    const parsedBrowserVersion = $cd2d5d6c9f4e8362$var$semverify(parsedUA.browser.version);
    const parsedOSVersion = $cd2d5d6c9f4e8362$var$semverify(parsedUA.os.version);
    const parsedEngineVersion = $cd2d5d6c9f4e8362$var$semverify(parsedUA.engine.version);
    // Case A: For Safari on iOS, the use the browser version
    if (parsedUA.browser.name === "Safari" && parsedUA.os.name === "iOS") return {
        family: "iOS",
        version: parsedBrowserVersion
    };
    // Case B: The browser on iOS didn't report as safari,
    // so we use the iOS version as a proxy to the browser
    // version. This is based on the assumption that the
    // underlying Safari Engine used will be *atleast* equal
    // to the iOS version it's running on.
    if (parsedUA.os.name === "iOS") return {
        family: "iOS",
        version: parsedOSVersion
    };
    if (parsedUA.browser.name === "Opera" && parsedUA.device.type === "mobile" || parsedUA.browser.name === "Opera Mobi") return {
        family: "OperaMobile",
        version: parsedBrowserVersion
    };
    if (parsedUA.browser.name === "Samsung Browser") return {
        family: "Samsung",
        version: parsedBrowserVersion
    };
    if (parsedUA.browser.name === "IE") return {
        family: "Explorer",
        version: parsedBrowserVersion
    };
    if (parsedUA.browser.name === "IEMobile") return {
        family: "ExplorerMobile",
        version: parsedBrowserVersion
    };
    // Use engine version for gecko-based browsers
    if (parsedUA.engine.name === "Gecko") return {
        family: "Firefox",
        version: parsedEngineVersion
    };
    // Use engine version for blink-based browsers
    if (parsedUA.engine.name === "Blink") return {
        family: "Chrome",
        version: parsedEngineVersion
    };
    // Chrome based browsers pre-blink (WebKit)
    if (parsedUA.browser.name && [
        "Chrome",
        "Chromium",
        "Chrome WebView",
        "Chrome Headless"
    ].includes(parsedUA.browser.name)) return {
        family: "Chrome",
        version: parsedBrowserVersion
    };
    if (parsedUA.browser.name === "Android Browser") // Versions prior to Blink were based
    // on the OS version. Only after this
    // did android start using system chrome for web-views
    return {
        family: "Android",
        version: parsedOSVersion
    };
    return {
        family: parsedUA.browser.name || null,
        version: parsedBrowserVersion
    };
}
$cd2d5d6c9f4e8362$exports.resolveUserAgent = $cd2d5d6c9f4e8362$var$resolveUserAgent;
// Convert version to a semver value.
// 2.5 -> 2.5.0; 1 -> 1.0.0;
const $cd2d5d6c9f4e8362$var$semverify = (version)=>{
    if (!version) return null;
    const cooerced = $cd2d5d6c9f4e8362$var$semver_1.default.coerce(version, {
        loose: true
    });
    if (!cooerced) return null;
    return cooerced.version;
};
// 10.0-10.2 -> 10.0, 10.1, 10.2
function $cd2d5d6c9f4e8362$var$generateSemversInRange(versionRange) {
    const [start, end] = versionRange.split("-");
    const startSemver = $cd2d5d6c9f4e8362$var$semverify(start);
    const endSemver = $cd2d5d6c9f4e8362$var$semverify(end);
    if (!startSemver || !endSemver) return [];
    const versionsInRange = [];
    let curVersion = startSemver;
    while($cd2d5d6c9f4e8362$var$semver_1.default.gte(endSemver, curVersion)){
        versionsInRange.push(curVersion);
        curVersion = $cd2d5d6c9f4e8362$var$semver_1.default.inc(curVersion, "minor");
    }
    return versionsInRange;
}
function $cd2d5d6c9f4e8362$var$normalizeQuery(query) {
    let normalizedQuery = query;
    const regex = `(${Object.keys($cd2d5d6c9f4e8362$var$browserNameMap).join("|")})`;
    const match = query.match(new RegExp(regex));
    if (match) normalizedQuery = query.replace(match[0], $cd2d5d6c9f4e8362$var$browserNameMap[match[0]]);
    return normalizedQuery;
}
$cd2d5d6c9f4e8362$exports.normalizeQuery = $cd2d5d6c9f4e8362$var$normalizeQuery;
const $cd2d5d6c9f4e8362$var$parseBrowsersList = (browsersList)=>{
    const browsers = browsersList.map((browser)=>{
        const [name, version] = browser.split(" ");
        return {
            name: name,
            version: version
        };
    })// #38 Filter out non-numerical browser versions
    .filter((browser)=>browser.version !== "TP").map((browser)=>{
        let normalizedName = browser.name;
        let normalizedVersion = browser.version;
        if (browser.name in $cd2d5d6c9f4e8362$var$browserNameMap) normalizedName = $cd2d5d6c9f4e8362$var$browserNameMap[browser.name];
        // browserslist might return ranges (9.0-9.2), unwrap them
        // see https://github.com/browserslist/browserslist-useragent/issues/41
        if (browser.version.indexOf("-") > 0) return $cd2d5d6c9f4e8362$var$generateSemversInRange(browser.version).map((version)=>({
                family: normalizedName,
                version: version
            }));
        else return {
            family: normalizedName,
            version: normalizedVersion
        };
    });
    return browsers.flat();
};
const $cd2d5d6c9f4e8362$var$compareBrowserSemvers = (versionA, versionB, options)=>{
    const semverifiedA = $cd2d5d6c9f4e8362$var$semverify(versionA);
    const semverifiedB = $cd2d5d6c9f4e8362$var$semverify(versionB);
    if (!semverifiedA || !semverifiedB) return false;
    let referenceVersion = semverifiedB;
    if (options.ignorePatch) referenceVersion = `~${semverifiedB}`;
    if (options.ignoreMinor) referenceVersion = `^${semverifiedB}`;
    if (options.allowHigherVersions) return $cd2d5d6c9f4e8362$var$semver_1.default.gte(semverifiedA, semverifiedB);
    else return $cd2d5d6c9f4e8362$var$semver_1.default.satisfies(semverifiedA, referenceVersion);
};
const $cd2d5d6c9f4e8362$var$matchesUA = (uaString, opts = {})=>{
    // bail out early if the user agent is invalid
    if (!uaString) return false;
    let normalizedQuery;
    if (opts.browsers) normalizedQuery = opts.browsers.map($cd2d5d6c9f4e8362$var$normalizeQuery);
    const browsers = (0, $cd2d5d6c9f4e8362$var$browserslist_1.default)(normalizedQuery, {
        env: opts.env,
        path: opts.path || $8NqU9.cwd()
    });
    const parsedBrowsers = $cd2d5d6c9f4e8362$var$parseBrowsersList(browsers);
    const resolvedUserAgent = $cd2d5d6c9f4e8362$var$resolveUserAgent(uaString);
    const options = Object.assign({
        ignoreMinor: false,
        ignorePatch: true
    }, opts);
    return parsedBrowsers.some((browser)=>{
        if (!resolvedUserAgent.family) return false;
        if (!resolvedUserAgent.version) return false;
        if (!browser.version) return false;
        return browser.family.toLowerCase() === resolvedUserAgent.family.toLocaleLowerCase() && $cd2d5d6c9f4e8362$var$compareBrowserSemvers(resolvedUserAgent.version, browser.version, options);
    });
};
$cd2d5d6c9f4e8362$exports.matchesUA = $cd2d5d6c9f4e8362$var$matchesUA;


// const isSafari = matchesUA(navigator.userAgent, {browsers: ['safari > 1'], ignoreMinor: true, ignorePatch: true, allowHigherVersions: true});
const $49f6b8e9145f1ed5$var$isSafari = window.navigator.userAgent.match(/Safari/i) && !window.navigator.userAgent.match(/Chrome/i);
const $49f6b8e9145f1ed5$var$isEdge = (0, $cd2d5d6c9f4e8362$exports.matchesUA)(navigator.userAgent, {
    browsers: [
        "Edge > 1"
    ],
    ignoreMinor: true,
    ignorePatch: true,
    allowHigherVersions: true
});
const $49f6b8e9145f1ed5$var$isIE = (0, $cd2d5d6c9f4e8362$exports.matchesUA)(navigator.userAgent, {
    browsers: [
        "IE > 9"
    ],
    ignoreMinor: true,
    ignorePatch: true,
    allowHigherVersions: true
});
const $49f6b8e9145f1ed5$export$8514dfc5d66e21a5 = {
    safari: $49f6b8e9145f1ed5$var$isSafari,
    edge: $49f6b8e9145f1ed5$var$isEdge,
    ie: $49f6b8e9145f1ed5$var$isIE
};



parcelRequire("iawgr");

parcelRequire("iawgr");
const $e778b3dba3b69111$var$SvgXing = (props)=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("path", {
            d: "M18.188 0c-.517 0-.741.325-.927.66 0 0-7.455 13.224-7.702 13.657.015.024 4.919 9.023 4.919 9.023.17.308.436.66.967.66h3.454c.211 0 .375-.078.463-.22.089-.151.089-.346-.009-.536l-4.879-8.916a.022.022 0 0 1 0-.022L22.139.756c.095-.191.097-.387.006-.535C22.056.078 21.894 0 21.686 0h-3.498zM3.648 4.74c-.211 0-.385.074-.473.216-.09.149-.078.339.02.531l2.34 4.05c.004.01.004.016 0 .021L1.86 16.051a.52.52 0 0 0 0 .529c.085.142.239.234.45.234h3.461c.518 0 .766-.348.945-.667l3.734-6.609-2.378-4.155c-.172-.315-.434-.659-.962-.659H3.648v.016z"
        })
    });
var $e778b3dba3b69111$export$2e2bcd8739ae039 = $e778b3dba3b69111$var$SvgXing;



parcelRequire("iawgr");
const $e55aedb786c75e76$var$SvgLinkedin = (props)=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("path", {
            d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
        })
    });
var $e55aedb786c75e76$export$2e2bcd8739ae039 = $e55aedb786c75e76$var$SvgLinkedin;



parcelRequire("iawgr");
const $30799e9b502d89d7$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("path", {
            d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
        })
    });
var $30799e9b502d89d7$export$2e2bcd8739ae039 = $30799e9b502d89d7$var$SvgGithub;




parcelRequire("iawgr");
const $14cbbd7528c9ce39$export$e17b9c1182212c96 = ({ id: id })=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("svg", {
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("use", {
            xlinkHref: id
        })
    });



function $b0353496199e405a$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
        className: "socmed",
        children: [
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("a", {
                className: "socmed__xing",
                href: "https://www.xing.com/profile/Leon_Dietsch",
                target: "_blank",
                onTouchMove: (0, $ad12973d6e24df39$export$f3f8da4197e92521),
                children: [
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $e778b3dba3b69111$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: "Zum Xing-Profil"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("a", {
                className: "socmed__linkedin",
                href: "https://www.linkedin.com/in/leon-dietsch/",
                target: "_blank",
                onTouchMove: (0, $ad12973d6e24df39$export$f3f8da4197e92521),
                children: [
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $e55aedb786c75e76$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: "Zum Linked In-Profil"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("a", {
                className: "socmed__github",
                href: "https://github.com/leonlaser",
                target: "_blank",
                onTouchMove: (0, $ad12973d6e24df39$export$f3f8da4197e92521),
                children: [
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $30799e9b502d89d7$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: "Zum GitHub-Profil"
                    })
                ]
            })
        ]
    });
}



parcelRequire("iawgr");

parcelRequire("iawgr");
const $fc9ca4f87b8dc19e$var$SvgSave = (props)=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        ...props,
        children: [
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0V0z"
            }),
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("path", {
                d: "M19 12v7H5v-7H3v9h18v-9h-2zm-6 .67 2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z"
            })
        ]
    });
var $fc9ca4f87b8dc19e$export$2e2bcd8739ae039 = $fc9ca4f87b8dc19e$var$SvgSave;



var $d44d9b633dca31fa$exports = {};
$d44d9b633dca31fa$exports = "BEGIN:VCARD\r\nVERSION:3.0\r\nPRODID:-//Apple Inc.//macOS 12.6//EN\r\nN:Dietsch;Leon;;;\r\nFN:Leon Dietsch\r\nTITLE:Freelancer // Web-Entwicklung\r\nEMAIL;type=INTERNET;type=WORK;type=pref:hallo@leondietsch.de\r\nTEL;type=WORK;type=VOICE;type=pref:+49 176 210 154 56\r\nitem1.ADR;type=WORK;type=pref:;;Lohmühlenweg 15;Gelnhausen;;63571;Deutschland\r\nitem1.X-ABADR:DE\r\nitem2.URL;type=pref:https://leondietsch.de\r\nitem2.X-ABLabel:_$!<HomePage>!$_\r\nPHOTO;ENCODING=b;TYPE=JPEG:/9j/4AAQSkZJRgABAQAAkACQAAD/4QCARXhpZgAATU0AKgAA\r\n AAgABAEaAAUAAAABAAAAPgEbAAUAAAABAAAARgEoAAMAAAABAAIAAIdpAAQAAAABAAAATgAAAA\r\n AAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAy6gAwAEAAAAAQAAAy4A\r\n AAAA/+0AOFBob3Rvc2hvcCAzLjAAOEJJTQQEAAAAAAAAOEJJTQQlAAAAAAAQ1B2M2Y8AsgTpgA\r\n mY7PhCfv/AABEIAy4DLgMBIgACEQEDEQH/xAAfAAABBQEBAQEBAQAAAAAAAAAAAQIDBAUGBwgJ\r\n Cgv/xAC1EAACAQMDAgQDBQUEBAAAAX0BAgMABBEFEiExQQYTUWEHInEUMoGRoQgjQrHBFVLR8C\r\n QzYnKCCQoWFxgZGiUmJygpKjQ1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5\r\n eoOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4e\r\n Lj5OXm5+jp6vHy8/T19vf4+fr/xAAfAQADAQEBAQEBAQEBAAAAAAAAAQIDBAUGBwgJCgv/xAC1\r\n EQACAQIEBAMEBwUEBAABAncAAQIDEQQFITEGEkFRB2FxEyIygQgUQpGhscEJIzNS8BVictEKFi\r\n Q04SXxFxgZGiYnKCkqNTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqCg4SF\r\n hoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2dri4+Tl5u\r\n fo6ery8/T19vf4+fr/2wBDAAICAgICAgMCAgMEAwMDBAUEBAQEBQcFBQUFBQcIBwcHBwcHCAgI\r\n CAgICAgKCgoKCgoLCwsLCw0NDQ0NDQ0NDQ3/2wBDAQICAgMDAwYDAwYNCQcJDQ0NDQ0NDQ0NDQ\r\n 0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ3/3QAEADP/2gAMAwEAAhED\r\n EQA/AP11hi96vLFx1qtBWgn3a+4PlyPyj6/pUirtGKdRWdWTSugCpFj3DOajqzH92uf2sgGeUf\r\n X9KkVdoxTqKUqknozWluFSLHuGc1HVmP7tQbjPKPr+lSKu0Yp1FABWZcjMjCtOs2f/AFrUAUHt\r\n 9/fFEduq8Hn3qzSL96gC3DCmBWpHbIUBqhD0FbEP+rFAEX2VKPsqVaooAq/ZUrGvdPDSM4bGe2\r\n K6Os666mgDjLm0CE/N+lcpfWu2RpN3Xtiu3vPvGuT1DvXDmH8JeptQ+I50NlttT+UfWq6/6yr4\r\n 6V4p1EPlH1/SomG04q3VZ/vGgak1sM5qlKhLk5q7VZ/vGgv2kiDyz61PHESvWmVZj+7WlOKb1J\r\n c29GM8o+v6VPgLEB6ZpKV/9XWvs4kk9kfnr0PTCphQFfWvO7L71eg6Z/qk/GunDLlk3Exr/Cd1\r\n YQo4BxitsQKBisrTfuityuipORykXlLTxbqRmnVMn3RWTnI2owUnqQfZlqKW2Vl21eqKTvRGpK\r\n +50OjDsc61kiNnNMNrmTcGx7YrRm61COtdXM3uEYRWqL1smzvmtNOlZ8FaCfdrhxJQ6iiiuGl8\r\n bAKkWPcM5qOrMf3a6GwGeUfX9KkUFRinUCspydjSmk3qHNHNFFZ8zNuSPYOaKKKqLbepnUiktA\r\n prdKdTW6VqjEzpupqJYA43Z61LN1NPh+4KsCH7MPX9K07aFRCoPPWq1X4P9WPxqJ7DQvlJ6U0w\r\n pnpU1FZ3ZVkQ+SnpULWili2auUHpT5mFkc9e6eswxux+H/164fWdHVEYb8/h9PevSpuprj9d+4\r\n /+fSu3DbnLiPhPnfV4FilPf/IrCPWuk1z/AFrf59K5upxJeH2CqMsZaQnNXqrP9415n2j0/slb\r\n yj6/pUirtGKdRVEBVmP7tVqsx/drOrsA+rMf3arVZj+7XOA+qk3U1bqpN1Na0twMubqagXrU83\r\n U1AvWtwNGHoK1YkygOayoegrYh/wBWKDOrsL5Z9aeowMUtFBzhULfeNTVC33jQA2iiigAqs/3j\r\n Vmqz/eNBrS3GVE0ZJJzUtFBuQ+UfX9Kqyx4J5rQqpN1NAGNNF71WY4XbjPvV+eoRFuTPrQBzlz\r\n FvPpXA6zbsbiRQfT+Qr1GaDmua1HT/ADCz461hXlKMbxOrB1KcJ3qbHzr4giMJJL/p9K87m1Qw\r\n HbuzXrHjDTJvm2j/ADxXzlrdteR3jIO2P5CvJrYuvHZ/gfRYelh6vwo//9D9eoK0E+7WfBWgn3\r\n a+4Plx1FFFY1/hAKsx/dqtVmP7tcoD6kWPcM5qOrMf3aDWluM8o+v6VIq7RinUUG4U4LkZzTam\r\n T7tADfLPrWbcR4kJzWtWdc/fNAGY77KYkuTnFE3U1nmXa5HpQB0UMnHStOO4CoBiuahn4q+s3y\r\n 0AbX2ken60faR6frWP51HnUAbH2ken61TuJQ2TVPzqgmm4oAzLyQbjXLXh8x2XpWteTc1iOdzE\r\n 1w5h/CXqbUPiM8WeG3bv0p5G049Kt1Wf7xrxTqGVE0ZJJzUtFAEPlH1/SqMo2yEVqVmz/wCtag\r\n CGrMf3arVZj+7WtLcB9RSSkDZipaVocxh63Atacm9uTivQtPjCRqM151ZPseuwtLzCgZrah8Rj\r\n X+E9KsJQoFbqyqwz0rgbO946/wCfyrejvfkH+f6V0ONzlOi8xfWpkcFa5r7b/nNWEvflHNS6dz\r\n ag/eOg3Co5WCpurF+2+9MuL39yOaSp2Z13JGmDtjpUZfa+3risEXv7zrWrE/mYf1raIjYhl9q1\r\n IjlAaxoegrYh/wBWK48TuBLRRRXDS+NgFWY/u1WqzH92uiQD6BRQKxnsa0twooorI3CiiirhuZ\r\n 1dgprdKdTW6VsjnM6bqadFjYKbN1NQCUKMVYF7Iq/B/qxWH5w9a0YJv3S/jUyV0NM0KKq+dR51\r\n RyMrmRapD0qt51DTcUuRhzEcwGTzXKa3EGiZt36fSt+abmuN1282q6Z6Y/pXbhk+Y5cR8J4hrs\r\n X74jP+eK5YjBxXUas/mSn/AD6VzUnDn61OJLw+wyqz/eNWarP9415n2j0/sjKkWPcM5qOrMf3a\r\n ogZ5R9f0qxHEdvX9KbVmP7tZ1dgGeUfX9KkVdoxTqK5wCqk3U1bqpN1Na0twMubqagXrU83U1A\r\n vWtwNGHoK2If8AViseHoK2If8AVigzq7EtFFFBzhUZQk5zUlFAEfln1phGDip6hb7xoAbUTRli\r\n TmpaBQa0tyHyj6/pUTDBxVuqz/eNBuMqrKMsRVqqz/eNAFN7ff3xTAuxfL64q5VZ/vGgCq8O/v\r\n is64twARnNbFZ9wcuRQ4c2hhiKcpxSiec6zo0d4SCcfhn+teI6/wCDEa/fD+n8PsPevpya1Mlc\r\n 9eaKk0pYjn/PvXn4jDnu5TVlS+I//9H9eoK0E+7WfBWgn3a+s9rI+XHVIse4ZzUdWY/u0pTk9G\r\n XTSb1GeUfX9KkVdoxTqKg29nEKsx/dqtVmP7tA1FLYfTguRnNNqZPu0FDfLPrT1GBilooAKzrn\r\n 75rRrOufvmgDJm6msSYkTtitubqarra+Yd+OtRUbS0AghJ9Kvox21bhsvaryWXyjisfaSAyNx9\r\n 6Nx962fsXtR9i9qPaSAxtx96bIjMm7OK2/sXtUM1vtXbR7SQHDXkTZ61lYwcV1N5Dya5uZdsjC\r\n uTGybp69zah8RFUTRkknNS0V5Z1EPlH1/SkMWBnNT01ulAFF32VTdTIxfpmrM3U1CvSgCLyj6/\r\n pViOI7Bz+lNqzH92taW4DPKPr+lMluPKj8rbnHfNWarzRbhn1rcCG2cu/TFdDBuGKyLKD5+ldh\r\n aWm5VbHWtqHxGNf4S7Z7sVvRb9gptnZcdP8AP51vR2XyD/P9a6jlMf5/enh3Axitj7F/nFH2Ki\r\n 66jjJr4TJ8x/SmSuXTYeDWz9irPnspBISOlO8S/aVDCMTK24HNbtlcwLEqSPhxnIwTUBjCffrd\r\n sUdoFaKANnPzbgO9RUqKKujSnKbdmW7f5x+7+b9K2YtqRgSHa3cYzWYP7XX/AFcYUf7y1oW32k\r\n oDdbd/f5h/SuOc1Lc2tIeZoR0f9DTleJhnf+hqG+1KCyTdJt/76FeR+Jfjl4G8MyS22o3KrcRY\r\n 3ph+M4I5CEdDWUYxTukFpHsrA4+T5v0p6mVYgQmW9M18L61+2z4I0uUxwyBsf7/t/wBMjXDXn7\r\n dOjxyG6gYeU3Qc9uO8NWx2fU/R9Z5FG6dPLH1zTvtMZXepyp6Gvzq0v9s3QfFRFu8wTP8Avf8A\r\n xoeleqaD45+KeuqLnwlbx3Oiv/x7yGe3QtjO75ZMOMMCOaapKZEpTirxPsPzgy5Tn2pPMk8veU\r\n w393P9a+VF8YfFPTb0LceG1u29r+Bc8ewNeq6P4/1CZETXLD+zbn/lpbeaJtnXHzquDkYP41X1\r\n KXQj6xV6nrQY7dzDFRQ3Ec3Q4rJstcsNS/dxOMntz/gK1IrCJBkHFc1aDp+TOmhKU5WntYtOVQ\r\n ZY1FvDoGHQ0G3jkGN1HliJBGvQU4O46q5dihKck1lSSEORWpJ941QaMMxOOtd1OEXuc1OUnJpl\r\n fzDWjBK3lDj1qsIPatGCH90PxrGslHY2G+a3p+tHmt6frU/k0eTXLTm3JpgQea3p+tSb8xgk4p\r\n /k1FLA5XgcVuBk3N0EJrzvxBft5sgC+nOfpXa3kEmelcdq9mWRnPX/APVXRhviMMR8J5LdzlpD\r\n kVmum9t2cZrQ1CPZKapKcjNRiS8PsReUfX9KpSjbIRWpWbP/AK1q8z7R6f2SGrMf3arVZj+7VE\r\n D6sx/dqtVmP7tZ1dgH04LkZzTamT7tc4DfLPrVWWLOeavVXlrWluBjTRcnn9KgSLnr+lXZupqB\r\n etbgW4YuBz+lakY2oBVGHoKvr0oM6uw6iiig5wpOaWgUGlNJvUOaYUyc5p9FBr7OPYj8v3phGD\r\n ip6hb7xoGopbDarP8AeNWarP8AeNBQyomjJJOalooAh8o+v6VVeL5zz+laFVn+8aAK3lH1/Ss6\r\n aE+a3Na9UJv9Y1NNrYak1sVRFisq6O2UjHStqs24i3Sk4qZJPc0Vefc//9L9eoK0E+7WfBWgn3\r\n a+oPlx1WY/u1WqzH92g1pbj6kWPcM5qOrMf3aDcZ5R9f0qeOMhetJUyfdoAb5Z9aeowMUtFABT\r\n wmV3ZplTj/VigCq77KqOnmnd0zVieo0+7QBRex3/AMePwqSKHywE6471cqWOPdzWdXYCSFeOla\r\n CR5Wkhh4qxt2nFc4EflijyxUlFAEflis66QZIrVrNuvvNQByd4gya5G7j/ANIbn0rsbzqa5O7/\r\n AOPhq5cX8BtQ+IpeWfWmEYOKnqFvvGvNOobTvL3LnNNqdf8AV0AZU0fPWquNvFX5utUm+8aAG1\r\n Zj+7VarMf3a1pbgPpWI8ukob7lbgWLI/PXfaeoMKGuAsvvV6Dp3+oT8a2obmNf4TrLNBityGKV\r\n h/q/k/vZH8qxrPoK2YJLiYm3X5UHfg+9b1L20OZFk26kfIdx9OlVZT5XDpg+mawde1O18MQfbL\r\n i5AHoR9B7+tfBPx0/beTwO13pOmQCRoQv70Pjdu2HoYW9a5q0nGKknodGGhzSaP0QurvT7K3Nx\r\n dTLHjsa8S8WftE/C3woJbTUNTT7ZDjfCElOM4I+YIR0Nfz8/EX9sf4ifEB5bezvGtVbphY2/u+\r\n sS/wB2vm648S+JrwGfVrhrqdvvyfKu704HHArl9udvsD90fGn/AAUA8EaPM0djpwvAOh86RPT1\r\n gPrXhGs/8FK9cBePQvDuy2GPLb7Wp9M8Nb565r8eL/xUloSbmAsf98/0Fc9N49DjMCbEPRc5x+\r\n a1nVr6GtKhqfqnqf8AwUL+K+ouRZRm0H+9C/8AOCuEvf27fi+bh1kvjv4z8kPp/wBca/Oux8YS\r\n SP8A5/wrpLfXtPml33I/eHr1/oK5vrDOj6uj6b8Wfti/GjVFIi1los/9MYW9P+mQrxa++MnjPX\r\n gbvXdRa4upP9Y+xEzjgcKoA4ArLbUdCkTLL/6F/hXGalZ291dST2hxG2MD6AetH1hh7BHUxePz\r\n E++6jM/r85X+Qq3dfESK5i/dwGJOy7y2Px215ZNpg/vVSfTHIwG4/wA+9H1hh9XR0t5461K3cv\r\n YXJgPsA38xWnpXxh8b6egNrqcgk/56ALjv/DtxXms2hSSd/wDP51D9he1TyhyV/rXXhMcqc3KR\r\n lWoKx9Y/D79qf4w+D9UTUP8AhIGuY0P+qMEI7MOpjb1r9QvhT+354P8AGNjDaeOpBZauQRcT/O\r\n +eW2/LHCq/dAHFfz+zPdx/d/pVW6kFvDHeBT9ofO4gkdDge3SvS/tamzn9gf0yj9rr4YeGdTW4\r\n h1wXSenkyp2/65n1rqfGH/BRz4V6Doa6lbSC7lIOYczJjDAfe8g+ua/mQtNdil08tcoxcf7R9a\r\n 564v7ae3Ek6swOeNx9a5MZjIVoqK3TNaVPlbZ/Sj8Mv+Cn3w58bauLDULQaWmceYZZZuzHoLdf\r\n T9a/SbwT8UfB3jrTU1Dw/qKXVvID5cm1k3YJB4ZQRggjpX8PdrfW0Moa2iKN2IY1778O/jx8RP\r\n h+6ix1N4bGP7ke1Gxndnkqx6tUUVfQ565/ZfbXovZnSMDauPmDA0ee4naIp8o6NnrnmvyI/Yj/\r\n AGk5PiC32fXdQJbjJKf9dv7qL/dFfrTa3F1PEv2HDWR+5KSBn14PPWvRcUjjoP32dC0EmzdEA5\r\n 9M4qePz0tQxi/eD+DI9fWsFbjTrRt01+gPcVq2zLegXNteK8bdMAduK4qzOsvwmR03TR+WfTIN\r\n SoFkXcvQ07nGDz70saLGgVBgCuOPxXHYPLFO2gDFOoPStbhYyLm3Vye1cbrdsFjYZ/zxXdTdTX\r\n H679x/8+ld2G3OXEfCfPetJtlb/PpWNH90fWtzXP8AWt/n0rDj+6PrU4kvD7ElUZYy0hOavVWf\r\n 7xrzPtHp/ZK3lH1/SpFXaMU6iqICrcSZQHNVKvwf6sfjWdXYBfLPrT1GBilornAKry1YqvLWtL\r\n cDMm6moF61PN1NQL1rcDRh6CtOOMsgOazIegrYh/1YoM6uwnlH1/Sjyj6/pU1FBzkPlH1/SoiN\r\n pxVuqz/eNBrS3GUUUUG4VGUJOc1JRQBH5Z9arvESx5q5ULfeNAFfyj6/pUTDBxVuqz/eNADKrP\r\n 8AeNWarP8AeNADKoTf6xqv1Qm/1jUARVE6A81LSN0oA//T/XlDs96vRNuUVQq9b/dFfUHy5dSD\r\n f3x+FWVg2jGf0pIegq0aDWluQeUfX9KnjjIXrSVMn3aDcb5Z9aeowMUtFABUix7hnNR1Zj+7QA\r\n zyj6/pT8bUxT6a3SoqNpaAZ81Qo3app6rr1rH2kgLixbu+K0IYAqjnNVYq0k+6KTk3ua0opvUl\r\n RgnbNP2+Yd44zUNWY/u1D7m/sodhnlH1/Sjyj6/pU1FTdh7KHYh8o+v6Vm3UXzNz+lbFZt195q\r\n aYeyh2OQvIuev6VyF+myZjnPSu1vOprjtT/wBY34Vz4v4CowitUZiOXbGMUrx4YjNRwffqzJ98\r\n 15pRB5Z9aeBhMUtKfu0AZs3Wq3l7jnNWZutRr0oAi8o+v6VZjh+Qc/pTKnQ/LTUmthNPoJ5Xv+\r\n lI0YC/McD1qXNVtQZvsyovfP8AOq9pIVpFmx8ky7d/6V29rcxRhYIj5jD8K4uwsraztftl5JtH\r\n v9cdjXlHxJ/aL8E/DvSmdZla7i+8Pn7lcfwMOjVUK8ou9yo0nN2kfXL3dvpdp9qv3ESj15747V\r\n 8u/GD9qXw34Bs5lsZVnnQDKgsvUr3MbDo1fl/8R/22fEfj0SaZozmNDwCNv+yf4ol/u18X+Ktd\r\n 1PVXY63dFpzy/A9sfd46YrT63LuX9Uj2Pp34x/tfeLPGKTGxdrdOwBVv7vrEPSvhDVfG3jDxPK\r\n 0l7eExuehRO34A9q2X1TRra1MTHe3/AAL1rmvtCOm62TEZ6f5NYYiu5xszow9BQldFZ2s4IT56\r\n 7nPVskfyrl5vEF9aSGG1l/cr90bQevJ5Iz1roptNkvzjOM0yLwtEgAkPI6/5zXFdnZZHAahq+o\r\n Xgwx6+w/wqXTtCub61jmZc7s88DofrXpsXhiw43Efr/jUFxYXloxhsf9Sv3enfr196T13GtNjH\r\n 07ws8eC3+f1rqYtJ062QNOmX78kfyNc1K+uxn5f/AGWqct3fCPFx9/v0/pU8qK5mduI9Kl+QRb\r\n f+BGqN1oW4mS3uNiHou3OPxJrioLy531afxBc28hgIyF//AF+lHKg5mQX9rfQHCHf+QrG+2Xcf\r\n yPHyPcV1UWuxyf60f5/KknNtdDzl/i/pRyoOZnMDVJR1T9asC5SSPzWHJ6ioruFc/LWWQ68dqT\r\n pxejE23uWJr6ND/qN3/AqzzdeaxYjah6J1x+NTfL/FWPc585tnSp9jDsTZFqcvKNqPsHpjNYk1\r\n rKSU83I+lWvn96BnvXRRik7IipotBlqjW3IOT64pszNdXJ8/hTj5v/rCpqrSpI5K/wANdcZtbH\r\n LKKe597fsufGHwD8I5PO1O2+2SNjJ8ySPp5norf3q97+LH7ffj7VL2Xw98LJPIsvlEFuDG2zIV\r\n m+eaEE5O48mvyENvbxf6yQj8DV7TJZheImnzGNhnEhGc8ehruw1eUpNSZCoQTukfpboHiL9pq8\r\n s28S+JrtvIPPl7rXnkr1Tn07V6l8M/2wviJ4C1y1l1iRhpkrMBCTGdmAwPzCJmOWbNfmxD8R/i\r\n foSrEmoGa1HVNkQz+O0nqa34PHS+Mbc2utDyXiwR36nP8IHoK6pRhLcr2cex/YT8KviTpPxK8K\r\n W2u6VOJ2dSXUAjb8zKOqr/AHT2r07zGVNxXn0zX4a/8E5Pjlplo7eCprrG/AXcD289/wC7/Wv2\r\n +igeS2WLzw+edwA5zzXnYiiou8BTiktC+JARkULIHXK9DVVEjtExI2c96soUMYMf3a5veMkVZu\r\n prk9cjzE7Z/wA8V1k3U1y+t/6hv8+ldmCcuezZy4j4T5712L98Rn/PFc+gwAPeul13/XH/AD6V\r\n zY/rW2JLw+w6qz/eNWarP9415f2j0/sjKbk5xTqZ3/GqILSQ7++Pwq2ieWu3OcVHBU561nV2AS\r\n iiiucAqvLViq8ta0twMybqagXrU83U1AvWtwNGHoK2If8AViseHoK2If8AVigzq7EtFFFBzhUT\r\n RkknNS0UDUmtiHyj6/pUTAg4q3VZ/vGgr2khnNFFAoNKcm3qFQt941NULfeNBqNqs/3jVmqz/e\r\n NADKrP941Zqs/3jQAyqUqZcnNXarP940AQeWfWonGOKs1BJ1oA/9T9fPLPrVqAYAFQ1Yir6g+X\r\n NOHoKtGqsPQVaNBrS3EqZPu1DUyfdoNx1SLHuGc1HVmP7tADPKPr+lSKu0Yp1FABULvyVxU1Vn\r\n +8azq7AQum+iO1zzu/T/69PqxFXOBYitc4+b9P/r1cEBAxn9P/AK9JD0FWals2ofEQ+UfX9KkV\r\n doxTqKVzqCiiikAVm3X3mrSrNuvvNVRA5a86muQv13zMOnSuvvOprk7v/j4b8P5Vz4v4AM1Lco\r\n c7s/h/9eiT75qzVZ/vGvNAZSn7tJSn7tAGbN1qNelSTdajXpQAtPhdmcxkYUfxZplW5NotEx1O\r\n f50G+HhzSsSskK/8tf0qKRFmQrJ8kSdJeuc+3XrV9dMgSyN1cvgf/Xx618c/tAftE6V4L0q40C\r\n xlHn24HIz/ABFG7oex9aDs9gZP7Q3x3tvC+nyaTYEO+Mbw2O6HoUPr61+OvjTxrqPiTVri6vXM\r\n qSFflyB0AHYD0rn/ABf8Q9d8d69JLLITGW9vQew9KzHtDGfLPJH9awxE+WNzWlh9SOTWY7WIpY\r\n 23kyf39+79CK51prrUJD9smLSN1bAGfwFdJ/Z+/tWjHoUCQC4c4J//AFetcX1g6Pq5zlnoVlA3\r\n m3D+aPTBH9a2ru/0iC28uKELt7biayrye2hOzf0rhdUnUzOyvxxj8hVwq8zsROlyq5rTa+0Uh8\r\n i33f8AAv8A61Zt3rdy5MxTYT/DkHH44rEt9Q8tvWrMj/a2L4xnt9K1Mhi6zezPjJX8j/Sums76\r\n 5Fsimbnn+Eev0rmfsvl/Niq7XTxzFR0FAHbfabhv48/gKbJb+fH5kh+Y1k2l6uPmNXX1KMfJnp\r\n /n0oAznC2zcJu/HFOMllMnmSjY56jk1HNdRPzmsK5tmmcyIcA0AXJ1sznbJj8DSxRRmMFZ+PTb\r\n XNS2UmfvVQ8+4t3MIPC/1oA7B1A/i3VTllHKbM++ayYr1h941I17Hnk0AEsDSHg7fwqkU8o+Wf\r\n mI71c+2x+tV3uI2YmgCLI/u1TmOHJAxV/zo6oXDBmJHStaW5nV2KT3Gz+HNMj1XynwYtw9M4/p\r\n UM3U1AsWfnrc5zoft+m3K4lsvx8w/wCFZl6LZgBbx+UF6fMT1qnv2VDJMWHFXCXK7galg5QYQk\r\n Of4uv6VeknbeiM37xc736bs9OO2KwrOXD4qednNwzL0OP5Vp7cD1fwt4u1rwtqUOreGbs6fPES\r\n chRJnII/iBHQmv2B/Zf/AOCgviuK8s/D3jS0MyR7gdQMqDzMiRv9WkPGOF689a/DKG5kQV6H4I\r\n 8RtpeqRTam+21z+7/I56DPU1rSftHymdXY/tf8I+LdL8b6RFqtgQ0Ugz1PHJHcA9R6V1gdY4x5\r\n Qytfh1+y18fdf06CGO1mL6cOo+Xp+89ULda/ZHwb4y03xd4fttUszxOGwOf4WKnqB6VdTDtaox\r\n TOykj3KWBrjtVcyWpZhtJ7fjXUxzFW8t+hrntfACOF6f8A6qvDxtOzMMSvdPn3Xf8AXH/PpXPK\r\n mQDmuh13/XH/AD6Vgx/dH1pYkeH2E8s+tU5BhyK0aoTf6xq8z7R6f2SKnrFu+bNMqzH92qIJEO\r\n z3qYNu5qCpk+7WdXYB1FFFc4BUbx7hnNSUp+7WtLcDImj561UAw2K0JutUT/rDW4F6HoK04pMK\r\n FxWZD0FXk60GdXY0EG/2pWG04pYegok++aDnGUUUUAFRNGSSc1LRQBD5R9f0qIjacVbqs/3jQa\r\n 0txlRlCTnNSUUG5H5Z9arvESx5q5ULfeNAFfyj6/pVV4vnPP6VoVWf7xoAreUfX9KqvF855/St\r\n Cqz/AHjQBW8o+v6VWeP5iM9Kv1Uf/WGgD//V/Ybyj6/pT4xtOKfSL96vqDwPZxNGHGBVvbnkGq\r\n cPQVfXpQNRS2G+WfWnqMDFLRQUFWY/u1WqzH92oqNpaAPp4TK7s0ypx/qxWPtJAVHfZTApk+fp\r\n mibqafD9wUnJvcBvlH1/SrkFrlA279KhrSt/9UPxqGwFSPZ3qSloFY1JNLQ2ofEHNOCkjOabUy\r\n fdrH2kjqG+WfWk2H1qWgVUJtvUCPyz61lXYw7Ctmse8/1jfhW8HqByl51Ncnef8fDfh/KusvOp\r\n rk7v/j4b8P5VGIScbMCtzUTRknOalorj9nECHyj6/pSGPC9anprdKipFJaAZM0XvVVsouetaE9\r\n QLHvFYgR2y+e20nb+tJqBli221qnnuvXnbjOD3qbH2fmvOfij8V9C+GHht9duJAblxyvORhlUf\r\n wsOjelRUbS0O/L1eo79jmfjx8Qbbwh4Mlka6CXIXiHH+2nfBHQ1+AXj7xpq/j7xBdahcExCdl+\r\n XIb7qgdQF/u16J8bfj3rfxW1maS1kIgB6ceif7C91ryfR7TdbJLKPmOc/max9pI9flQum6VHaw\r\n YHLH+L860IrFMbpZvm7/AC1ZnmjgSuB1bV5EncRnjj+Q9qifvq0hpJbHV3mo22nLnIfH4V53rv\r\n jvl4IY8AYxz9PauX1G7vrskISfyqnH4dlmt1uZ/vNnP4HHrWfsYdirs5q71fU7yUmMHn6UW1vf\r\n XBHnTFCeowDXX2VrDat8y5qHUNn2l5YxgHH8qqMVHZGFfYW0t4bNQ0reb+lTm9jMpljTCntmuc\r\n lkml+VeatQQSiBS3Xn+dUcp0EmoJKu3bj8aznVCd+7rWLM8kZxUInlIwaANSS42fdNU2uJXfIq\r\n DZI9X41WOEB+tAEazSd6qT6pNE5iVc475/8ArU6a5jQ1kzXMbyFqDOo2loTPqE7/AMOP8/Snrc\r\n M0YZo9xPfP/wBaqPnx1sWs8BgUHrzQY81TuY0tzIOkXH1qviSUeYTtz2rqdlu/+TVGeBQx2dKY\r\n c9Tuc47OnfNNFw3Qmr80HPSsuWJw5Iqo2ejFzVO5oIC/8ePwqXcB+7znHesXzHSpo5yevWtYQs\r\n wbm/iNT7KJed+M+1Runk/ufvbe/wBafDNxU5TzDv8AWtBGQ8Bfvj8KpupR/L64rovJrOngxKzf\r\n SgCGCHLBs4/CrjTKrGPbnHfNVN+ymq29t3rScUwNFcOOBjNXY4pXCrOvmQp90fdxnryOetUoeg\r\n rVGoCKFYMcj+tZVatSiuajuHKnufYH7Onxfn8L6nHZTwebag8x78dnPXaT1Nf0I/s4/Ezwp4o0\r\n +0i0y4FtcEN/xL/nfZy//LQqAcgbv0r+V/wxHNbSC8U7e/8AMV+ln7Gc+q6r4ou9U0m7Iubbyy\r\n UwO6Sj+LjoK+gy6oqtO9TVnLWXLsf0kPOrsi3H7qRs4X72fxHFYOqPNKrxyR7WHvmvAPg78abb\r\n xpcz6V4lHlX9ptCZzzuDk/dRV6KK9xt9XW8jZrjiQ9R/LoPSnGm4yszz6lVy0Z4brspF4YiMe/\r\n 4Cswp5Z2A5x3rZ8VKovyy/54FYgbcAa5cSdWHHVQm/1jVfqhN/rGrzPtHp/ZIqesu35cUymd/x\r\n qiDQQb/apgu3iooKnPWs6uwCVIse4ZzUdWY/u1zgM8o+v6VG4wMVaqvJ3rWluBlTdaqeXls561\r\n bm61COtbgXIYveryRd81WgrQT7tBnV2HodnvUm3zPmzjNRVZj+7Qc4zyj6/pUTDBxVuqz/AHjQ\r\n AyiiigAqJoyxJzUtAoNaW5D5R9f0qJhg4q3VZ/vGg3GVC33jU1Qt940ANqs/3jVmqz/eNADKia\r\n Mkk5qWigCHyj6/pVJ4/wB6wzWnVCT/AFzfhQB//9b9jnXZ71GvXNTzdTUK9K+oPDLCT7O2fxq4\r\n l0CoOP1rMpvm7eKANj7SPT9aT7T6L+tZHnVaiO5AaAL32k/3f1qxHcjYOP1rNpvm7eKzq7AbH2\r\n ken6006jt/d7M475rJ86k3bjmucDW83zT0xVmLgbaowVfj60AWkg398fhV6NPLQLnOKhh6CrNT\r\n IApwQkZzTamT7orGrsbUPiG+WfWnqMDFLRXOdQUCigVcNxhWZdx7mY5rTqhc9TXRDcRyN5Fz1/\r\n SuTu4j9obn07e1dledTXJ3f/Hw34fypV/hAoeUfX9KPKPr+lTUVygQ+UfX9Ka0XHX9KsU1ulZ1\r\n dgMmaL3qKLbCGe4OxB909d3rVqbqayrwjU/KsSdq224sf97n29K5wOf8X+JYfD+hz6zeR7YogC\r\n AW65YDsD6+lfgX+018f7vxz4y1SK1QpYuYhHCHyFwkeedinkrmvtz9vP8AaDGmaePBHh2TLsCr\r\n FfrC/wDEnue9fkv4f8FX1+FvL8lncktnHv6Gs6ux6GXfxH6Gj4S0eWeM3CrtB5x19a737D5MeS\r\n dmP4fSp4b200KEWyjn/J9/WsnUdW8yIzdM/wCfSuc9g5zWZiuVBz/kVycVvLeybWGF/vdf0qzd\r\n X32iUilF+0MIgQcj+vPpQBb/ALLs9PXzGcSH0wRXPX1x58jGIbE4wvXFaSbrhv35wDWVdokd06\r\n xnKjGPyoAy/mjbJTf+OKjms/tmZM+Xu/h64xW/D5PG+oJtvmNs6dqDGv8ACYtvpiwtuZt34Y/r\r\n Vp9pYx7MAd81bqO6K/ZwB9//AOvQcpy2pxpGNyfOfSsaB8oGZcE9q3YbWV5cy9KfcaaTMxjHy8\r\n YoAzo7tE6pn8azrm+aW4aNY9o45z7fStv+zJfT+VNOlFTvYcn/AD60Acld2shG4P8ApWR5W0fM\r\n +D6Yr0P7B5nGKD4RM487oD/n1qlKxcIczsecEEdGzU0aXRAaMEj8K9A/4RWFOHP+fzqyiW1lH9\r\n mAzs789+abma/Vjh4vti9U/UVtRea0IZ0x+NaMs6g/KlVoZp5pjEqcdqhh9WKLxo3322/hUUsE\r\n aRblO4flXXt4eaZNz8f5+tYU9p9nlNoOQv8AXmgPq5yDnzHwFxUT2+1id2PbFdd/ZWPmx/n86y\r\n LyyfzWwOK2pvUwxFLljcxhOY+OtXI9U2KFMecd8/8A1qqyWcgPSovsspGcVscRtx36P1XH41HL\r\n KjsccVjbHTrSKXL570AXHty/Q/pTktynBNaNntwN9JcY85tvTigCFDs960IZYpdsbR8jvnrWdV\r\n +FdsYk9c1lVhzKxcDtRqPl2fkRptOOuff6V6t8A/idr3w48Ww3+iZuju/0uPKpgbXC8srdmPSv\r\n nn7dn5c1uaNLeRzrJozfvm/4+OnTnb97jpnpWmCxDhPlOPEbM/pO8H+M/BXxV0221jwTItlrCA\r\n meMb3JJJA5cKv3VPQV71oPjmexuY9O1QfveQzk+xI4C+lfhz+zU2t+FNYh8Q+HLgvAhzcJgeki\r\n j7+e5PQV+t8et6d8SbWPxbpB2Ccfd54MfyHqF/untX19Wn+4UzyXufQHicIJY5reTzxJnttx0q\r\n g1uYvlJzj2ri/DWuJPi0uW3PH/AFyfSu6ll87Mg714WJO/DFB22e9VWUyEv0zU89Rp92vM+0en\r\n 9kj8o+v6VAw2virtU5P9YfrVEF6CrYj3c5qpBWgn3azq7AR+UfX9KkVdoxTqK5wCq8nerFV5O9\r\n a0twMqbrUI61NN1qEda3A0YK1IoyyA5rLgrZg/1Y/Ggzq7CeUfX9KkVdoxTqKDnComjJJOaloo\r\n Ah8o+v6VEwwcVbqs/wB40AMoFFAoNaW4VWf7xqzVZ/vGg3GVGUJOc1JRQBH5Z9arvESx5q5ULf\r\n eNAFfyj6/pUTDBxVuqz/eNADKrvDly+evtVikbpQB//9f9mnt9/wDFiqzQlMjOcVp01otwz619\r\n QeGYjyFO2ai2tJ8/TPar00HNOih+QVFRtLQCh5Tev6Vo26ERAfWneTWhBCPKFY+0kBT2mqzxku\r\n ecVteSPSq7wfMeKTk3uBleUfWpEBHHWr3ke1Ahw1SBLCa2be3LoJN2M9sVShg4rZgG2ICk2a0o\r\n puzFSPYOuasBcjOaZUyfdqGzf2Uew3y/enqMDFLRWNR6FRglqgooorEoKKKKzqTcVeIBVC56mr\r\n 9ULnqa1oVJN6gcvedTXL3MZadjn0rqLzqa5yf/AFrV1V17gFPyj6/pR5R9f0qaiuQCHyj6/pVS\r\n Z9hK4zitGqTx75m9Kma0JkzKdmc/drzD4seKV8FeE7jUEj3STr97djG1lHofWvV7+5htFy3Ffn\r\n B+2V8V4ItKn8OWkn72EDIH+0Ym/u+nvXnVpuOx00YKW5+YPjK+m8U+MrjUdRY3AZhjPG35AO2P\r\n SrEk406Eqo3KOh6Vi+Gka7hluZ/vn/E1V8QaqlvpywE/vBnP5j2rkp1pzk1Jnowpxp+9Dc5a5n\r\n e61DzOoz0/Co/EF2kMGQNuf4c9OlLpSYjN1L0//WK4bxXqn2i6YxH5DjH5D2rY09rPuWNPga5z\r\n Nux7V1SR2ttbLcy/MxzkcjviuV0W4WO23P8A55Nczr/iNo3eJDwMY/T2raiot+8TKrPozY1jUx\r\n ekw2/7j3+96eoptvALXTI3ln81+cnbjvXmNtqcs0/XrXQtczvGEHSorOMdjpouUtzS/tF5JNij\r\n HvmtKC6IAjYZI71gWUDb9zVvQ2zST7h0rlpVbysztlh046liW58sZxmn2ls90wuScK38OPTjrW\r\n k2kyOnT/P51sW9slrp8aMMMuc/nXReJl9Uj2M+TTopU+V9h9cZpsFosWIC28j+LGM55pUlaSTa\r\n tbNnp8kku8jrWdSaS0B4RdEZ8llsGQM0r6QZrVZt20tnjGe/1rv49MXyxuFPTTlkPkqOBWPthf\r\n VF2PJItNeOTHX8P/r1cmM0YMSLwO9exQ+FNw37f8/nUv8Awh/mP93r/n1o9sbYfCpSvY+eLrT7\r\n 2cnbIV/4CD/WmwaFJ5a+Y+9+c/Lj+tfTMPgHf/D/AJ/76rcg+H1rbQi4nAGeo5/+Ko9sdn1ePY\r\n +a9P8ACklycMu0fn/WuhHhy20v/XDO3+Ln/E169fvYaeCkABI+tec6nPPq109sFwOOfwz7elHt\r\n jKrQstDgtavAymKxXc31x6etcxZaDqN0/wBrul8sN9D047GvatN8HR2bfaJPmz/n1q5M63F2+n\r\n JHtVMYP1GaPbGHsmeOX1iltF+6bzG9MYrn0srucb2g2qe+4GvoO58KWdmn2iVgfbn/ABrz3W9W\r\n jikaztUyFxg/XB7imsQ1sUsKqmk1oedyaODzu59MULoJMQbd+ld3oGk3OpTBpVwD/wDX969IPh\r\n EBQoX/AD+dV9al3K/s2j/L+Z8wXekMp45/Cq0WkOy+lfS8vgjzP4f8/nSReBMDGz/P/fVZVsZO\r\n KumNZZQ/l/M+Yrmymth61TBJGW619K6n4G+X7n+fzry3W/CE1qzuF+UY/p71dHGSktTlrZfTjs\r\n jzWSfZ2zU41P8A0cQ+X075/wDrVWuIWikKNVXGDXownc8qvTUNUTCYq2cV0ujyXMrg2b/Z2b77\r\n Y3bsZxwemK5Suv0CRYlRn6HP9aaik7o43BPc+xvg546XQJ0s1fyoW/1oPO77xHYkda/UP4c+Ib\r\n XS4dP1LRjv07VvMC24Jxb+VuU/MwJbcxJ6DFfh8ttJ5P2i2faf8+tfV/wa+Ms+i+GBod5Juey/\r\n 1ZP/AE0d2PRT6+te7gsdUqfuqzvFfmebj6PLBOmtbn6yzXB8MeLY99x59vPzv27cYT05PU19La\r\n XLHqFn50J+UDj361+emk+Kx498Cwahbvm6gyW9eZMeijotfYPwS8QR6vo8cG7cQCP1f2HpWOMc\r\n H8IYNT+0em2duL/fuby9ntnOc1SA28A5xWpDG0M0qL3xWUqsow3WvFjfndz2pW5NB1MNvvO/dj\r\n 8P/r0+pk+7WpiIibKuJkrVarMf3aTSe4D+akWMsM5qOrMf3ankj2AZ5R9f0qrLHgnmtCqk3U1S\r\n ilsBjTRe9VMYOK0Z6zz978aYGhBWnFJhQuKzIKvx9aDOrsaCDf7UrDacUsPQUSffNBzjKKKKAC\r\n omjJJOalooAh8o+v6VERtOKt1Wf7xoNaW4yomjJJOalooNyHyj6/pUTDBxVuqz/eNADKjKEnOa\r\n kooAj8s+tV3iJY81cqFvvGgCv5R9f0qF1wcelXKrP940Af/Q/ajyz61YVP3YqOpx/qxX1B4ZnT\r\n R+9QLIE+XGcVbnrPP3vxrOrsBfRQ9acMI8sVmwVswf6sfjXOAnkiomtx1z+lW6a3SgDNcbKjU5\r\n PSpZupqBetAGnCRitFPuisyHoK00+6KUjahuOqZPu1DUyfdrN7HUOqRY9wzmo6sx/drGewDPKP\r\n r+lHlH1/SpqKyAh8o+v6VEwwcVbqs/3jWGI+FAMqhc9TV+qFz1Na4fcDl7zqa56ZMyMc10N51N\r\n YUv3zXdX+BAV/LPrTxBld279KWpx/qxXGBRcbPegJEIWnL/N3XH9aWeq62wb53bAb+lTLYmZ5j\r\n 8QNQt9O0CfWJJtvlAHy8dcsB1/+tX4F/GvxfceN/iFqmrj91b3BiCxZ3Y2Rop5wDyVz0r9Tf2u\r\n /Gq+HNBm0+CXaZBjH0aI+h9a/EuTVMvumOXLHJ/GvMxHU68OdlHNFpFl5wG8enTv+PrXj2vX/w\r\n DbF892p8pGxhPvYwAOvHpXT+INTb+zDsPb+orx61uZZIw575/nXDQ+NnpP4TvpdeA006ekGDj/\r\n AFm73z0xXCvZuYFSR9xGfmxjOTWnFMp+9TdRuYo7XcP8811kHPz6sLKEwgZ98/8A1q4S+nNy5k\r\n z17VHqF41xMcH5ajtYmmKoO9X8K5ma0Y80rGlo1mZ7jrj/APUa9Vi0FltEnDbic8Yx3+tSeD/C\r\n Uk+19v8Ann3r2aw8LXbzC2WMlV+nfn1rysViLs9rDYZI8cs9GvLt9iRFffINeneHvAF7MFa4by\r\n 4+z4Bz17bq9/8ADngHylEkkX+efevSTof2m0TS4IsFM5P1Oa4KNd87PU+r6Hyne6KljJ5MbecP\r\n XG3+tefeLvO0xN0CeaT/AA5xjp35r7F8WeEtP8OaU11cMPMx059QPU+tfNGkWj+KdadAu6LIx+\r\n R+npXX9YYvYGD4N8L3mr2/22b9z/s4DdyOuR6V6NBoyWyDLZI7Y/8Ar16smnQaFZi2RMEj+uff\r\n 1qtb+Hbi+UXAXh8/px61lVxDsb4fC80rHn66dJcfKvFdNpXgyRlW4aflu2z0z716xoHghnI3L/\r\n nn3r0y28HeTGF24x/n1rn+sM7fqCPH7PwtmPG/9P8A69XJ/DM9pF54XzE7Hgf1r2yHw4EHT/P5\r\n 1S1HQNVuFaCBf3P8P3fqe+etH1hkTwairngL+KNL0xvLu02Y9yf5A15j4v8AH8M9y8FkuIWxtf\r\n PsM8Fc9a9v134Si9YvdcE//W9Grx7WvhHKt21vajMa4wfqAe7UfWGZ/V0YeneHbC4szql1qnv5\r\n fkn1x1BqEHTLlcW2F9JeTn8DXcw/Cq8ewNvvx+A9f96sK3+Dus2reWsn7odOF7/8Do9uzKtQVi\r\n hawaXbHfeamCP7vlH+lZ2ueINEtVYadF57/wDPTLLnp2Irrbj4WwIn+my8/Q/0aqEXhXQLE/Zv\r\n vMnf5u/PrR7dnP7A8Vz4j8RTmOGIoh91P+HpXXad4Ijt1Uag2Zx94Y/LofSvRXgl09c6XHnHT/\r\n Jq5ZabqOohby7XEj53DjtwOlH1hmtKhqY1notvAoEC4x/n1rfgtiAIym4+vSu007w+2BuH+fzr\r\n qrfw7GqiQjn/AD70fWGdH1dHndvo003Kxfr/APXrVh8PDhZTsbuMZ/rXpEKNaDCx5q3Dpct/Ob\r\n orjf8A04rDEYh8pUaCueQah4WDrw//AI7/APXrzbxH4Sje1aLdgjvj3HvX2G3h9dnzD/P5153r\r\n 3hwS3MqAen8h71eHxDOPEYc/L/xl4bfTbhpBJvH+7j09685bgkV9ufErwXhWbb/n5fevjbWrT7\r\n DqU1t/cI/UA19Fga3P7p8zmdHlhfzMute3vN9uloq7SmfnznOTnpWRT4n8tt1eieIeiWl5c29r\r\n 5Xmbs98D1rotFv2gFv8A3ju3nPXrj8q8+s7rzABXSWu8PER05rDEYh0Y8yOjD4f20uVn6B/AT4\r\n lv4auJdGng+1RXoAB37Nm0Of7pzkn1r9Hf2a5ZdF1yfwxLN9pFttb7Rjbu81ZJPu84xnHWvw28\r\n LeIpNM1+1IOOT/6Cfav2O+AGsF9Qi1kn/j6HX12K6+n9Kili3UKrYT2Z+gxlVLyRSuRx/Ksadg\r\n 8rMBjPapb2by2SX+//APWqGYYkIrtcLK5xqpd8pFQsmDtxRUf8dQUXlXdVhV2jFQxVYoAKsx/d\r\n qtVmP7tAD6qTdTVuqk3U0AZk9Z5+9+NaE9Z5+9+NAGhBWnFHlQ2azIK2YP8AVj8aDOrsTIdnvS\r\n sdxzTaKDnCiiigAooooAKiaMsSc1LQKDWluQ+UfX9KiYYOKt1Wf7xoNxlRNGSSc1LRQBD5R9f0\r\n qJhg4q3VZ/vGgBlRlCTnNSUUAR+WfWq7xEseauVC33jQB//R/bLyh61JsATGaqecPWlM3y17/t\r\n JHhkcwHrWc336kmmqBW3c0nJvcDSgrZg/1Y/GsaCtmD/Vj8akCWoXfkripqrP940AQOm+o1h+b\r\n r+lWKRfvUAWoYuBz+laCR/KOaqw9BV9Puiom7G1D4hvln1p6jAxS0Vm2dQVIsm0YxUdFZz2Am8\r\n 0+n60eafT9ahorICbzT6frTdu/5umajqZPuik4KWjGkN8v3qjcx4zzWlVK671tSgk9BtHJXkXJ\r\n 5rCkiJc810d5941hP941rXfuklbyj6/pU6xfuxz+lJU4/wBWK5QMyaL3rFurd7mKf9/5ItwDnb\r\n u3bv5VvzdTXlXxQ1//AIRnwveX+du5R+jKPQ+tYYiTjG6N6FOM5WkfjB+2V49m1jxFJpytsWE4\r\n 3ZznKxHpj2r85rjWt+oPEOgxz+H0r0744eNpvEXiq9lVs4Yf+gr7D0r5stbiZ5/Obuf5V58nzb\r\n nbGlGOyPVdS1cvZeSI85HXPuPauZsQq2aBhzz/ADNJHdLJHtY1XubgQx4XoKzjTjF3Rrd7EV1d\r\n NFnaM1g6jqLyW2zbj8fepFn+0SYrKuh/pckH93H6jNWI56u08MaZNdTRPGmQxP8AWuXs4POu0h\r\n 9Sf5V9ZfD/AMNpHb2wKZI3fzb3rDMKrhT0PZyGhCriHGa0t+qPYfht4NmuoUyNv4Z/ve9fWfhj\r\n 4fWsaRPMQX5zwR6/7VUvhlpMccKfu/8APze9fTmk6EJHWTbgH/6/vXgSm5bn2McHRjtE5WDwTb\r\n SQBE+X3x/9ermm+FLGzM6zLhowDv55zntmvdrDSIUjG4f5/OuR8c2P2bTZprUYZgP0IHes1FJ3\r\n Rr7GHY/Jj48a1qGo+Jm0KzchCcbhj+6jdCPb1r0j4PfDoaHp8Fzdt5ztuJJG3u3ox9a0bT4Z3e\r\n teNft94mV3d8f3MdmHpX05e6CLApYWSf6sDp74Pc1d2HsYdjyW+8Dza9qKmMGJPXG7sPceldxZ\r\n eCEsWGm7t3lfx4xndz0zXv8A4Y0eGLTt00f7z/6596ux6EskpuXXlv6cetZVpPlN6FOMZXR5Tb\r\n eGU09BIG3+2Mf1rUigEqg7MZ969On02MptxWYNPjiAUVy8zOo49dJEnfH4Up0sxNj7Rgf3Nn9a\r\n 7DZElOfSo5o/tWfvf049aOZkygpaM88vdLWcEFN/6VxN94bXzXKpt6cdf616teXsdiSMZrlL7V\r\n xKWlC8H/PpRzMj2MOx4XrlhfWLFomz7YHtXl19N4mkvZJI3KQnG0YU9v8AGvonUpPtZI25zXJ6\r\n kyw2/wBlWL517/U5o5mZVqEeXRHh92t9MuJnLH6AUyDQYZrVZmX94c5/P616hpnh+W+nzKmAf8\r\n +tdS3hZY5zCi8D/PrRzM5vYI8i0rRyjgYyP/1+9d1bachIQxcj3r0G08PQ243MP8/nXRWehwys\r\n HUcH/PrRzM1o0I31R5uumeWu4L/n866XTfDRuoEumm2B8/JtzjBx1zXop8Px7Pu/5/Or9rpohg\r\n WMDgZ/nRzM6fYw7HL2mjWVuP3kfmfiRU0lnbrIXij2L2XJOK6r7F7Vn3Nvtcr9KmWujLhRh2OW\r\n uYgw2gYrlNQ0sR7rlm3b+2PTj1rvpoeaw9UhzAB/ntTjJx2OLEUIWeh8yfELRkubVnzt/DPdfe\r\n vzj+IOhtb67dXKvkMV4x0wqj1r9WfGOn77F+P85Ffnv8TtOjjvZ2I5+X+S17WU15uq030Pmc1w\r\n 9N09V1/zPmloGCF6qseMV2sNtHJEy1zF7bCF2UdsV9HGp3Pla9KMdibS2w+ev+TXpOnFZEQgfd\r\n z+teXWcnltXqfh0edCD65/rXJjo80bS7hl85Rqu3YtxzFtXimHy7CePqK/Yr9lbU4PE2jabaq3\r\n kTW/mbv4s7mkPt2FfjjcD7PeBv8APSv0n/YT1YP4reCZ/kG3A+qTH0qcLBR2NsXNy3P2WltjfQ\r\n Rqp2tF29c1CZHkO+RPLb+7nOMU17uS2v8AfGMx8fyqae5S8la4j4Vv6cV67k3HU8hJKZFQseTu\r\n zRUyfdrM0JFbbVhW3DNVasx/doAfVmP7tVqsx/doAfVSbqat1Um6mgDMnqmI9zdauT1XXrQBdh\r\n ix3rViGEArPirRj+6KDOrsPooooOcKKKKACiiigAoFFAoNaW4VWf7xqzVZ/vGg3GUUUUAFRNGS\r\n Sc1LRQBD5R9f0qJhg4q3VZ/vGgBlRlCTnNSUUAf/0v2Q+2H0/WpBdbl6frXP+f71YSYbRzXuHh\r\n mi7b+9MWbYdmM471U84etVmm/eGgDpobn/AGf1rYhuR5Y4/WuQhn4q8t5tG3NAHT/aR6frVZ7k\r\n bjxWF9t96ge9+Y/5/pQB0X2laQXA3dK5v7b/AJzSC9+agDtobhcVa+2BeNv61yEN7U5veev+fy\r\n pNJ7m1D4jqfto/u/rUi3IIziuR+2+9WY735Bz/AJ/Klyo6jp/tA9KT7QPSuc+2+9H233rKskog\r\n dJ9oHpUiyqRk1y/233qdL35RXMB0XmL608TKBiud+2/5zR9t/wA5rSlG71C50fnrWfc3I3EYrM\r\n +2/wCc1BJcbsmulQSdx3I7lt5JrDk4lK1cmmqhnc5NRX+EROkG/vj8KsGDamM/pRD0FWH6VygY\r\n 80XJ5/SvmX9pqKWX4c3/AJbbPIVecZzukjr6gm6mvn79omJH+GeqE/3U/wDRqVz4r4DqwvxM/l\r\n l1+CQajd3ch37mHHTHauMaHyZ3tdv3MfN6556V654jgj824/3/AOtee675dtNJIO+P5CvPO45P\r\n +0Clz5G38c+1Gq3/AJB+zhd3+1nHoazZI2kczpUIVr25KN2/wqlYDY0mHfH9pZse2PqKzby5Av\r\n 5Zwv3scZ9BitJn+xp5Nc9Md9yw9cfyojuB0fg/TG1XWYwG2YJ7Z6g1+j/gDwrH9itmZsn5u3uf\r\n evjD4QaF9r1ZDjqf6N71+pPg3w35Nlbjb0z/ADPvXBmTvTXqe/w5/vMvT9Ue2/D7w9AkSc/p/v\r\n e9fQVnYxwKoXnFedeELHyEXj/PNevW8W5Aa8Q+1HrEzjAOKzNU0g31v5Dvx649x7108MPFXVhQ\r\n gKetAHiy+Cba1Ysh+b1x/wDXrc0jwvbwzfa7lhKW/hxjpketen/2fG/aqEtiyTMqDgYxQBmJpN\r\n uZQ6fIo/h6/wBaW8sFZ28obV4963YbOTHSteOzXyhv61jX+E1pbnl0umSZ+9+lZs+kNy/mYz2x\r\n /wDXr1aayj9Kw7uzBYgDiuU3PGb22kiJw2apQvdy/wCjg7VH0r0i80neen+fzqCDR0iUORg/59\r\n 6AOFm8JtdDe8/X/Z/+vWVdeFI4oxFvz74/+vXssMMZ+WqGo6cHbcBxQB4jc+ForGH7SW347Yx/\r\n WuW+wWl032loMbu2T24r3zWtMP8AZ54/zmuCsNH3WqHHr/M0FQhzOxxH2CBRiKLZ+Oa0INGBhW\r\n 4L5Y9sfh612f8AYo9KvW2mcCIjgUGv1dHnb6LLd/IrbPwz/Wug03QGsoEjeXcVzztx1P1r0qz0\r\n iGMZYf5/Om3NkvnHYOOKCJ0uVXOSNrkYz+lVHTym8vGcd67H7F7VXl03JL4/z+dBmcuBntVC6t\r\n Q7F846dq6Sa12VSlhyucUFwOHuYgp9ax7qATrtzjFdZeQc9K56ZdrsvpQceI2Z5P4ujEds0XX3\r\n /EV+eHxhtvLvrnB/u/yWv0T8ZfcP+fSvgD4xRZurl/Xb/Ja9XKP4z9P8j5nM/wCH8/8AM+WLeY\r\n xBs81BdQC5j+0Zxu7fTioZX2bsVLav5lsq/X+dfSeZ8niTGjhO7Ga9P8JS7VWDGcZ5/OuAmj8s\r\n 7q7nwlyiyeuf61hiW3HUwwP8V+hsa1H+/DA/5wK+uv2Pri7tfGgMbkByOMDsktfKtzF9ougvX/\r\n 8AVX2X+ynpvleLY2x3H/oElVhzfEn7waW8S6Siyx+Yzj72cY5qnFbeQgjBzj+tSacc2MQ9qszD\r\n bIR9K9P7J5n2it5Z9aZ5m1tmOlT1Vb/WmoKLiruq5HD8o5/SqsVaMf3RQAzyj6/pUirtGKdRQA\r\n VUm6mrdVJupoAzJ6rr1qxPVdetAGlFWjH90VnRVox/dFBnV2H0UUUHOFFFFABRRRQAUCigUGtL\r\n cKiaMkk5qWig3IfKPr+lRMMHFW6rP940AMooooAKrP8AeNWarP8AeNADKKKKAP/T/WLzT6VZjc\r\n lR2pPJpQu3ivQ9rI8/2UOw/caBEXO/djNNqzH92j2sg9lDsOTKe9OJJOc0lFHtZB7KHYOfWqsj\r\n sHIzVqmGLcc4zR7WQeyh2KvmN60B2zmrPke1Hke1HtZB7KHYRLtk7Zq6kxkUPjGfeqfke1WY12\r\n qFo9rIqMIrVE28/wCTTftbR/Ltzj3/APrUlJ5Qbmj2s+5Q77c39z9f/rVIt0zDO39ah8kelWEh\r\n +UVMpye4B9pb+7+tPW9dRjb+tHk0eTUgO+3P/c/WpFunYZx+tQ+TVmOH5RTjJrVAJ9of0/WpVm\r\n LJyKTyasJB8o4q/az7gUnQv3xU0NkWUPv6+1WfI9qsxrtULUynJ7gQpBs75pZOBirFV5akDMm6\r\n mvnL9pKcwfDLVGxnKp/6NSvo2bqa+bf2m8D4Xamf9lP/AEbHXPivgNKcnF6H80GuRGcXEpfHz9\r\n MZ715p4jtGumYCTb07fSu91u62Q3Iz/F/7NXGSn7Qc9c1556VJ33OUtUEUZgYbvfpVe3iFrfM/\r\n 3h6dO1dBNa+Wd1ZM4AYv61SO90oWvYp6sfObzR8vt+VZkNuZpFlzjParM0nmHbV/SbbzLlU/z3\r\n rKpU5YtnJRjzVeV7H1Z8CNFZr2Ofrjt+D+9fqd4TsRJZw5Gw8+/c18Rfs/6LCPLZh/n5/ev0P0\r\n mzWFEKDgV4levOa5ZM/Qsvy+hSgqtONpP1PQ9ItBbxqQd36eteg2GZLdGxjr/OuO0dPNUL/nvX\r\n odjb7IVX61ynoFqFOKyJ7+aPUHtli3BcfNux1GfSuohh4qxFp8Mk5kYfMf8Kumk3qZ1ZNK6IbO\r\n JpEDNxWqtijfNmr5tlRMLSIMLitvZxMPayI0t0TtmoJYC7HbwKvU0yopwetJ0oPRoPbzWqZjvY\r\n O/8WPwqlLpuCcv+ldL50dULghmJHSp+r0+x10aspbs5iXT1yct09qwbuEeY0IOMd67Cbqa5a7/\r\n AOPt/wAP6VnUoU0tEdzWhQg01g27zevtVqWHP7rrt7+tW4egqXy9zk1j7KHYk5fVgGtjDj8fyr\r\n mLCyWOFYSc4zz9TXa6pD8prnIV2yYo9lHsVGbi7obJZIgznNNht0B8zPXtWhcfcrNEu0Yo9lHs\r\n ae3mXJAXXarbf1oitQIwGfJ9cVU86rMc3yisq1NKPuhedTQn+zL/AHv0pskahdnXHem+dVeWfr\r\n XNyzD6vIzLq0Vz97H4VgzRlZGhHbvW7NNzWbs82Vn9aaUluJwcNWc3e2WBu3fp/wDXritQjMcj\r\n t16V6jfQjZXA6rDy/wCH9KZlJU3ujw/xRm5ymNv+RXw98Y9OaOa4Xdn7vOP933r7u16H5z/n0r\r\n 5W+L+keZaS3OPvY/QoPWvQy6TjUbXY8rMsNRdLRH5zalGYy3epbFNtqkxPXPH41satZ5ldQO/+\r\n FZJBtrFFPGM/zr6ejPmjZn5tj3y1LIguZvOyijB9a7zwlHstUBPTPb3Ned2I8+XB716RpuLTyY\r\n +m7NdFWlFwOnD0oJc6Wp11kvmXWSPw/Cv0D/ZV0C4udahvSNgc9OvRZB618JaVa7tdtrb/AJ6E\r\n /oua/bf9nX4fQ6PoWn3zJhmDn/x5x/ePrXPFKOxjiT7HtQ1tDEhGcD6VcuTmZj9KtmJZEXb2ql\r\n OCJSDXRTm3ozzPtEVVW/1pq1VVv9aa1KL0VaMf3RWdFWjH90UAPooooAKhkj3c5qamt0oAyZov\r\n eqQGGxWlN1NZ5/1hoAvxVqxRlkBzWVFW1B/qhQZ1dg8o+v6UeUfX9KmooOch8o+v6VEwwcVbqs\r\n /3jQAyiiigApOaWigak1sHNHNFFBftJBzVV87jVqqz/eNAvaSGc0c0UUD9pIOaiaMk5zUtFAe0\r\n kQ+UfX9KiYEHFW6rP940C9pI/9T9cvNHpSbQ/wA2cZ7VFTfN28V2HGWPKHrViOL5RzWf51WEn+\r\n Uc0AW/K96jIwcVF5/vT1bcM0ALViPG2q9MMu04zigC9xRxVDz/AHo8/wB6AL/FOEYIzms7z/er\r\n CTDaOaALXlD1pNwT5cZx3qHzh60obdzQBN5o9KsRyjYOKo1Zj+7QBZ80elSKQwziqtWY/u0APw\r\n KsR42iq9WY/u0APwKmQ/L0qGpk+7QA/PtSUUUAFRvHuGc1JSn7tAGRNHz1r5m/ae84/DPUYIY/\r\n MLKvfGMSRmvp6brXmvxB0i31rwvq9vcjKqiY/MH1HpXPivgKjufyR3051C8vtNlHkNEw5+9nPP\r\n tWPpgaSJXcbSc8dehNdH8TLJtH+Keo2sPEe9f/AEWD7+tUPLWJNydK889TDlXUIx5fBrl5ojJH\r\n t6V0c0nmcVReHiqienL4TkTZNG2S2fwrqPDdp514hzjP+BqnNDzXVeDLbzdRRPf+hrixTexxYb\r\n +Mfoh8DNMcRxlXx+H+/wC9feOmRsltHEecZ5r5c+B2iYtomx/n5/evse2sNgAxXjVD9Nw38BHQ\r\n 6J+5wev+TXplnPE8CueCc8da86s02CvQtHsknto5GbGc/wAzWZZsQzJU8bAzlg2Bxxj2qG4jtb\r\n RMs+PzrBOu2EcxUyDj6/4VrS3Mq3wnfNdRomDzTI5FlUOOAa87vvFOnxrjzB+v+Fedaz8WtO0g\r\n vB5g+THr3x/sn1rc5D6IeWNR96si6YFzJvwD2xXyDdftCaeshXzh+v8A8RWNP+0Tp0kpgMo4+v\r\n 1/uUCkfZcdzbs2Gn2/gTUr3lqnyCTdjvjFfKejfE3T9VYMJxz9ff8A2fau7sfEMFzPtjlyp6f5\r\n xQduHPavNhlJ+fGfaubv123b7DuHHPTtSWrRtGG31YzGeetZ1dj0/slRJ2T+DP41pwuTEJSvXt\r\n Vf91T2uo449npXOQZmoS7+NuPxrmCpWYmti8vY89a56S9j8xhmgCW6vAi4YfrWLbXkV1cSxFtn\r\n l49+ozXH+LfEsdhGTu/zx7V4jafEdRqd6qv/AHP/AEH/AHaAPo2HW7WWZ4mbbt78mtK21awlUZ\r\n nA/A1+furfFWa0u5ysnp/L/drzk/HS8icnzTjPt/8AEVUYczsZVcYsOudn6mT6nYwruEwb8CKy\r\n H8QWbHkj9f8ACvzYi+P00g2tN/n/AL4pkvxzfeQJf8/98Vp7A5/7ep9z9JTqdjJ1mA/An+lEWq\r\n WayeWrhsd+a/NgfGm6f7sp/wA/8ArrtG+LkzwxvJJknP8AM/7Nc+JpcsbkTzaNZcsT76vL+Ep8\r\n nNcHqd1u3EJn8a8U0n4lreKA75/yf9mu5t/EdvdwjnJP+fSuEz+sHNax+8Y5GP8AIrxfx1oq63\r\n p8lmJPK2D72N2ckHpx6V7brLqwLJ/npXnV9D50cmf4q7sB8b9DHEVeaDR+WHjG2bRdZexI8zn7\r\n /wB3sD059a4rVgBmAH7uOfrg19FfGLw39mv3vNvQ/wBFHrXzTcTfaLhvw/lX02HPzvMf4omlr5\r\n cwY84rvbWZb29hj/1fl5985FcdDH5fNT2908V8rr0P+Fd1X+GdtD4Ee8aPfoPF9i5XiNm79cpX\r\n 9EHwTaLXfAWlXcX7jesnH3ukjj29K/mssbiSPWra49Cf/Qa/oa/ZS1Y3fwv0Mk8kT/pLJ7VynL\r\n iT6oiY2jCFvn9+lV7vHntj2/lVi7GJQ1U5zukJrWlueZ9oiqHy9zk5qakX71blFuKLOOauqNox\r\n VeHoKs0AFFFFABTW6U6mt0oAzpuprPP+sNaE3U1nn/WGgC/FW1B/qhWLFW1B/qhQZ1diaiiig5\r\n wqJoySTmpaKAIfKPr+lRMMHFW6rP8AeNADKKKKACiiigAqJoySTmpaKAIfKPr+lRMMHFW6rP8A\r\n eNADKKKKACqz/eNWarP940Af/9X9ZvOFQsdzE5ql5w9aPOHrV+0kcZb/ABqRXCjFUPOHrR5w9a\r\n PaSA0fMFSpchVxj9ayfOHrR5w9aPaSA2ftY9P1qFpgzE461mecPWjzh60e0kBo+YKkXBGayvOH\r\n rVhJvlFHtJAX8D1p6sAMZqh51HnVpTm29QNHePX9alW4CjGM1k+dR51agbH2ken61YjuRsHH61\r\n z/AJ1WY5vlFAG39pHp+tXYZQYwfWua86rCXe1QuaAOi8wVItwFGMVzf233o+2+9AHTfaR6frSr\r\n egfLt/WuY+2+9WIrjd81AHUJOH7YqcHNYkM3Fa8J3Rg0AS0p+7SUp+7QBmzda4fxajvoepQxnm\r\n VF/DBFdxN1rDvLZZ1mjccOAPyo5Iy0kJya2P5L/wBo2wuPDHxPvRNEZfNcYbO3pGn19a4SyQXK\r\n m0DfcH3/AFzz0r9TP25PgSsc0/iGCLnrn/vyv9/+lflN4V3i5eGX7wOP51x16UYrRHbh6kjFu7\r\n o2V99mK7ueucdq6i2003pwG2j1xmuU8RR+Xqwb3/oK9Y8NxI2nxzHqc/oTXnym1sevTk5aM821\r\n S1aylMf3/fp6V6L8NNCa91GKXft3E8Yz0De9c3rKxyXu3/PQV9B/A/Qxe6rGoGcH+j+9ediakj\r\n 28BgaEpczjqfpN8IdCFhpsTmTdx0xju3vX0YjL5Qkx17fSvL/Cdl9gtYounH+NemoMJtPQV5fM\r\n 29T7XD048vLbQuW0zSNt24/GulN7/Ztisxl6Z+XHTn1rjvt8Npy1eQ+N/G7x3M9vC3yjbj8h7U\r\n zKsuXY3/F/xQeMtEq9O+76f7NfP2pfFG5ivZM8Lxzn2/3a8t8Ua7fXc7FSTn6e3tXleqLql6DH\r\n Hncfp7VrS3PNqVJvQ9p1/wCNQtlP7zJHbP0/2a8A8TfF1tTnlKtsLY5znoB/sj0rKh+E3iPXJN\r\n zbsH/d/wDih6VYn/Z81ZZCGzx9P/jlbmXsq8vhZ5RfeKrlpTILs/Tb/wDWrDPia9luyUuTzj+H\r\n 2+le2H9n6/8A4gf0/wDi6s2vwGeCQNJ94f5/v1FRtLQFhsRD3qr0Oc8OeKdegAMM7N+Cj19q+t\r\n fh14+1NbG3W5UtJ82TkDu3oK830f4Y/YVA25x/9f8A2jXf6V4bmspFKrhR/wDX96x9pI9HDn2H\r\n oXim5vbdQBtz759favUtMu2axjZ2yxzn86+a/C87QoqN/nrXsNnev9mQL05/nWNapLlPWppNan\r\n byamE7Z/GoHuTNH5obbnt16VzO95OtBkkRdtc3tZF+ziR311IpwOawHnfJcnGe1aE0y5w1c1qN\r\n yqbiOlTKtNdRShFI8d+JE8skbBWx/la+UxcXNhqdzIxLiTb7dB+NfS/jGf7RuH+e1eJ6lpitEX\r\n UfMa66LctzgrTcdj518YSXNsZJo/3pbt09K8TlOozQ7vKIJzxketfXP/COi7lInXj/AD71vWng\r\n HRnVfMAB9Of/AIqvSp8lNczR5GKTxC9nPVHwnFaa4XykbH8RXSWHhHxfqDiaG2by26Hcvbj1r9\r\n FvDfw28LSEGUL/AOPe/wDtV6zY+FNFsAtraIpROnXvz3NafWKRw/2VDsfm1p3w98VKgMkJ/Nf/\r\n AIqujHh3VbCBUmyjrnK8cZ981+jM2gQ7P3UY/wA/jXCaz4JhvHeRkG5sZ/T3rnxNSnUhZI2o4K\r\n NJ8yR8aaXq97p7gMpbHuB/SvStE8fPHMsTxdP9r6/7NdBrnw7kjYtGn+eP9qvHtT8O3+nahIwB\r\n AGPT0HvXB7OPY6bI+ooPEMV/AONv45/pUUTLctJGOAmOfXNeF6DqN0CI2P8Ann2r2bQWZ4Xdup\r\n x/Wi/s/egY10+XQ+bfjPoovdNmnVtpQDjGe6e9fnzEgSQs7YOTxiv1W8caOb7SbkYzwP5j3r8v\r\n PFOly6dq9xCBgIR+oB9a97L6spaSZ8jmWHV+a2o9plZNq0y1xLMVxgw459d1YlpM2/axretU8s\r\n XMw/2K92UU4anjwxNaMuW+h3pvFgNpOE3FywxnGMcV+/8A+x3E7/DjR4CcCMTHPrullNfzwWtx\r\n 9p+wp/tN/Ov6SP2QNP8AL+HGlSEfwy/+jJax9nEcqspbn1XMnnAnONn65rGSTzV34xnt9K24zl\r\n pV+lYcQ2pj3NNRS2Mra3JKRfvUtIv3qoZoQ9BVmq0PQVZoAKkWPcM5qOrMf3aAGeUfX9KgkG3i\r\n rtVJupoAy5uprPP+sNaE3U1nn/WGgC/FW1B/qhWLFW1B/qhQZ1diaiiig5wooooAKrP941Zqs/\r\n 3jQAyiiigAooooAKKKKACqz/eNWarP940AMooooAKiaMkk5qWigD//1v1L8pvX9KPKb1/StPya\r\n PJoOMzPKb1/Sjym9f0rT8mjyaAMzym9f0o8pvX9K0/Jo8mgDM8pvX9KPKb1/StPyaPJoAzPKb1\r\n /SpFDKMVf8mjyaAKXPvRzV3yaPJrWluBS596kWNmGc1Z8mrMcPyitwM/ym9f0pvmNH8mM4rV8m\r\n kNnu5xQBl+e3939aaZmPatX7F7UfYvagDK81vT9aUSMe1an2L2qB7faxWgCn5jelaNtIRGKr+T\r\n ViNdoAoA2IZDXQWsx8pRj1/nXNwVvWv+rX8f50AayruoddoIp0VEvU0AZU3WqcwV064K/rmrk3\r\n Ws65UiKR15IxVwJmfMf7TPgJ/GPgS6MA2uqjtn+OP3HpX81Op+HZ/C/jXUdMuuGgZMjH95M9if\r\n Wv6zp76O80K4s7lNwIHH/As+lfzwftdeCzpXxR1fV7WPZFcGHb/wABiiX19T6VyYnY68OfCevW\r\n /wBsv9wOzH49hXpmjWzWfh2G4Zs5Dcf8CIrktSsGiuoiw+/n9MV3PiqdNF8L2cXQsH/9DH19a8\r\n mZ7NE8we5N3fFj8uD9e1fe/wCy54c/tCWPUGk2Zz8u3PTzB1z7V+fFmGm1OJF/5aE/oK/XL9m3\r\n w4dM0O3lZcHDf+hSe/vXmYk+ny4+t9OTzZgg42fjniurNxFghjtrG0SDcZJfp/WnS2/nwmQNgn\r\n P8681fEfXUNjhvF+uQ2itiTP4fSvmPXPFDXWoSxpDvHGG3YzwO2K9p8YeGry/LCI9fp7e9ed2f\r\n gK4iw0y5Pf8AzuqznxHU5vTNAbV2yRsz+P8AUV6BpXwxYSCdT5hP8OMf+zV6J4V0K3tSolH+ef\r\n eur8RXR8PWo1GBhtboPoQO+fWtaW5zYKh7Wo0cxaaS+mIFksQoH8W8H9OaztbubSxi+2XCqsbd\r\n 8+mB0FcfrfxOvNStmRDtx9PUf7I9K8rmuLHVYPP13UhHC2cpsJxg+q4PYVub18TDC/Edfq3jrw\r\n 9BEXtpBM4/gwy/qVrx2b4raY2qOt2Ps3T5eWxx6hazdYu/hFbsbe11IGb/AHJvb14rgtQsfA2p\r\n A28Eweb+9iQZ79M46VnV2POnnlLF/uYbrU+o/D/jHQtSUfZZBMx7YZfX1Feh29xBdYjMIQ/72a\r\n +BrG1n8IyfabByyDp/kk+teyeGviZdTwRTT8M2c9OxI/u1znZhz67s9OkiG+Pn2ruNKvGWJIHj\r\n +YZyc/WvGvC3jhbtFDf56+1exaRIL11nA4b+maxr/CevS2O3t1BXdtqSaLevTFdBp+n74hxWyN\r\n GzH0/z+dcpqeG6wskGSOf8iuAv9ScIYynI75r3nX9G4PH+ePevDPEFn9nmkXHTH9KmZMtjyHWi\r\n JWbJx/kVwt+q2yedIcof6Yrd8R3vkORn/PFeW6nq02pI2nL0Tv8AXBruw55mI6j9W1izt7czW2\r\n JH/u8j074rhNN1TWPEF6UgQwbv4chscevHpVG6sLizkILbs9v8mt6zsNfutJLaNARMnV8r3P8A\r\n tceterDDOuuWJ4OKxaw6533sd3aaH4h0+RTd3vkxH+Pahx+APvXYreXunfNbaiLuIdJNqpu9eD\r\n k8Gvleaz1fU9PuF8UaubYJjjyg3f8A2CPQV83Nf67Z3jWugau1xZIf3beWFznk8Nz1zV/2PUOH\r\n +34H6pW3xHmi/dzHp3yP6LXU6Z4+0u6cJO2HPXr/APE1+Z+heM/GOnqC8RuMe6L6+xrs2+JeEW\r\n 4v1MF4330znGOByFx0rnxGAlRjzyOnC5nHES5F6n6VzTWt/FutIRMT0+bH864DXfCI1FWeRPs7\r\n t1H3sdPevA/hj8Vbq4mVBJ8vvj/a/wBmvsGw1e31W1SSQgyPnP4H6VxnoHzb/wAIKNPnMn2jPt\r\n sx/Wtmwl+yTvbKu4cc5x2zXr+saL5ylox/nj3rhRo7Q3BLDn/PvWdXYqMObQ5zVLTzLKSE878c\r\n +nIr85/jB4eGkazeYPm42c4x1Vfc+tfqHPYeYmMV8e/Hfwnua5utv3tv6bB6162X7nh5jhz884\r\n 1Jk3AYxXSW0vmWMyYwW28/Q1Re0MUzp6Vetk2QSZ/2f519M/gR8jXpcjNTQbWVtV02zHO9n5+n\r\n Nf1Ifs4aIfDXw00mNn85ikmeNv8Ay0f3PrX82vw/0+G88TaQGHV5P5Gv6h/AVqtn4TsLdOAqH9\r\n WJrM5zr0Gx3b+9WU6eW5XOcVrVmz/61qAIaRfvUtIv3qANCHoKs1Wh6CrNABVmP7tVqsx/doAf\r\n VSbqat1Um6mgDLm6mqYjy+c1cm6moF60AXIos45rWiG1AKzoegrSj+6KDOrsPooooOcKKKKACq\r\n z/AHjVmqz/AHjQAyiiigAooooAKKKKACqz/eNWarP940AMooooAKKKKAP/1/1y8kUeSKmorp9n\r\n E4yHyRR5Iqaij2cQIfJFHkipqKPZxAh8kU4W4IzmpKmT7tHs4gV/sw9f0o+zD1/SrVFPkj2Aq/\r\n Zh6/pR9mHr+lWqKFFLYCr9mHr+lPWMKMdanqdItyg1QFPYPT9KsRoNo4qfyasxw/KKAKewen6U\r\n bB6fpV/yaPJoAobB6fpVKa3DOWzitzyaz7gbXYf56UAYzqFpETcc9KfN1pYqAL8MWO9bVsMIBW\r\n VFWtB90UAa0VPkTPOetMiqd+lAGRNF71UVPLLs3zB8cdMYrRnqlJ901cCZmDK1tDFJCYd2/vuN\r\n fk3+3N4DhttPm8RJJ93B2bevMK9d39K/V686mvhv9tjR1vvhZeTKMsoX/wBGxe9cmJ2OvDn4R3\r\n 9hFq9hbapG/llS37vGf4gvXj09K5z4wu0dnYwL0Xfn8ShrX8MPI2iN5vSNj+rmsP4iSLrDKE5C\r\n dP8Ax36elePUlytM9am3pY53wPaNqfiCwt8bcluev8JP9K/cn4daKujaPb26tv8Al64x1LH1Pr\r\n X5KfArwx/afiO2fH3Cf1V/f2r9rNC03ybWJMdF/wAfevGxNWWp+hZRhaUqfM1qdRpv+iQMpG7f\r\n +GOtYhhuPtDQq/yjvj1romQolWLG2SQiRup/pXle1lzHqJ2nyozYNGJXdI+78KuyeHrOS3VjJt\r\n Y9RtJxz9a6gxxomKxNQkht4TOzY9qr2s+45QUtzzfxNZQ+HbVrwXHmY/h27e4HXn1r4p+JHxmj\r\n mnl057jyBHj5MbsZ2nrtr0r4x+O7yYPY2JLHpxj/AGT3Wvix/h1e+LtSea6DCaUjP4DjowHQVv\r\n h8QoyvU2OarCrSXNhdJffp8zVm8aanrVu1noymR26OCB3z0YD0rzOTRNZTUJ08QXzb1xug2AYy\r\n Mj5lP0NfXPgX4Gah4dC3UY3d+3v/ALZ9a3/EXwWudcv7jWpV2tcbcjj+ABf749PSvXo4nCy3R8\r\n 3mOGxlZNVXc/OO4svDUmsi3FmVYnl/Nc9vTNfQ/gr4e6Xf3kEdndlZJM/LsY4wD3LV1F1+z1JH\r\n qf2gjof6Y/56V6H4V8DTeGtWa8j5MWD+akf3j61pjp0JU17Na3PJy7J6tGu6lPRtFjxj8MNa8L\r\n 2kZji+3I+e6x9Mf7R9a4bTtGZLoWc8fkSr1XO7GRnqDXt3iDx34l8R40+1j4j4/g74PdR6VBoX\r\n hie4ZNR1Ti5f7/TtkDocdK8k+xwcKkf4h1fg/wALTRRrIjb/AMMevvX0V4WieLy7eRNpXOec9c\r\n msPwetvaxqgXP+TXqNpaq9z9rUYDf0GKxrfCe1KrDktT3PUdLgSOAMTn/JrpoljNuG/wA9a4q0\r\n utkQXNbcN5+4Vc9M/wA65TLmqdzmfEcyICNmfx+lfN3jCf8A0iZwnXHf2FfQWvuHB/z6V4T4nt\r\n N/mNjrj+laUoxb941pKcnZny/rumvqUzASeX+GfT3rnbrw1/Z+nB4G8+c5zxt7/XHSvUrmy/fn\r\n ik8qKzbz5RkeldcXGOxz4iifN2k6Lq0+qeZqEJSLPQkHsfQ19Q+HfGuheHdJk0ZdIFxKwA83zi\r\n vcnptPr61h3WqWV+PJijCn15/wFYIvdJ0+4NvOMzL94/N35Ht0rqo46pSd6bseJicvpYhclZXW\r\n 54X4v+FT6/d3N1JEZ4pyD5YbZjAHcMPSvLdP/ZzvbWbzrfMK54j+9j8TJX3pp+qRXA224H+fqK\r\n 03lnVj8g/Sun+2sT/N+C/yOP8A1cwP8n4v/M+UNL+GHiGxjCRP0/2U9/Vq4Dxf8IdTvdRmurgk\r\n yvtywAHQADgNivuv+0J0/hH6f4VUvNQtJIsTxgyd/wDOK5MZmVetBRnK+vZHRhsnw2Hlz0Y2e2\r\n 7/AMz88NO8D+JNFmzazFcf7K+/qT619I+BfGGr6PaQWeqQGVo92ZCwGcknoAema9NeG1nf5YQf\r\n zq/D4Ni1eMAJs3f59R6V5ntZHd7E7jS/H2n3cAXyQW9Nx9/9mqN3qa3V45WDYDj+LPb6Vzw+HN\r\n xov7+Nt3t/lj610mm6fI8KSSL8xzn9aidSTRjX56cU4dxwUBdxFeMfFnQ01jSpcN5Zx6Z7r7j0\r\n r3y4tvLSvP8AxLY/bLaWHHYf0r0MLXnHZiqYdVKfNJan43+J4W0rVZLYjfz16dgff1qLT4lvfM\r\n t87OnPX3r1j4veGfsWqvNjv/RfevLPD0LvdzuOg2/yNfR0sXOcLNnw2MpJVGnse0/A/Q7jX/Hm\r\n n6ejeWIHb58ZzlGPTI9K/p78K2rQaBaRMeVTHT3Nfhp+xB4AXXvFI1Blz5ZB/NZh6j0r97LeAW\r\n 0CQr0UCu6g+bc8msktg8r3qjPbZctu/StQ/wBaqzdTXVUhFRujlpTblZmQ67Peljj3DdmnTdTT\r\n 4fuCuc3JUOz3q7GvmKGzjNUa0rf/AFQ/GgA8o+v6VIq7RinUUAFVJupq3VSbqaAMubqagXrU83\r\n U1AvWgDRh6CtKP7orNh6CtKP7ooM6uw+iiig5wooooAKiaMkk5qWigCHyj6/pUTDBxVuqz/eNA\r\n DKKKKACiiigAqJoySTmpaKAIfKPr+lRMMHFW6rP940AMooooA//Q/Xiiiiuw4wooooAKcFyM5p\r\n tTJ92gBvln1p6jAxS0UAFSLHuGc1HVmP7tADPKPr+lHlH1/SpqKAIfKPr+lXYVAjA9KgqzH92g\r\n B+BViPG0VXqzH92gB+BTggIzTamT7tADfLFZV1bZdm3Y/D/69bNULnqaAOUuU2HrmmQ8gVNedT\r\n UMHQUAasVbdtHmNWzWJFXQWv8AqF/GgC0rbauqnmxh849qoVYSXbGBQBBNCP71Zsy7QR1q3NNz\r\n VKRty5q4EzObvOpr5a/an037R8K9RlZuCqYGPSWP3r6lvOprwf8AaKtPtXwo1AY6Kn/o1K5MTs\r\n deHP5vrSNbXQrqIdd3X/gZrhWt2PyO24nvjFd3qBMEFxB/tf8As1c7bQebqfkdcY/UV4mI2PWp\r\n 7o+qv2afDQg1NLlpN3tjHaT3r9ZNMtA1tHIDjI6V8Dfs+6D5Xlvj/Pz+9foZZJ5duiegNeJiOp\r\n +lZN/CGS2fmDbux+FLBCLdAm/OParp6iqXlyPcHHTivL+0dn2yhqWqyQLhYt344/pXjXiTWdYu\r\n 5pYIICqHGDuB7D2r3m409ZE+YVlf2ZaE7GQEj61RZ8mad8OZ77Uftt7JvGc7SuO2OoavSj4Q0W\r\n 2mLxwiOUYzyx7fWva/sUFvyqVlX2jR3TNd5wW/px61zYqDlBKPc7cDy875uxw9vHJbgKr7l9MV\r\n Yut81vsGF/8A11W1FLi1YiMZHauQurDxPeytPaqRE3T7vb680sPQqGuJ9kRahpcjE4kA/Af41w\r\n 0r2mj3dw1zKJpH25TG3GB6jPrXSzeHPGEh+6T/AN8f402L4UarqZF7eZEkn3hx247NXrwpziry\r\n PNjOlCVzx5LyW3uZZbNPvkY9sD3rf0RNVumQTMdxJycD37V7HafDL7BzIucf5/vV32heC7cBJC\r\n nr/X3qzdUlV+EzfCGjzQoryHf+GPX3r1+EhIlUJjHvWpp+lW9pEBj+dLPCnmtt6VjW+E3p5bKm\r\n +dlJZ2U9P1rQS7KxA7f1qt5Iq0If3IrlNvq5z2pXZl42Y/H/AOtXnOuxB0YdP8ivR7yHmvP9dG\r\n 2R0+n9Kic+VXN8Ph/eZ4lfWvlzE5zVM6b9q+dnwD/DjpXVXdtvlNS21l0BHH+fes/rDIxOHOGb\r\n wyh5hO0+uM/1rPuvBEVzmWTmU9Wx/TNe3WllDj5hWqNOt3GcU/bs8z6urnzSnhO/s2Jt7raP9w\r\n H+Zq39g1wLt3l/9rCjNfRn9h279v8AP51Yj0yzgURFMkUvrDK+ro+YZNI11/4yPwX/ABrVsdDv\r\n niVJ4vMbnL5Az+FfRn2Ky/ufzrXtLKyESkJzz61cKvM7B9XR41o/hHOGeL9fr7108nhrykxFJ5\r\n RHtnH616zAkEf3UrPvbYSyM4GAcVoH1dHlItJrdv38vnL6bdv9aJLWJiZ4xsU/wdcdutdXeWXP\r\n T/P51h3CeWhT0qZnHjcOuVepx+oygAjFcXdkbpMjOQK67Uu9cs8ZeZx2ruw5t9X/AHJ8F/HfRm\r\n kd7hOPb/vj3r5b8JSKLi6tpV2sNnP51+iHxa0WGeBiw/z8vvX5/appsmmeIbp4hhHKY/BR/jXu\r\n YZn57m1Llk2fsR/wTt0qCMXE7PuPy44/671+re4tyRjmvyb/AGCLprCPaxxvx+nnV+s7jDYHtX\r\n s4bc+ZxAw/1qKSPPOalP8AWh/u13VvgOCj8bMeaLk8/pToojsHP6VJN1NPh+4K5DqG+UfX9Kuw\r\n jbGBUFWY/u0APooooAKqTdTVuqk3U0AZc3U1AvWp5upqBetAGjD0FaUf3RWbD0FaUf3RQZ1dh9\r\n FFFBzhRRRQAVE0hBIxUtVn+8aAH+afT9aiY5OaSigAooooAKKKKAComkIJGKlqs/3jQA/zT6fr\r\n UTHJzSUUAFFFFAH/0f14pwXIzmm1Mn3a7DjG+WfWjyz61JRQBH5Z9aTcV461LULfeNADvMPpT1\r\n ORmoKmT7tADqsx/dqtVmP7tAD6KKKACrMf3arVZj+7QA+po24xUNSx9aALqxbu+KtLa4TO79Kj\r\n irQH+rFAGa67Pes245zWrN1NZU/egDmLzqahg6Cprzqahg6CgDVirYgnCRBcdKx4qnMu04oA1/\r\n tI9P1qF70A7dv61m+dVd5huNAGg8272pplwm3GazvOHrVgHdGDVwJmULld59K8l+Mtq1/8Pb7T\r\n oxlnVefTEinpXrk9c/qtjHf2U9tPysgAA+lcmJ2OvDn8wvjPw8+l6jd2ssvKMP4eucH1965Dwv\r\n A+pas12F2cj5evQEdfwr6//a38AzeGPEct1Cm2OQ/yWIf3j614X8KtJjvJ2bGen/s3vXgY2TUb\r\n o+lyuhCrUtNdD70+AAE1uPk2lffP9+vs61k82BZCNuc8ZzXyV8EEjtLhofp/J6+sFcRjYOgr53\r\n EVZH3WDfs1yx2L3B71agKKBkZrI86pop8tivGrVqi1iz0eVW5upuOnnjC/L+tU4rIJMQx3Vq2a\r\n bxWklnmUnFaUatSW7EZU0MQjxs/WuNvNNnkuWljl2xnGExnHHrmvUZ7L5OlZ72SeTz1/z713pN\r\n K53ZfGMqjUux5uLe3i/wBfH5n44rorIWptkKKEXnC9cc+tVNRsmydo/wA/nWZGlxGgQdvpWka0\r\n 47HpywmHlvH8WdXm39vyqjI+J22crxisb/Sff9K17SN2iUv1q5YqpJWbOWtluFtpH8WSSwLdLg\r\n jb+tX7DRp44lZBlOx4qWGHiqWp+Mv7GAsNv3O/1wfQ+tZ+1kOjShS+BGhPFKp2H5femLAFQfNu\r\n 98VNZXn9q2f2np/+v8PSqYl2pjNXTbm7SOueJnKPLJ6A7KnvVuM7rcEL61iTTc10mnlG0+Mn3/\r\n nWvso9jLnRzF4Dn7teceIYSHeX1xx+Ves3nl5rzfxAokmkUdOP5Csa9KPLsVGq4u8TyFrnM20p\r\n +Oa37aJXhVhwTWZdWvlyFqktdQWIiJj0rk9jDsTKbluaxil/hrStoJxGM5q9p11ayKN1dbAlrJ\r\n EpX+tHsYdjLkjuc3DvUciry2yyjeeprd/s9ZPuj/P51ZSwKKFI6Uexh2Hyo5v7En+RWxZWaFFF\r\n XvsXtV+1t9pC+lVGnGLujOqrLQQQxW65KbvxxWZdFZCXVdoPbrXRzw/JWNLD8tWc/MzjLxRk8V\r\n zV5Z+Zl92M9sV2l5Dya5y7XblfSsa0mloZ1VzLU801Kw5I3/p/9euQnAt52X736V6BqX3jXBam\r\n MSFv89q2w9WRxVsRUUXFM8Y+JmmtcWLTeZjjpj3X3r4013wxFcW0d60212JyNuehA9a+7PGUQu\r\n NNZevH9RXx94jt3j8u3HQE/wAwa9zDVZXPmMdRjUTcz7q/Y4hMc0MacAd/+/tfrhJGM8HPA/lX\r\n 5rfsj+GJItPjvNv+cyj1r9JLdi0Ck9cV7eHqSPz7HycanKhdme9MkGBip1qGWvSlNuNmUqUVDn\r\n S1MybqafD9wUybqafD9wVkQSVZj+7VarMf3aAH0UUUAFVJupq3VSbqaAMubqapiTD4xVybqazz\r\n /rDQBqxS4xxWtEdyA1hxVtQf6oUGdXYmooooOcKKKKACqz/eNWarP940AMooooAKKKKACiiigA\r\n qs/wB41Zqs/wB40AMooooAKiaQgkYqWqz/AHjQB//S/Xzyz609RgYpaK7DjCiiigAqFvvGpqhb\r\n 7xoAbUyfdqGpk+7QA6rMf3arVZj+7QA+iiigAqzH92q1WY/u0APqWPrUVSx9aANOKtAf6sVnxV\r\n oD/VigChN1NY90+3PFbE3U1zeoy7C34UAc7fXIUniqcF+vTH61z2sah5bHn/PFc1FrGHxn/P5U\r\n AeyW9wjjPSnysm4ndXnlnrPA5qefVXZiQeP8+1AHYPcqvesyTUR5xULx65rjZtTlz1qa1ujIA5\r\n 6mgDuoW83vitNDsjC9cd65uzm4Fb8Z3RA1cCZlaaX2/WszUN01uvl/K0ec985NXZ6ihA3uZPun\r\n FcmJ2OvDn53/ALXPw7Hi/wAOTakJPsrQjP3d+ctEP7w9K/MT4LRi2vprSZsGMgZx1zvr9/8A4x\r\n eGLbWvA14sQySo9f76+49K/BW90ifwd4mukxtBYf8AoP4+tfP474D6rJf4r9P8j7R+EsQfVmKy\r\n YAI7ezV9WOCGxnNfEHwk1doL6NmP3z/IN7V9uK/mAP6gV83iD7XDC4PrWjaWZkAk34z2xVCt6w\r\n /1Sfj/ADrzFDmlY9P7J0unwbAOc1uR/K2QM1l2fQVuwxZANenh8OQTFfOXGMVi3cBSRlB6V1MM\r\n HtVW5tN0jNiuzE0uWnc6MPPllc4aaEE881DHZRyHkYrqJrL2qH7L5abq887PrJztxZRwLuxurN\r\n jnPmlFjwB710ky+Z8tVEtkjkyaDSFXmdh0fyrnFYmr6DbauBIx8tu55Pp7j0rTvb2OBcVjJrUR\r\n GzP+fyoNDbsFi02x+xr83+1+OelYrAITHuyR3x604TtP901V8mU3RB9v5VtQ+I58TPljclNi8v\r\n RuvtW1BbywWap1xn+ddDpGnq6jcP8APNblzYRou0DpXUcPtzx+/klQniuSuleeViRjOK9W1KzT\r\n ceK52bT41j346/59axr/AAnThqvNJo8Y1i0ZASOf8ivMJzOdRkjA2gY5/CvoDUraOQlcV5xqOm\r\n xRXkjgc8fy+tcp2nPtdS2Me/du/Suj0TxcDFHG6cjPf6+1cRrJbbtX/PSvJLrxHJpmqSWxbGzH\r\n 6jPp70AfemiapHcIDt/X6+1dUyq48wcZ7V8peCfG6yBVZv8APPtXvmm+IY7kqoPX/PpQB1RBz9\r\n 2rMERLbsU+Jo3j3etaVqYioNBjX+Ez7olExtz+NYzPuTkYNdVe+XtNctNjJx0oOUxLmAOTziuR\r\n 1KHbI4z0xXazdTXI6p/rZPwrDEfCiZbHnOpRck5rh9ag2Q+ZnJ//AFV3upd643UF87dH6Vphzz\r\n MR1PK/EMimxbd/nkV8ueK4o45LadTuaVm+XpjBA619A+Mb37Pug/z2r5u1iRptdtoW+4rH9QDX\r\n t4bc8LFfCz9mP2XdIW18HQzsv3h/7PJX1fHDtiHPrXz/APs+3dpH4MtYFPO0+v8AfevotxtUCv\r\n cw5+cZl/FKBbZ71Czblz0qSSof4K9N/CdD/gooTdTT4fuCmTdTT4fuCoMCSrMf3arVZj+7QA+i\r\n iigAqpN1NW6qTdTQBlzdTWef9Ya0JuprPP8ArDQBfirUil2oFxWXFV9OgoM6uxpIN/tQwwcUsF\r\n K/3jQc4yomkIJGKlqs/wB40AP80+n61Exyc0lFABQemaKqyy7SRQA559naoxdZONv61mzTc1As\r\n 3PWgDokff7U15NrEYzVGGfip9245oAm80+n61Exyc0lFABRRRQAVWf7xqzVZ/vGgD//T/YCiii\r\n uw4wooooAKjKEnOakooAj8s+tPUYGKWigAqzH92q1WY/u0APooooAKsx/dqtVmP7tAD6lj61FU\r\n sfWgDTiq0Jf+WeOneqsVSL/rT+FAEVy2wFutclqjh1Z84z2/Kusvfu1wGql8uB04/pUVG0tAPJ\r\n PEdxsZsf56Vw8dwS+c4Ndnr1rJIx/z6Vxa6ZOZMgcVj7SQHS2c5wOa6CKXdEP51ztnplxgcV1t\r\n ppk32dcj1o9pICg8e72q/aRFUXB9as/2bL6fqK1rSxKxKCOeaPaSAfbOy9s4rp7WUtbrx696z4\r\n bL2rRjTy1CelNVZIGhrxl++Kili8yEwA7T/eq1UX8RqJNy3KjNx2Oe1OAtpEumStv8wAbumMHP\r\n Svx1/aP8Bf2N4quY4pN6oUO7bjOUjPTJ9a/ZLVPun/PpXwv+0p4cglt21Vh80nf6eWPWvOx1KH\r\n s9j28nxVRVnr0/yPjjwOPsk1u+77uePzr7j0TU2vYUAjwMdc59favgPT9RW3vo4lPQn+VfbHgf\r\n U4Tp8Ic/Ng5/M+1fNYinHsff4Cu5bno8YLyiPpnvXUW1r5IEe7OO+K4yK6WS7G3/ADxXdQHODX\r\n BQpR52fQu3JdHQ2cXHX9K6a1jHlrzXP2fQV0tr/q1r0I+7sZGnDHx1p7Qb3IpYegrTg2Z5610R\r\n /e+7PYyrTlGN4nOXVmUGetZssW+LbjGK7K98vZXJXtzHEpFctajCOyLoyqS3OcaARNuLZ9q5/U\r\n r5YJXOOOKrax4gjhYjOP8AI9q8W8W+OIrcSANzx/T2rz3duyPawdNc15G54i8VRQ5G39fp7Vzu\r\n jaqupTgq23cenX19q+ctT8WXGp3JWNs/5+ld14BuLmK9jab7uf6GnyzPQ5KfY+utPt3t4RIw3j\r\n 8q3YII7gC5B2s/8HpjjrWXDrdmdPC55x7+v0qlbyDYLwzBUboPpxW1BSUtThx9FSppQ7np2mCf\r\n gLFx65+tb1xab497ybGP8OM4rzfT/EG793BKGP4f4VZvfEUkLNHM3zDGf84rrPI+pzF1S32scP\r\n n8PpXK3T/u/JPGO9MvfE0GSWb/AD+VcnqPiCLa0itx2/zionHmVi4QlRfMzL1SVbRi7Nu/T0ry\r\n rXfEdlFcPvOG4yOfQe1YHjbx5Ha7hvx/ke1fOOs/EnSnmPnv8569fb0Ws/Ymv1t9z6R87T7yLz\r\n jPj22mvmnx3tPiK6ktm3L8mO38C+tdJpfj3RHs/v8A/oXr9K46S8t9V1qW5i5ifbj8Fx7dxWdW\r\n k0roFXqT0gy74Z8Q3NhIN8RIH+19fY19N+EfFKzxxTY5Oflz6Z9q+eb3S0FvvgHNO8Narc6XcL\r\n HMcBD/ADzWHLMr/aO5+hmma0biBRs2++f/AK1dZZzgQq27PWvnLw54vguLdUVuf/1+1enWGs4t\r\n 0Un1/wA9KaUluaUlNv8Ae7HodxL5oxnFZMmE+UnOO9Z0OoBx1qrdXuJCM0zo9nTLMzrk1x2qyf\r\n vn49K0Zr3nrWHetvUyetZ1EmtTCvCCjeJxeovnNcddy/Z2kmxuDY46dK2dXudjHn/PFctcTedb\r\n +9dmHpRPExHU+dPH9yrXLTfdA7fgteLahJBNJDfq2CpPy4z6DrXpnxPjmjDsn+fu180m+uGJhP\r\n 8ACa9elBJXR83mM3Gnddz9uP2U9Rk8R6DGwbyRCOn3s5aT6elfbS3JmjDldvtnPTivzm/Ya1Jp\r\n NONu57D+c1foxJH5RKelerhz43F0oyd2iJl3VCy7Vx1qz2/GoJa9P7Jxc7+HoZk3U0+H7gpk3U\r\n 0+H7gqAJKkWTaMYqOigCbzT6frUituGaq1Zj+7QA+qk3U1bqpN1NAGXN1NZ5/1hrQm6ms8/wCs\r\n NAF+KtSKLcgbNZcVbUH+qFBnV2J0Oz3oY5OaSig5wqs/3jVmqz/eNADKiaQgkYqWqz/eNAD/AD\r\n T6frVO6HymXPXtU1V5zlCtBnVk0ro557nc2CMfjVeW7ELEYziqWpS/ZyT0/wAiuVudUzk5oOf2\r\n s+539rqQc42Y/H/61dHbOJUHbNePWOpjd1rv9Mv96Kf896DWlOTdmdXKvlrnOaqiYntUxk3pVS\r\n g3JvNPp+tHmn0/WoaKAJvNPp+tRMcnNJRQB//U/YCiiiuw4wooooAKKKKACpFj3DOajqzH92gB\r\n nlH1/SpFXaMU6igAqRY9wzmo6sx/doAZ5R9f0qRV2jFOooAKlj61FUsfWgDTiq0Iv+WmevaqsV\r\n aA/wBWKAM65XeCvSucurBXBy36f/XrpZuprKn71nV2A851HQklJ/eY/D/69Z0GgRRgDfnHt/8A\r\n XrsLzqahgi3KG9a5wKVtpUSCtyHTV8sYHFTwwcV09nCn2dM9ef50Act/Zop40kY378e2P/r12H\r\n kx1QuAFYgdKAMD7OIuM5qF4cndnGavzdTVc/doAz3Gz3qL/a9amnqH+CgDLvYvOyM4r4r/AGl9\r\n R8vTjpWz/V5/eZ65MZ6V9szdTXxV+03prtbNdgcN/QxiuPHfwztwE+Wo35H5syxPZ6gk2/fyeM\r\n Y7V9PeBdYkuSiY2D659favlTVr1Yb1EY9z/SvdPA2oqsqMp4P/ANevmsQfa5dXZ9aafIYp1fO7\r\n 9K9Nsbwzbfk2j65rxLRL37RMq/5717FazpBCueorgofxGfXUKvMrHeQSrEmSc10VhOskCuOM5/\r\n nXlQ1FpflU12Ol3RjsYwTzz/M12HQegwFSOTUUt35MzADOMVyn9rbO/wDn8qpya2hYkn/P5V0Y\r\n fdhyc2htanrpiX/V5x7/AE9q4TUtaE0bOV257Z/+tVXWdZj2nn/PHtXjmveKBDJJGG4GP6e1ZY\r\n jqejh8OYfjHxKbVmIXP449Pavl3xp4lluGeSMfM+Plz0xjvitvx74t+Zju/wA/L7V5B4fM3iDW\r\n SG5jJGPyP09K4sNDmqNHdXj7KCkem/D7QZ9UkFxMdg9MZ/vD19q+jbbRVtIFZDyO+P8A69UfDG\r\n m2WlWaKAAxHv6n3963tR120tLcoxAI+v8AhXoewOT6ycnqvi+70QEeV5wHbcF9PY+tfNPjL4te\r\n Mr/XLmz06NrW2GzZ8yNj5QT1XPWvQvFPiqzldl3D9fb2ryC/8T6TbuzPgt36/wCFTOnyq5lWxq\r\n pxuz0PwL408XabKLi6uDP/ALOEX19Aa+mNL+JEWsRhb0eTN/Fzu9cdFA6CvhS2+ItmrbYiP1/+\r\n JrV/4SdW/wCJmsu3zO3049KzOb+1oH1V4i8YRW0xSNt4Pfp6e1c5qnje3ttFWUndJg/LnH8X0r\r\n 5Q1nxnMwMivux/9b2riJ/GFxeIfMkwp7f5Fb4eHNKx52aZnGVJKPf/ADOn8Y+NTrFw0W3yR653\r\n ensPSvHNQs4JpizT7j64IzUGuX8L5ZH+Y/8A1vavML3xC8E7Rbs4x/npXZ9XR4X199z3vSJLZI\r\n RD198n3r0Tw+8ceyFG4Gefrk18n6Z4mfd1/wA8+1et6F4jKQRyMeTn+vtWVagrHo5ZmKjVbk+h\r\n 9cWs8UMAMh3/AKVl38dpfM0qSeQxxxgtXjcXjTMe3d/n8qs2uufamLb8Z/z6Vz+wPe/taB694Z\r\n 8RLo18I2k84D/gPY+x9a+mdD8TQ36CRl8pOxzuz19hX57fbvLvgd/+cV7L4W8ZpI40lpMFO/1y\r\n fSufE0uWNxf2hGpoj6wT4h20V+LCCHzj/e3Fe2f7tdjLqXmncybSQOM5/pXz7pOgx2t0up793f\r\n 8AQj1r0htZEx8wdD/T8K4Q9ude9wGzWfd6gkcZiIzjvn/61c9/anvWFqN87O7DocVMx+05tCjr\r\n DpMSd239fSufBEUXLbh+VZ+pXsmT/n+lc5c6qYoipPT/AD6V3Yc8/EdTzH4mXUTow2fr/u18l3\r\n 94LOd5Fh3liOM4r6R8Y3f2ssD3/wDrV4NPp4fUXEgyMj+X1r1obHzOZ/w/mfqn+wjZzXNmb1h5\r\n YGPl695h1r9LbiQSyM44Bx+lfEf7FtjbW/hhjEOcD/0KWvtCAkwgnrz/ADr0sOfJ4kn7fjUEtT\r\n 9vxqCWvT+yeZ9ozJupp8P3BTJupp8P3BUFElFFFABVmP7tVqsx/doAfVSbqat1Um6mgDLm6ms8\r\n /wCsNaE3U1nn/WGgC/FWrFIVQDFZUVaMf3RQZ1diz5p9P1o80+n61DRQc5N5p9P1qq8vznj9ak\r\n qs/wB40AP80+n61EzAnNJVWSUK5FAFrIqJowxJzVfzh603zwWIoMa/wnJ6/Zl1OHx+H0968o1H\r\n NqzKW3EV7XqaCRT/AJ9K8O8Vo8dzLjoMfyFBykFhfo0m08V6FpWqLGyx43Y7569favnJNTlgnP\r\n PT/PpXcaJrhZ1yf88+1BtQ+I+nrW7EkY4q4FDjdnrXCaTf74gQa7C3nBhU59aDqLvlD1qu7bGK\r\n 9cUvnD1qJjuYmgB3mH0qQY2hicZqvVO4ufLIT0oA/9X9gKKKK7DjCiiigAooooAKsx/dqtVmP7\r\n tAD6KKKACrMf3arVZj+7QA+pFj3DOajqzH92gBnlH1/ShRtbFTVH/HQBoRVoD/AFYrPirQH+rF\r\n AFCbqayp+9as3U1lT96TSe4HMXnWktpdqBcZxS3nU1DB0FTyR7AbkU2P4a2YJj5YxxXPxVtQf6\r\n oVFSKS0NKcU3qW/Naqs0vJyKlqpN1NYm3JHsUZpeTx+tRg7owabN1NKn+qH40GdSKS0Kc9Q/wV\r\n NPUP8FBiUJupr53/AGh9KW88HG5BwYwe2c5dPevoibqa8q+Ldl9v8HXEOM4X/wBnX6VlWgpRtI\r\n 3oO0j8KbpRrurSoZPs3kn03ZyPw9K9g8D3flSJB97b/F0z17V4frsc2l+I7uNePmH/AKD+Nd/8\r\n P75isZc/Nzn/AMe9q8bE4en2PqMuk7n2j4Zv0hnVmOf8mvYRfpdsdp2Dj3r5X0q9m85Sh/zzXr\r\n Gm6lKrbGPP+favFrQjD3obn2OGquJ6nZaqkFyIiu73zj+len20yvaI4OM54/GvnG0uZJL4fX+l\r\n epWurmPFsTyv9efSuf2sj16M4y+I6yeQk9a5TVb2S0dnHzD06elXri8+Xdn/AD+VcTrmqII/mP\r\n P/AOqj6xUjrFndJQjG6MzWNYbyTIePbP0r578ZeKorSOS6PzMcfJnGMYHXFdB438WR2Fi53Y//\r\n AFj2NfAfjH4izXmtXNqj5QFcf98g/wB2uqnJz+I5KmOqQ+FnZav4nk8R3TQLF5PP3t2709h6V6\r\n l8NbWPTpkgkPmMuct0zncelfOOgajGkgmlP+efavWNH8VwW1y0iNjp/I+1dkKMIe9FanMs1rVH\r\n yVJXXyPqTV/EqacQw+YDtnHp7V5R4p8eCdpGVdmccbs+n+zXiXij4itNP5aP/nj/AGa8g17xVd\r\n yTyEN8px/Ie1aczODFZhUj8DO/1zxPJJMxDdf/AK3tXkPiDxFMbmRQCenf2HtXOza7K8h3H/P5\r\n Vg3l6Z7hsnk4/lVwSk7TPDrZlXlpWldHR6d4lkhl+eLd/wACx/SrfiDxldpbCSI7E7Jwccjviu\r\n H3+XzXJeIruaX5E6f/AKq1VCltY4qlarL+Gz2jQfGzX1r5UsWffd7n2qXWriaLTlu7c/fzhfTB\r\n AryrwvBcCDd/nvXoES3d5aLahSQuf1OaqEKcHeKFhsNi6smqjujgmutSuN0jOR/s8VnvE8486R\r\n 8Meoxn/Cug1MTacxjZcGuZeR5WL9M9q150OtgsRHYlhujZtn736V2+neIiLNB5eOv8Xv8ASuB+\r\n yySduTWxa28iQKvpmplJNWOWlHEwleT0O5TxQ6f8s8/j/wDWrWsPFrpJvb5FPbOf6V5x5MlaUu\r\n nM+mJKpwxz/P61nZHT7Wt3PR211J5fOW4wfTH/ANat2x1q5tpVv4n+93+nHpXznZ/aYLj96/Fe\r\n q2moRyaXHBGcsuf1NZVaUZRtJHZg8RVjNts+4fh344n1SJbeZs/5b2HpXvKT7Ixivzs+E2sXUe\r\n tpA5O3Pt/db2r7+tRJKQR0IFeXWowjsj3aOIlLdmib1wfu/rTWuvMUqV/HNNuAtumWrCbUohIc\r\n GufDQjOo4yPRhNJXRBqceMn/AD2rzvVlZi5DY6f0rsNT1OLb1/zxXnmqapGVbnp/9avSjSjHZH\r\n HiKp5frjBHO45/yK5P+zFvv3yybCT6Z6Vc8R3LO7bf89Kp6NMfs6qx5/8ArmuzDq8rM+ZzSq/Z\r\n 6dz9Z/2NRJZ6I0JbzBgc4x/FLX3BFGGiDDgHPH418Ufsdp5mkt9B/OWvuDbsTbXtYanE+SxFSR\r\n SdtnvULNuXPSpJqh/grvqQShocFKbc3coTdTT4fuCmTdTT4fuCuY6CSiiigAqzH92q1WY/u0AP\r\n qhcSbWIxV+su6/1jUETbSujPml56VnGX5ycVbnrPP3vxoMfaSNWGXPatBJfl6VlQVoJ92gTm3u\r\n WPNPp+tHmn0/WoaKCSbzT6frRs3jfnGe1Q0hl2rigBHbZWVM2ZCelSzTc1gXN5tmYZ9KANXPvT\r\n Q2192axftvvVhLjcoaqig5VLRmhNiUY6V5T4xs0UyvnPT+lekedXEeKF81ZPw/pXNWm47HHXio\r\n 7Hy1qNx5VwRt/Wr2kamUmB2/r9azPFA+zzM3+e1ctp2p4mAzXnvFVb7nLRqy53qfX3hvU/OiUF\r\n cfj9favTbK53IqY/HNfOnhbU/wB2vP8AnmvbNIufMiR/XNddGrKW7Or2s+52hTAzmkRz0xVdpv\r\n kqib9Ishj0rvVrXYe1kXrm8+zjO3P41yN9q6tMTsx+P/1qq6zrkcan5v8APHtXleoeIQbltp44\r\n /l9KXNEftZH/1v2AooorsOMKKKKACiiigAqzH92q1WY/u0APooooAKsx/dqtVmP7tAD6kWTaMY\r\n qOigCbzT6frQp3Nmoalj60AacVaA/1YrPirQH+rFAFCbqayp+9as3U1lT96AOYvOppttHuQHNO\r\n vOpp9r/q1/H+dAGlFFnHNa0I2xgVnQ9BWlH90VnV2NaW4+qE74crir9Zs/8ArWrnNyq6b6YTsX\r\n b1xU9V5epoM6uxnzS+1RebhOlE3WoT92g5yrNLyeP1rjPG6bvDk5PPmDp6YYV1s3U1heJ4fP0F\r\n k9j/AOhConsbUfiPwx+JmhrZeJ7iTfuDsOMYx8q+9ZfhZFtLwKG3D6exr0v462n2PW5Xxjn+iV\r\n 4z4fvt10pz/nmvKxR9Pl259XaLPHEqzFd2O2cetd8mpRRxLqGP9Z/BnpjjrXjulXuLYc/5yfai\r\n +1149tuDwP8A9fpXhYrY+oc+WCZ9KeHdl84uR8uO3X1rpbiQJqD3Abg4+X8Mda8m8G64kdmGY/\r\n 5yfauvN+bs/aE6N/TiuA68PiDt5dXWSPZtx75/+tXnOv3JkmkiBxjHP4CrvnSVzuopJJPIfXH8\r\n qmZ6NTEe4fJvxl16WytJIlXd75x3X2r4Oe7kl1Brx+rkcfQYr7h+NenyPC5x/n5K+Hry3NtgHs\r\n TXdhzx8TiDuRePHZecpx7fjV3RdUmubcOflJz/ADPtXFfbc2JXPT/Gn6BqqQwCMnBGf5mvT+ye\r\n Hisa6aua9+JWvQTJn8PartzarLBhTufvXI3utR/bOv8AnH0rq7V5TAl9GNyvn9OKgzpYp1Nzj7\r\n jS5Y3LTfux69ayINPe4vpxG2Y49uGx97Ir6i8G+ALjx862/l4z/wDX/wBpf7tel6p+z1P4bAsh\r\n Hlj1PrnB/vn1qJz5Vc9GngHiPdifAjG8uFkWO3PyY/iHOaTTvD2p63BHIICgYnByD0J9x6V+k+\r\n h/s6G2tPtN1DxJ/Qn/AG67fQf2bb+5KvYQ/uTnb0989ZM9aj6wz0KGWeyfvHwV4c8BXsVuEcY/\r\n L3/2q9m8N+D9NsbLdeTAyJ1G09yfQ19Y658BPEWk225YSMf7vt/t+9Yvg/4F614jvJoJ1IJxnp\r\n 6H/bHpS+sM9alOlE+E/FPh2HWZpW09NxTsO/T1I9K85tvh/rN2v2jyTHnPy5Bxjjrur9ibH9mG\r\n Pwxay3dym44H9R/z0PrXIaL4Ctbu+ltkt/lXGOfY+9H1hnPia1M/K2DwVfrL5MiFT68f41HrGi\r\n y6MTEV8xl6jp1x7n1r9M9V+G1jDrAieMLz7+g/2q8s+IXw30y31a6dgMKE9f7q/wC1XRh6vNJo\r\n 8eq4VNIn5/yyzRQGZrbp23VzsfiSSaUwPF5Sjtuz/SvUfH15Zae7WdsAT+Pse9eXWvhm+1iOG4\r\n gQ7nJz07HHqPSusx9gQX1pd3Q3w5VT/Fwa1PCzyW920Er+YFxzjHUGvoO28DpZ+GC9wuJMf+zf\r\n WvnyO2ksdVlJGBkfyqZbHPiI+zjzHv3w9mQeIIyqYGfX/Zav0O0W6Ro0XZnjrn61+angm9S1vk\r\n uGPT/Aivu3wp4gjudJgut33g36Ej0rzMQXh8Qdt4nmKQEr/npXkaXsjysvpXU+IdejkjK5/wA8\r\n e1eUjV4ku5Fz0x/L6VyYP+K/Q9aOIdizqeryeb5O38c1ympBssTJ17YrO1PWovtuc/5wPasW+1\r\n cSXToDxx/L6V6hwYjEGDqlyEYgrn8fpU+lKJIVmBxuP3foawtZlwC3+e1b/giF9RltYByHLfpm\r\n ujDfGeFi6vNGx+xf7F+nbtAe4kfbgA4xn+KX3r7HZw6lhXzp+z7ocnhnwxHxjzF/kz+59a+hog\r\n RAAff+de7htzwMTsVJqh/gqaaof4K7q3wHDR+NlCbqafD9wUybqafD9wVyHUSUUUUAFSLJtGMV\r\n HRQBN5p9P1qhcHLE1ZqrP1NBnV2MuestnxIRitSesh/9caDnNKGX2q8svHSsuHoKvr0oAseafT\r\n 9alU5TdVSgybVxQBI8+3tms2e+wxG39aZNNWBeX6ROwY9KAL8t7ntj8a5XUL3ZcOdvp39qoXmu\r\n xx5wf8/lXIarr8YUyZ/zx7UAdcmpbzjb+talvqHSPb075rxyw8SRyS7d3+fyrq4dUDTEqeKuBU\r\n T0sygDdXH+IL1Ujclc9O/0px1P5Oted+KNY2rIufT+ntXHiOpxYk8Y8Y3a3EzADb+vpXmNvMYb\r\n raPmq34o1r9+wz/nj2rntJuPtMqv6n/GvJe5wUfjZ9K+DZjcKoPy/wCTXvmlXf2aNIsb9uec46\r\n 184+Fpfs6K3p/9evXLLWEWNST/AJ/Ku/DnUeqyawFT7n6//WriNU15kuJPk447+w9qw73xHGid\r\n f8/lXmmv+Kol8xt3p/T2rrxM+WnfzA1te8S5JG3H4/T2rg31Lzj5mcZ/z6V5pq3ihriUhW/z+V\r\n NtNRkeEEn1/nXD9YA//9f9gOajLkHGKkqFvvGr9pI4x3mH0p6nIzUFTJ92rpybeoDqKKK2AKkW\r\n TaMYqOigCbzT6frUituGaq1Zj+7QA+pFk2jGKjooAm80+n61IrbhmqtWY/u0APpVfaelJTO/40\r\n Aa0Mue1XxL8g4rLgq9/BQBXml9qyJ5uSMfrWjPWPP940AZNyu/2pbYbUApZ6WDoKANSHoKurJt\r\n GMVSh6CrNJpPcabWxN5p9P1qjKS0hNWKrP8AeNT7OJXtJDOaryd6sVXk71FSKS0E5t7mVN1qE/\r\n dqabrUJ+7WJJnzdTWdfLNc2htQmEOcPn8elaM3U1NNfomnxxKPmTdn8TTUU9zow1ubU/GH9ra0\r\n 1Hw7rRVLUzpIfv7guMCLtz618p6NdraOkjHJPb86/Y/9prwNaeJvCc2pJFmWMZ793jHqPSvw21\r\n S5udKvWt5htZG5H1rhxFKOp9BhaijsfYOjaiJLISAdun4mqJvPt9+0ZGzGOc57V5f4U8TqbAKz\r\n f5yfauii1IB/tanh/wCnHpXi1qMHuj3qVdzXLI9o0vWjagWYXOf4s/j0xXrOm69FYabDE6eYRu\r\n yc46n6V8xWepZxNmugTxI8qIoPHP8AnpWH1en2PUw3IfVllew3kPnY2e3X+lZE+pIbmaNY8hMY\r\n OeuR9K8403XJI7Ddn/OT7Vo6PqS3ELzOeW/+v7VyYulCME4rqd9VR5NDzH4lWQ1eymmA8vZjjr\r\n nJX6elfnV4znW0fleWJ49MYr9TtRs47/TbgY6gfzr82vi54VuYrxpol+Qnjp/s+9PDHkYmKPLY\r\n LwylLYL9/vn8a7KHwFqKJ9phmLq3IG0D+tcZpcPlX0KS9QT/ACr7x+HVlaahDBbypkYPr/tV31\r\n G1C6PPpZfDFT9nJeZ8G6t4Z1W2n82XIH0Ht717N4BvrL+y7WyvV+Zd+c57sx7V+g+r/AvStbsf\r\n MiQAke/qP9selfMviz4Calo17LJZKdi424x6D1c+tc/tJHoU8iUPhR9X/BCw0X93JauFb6H/AG\r\n /WvqLxBp2m3k9ukrjzFzuODz096/Nj4aarrfhK6VJ8gL9P9r2PrX1dZ/FSwN3bTX5+Yk569uOy\r\n 1MpOWjO6lg8bTd8M7P0X6n2DrujWMuhQwQr5fB+bk/xDtmu++HWiQafotrmUSY3/AMOP4mrzC/\r\n 8Aiv4Tk0OBcjOD/f8A7w/2a67wn410m70yGWCQBG3YHPYn1FRyo5cTh85e8/wX+R3PjK3t761M\r\n YwnvjPcVzngfRbXTE80ESSP1bGOm7tk+tR634j09ov8AWA/n7e1cCninw7auXnvxHJ3XYxx+IF\r\n HKjxKmEzlfDL8F/kev+J4JDZyRsokD47gdxXhOiW9hol9P51qHIxzvI6g/X1rI8TfFHw9DGUTU\r\n M4/2G9v9mvlrxH8apYtXurawfzIfk2v0zlRngpnrRyo6cPleZz/iO/yR1XxG8U6TH4i35EIB6c\r\n t/CvtXxL8ZviZdN4r1Gx0+28+ACLbKHC5+RCeCvrxWj4wbVvFF8bpXIyfb0H09K44+G52m8u4X\r\n e46n/Jq6cnB3ie3hMnqUZc9VbnzlH4W1PX9U+2TsQCfuYB7Y65HpX0v4H8GRWMUU0y7uvydMde\r\n +a77w34VhiwzR/55969f03w/DtDKuB6f5Na/WKnc+geXYf2fNy6/M8L8ZwF7Ty4k8tcdM57ivl\r\n LVtG36jIobaeOcew96+9vGmkRxwnj/PHvXyH4gijg1aYem3+Qq4VpydmfH5hCLlyPY5aw0mWBf\r\n kkyfp/9evorwbrEtj4etrSQbim/wCbOM5YnpivLdGijuGC9f8AJrsb/dp1kmzgc/z/ABpygpbn\r\n FGEY7HVX+rtcHb0FcNeXEkN5K6tuBx7dqqS3kn2Qz5/zmuf/ALVV7RZXPJz/ADp0MPTUrpG8Z9\r\n ytqUsrTebn8KpWl09xesH+U8fypFvo7h8df8/Ss6SZYL6XHGMfyrq9nE4sRURo6tLHIfJLY9/y\r\n r2z9n/w+de8VWOkLJtWNn/eYznKu3TI9PWvk7U9RmkvdqH/OBX6d/sSeB5NQ8jxHKmQM8/8Af5\r\n fX+ldWEpRc3oeFiqumh+rvg2xXyE0ML5Yt1H73ru3Zbp29OtdJFdCeESBdoORjOehplj5UELXc\r\n XVgB+XFRW8LW9uIn6jP6816kVy7HmybluRTS+1RiT5OlJN1qlLJsU06tWXLYhQSd0LK65NQLdB\r\n D5eM+9YF5qGw9ayTqfO4n/AD+Vc3tJFHoUciuOuKVnCtjrXnn9u7BjP+fyqwniFNvJ5/z7VrSn\r\n d+8RUlyq53PmCnBsjNcP/wAJDH6/5/KtCDW0aMHPX/PpW14mXtfM6nP+c1RnkwxGKyf7aT1/z+\r\n VV5dVjbJz/AJ/KjmiXCak7SLM0vtWLLORMw20ybU489f8AP5VAl1HId+etHNE05afY1oZzj7v6\r\n 1pxy5UEjFZEM0eKsGYZ+XpSbXQiqo291Gl5gqtM/U1W86oJpuKRzlK5u9h6ZrgNZume6kIOBx/\r\n IV015NzXB6tNieQ/T+VTJ2WhhiJuMbxOE1y/e3JIOf8ivMtb8TukBXZ09/ce1bnivUfL3DP+eK\r\n 8C17WvmePP8Anj2rgr4ipHZnF9ZqdztNG8TubrBT9fY+1eyabryuiuV6+/19q+L7bXzbz5z/AJ\r\n /KvTdI8W5t4zu9f5n2rnw+NqubUmH1qp3PqKTxGqJ9z9f/AK1ef+J9XWaF5gMbu2fTHtXm8/iz\r\n 5Pvf5/KuY1rxRusc7uuf5j2qMRipdzOVWUtzh/EeoebOw6fj9KueHLoQRxk/N1/ma8k1TXfMuT\r\n z/AJ/KtvRtZ2xJz6/1rjw1bnm1IKS94+udD1hHiC7Mfj9faux+3COESBvwr5q0fxH5YHzY/wAn\r\n 2rfu/GPlwbA3T/PpXpRq8ux0Hf6z4pMeVC/r9PavINc8WebM8IXHTv8AT2rhNd8afMfm/wA8e1\r\n eevq899dGZT8rY/QY9KK1eU48rYmz1ezmM8u7rXpWk2zTW4bp/+s15p4VhaYjf/nrX0X4f0YPZ\r\n KwHXP8z71VGlF7o6aNOMlqf/0P188w+lMJyc0lFBxhTlfAxim0CtaW4EnmH0o8w+lR0VuBJ5h9\r\n KkXkZ6VXphl2nGcUAXMe9SK+0YrO8/3o8/3oA0/Mo8yszz/ejz/egDT8ypFuNoxj9ayPP96PP9\r\n 6ANn7T7frThMDzisTz/erCTDaOaAN1LwJ/Dn8atrfAoPl/Wua84etWEm+UUAbDzh+2Ky7hxuNJ\r\n 51ULib5zQBFNJ7UkMuABis6afmrFqdyA0Ab0UuMcVdU7hmsyKtGP7ooAfUTRkknNS0UAQ+UfX9\r\n KpTDaxFadZ1x99v89qzq7AY83WqMk+0lNuce9XputZM3+saucBjtv9qW1CCR1dd27HtjFMqSFd\r\n r7z0q4Cc+XU5Txdp0d5pE2mvHuEoAznpgg9K/Bf9pv4dSeEfG2oMsm6AmMg7cfwR5/iPc1/Q9c\r\n xQ3CYavz7/bE+EaeI9An1KwjzNgEkezRDuw7CuLEdT0MPiD8Z7HWW09EiiHnb885xjH4V6fYay\r\n 0lvHp5j5jz8+euTnpivHNP0m50y8ltr4YaM98d8nsa7PTtSjDB8/5/KvHqnuYbEO57PFqBt7TZ\r\n t3H1zjv9Kk0TUvOlEDrt2fxZznOT0ri49Yjkj25/z+VJb6mLe5Lg9f8AD6Vie1h8QfQSeJ0jjF\r\n l5XX+Ld+PTFblrq6abZKQfM3/hjn8fWvEIppp4/PWpRrUrD7Mx5T+vNceO/hr1PYpVeZWPpjRr\r\n 2K5sHVmxvx/M18//ABR0WKSyW1Vd5Gf3nrkqema0tG8SSRkQbv8APPtXb3tpFq2l+ZIMsoP8/w\r\n D61Z4c5sSfnVrmjyWOsQqhzknt7D3r7n+ENh5lvawk/MM5b/vrtXzr4hsbeXWCcf6s/wAwK+m/\r\n gzdRSNAR7/8As1d1X4DoyCUY4mXN2/VH29oNjMIUi8zIx1x9a3r7wvHfRmCRQx/vev4Zq94cSK\r\n RUJ/z1rvnKwyEBcgVyn2HtqR8leJ/hlHbM00Qz7Y+n+1XnU/gI36xRkGN485brnP8AwIV9u6oY\r\n LhSrJ/niucXS7EL5rKMn6/40Hr5NWoe2fN2/U+a5/C9wtukW4kJn/PWtHT7jxHYAQWkJ8hfunc\r\n vfr1yetfQxsNPk+UgfrUyaMrL5cIG3t/kmg9bE1sN2PA77W9fkjxNlPxU15jqNtPeXsk8wLu2M\r\n nOOgHoa+pdZ8E3N2pKkDP09vevOLn4f3cEzHeDj6f/FUHnQqYaUrWPEZfDIu1w9oX/7aEf1oTw\r\n lZxwiEw+Sw6jJbH617P/Zd1YjHp9P8asLYWs0fm3JAkPX/ACKDOri8NTPDG8Iqwwk+z/gGf61o\r\n Wng23gt1lll81+cnbj+teqzWunR/xD9awpjGZ2iiOVGMflQeJjsxpV4qnDvcw7Syt4yFWPHvmu\r\n lt7TYu5RxTobLADYrY86G3sgr/AHhn+dBo/wCEeL+OtpiZWOP8rXxT44tvs99NdJJv3Y+XGOgA\r\n 619N/FDxAsG8Kf8APy+1fHOt6+l9cPEW5H/1vataW58Jj/4h0/hOZm/en8vzruNbv1urGOIpsI\r\n zznPce1eOaJrUdtL5Wev8A9f2rr9Y1ICxSQHg5/mK3OE0pbhBprQgZPr+Nea3TtFahA2cZ/nV9\r\n NX8y3K5/z+Vc1dXO+MrmtaW5jXnyxuLpk7ed8xpur6jJa3zER71fHOcdAPasEXn2d85xVHVNaM\r\n 0ZCDLJ/XHtW54uIxJ0ekWFzq+uQ2kMefNJ+bPTC5r99v2U/CS+CPhvZ2kx8+acPlsbduJZD6nP\r\n DV+Sn7J3hZvFviKKeePcEP8A7LJ7j0r96PD+kJpWnQ28S7VQcD6kn19668H8bPJlV5nY7qwszH\r\n ZLA0m7BznGO+a1r2ZZ5mlVdgOOM56DFZFnPkBavPyK9EkzJutZN2Rg84rWm61zeo797Y6cVnV2\r\n A5LUxljh/wBPpXKz3YhyhOcd62dS8zcf8+lcLqEM5dnXviucB9zqajPNZEmuBCQD0/z6Vy2ovc\r\n xsRXCX+oXEcrDPp/npUVJ8qucWOny00/M9bbxIF/8A1/8A1qni8bJEoiKZx33f/Y1833muXCHr\r\n /n8qwZPEtwrk7v8AP5Vl9YPK+sM+vI/GEb9Vx+P/ANari+KI2Qcfr/8AWr40/wCEvuE/i/z+VX\r\n 4PHEojAL9P8+lH1g1o4h3PrV9fR/8AP/1qs2/iJFAj25x3z/8AWr5G/wCE5k/v/wCfyre07xoW\r\n RSW5/wD1+1P6wdP1g+w7PVVlHp/n6VuRX4C4Az75r5e07xn8o+b/AD+Vd3p/i9HiXLc8/wCelb\r\n 4erzSaLhV5nY9wW53VWmujuKY6d64Wz8Rxvj5v8/lWkmrRyPnPX/PpXYakuo3DR87c/jXnGr6i\r\n 3mSHy/Tv9Pau8vbmN061wGqmMs5+lRPY5cX8B4H4yv3Jb5P1+ntXzR4k1OWGeRjHnOOM/T2r6Z\r\n 8Y+Xlv8+lfL3jKWJC+P89K8rEnmnEXOpERmY8Y7VPpfjQRQIvlZxn+L3P+zXnOt6g0ds20/wCc\r\n j2rzm112WMBSemf89K8zn5XcD6wXxaLlcbNv/As/0rP1bxEFstuM/j7j2rwez8QSYHzf5/KnX+\r\n uySoUz/n8q4cRiQNK41jzLg5GPx/8ArV02nauI4lG3OM85/wDrV4nLeSCTdmtyy1cpCoJ55/z0\r\n rmwdd+0bNaW59DWGvYA+X9f/AK1N1jxGsUBfGT6Z+ntXi0PiPZjn/P5Vk6hrc91Kyqfl4/z0r1\r\n PrDNzqLjWJdUmMars/HP8AT2rvfDtoRBFC3zEZ+b1ySa898M2TTSB2H+ea+gvDuj7ljbHr/X3r\r\n ajV5pWEz07whpB2q279Pr719P+GbErpsY69f5mvL/CGjDYvHb/H3r6I0SySGxRTwef5mvYobHZ\r\n h9j//R/Xiiiig4wqJpCpIxUtVn+8aak1sA/wA0+n61C10VbGzP40U3yt3NV7SQB9sP9z9ahaYs\r\n xbbjNTeTR5NaU5tvUCv5p9KPNPpVjyaPJrUCv5p9KPNPpVjyaPJoAr+afSpFO4ZqTyasJB8o4o\r\n Aq08OQMVZ8j2o8j2oAr+YalW4KjGP1p/ke1Hke1ADftJ9P1qvIxck9M1a8j2o8j2oAynty/wDF\r\n j8K0rODbEo3Z69ven+R7VYiXbxQBeiizjmrqjaMVXh6CrNABSE4GaWmt0oArvcbP4c1UkfzMv0\r\n zTpupqIfcrOrsaU0m9TOmrImz5jVrzdayZv9Y1c5r7OPYi5qQSYXbj8ajoppidKL3Qh3k53Vy/\r\n iLTYdUsp7G5G8TAD/dxg9utdTUFvCJbqTf0GP5VEoJ7lRgo7H4F/tO/DZvAHiSWe3l89Jz02bN\r\n uFj/2mz96vkdr5rKU2/wB7Z/F0znmv3C/aw+FieJtPl1GCPcYx/Mxj+8PSvxA8YaPPpF9KkgwV\r\n PP6e5rhxWHgoXijuwtR82ps6drEjuF2cfX/61dNLdbQj9/SuF0V1S185u3+JrRt7tr18p07V5/\r\n sT3cNUR9G+HtUhOm4ZMnHr7msC7nEF3JdgZD4+X0wMda4jTtUkgAgzWxcXO+LYetY16EXH3ke1\r\n Rq22N3TdYVrsSFdo9M+30r2KLxTBa6W77d3mjpnGMH6V8xK08T5Wuu89m0eN3f5jnI/4FWMaUY\r\n 7I0lOMtzn9Qhee+lmR87yOMdMCvYPhPeyaM0EDDzSpbnIXruPv614A2oTRznaM/wCfpXb+F11q\r\n e9S7hO2Nug+XsCK1SUlZmmFcITvE/W/wHfyX8KOE28dM59fpXu0bwG1USp8/Oefeviz4Tz6yYE\r\n Vn/wDQf9qvp2C6uUURzHLDqeP6VyVly7H02CjTqfEaN6kZY7U/WuG1S3laVyr+WvHGM+ld5E6v\r\n y1cd4suorWKQg8jH9K4oVZOdmz08ZTp4ekqlBWd7Hl2q+IhojFnbzMdunp7H1rip/jL5M7Io2A\r\n YwM5/9lrxL4l+KrhZXWNv8/L7V82ajrd66tMXILfT/AAr0qMFLc+bxOPr/AMx9uav8dpol4kx/\r\n kf7FeT6j8f8AVWvJBGm9OMNuUZ4/3K+Hte17UpWKrIf09vam6drFwthGsrZcZz+Z9q6qlCCjdI\r\n 82GYYhS0kfbI+ON5LzJD/4+P8A4ioovi3dX9w8Qh24x828Ht/u18VTa1dfwk/5/Cul0HWJkQOx\r\n 5PX9fauf2cSamKq1PiZ9Nr8Q72+1AWQXZk/e3A9s9Nte7eH42+zxtJL5jc5OMZ5NfDWm3cn20X\r\n P+emK+sfBmsmfTbdyeTu/Qn2rKtFRV0b5bGPtrvse8IU8vAFcbrTESS5k2gAcY+lbdpdb4653x\r\n YYYdPa5ZtrMP5ECrowUtz6mtUUaOh8RfFjX1S5e2689f++T6V8tXJZNQlnEm5WxgYx2r3T4l2g\r\n vLqSVG7/8AxNfPk7eTK0ZPIru+rwSvFH5pj8XL2r1LUcrx3AnDdO1ehXN+134fjmC4Izxn/a+l\r\n eW+cK7PRL6O5sHsieUH8yTR7HyOL63LuVPD9w+pRybh5ezHv1z/hUF3drBEXPJ9KbpF1HZPNH9\r\n P61weu6ozSSKp+X/8AV7V04ShFyfMjkxmKm4aMsXGsieQoE2++c/0rY0nyXZInXe85x1xjGa85\r\n sPMnmz619QfAr4Zah468WWkECFkiY7undXP94f3a9D6vT7HkyqSlufqp+xP8J4ND05dZupuXGQ\r\n mzHQyjruPrX6Wm1EkeB8nt1rx3wZ4Vj8M6VY2FouGQHdj6k9yfWvdpipclOmB/KqhSjF3ijJRS\r\n dzMgszC27fn8Kvk5GKSitCis9vv74/Csy5tVJIJrcrOufvms6uwHG3mirKT+8x+H/wBesG60JV\r\n j27s474/8Ar13U3U1QlKbSD1rnA8P1bw5vY4f9P/r15pqfhBpJnYS4Bx/D9Pevpe8to3bNc5e2\r\n ECqSetY1/hOfE04zjaR8d694XktskSbse2PT3rzm70uVAX/z/Ovr7WNNt7hiMf54rhrrwtFIxA\r\n HH+feuSyOL6pS7Hy6dOmmbH3fwz/Ws260y5gkYKdwHfH/16+i7zwxHbktt/wA/nVM+HYJoA5HJ\r\n /wA+tFkVHDU1sj5jnluITjbn8amtNaljwhTGPevZ9R8Hq5JVf8/nXneoeFJobtwq8DH8vrRZF+\r\n xh2NTT/ELKBlf1/wDrV3em667RK3TOe/8A9avI/wCzLiDjH+fzrZtZpLeFVPUZpqcoawInFQV4\r\n n0Bp3iEqBn+f/wBauqsPE2+bygvA75/+tXy5/wAJBJBxn/P5Vt6b4qKbXLdf8+ldFPFT+0zL2s\r\n j60l1JfK3Z/wA/lXHajqincMfr/wDWrzSLxj5ke3d/n8qwr/xP+8YFvT/PSniMU+T3HqY15ycb\r\n MreL77duP+e1fKfje9PnyL9P6e1ev+Jdd3g8/wCePavnHxdqPmTOfXH9K86VWUt2cpw+qv5lsx\r\n NeUsxWZsDvXpd0++0P+e9efSQneWrixTtG6Av2t1tHIpZb7MrDb6d6zN+ykD723eteZJc24Gpu\r\n EvbFVpSYyQKmiqG56mnRpxUtBOTjqhsQedsbsfrW/YQMJBEfmI71hWX369E0Ww85kkx1/wDr16\r\n lGlCW6Oug+bc9L8LaaMA5/T619EeFrE+XEp568/nXmnhXTPkXj/PNfRfhjT0jtYmYc8/zNerQw\r\n 1NO6R3+xhbY9e8L24gjUnn/Jr0mO+REAx+teXWt/HaRgZx/n6VUuvEwExUNwP8+ldsUlsVFKOx\r\n //0v14ooooOMKb5G87s4/CnVMn3aAK/wBmP979KkWHaMdamooAj8sUeWKkoFa0twI/LFHlipKK\r\n 3Aj8sVItuGGc0VZj+7QBB9mHr+lSLDtGM1NRQBF5dJsNTVOkW5QaAKWw+n6VIsG4Zzj8KueTVh\r\n IPlHFAGZ9n9/0p62hIzn9K0vI9qsJCNo4oAx/sZ9f0oFhk7t/6Vt+SPSomG1iKAKSW2z+L9KGG\r\n DirdVn+8aAGVC78lcVNVZ/vGgCB031Ukby8r1xV+s65++azq7GtLczppOelZkh3OTV6bqaoN94\r\n 1zm42iiigApYV+Zx0LY5+lJU0a4G6gDh/GGkQ32jTadN8xlA+fHTBB6Zr8Hv2oPhzP4W8T3ltE\r\n /nxAofM27eqxnpuPrX9AmpxC4XFfGn7RPwitvFGizXsceZ8An80H94dhUThzKwKfLqfhnPYxWG\r\n lhBPuZ/wDZxjBqLw6ZbE+Syeaq9HzjOcnpXYeJ/AWr2WoSwOpCRn29B71zMVw9uDYhfnTqfrzU\r\n ewPRw2INM6pbpegnj2/Cti71hY5BKqbg/bOOn4V5SbS5fUd0pwCf6Vu3dyIphbg5Cf15rjx1Pl\r\n p38z2aWIPb7Sxim037dvwcfdx7461y8Im1SZoxJ5EY6cbv8PSo9N1z/iX/AGfP+cn2qJrxbW0U\r\n rw5z/OvJNvrBY/0fSp9jL9q/Ep/jXUaZrNw14BbDyE4wnDY49cVwNostxJ58vSur04qboSp90/\r\n 0FXA2o4j3j7i+Fuo6mVTFxj/gI/wBqvr/SL1pLeGOc75Gzlunf0r4W+G+uw2qpuP8An5vavoqx\r\n 8ZxC7iRW4Gf5fSuOufUZdiHc9w1nUf7HeNAvm7899uOn19a4PxUGvY5XkfyVIGDjd6VV8TeII5\r\n 5oOc9f6e1YPxG1hR4aQWx/eYOf++l9q82n/EPdxtbmopeZ8U/EMsmovDEvnDP3unZa8O1uzkAf\r\n D7f9nGcdK+h7YxX8ri75c+teQ+LbdY9cubVOi7P1UGvYw58xiep8/wB1ayeacnP4VSLBJTEOo7\r\n V6zNoW75sf5/OvPLjSJY/EMwx8ny4/75rurfAeYviK4Yxjc0f61oWtyNqsqYHPeu3Ph0XdsBEv\r\n zf596yj4cns1COvK/wBfxrkLN7R7nzkCbMH1z9a988FapBBBDZSvho85P1JNfPemOto2G/z1ro\r\n 7S+aO9e4R8KcY/LFYYj4UdGGnyzufZdt4ltYNsYG/3yR/SuK+JV3NcaWZoZtgYcLjPQr3rxfSP\r\n Eqy3qxtJ/nB9q0vFviiNjJpu/Plgfrg+laYc9fE4j9yfM/im5uQkgZ934AeleKySOxLt1PWvU/\r\n FGoo0zRZ6//WryS/kEdw6jgcfyr2sPDmdj8vx+I/esY91sPTNaGh3rWt1LOfmEuPl6YwCOtctN\r\n NVi2ufLjDV1+wOP25tajcNaO86ndu7VwNzeSTlj5f45rS1PUfMUjP+ePasNbtkhCKM7u/wCNVG\r\n nyu5M6nMrHX+C7V9X1AWkS/Mf8Cf6V+5/7DXwpj8JxxeJdSP2lr3OIiuzy/L85PvBjnOc9K/Lz\r\n 9lb4Xap4h8TRajJCTBn2/uyD+8D1Ff0a+AfClpoPhKxa3QKQH9f759z61oZHoKaXHY3T3Xm+aJ\r\n MYTG3bgY696mhZ4owjfMRnmoLRJpjvfoK1DGrcigCv5x/u1aRS8YfpntTPJHpVgDbGBQBVd9lZ\r\n 8zbiT0q7PVCTvWdXYDNm6msS5Vt5IPFbc3U1SmizFurnA5aeUoea5fVJ2cMM4rc1F9jEVyGozZ\r\n iJFY1/hM6uxw1/di3clmz+lMt9UtnjDtwfSuN8RzTb2C/56V5jdaveWsh5OB9P8K5TnPbtREN2\r\n pCNj8KzIdKIiH7zPXt/9evMtN8XZbbI3+fyrtofE9uYgpb/P5UAab2ip1G6se60aO5Yy427vx/\r\n rVr+3baTnP+fyqxHqtuyjmgDhrvwujnh8fh/8AXriNU8PvFO8atwMc49vrXuf2m3ese9t7eVmf\r\n 1xWtKHMzGv8ACfLetWU1rkj5v09K41tZe1+QpyPf/wCtX0H4lsrbB4/zx718z+LIjDfTGP7o2/\r\n yFebjqvs9jlOlsfFuDgp/49/8AWpL/AMUDzGfZnp3/APrV4Dda5JayEZx/n6VXfxQWjyW5/wA+\r\n 1eVgsa6tVw8jKrsei6x4o80keV/499PavMdWn+3Mxzt/X0rDvNd3nOf8/lVJNQ8xd2etesYFmX\r\n 5YfK6+9Yh07cPv/pWrv30mMCuXF/ABxeoW/wBnyQ2fwqhBL8gOK2dZ6H/PpWDB/qx9a8+2lwNy\r\n GXPamzZdjx1pkFa0Ft5qhsdaqnuTMTTdPaVgd2Pw/wDr17P4X0tjHEufXnH1965nQNJ8wjj/AD\r\n z717d4e01IUjDDpn+vvXq4c68Mek+G9M8qNW3Z/D617Hp2yCyjYtzzx+Neb6fNHBGB0xVybWGU\r\n FEPAr2KJ6vQ62/1zZlQM/j/9auUl1d2kJ29ff/61cxeahI561WW6xEpPU5rck//T/Xiiiig4wp\r\n wbAxim0UASeYfSnqcjNQVMn3aAHUCigVrS3GFFFFbiCrMf3arVZj+7QA+iiigArSt9vlLn3/nW\r\n bU6S7VAoA0fkqdCNvFZXnVoQHdEDQBPn2qxHt2jNVqTzQvFAF35KoTY8xsU7zh61Ex3MTQA2qz\r\n /eNWarP940AMqF05LZqamt0oAou+ysu4myx4/WtGbqayJ/vGs6uxrS3KE0vJ4/Wqmd3NSzdTUK\r\n 9K5zcWiiigAqQSYTZio6KAGlcnmuY1zT1ktrl5B5iSBcJ0xjHeuppTCl1byxHtit8Ok5O5nVnG\r\n KvI/NH4k/CWzuLW71KKQKTg7dhPdR13V+Y3iLRx4e1V7l4/O80/d+7jAA9T61++3iHw3HfWNxb\r\n 464/mPevys+NfgAWepSIFxsP8wnvRXnGOx0YfEUj5C8VeH4jYrqMVx5RYfc257gdc140t3cx3r\r\n RMvmgY+fIGePSvYPiHLNbW6Wi8df8A2U15RCkyP5ZXkd68yrP2vuy1PWhVhJWidZYXSRANI+32\r\n xV/7ct9cmJDhBjB9eK5Ge2kdOuKZbzHT0GTz61h9Xp9i7s9JGuxxJ9hWDr/Hu/Hpiuk0yWW3t4\r\n o0TzSM/NnHUmvKYbnzB59dBofiwW120c33Fxj8j7Vz4mkoQvBGlKbTufU3h2SOC1FxJcbG/ubc\r\n 9z3ruvDPiCa+1MI3yKh+9nOcg9sCvk238SSXl6oifEf/ANb6V6zp3iW309cRMNy9/r+FebKm5b\r\n nt4TFzj8LPq3xB4nSDynB3lM8Zxnp7Vkan44W8s/Pmg+WTgJu6YIHXFfKNz47nub4I7/L/APW/\r\n 3a3L3xE7WibD8vP8/pRRwsOa7R68swquNmzumtWnuvt8Mmwf3MZ7Y615p4ulkj1mbUTHuWTbxn\r\n phQOtdhourh7bLH/OT7VF4hggv9LR0+/z/ADFdsaUY7I5pV+bczLKzgvdO+1eZtI/hxnvjrmvP\r\n /EFr9kgXUo4/MaTOVzjG0gda2NPu57RDA/T/APXXSpbwXulBZOcZ/nWkldWZneBn+Dbm2ktftM\r\n 33x/yz/EjrXQ6jaRarEb3b5Hmfwfexjjrx6V4rZTXen66IRnyc+392vVdQ1yCNmhQ8ADH4jPpU\r\n eziHNE831fTmtpCUfP4fT3rnHuZ0i2hsH1rrdSvo52PNcTqjhELjp/8AqqJ0YNaoyrVVBXic6u\r\n qXel3f2kSeZjtgDt/9en3ni+a6upL+RMGTHy7um0Y64rlbq68yQr/n+VYF9I6MyjoK68Ph6fY8\r\n 3EZnWty82nyINb1Q3Fz533fb8vauauLkXDmXGN3v6Vn6jNJuNVIZj5C59693C0acdbHzNblnLm\r\n kSzMM1KxRbNXDcnPGPesqabmqRlkxz92qrTS0ick6f8pKF85/nbbXXeHfDY8SanZ6Lat85Ygtj\r\n rxu6ZHp61zdpYTXp2wjJr7i/Ze+Fcv8Abmn+INRTKSs+Af8AZEi9m/pXnzrvZsycan2T9cv2Xv\r\n g/p/grwdbteIHkkU/OQVxh5OwY/wB6vtm0tki02KyjfckecNjGcnNcdpUUTaTZ2lsu1Ap6fXNd\r\n +bYWh8hTkLj9ea3ozjL4jSmp/aLMMqQ2/khMn+9mkhXEYB561XFWo/uCuqrCCjeJtJK2g/Aprd\r\n KdTW6VzEGfPVCTvV+eqEnes6uwGbN1NNJBtwv1/nTpupqi8235K5wOV1Ow81jh8fh9K4DV7WS3\r\n 3L94DHt6V6tMm85rDv7BJkII5rSnTjN2kZ1dj5z1G3WeQhhtrznxDpSsXRT6c/l717trukNGxK\r\n jH+R71wN/ZL5JL9e9Y1qMFsjnPlrUoZ9PlLKd3t0rPj8Tzo3lsmMe//wBavR/ElnHvb/PpXhev\r\n q1rcSOvQY/kK82pJrYzqyaV0el2/iY7ef5//AFq1ofFB4GM/j/8AWr5dk8USQyFd2Mf59KtQeM\r\n WQhS3P+fasvaSMPayPrm18Rbh0/X/61ax1wNFnH6//AFq+V7PxmcD5v8/lXSW3jDzEA3f5/KtK\r\n VacW7MmU3LRnfeI9X3AgL+v09q8I8Q36ytIpTnjnP0rqNT1rz1PP+fyryjWr7M0n4fyFefjPfT\r\n 5iDy7Xx+8Yg/54rhLid1JA6Cu31h97H/PpXG3EWcmvGpJUZ3p6CcU9znrjUnjP3c/j/wDWq9Ya\r\n kXjXKY696y7yHk1Bav5bBPSvYpVnJak+zielWUnmjnirM7eWTxmsTTZuBWrOdwzW1eCcNQ9nE5\r\n vUj5xI6VzYmML+TtzjvXSXn3jXPtHumJrk9nHYPZxNW2kLDpXYaYAY0B965mzh4rrLBdqr7ZrS\r\n lRhfYTpR7Hqnh9khAOM4/wDr16PY33zjCYH1ryDTbrYoruNO1FFC7j/n8q6opR2LilHY9aS5Yp\r\n 6U03qImGPNcaddjjTr/n8q5e/8QMZmKnjj/PStfrFSOzNvbTO+u9cSHOI9344/pVOPWXuVysG0\r\n D/az/SuJsriS/bHXNepaHpCtaAOOR1/M11Ua05bsXtZ9z//U/XLzT6frR5p9P1qGig4ybzT6fr\r\n R5p9P1qGigCbzT6frThcEDG39ar0UAWvtJ/u/rSfaT/d/Wq1ArWluBa+0n+7+tH2k/3f1qrRW4\r\n Fr7Sf7v61YjufkHy/rWbVmP7tAF37Sf7v609ZtwzjFUqYZdpxnFAGl5lOByM5rK8/wB6sJMNo5\r\n oAvfjWlBOEiC9awvOHrVhJvlFAG39pHp+tVJLj5zxVLzqrvMNxoA0vtFPF0AMY/Wsfzh60ecPW\r\n gDZ+1j0/Womn3EkD9ay/OHrVqM7kBoAs+afT9ahe5527f1oqs/3jQAjtv9qy7jhjWlWdc/fNZ1\r\n djWluZM3U1CvSppupqFelc5uLRRRQAUxmZRnGafTPNUMVfgCgCubpQcNxUsE6weZOTlJcY9scV\r\n h6rqukWi5mlCn8fb2ryLxB8a/DPhlpIbmZXSPGPvd8ein1pOfLqZ1MM665Yno14+wyeQnnF8cZ\r\n 2/zr4Y/aW0CLR7SPXLlwJLvOYMfc2GNfvAnOc56Vp+Kv2h7nxE7W3g5CZOxH4f34x6GvFdZ0L4\r\n ifE2RLPxBkCEknPl/wAWD/CV/uivPxGIOjD5RUPjT4n+EMW8OribdG2Tt29OVHXP9K4GCw0qa1\r\n WfzBubtg9uK+t/iHp8OmGLw5dR71XIJ/75btn+dfKfizwje2vie7t9LB+yL5ez8UBPU561y4Wr\r\n zTaPWhgJUVzSPPNfjWIHyJP0+lcNcSl7dUZvmGefxr0HXdHurSLM4Ofw9vevKbguZmUdBXeUdT\r\n p+oKYfII/4Fn/61PungMC2icSJnMnrnnpXGGWS356VmyarI1ywz6fy+lRUhzKxlWnyq56jYXzW\r\n sXlhst/ere0bVLkzGOR92O/A9a8ts7qSTHNbel35ivnRjyMfyNZfVjfD4hnpk175d0COv/1q7G\r\n LXfNtI7Yx4K5+bPXJz0xXjFzqebgc/5xW/b6lhFOf8/lUTpcquen9Y0Pb9M1fyovLxn8fr7Vv6\r\n frhkkNo65C98+vPpXhMOu7OM/wCfyrotM1nkzZ6//XrIX1g9J1KaFpdqjb71aW5W3sUQPnGf51\r\n 4xe+KM3m3P+cfSr7a87naDx/n2oD6wdfPcxSucR4b+9msC/aZHaQyZ/Csw6ssfzMf8/lWZqOux\r\n PGSD/n8qA+sCS6thsEZ/H/61VtSvVksBIBjOf51wt1ftJIdpou9RZdOVGPIz/OlI58TiPcOem1\r\n Ly7g/Jnn1qzLcLPF5u3bntmuOe6Lz5rbWb/Rl/H+dduHPBxGIMDUmXcaw/Mz8vQVev5cuRWWxG\r\n 3Nelz8sdDzfaNu49oA3O/wDSnn5oltlTLD+LPrz0pLS1luX2LzXtPgbwDLqM0UsyfKxP6Z/2q4\r\n a9dR3PWwVL2mjLnwm8IT390rTfKp9s/wB73r9PPhTpElh9gsIov3duXxJkfNu3Hp2rzLwJ8PbW\r\n wtUdUAP/AOv/AGq910mw1TTTHcW/EQzjp9O5rxp4m8rs+khlKcb2P1J8OfZrrw1DtHlyIDz97+\r\n I1atbttojmOcfx46/hXy54U+MdtoOmCLVP4Rz19T6KfWu30f8AaI8DaltsncI4zn/We5/55124\r\n fEHj47CqmfQB2sMwHzD6dKsQ7xGPNXY3dc5xXJ6VrWm6pGJtKnDZ6DB9/XFdEs0oUCc/P3/yK9\r\n eNXmVjwIzvJov5FDAFapecPWlM3y0zUjmA9azJSQSAKmmmqDzk289azq7AZszNn7tUHgZz5mcZ\r\n 7VoTTx1Rku41G3Nc4FVgU681jXUhEjHHHHFaM17Hk81g3d7HuPNdGH3ZnV2MDVCtxkFMfjXmOs\r\n 6Szu+18Djt9PevQ7y9jz1rDubmB0OetZYjqc58ueK9MlhZiGz+H0968E8R27SpIhGDxz+VfXvi\r\n tLd8n/PavnDxLBEJpcDjj+QrxqplW+E+Q9dtZLSYvnd7dPSuLN/IbgjG2vYPFUEe9v8APpXieq\r\n EQ3LsOnH8qxOQ66zvGx1ro7fVJLeMNjd7ZxXk1lqmW25rubKXzoVHrmrgB2UWuvc/IYtv/AALP\r\n 9KxNVBeV2z6fyFSQx+WM1Wu23sxrjxHUDg9SJDEYrEZd8e48V195a+YTXN3UflMU9K8efxAcle\r\n R8nmsdrfa3m7vwxW5edTWZJ9yvRw4GlYXhUhdtdKk/mKFxiuNsvvVvxy7X2+ld9X4AFvIcZbNZ\r\n kdsGO7d19v8A69XL6f5OtZtvNk4rkA6C3GwcDNa0FyVwNv6//WqhZpvFawg281rS3A17a/x/D+\r\n ta8WpFPm/SuS37KxrjUXW4aMHgY/l9K3A9Jl1hnGKhS6eUAYz71wsN1JIK63TpVFshfrz/ADqZ\r\n geq+FUCMCwz/AJNe9aXGv2cTA43/AMPpg1876Bfxxkc/55r2bSdS3Wq4PH/1zXXhwP/V/XLyj6\r\n /pR5R9f0qaig4yHyj6/pR5R9f0qaigCHyj6/pUDZVivpV2mGLcc4zQBU3Gk3Grfke1Hke1a0tw\r\n Ku40bjVryPajyPatwKu41IsxUYxU3ke1Hke1RUk0tAI/PP8Ad/WoGYsxbHWrfke1Hke1Y+0kBT\r\n 5qzGpKA5p/ke1PC7RitKcm3qAzYfWpFJUYoorUB241RlnKyEY6VcrNn/1rVE20roB32g+n60gu\r\n CTjH61BSL96sfaSA0UJetGJykYXris2HoKvKMgUnOb2NaSTfvFnzT6frUTEnLUzbTsfLS5qnc3\r\n 5afYrPcFP4c/jVeQpIN5baT2omqBhEse52waTc3uyJuMVeJRn254NRBPkDDnNZ15qdjATukAx9\r\n a43VfH+naaGhVwSn17/8B96nlkZe18zt5biSPpHn8aBewCMNMwRu69cfjXyz4i+Ocdi7LEc/5H\r\n +xXk0vxm1PV9TcwkhGxjp6f7g9K1owbl7xMqrtoz7vl16wiOGcfr/hXG+IfG1taRS+VHuCgfNu\r\n xnp2xXztbatqeoRh2cjP0/8ArVyfjjxBcaRpDiRuSOv4j2PrXfXoU40+ZLUMHVlUqcs9jxX4yf\r\n GjV5L17LTYzuz2ceinuleT+C/AfjDx5frq2r3bJb3B/wBVsU42gr94MD1HpW14E8IXvjHxaL26\r\n XdAW5zj+6w7EelfoVp+l6V4dto7C1iH7ods/xc+/rXwWMzCvGbipafI/TsBlOEVNVOXX1Z534b\r\n +FuieEbJbmBd0oHU7vU+rH1rYvrua4gPkYhkb7z4Bzjpx9K7C4llvBsxgViS2GwmMDpXBLG1pb\r\n s9OODox2ieJav4T02/DNqEfnzH/lpkrjp2BrhYPhPZX08imXZjHO0nqP96vpKbSfM7f5/Orljo\r\n 6Qxs5HJH+e9a4TEzjNu5hjcNTlTs0flT8Z/Bkem3LWccmR/e2+yHpmvlC78HfZJWZ7jcPXZj+t\r\n fqH8avBzXdy06rn/APUnvXyl4k8AXDaALyNOWz+jAf3q92jXctzwK2FhHZHxPr7Q2gKod5/L0r\r\n jJWCLFcD5mlzlf7uOOvfNdb4h0m7tr50uBwD7eg96zdDtoZNcEc3+rXp/3ya71a10eFj4NQVu5\r\n 1FlaJbWiTzvtLZ+XHv61jy3Zt9YmKjIO3Hb+GpfHt15WoRwWxwi+nuFrKmyZDO3fH8qTva550a\r\n lWOzN6WYyOJs4x2rRj1XZAp2evf3+lcX9u/hzUj3eIQKcYqekjop4ms3aTOsTWTI2NmPx/+tXZ\r\n 6VqYNsIzwRn+Z9q8Vt7z5617XVnjuHjU8DH8vpV/V6fY29vPudPqF75d/ndu5/pXWaVqi3D+UV\r\n xjvmvEr3UJHvOv+cfSuu0a6kRy/wDnvS+r0+we3n3O01zVBAfLXn3/ACrmnvHeINu61zGt6jJL\r\n dbc/5wKYl6RGIj1FP6vT7B7afc6ezlR3w5xUGszRjdGjcDH9K5KW5ni+Zay7i/mkzuPNbUcJRk\r\n 7SRhiK1Rx0Y4ytHJwN2K3rS7+0r5LDYR+Nc/ZOrv8APVh3KXsip7fyqqtOlH4UZU6XP8epHeqo\r\n nKBs++KreQTKYlOff8Ks29jcXtxsQZLV694b+Hd1dyh2QnP/ANf/AGq4p1raXO6ngadvhOR8I2\r\n Lm7WMpuz3/AANfcnw+0YLZW6CPGN3zfi3vXGeEPhc0V2jMn+cH/ar7J8MeE4LCyhRl5XP8z715\r\n WJqo9fB4WEPhRuaFYtBbqSc+2PrXYQC4dRiXEfZNoP60yK2VIwq1bgQoAp7V41Wp2PoqUp2sy3\r\n eWVrqNr9nlTBP8WT6+lfPvjf4Z6pYiTU9EuSWOCFCjtgfxNX0ZD0FNWC+a6Z3G62ONo49OffrU\r\n RxVWOzMq2Do1f4iufLvw2+NPjTwFqAi1pWaJD1JQdm9Eb+8K/RLwF+094T8SW0Md64gmbO4ku3\r\n c+kY9K+WfGngnRdfgKlArnv83t7j0r428Y+B9T8J6i76TIwRCMY9wPVj6172SYudSs41ndW/yP\r\n nc2yrD0aSqUI2d+78z98NN8V6bq7KNPkEqt/FyP5iuiuZJIQQi78e+K/HL4Q/FPxJY2i23mkyD\r\n p931b/AGTX0tpf7Q2sadMNO1MEtH948d+e0dfRVHD7J8zOMon3ELl5GxKmz8c1UupIUcgS/pXi\r\n 2hfF/StZjHmSBWP19/8AZHpXpNjcaZqcC3KSg78+vY4/pXJNu2pnCd3YdNc88HNZ07kjeXx7Yq\r\n bUhHbrujOf8iuLur6QgnNZGpPd6l5RI6/5+lYFzqm4F/8AP8q57Ub2TJ/z/SuclvpNpGaqM3HV\r\n GdXY0dQ1soT8ufx/+tXOXOtsULgde2f/AK1Zl5JI5NYU3mZK0pPm3OcxNe1iaUkCP9fp7V5JrS\r\n zTb3Ixnt+VewT2yyH5q5LVrKPLCvNx8OWmnHe4pRT0Z8l+J7OVnPP+eK8X1jTpHd03YP0+nvX1\r\n zr2kxyOeP88e9eP6xoAa5kIHHH8h715PPU7k+zj2Pm4wS2Em/O8flXd6DqweKMMmDzxn6+1aWp\r\n eH+ScVhR6XNbS5QfKK6sI5Sm1LsZVYJLQ9I+0LJF8oqg5J61DpxYgK1as0AC5FViacbHOYUuPS\r\n uR1THnu30/lXTXjiMmuK1G4zM4+leX7KDlsByeoXGwn5c1QWTzogcYzn3q7eR+YTVCMbfk9K2i\r\n lHYCWGUwnO3NbMLGVBP93d2+lVYbXzK0Fj8qPZ6Vo6jaszWlFN6lC6bzBt6VVgi2ty36VZm61A\r\n kbs+R0qDo9nHsddp8oQDPNbTXK7M7a5qzhkxXQLaSNAD61rS3GqUexj3V/tONv61gzTbpWnx17\r\n Vr3llJnp/n86w7hCi+Weorc5K6UdjTs9VRTgx/rXQR6irDCjbXAW9tPI/y10VtY3IAJpNHJTnJ\r\n yszvtP1V4SCBn8cf0r2Xw94jjXTY2kXBbPGenJ9q8Bs0ZB81SS6ndQStFGcKMY6f4VcZuOx0H/\r\n /W/XLzT6frUituGaq1Zj+7QcY+iiigAqRX2jGM1HRQBL5vtR5vtUVArWluBL5vtR5vtUVFbgS+\r\n b7VIpDDJqtTDLtOM4rOrsBe4o4qh5/vR5/vXOBf4qJo8nOaq+f70ef71rS3As+V70eV71W8/3o\r\n 8/3rcCz5XvVKa2y5bd19qk8/3qCWas6uwFV0Cd80xdmeWqGabmrEMURgWZ2wWz+hrnAvRbMfeq\r\n xmXPyR7l7HOK5yfVrG1OGkHH1/wrmtS+Kenabus1YEx/Xvz/AHfeujDQ5pWInPlVz05Qv8Z21V\r\n vr62sojIzggfhXzDrnxhbcfIP+eP8AYrx/xB478Tak0lxBIRA+No+XtgHqM9a7Pq5n9YPqbV/i\r\n no2nSFJQOPc//En1rzHW/i0l1LI1jFmI42nd9M9Vr5F1HUbm6kJvHOf8+lS2t1JHAscJOwZx/k\r\n 0fVzGtiPdPUtd8d6hcMSgK/iD6f7NeZaje6jfSNctcFd/8O0cY4604uz/eqCX7u2j6ucv1hnNS\r\n 6Y142JZCT9P/AK9dj4e0a0sUjyu8jPPI9feq9ja+Y1dja2uwKMdKmVLl1N6NXmbR29lMjxBI02\r\n e+c14l8aLhhZxWQHJzl/xQ9K9fs5PLFeSfFWL7SYD1yT/7LW2J/gndl38Y9K+DuiW2naCj7d8j\r\n j73THzP717bBbJCgEw81h1bpmuR+HWnCPw9A2Ox/9Cb3r0J4sjNfl+O/is/ZMD/ARk3EsR4SLb\r\n +OaymjLnce9bU0PNVxDxzXGdRnCIAdKJYtsYI79q0vJHpUsNt5r7PSmp8uonDm0PJ/GHgwarYt\r\n KZdp9Nue49x6V4FqfhZBoy6SU3FN3z+uWz0zX3DcQQyJ9nfvXG6n4QtwfN28H/63vXoYfEHnYj\r\n Do/Hz4n/AG/nSS9tbj32+WP9kdd9fGWv8AhXUfDUvlzKd8XVuBnOPc+tf0P6/oFj9gZWiB/P1H\r\n vXxB8avgzBrGiPq1nDh5R0H+yyju49K9zDVeZ2Pncww/ufM/InUjJqRE/wDEvb8v8KsvK0lqrF\r\n Np9M+9dZq3gTX9CvJN8J2A/wCz/ifWuXvbPUCpbyyB6cV2X6Hj/Vjmd7hzhelXeZYxuO3261B5\r\n c6NgqQam8uR/mIxmtae5nOlyq4xIAhyH/SnROVumPXOP5UvkyUnlmP5j1rYzHXEQEnn5z7V0Nh\r\n qIS3D+X1zxmuc8zzflqyreXGE9KAJLtxLP5p49qzpLoi6ZwvBxx+FE03NU3zw/rQxM7Q26PZ+f\r\n 7dPxrlJDBJyzbD6YzXV2cnmafj/PWuUkRFlKsuaOdx1RShzaCRpChyJf/Ha0bWF5Zt8Q8zd+FW\r\n 7LSBdAFEP6/wCNer+BPBt1PfxkxEx54/I+9efiMQrHo4XDnUfDT4eXOr3STSfux9M9m/2h6V9n\r\n 6F4Bh0wrubeR2249f9r3rd8D+G7fTLKN/LwQP6n3r1y1sY5oxNjG6vIniD14YfQ5jS9GhgcShe\r\n n/ANf3r0CGDzEDqdme3Wkito4xWggAXA6V5uIxJ6eHw4kSGPqd1SE5fNNoX71edCrzSaPQqUlG\r\n NzRh6CpvMuVbAk/d9lwP51DD0FX1i3KDitjnIG8lx88eT9TWXreh6VqWlsJLYGQj724+vpn2rd\r\n 8j2q9EI1iCSdK2oYn2MuYiph1WXKz4j/su78P+IfNhfEYP3cD+765PrXvhWw13So52i2TuDmTJ\r\n OcHHTgdBVX4g6HCI2u4Bz/8Asj1rnvCV439kQRyHkbs/99GvpMDinUPkM2wqppmFeaZq2kTGW1\r\n viR/d2D+pPrXonhL4matpcMNvcOXKZz0HUk/3T60+5hgnTLVw+oaL/AKS80ZwDjH5fWvcrwtTT\r\n PksPO9Vo+0fDfxGt9WiVLgbPfOfX/ZHpXYvNBc8xHKHoa+CtLvLqyYBXxivTdK+JM9kqWMjZ2d\r\n /rk/3a4TvPoPU7GMAt5mfwrkpoFALbs/hVnQ9et9ZUeY3X/wCv7D0rsV0W1uOEbI/H/Ggzq7Hn\r\n cdrHO2C+38M1QvNN2TtEh3AY+bGO31r1YeEVHzKf8/nU6eHUX5WGSP8APrQc54Bf6fLGMiuYu9\r\n GluIzOZMbu2M9Pxr6Q1Pw/HtPH+fzrg9Q02OFDHjp/X8a58TDmjYD5b1rSnRiC2fw+nvXnV9p+\r\n 6VkNfReu2ce8nH+ePevM7yyj+0Nx6fy+tcXsEB47c+GPtBz5m3/gOf61h3XhnygYs7sfxYxnv6\r\n 17r9ij9KiuNNgaLJHJrWlSUW2Y1/hPm9tKa0bO79KGfIMePxr0rV9MXcdo/wA8V5/qEBt2Yelc\r\n +JOU4XWItmWBz/kV57eqSWlJ69q77UpPNYrXEakuzcvpXmL4gOUku/m27f1pYIPtEm7O3NUpP9\r\n ZW/pUW4Kcf55qwNy2sPLTO7P4U+WwL/OGxntituKD930q3FaboxxQb0NzgZ9PYH736Vq6fpm+J\r\n cnk57f8A1667+yd/b/P51uaZo3yquP8APPvQdJk2OibgOf0/+vXTxaPtgC7unt7/AFrv9H8OeY\r\n o4/wA8+9dG/h3YNu3p/n1rWluVE+c9Ws/s3ON36elcPPprXMzThtm7+HGcY96+idf8P8EY/wA8\r\n e9ecNpOyUx46f59a3OHE9Tn9H0YAgE5/D/69dkulAnywvTv/AJNdNoGh+YRx/nn3r1Kw8H+aok\r\n 29f8+tBw0fjZ4HP4fkA3B8fh/9esSbTzE2xhuI79P619WXHgsbPu/5/OuK1DwftnI2/wCcfWg6\r\n j//X/WypFk2jGKjooOMm80+n60nnH0qKgUGlNJvUm80+n60eafT9ahooNuSPYm80+n60nmn0qK\r\n itaW5nUiktCbzT6frR5p9P1qGitzEm80+n61ny3DeayhP1q1UZCA5NZVk+XQ1pKN/eCMM/UYqb\r\n y0H3nwfTFQ/aI0qtJPCzly+M1zcsjflp9i0do6HP4VIsatGG38ntisz7fYR/fkGfoagm1vToRu\r\n EgwPr/AIVtRTvqc2KcYwvA0ZTMn3I9344pFeUqC6bT3Ga4q7+I2n2J27gcfX/4muG1X4t27SOY\r\n jgcf5+7XQcHtZ9z27zox984rKvNX0+3JV5huHUYNfK+rfFq4LHyz/nj/AGa8/vvGmo6lI1z5hG\r\n /6duPQVpTgpO0g9rPufWWoeNtOtmIyG/Ej+led6z8VfKkeC3gyq4wd/rj/AGa+ZbvU9QnbIcn8\r\n qyGvLvO1ySfwrb6vT7B7Wfc9M174gahcsTGpX8QfT/Zrh31C6vnN1NKQz9senFZBd5PvUASAfL\r\n 0qoUowd4omU3JWZsrMn/LT5qrXFzdMTHDLsi7LgH9aofvfetCKEmEO3U5rW7IsirHbwlt1wvmf\r\n jirSxW7NsiTYvYZzVOZ9hpltcZkouxSgnoy7PabRkN+lZckb+nFdMU3p0qwtnGbNWI55/nRdke\r\n xh2MvSlAPPH+TXa+QqQJOGzu7fQ4riVRkk+WuqSY/2fErdfm/nWVZ6G1GnGLbRsRQ5h80H8K8x\r\n 8c/6UbYN8vLe/pXrlkgksz/nvXlnjiMRLbn3b+a0Yn+CduX/AMY+l/BG1PD8EQHY8/8AAjXWTD\r\n y2MeM471xPgGTzdJgHsf5tXo13Bi4bj0/lX5piYp1nc/X8LJrDpow3i31TddjFcZxW/wCSPSs+\r\n eH96ay9lHsX7WRnfhWjZKE/ekZz2+lReTVqIbUAq4YenJ2aKVea2KUti8lx54kx7Yp90xn/cHj\r\n Her1RCLdITXRGhCOyIlUlLcwL60gNuYnTd7596881LRLe6gNk65jXp+Jz616zew/LWIlqjHmtP\r\n aSpq8DmqUIVFaaPkrxj8IND1SFk8sRs38WGPp/tCvkPxZ8AZLa7mjtR5kIxtfGM8DPBf1r9WtT\r\n 0iORSQP88e9cDqPhy5lVtqZiPTp/jR9drdzH6hQ/l/P/M/F3X/AISmwkYyHGP9n6f7Rry/VPAy\r\n QSNIJyBx8uz/AOvX7J674G0idib2Ln8fb0NeSa98JvDlyGlijwD0+97f7VdGFxlVyd2c2KwFHk\r\n 0j+Z+R9zYR2z7Cc49qx7mwlmBMSkqehr9GdV+C2jPKdsf/AKF7f7dc/wD8KRiD/uYv3fb/ADvr\r\n v+tS7nn/AFGl2Pz1TS7yJs7Cfyp0tpdHkxlfxr9F4fglF0eP/P8A33WRqXwWiWVsR8cf5+/Uzx\r\n soq4vqFPsfnzHpF1cNgAirzeHbplWIZyvfHr+NfcUHwjjjfAj/AM/99V0kXwjgSFZjHzz/AJ+9\r\n WDx8+4fUKXY+KNF8KapLF5SRk+/Hv716n4a+Ekt0I5LqAsxzls/XsGr6h0zwrb6cwHldP8+tet\r\n 6ClnHDHH5IBGfX3rGtjqjjozqwuAo87vE8d8L/AAh0iGJTPF9evv8A7VevaR4C0nTyrQKAB0HP\r\n +NeixW0MkeVGKljt9nyjoK4pYict2enHCUY7Iks44YYhGI+B71qxSBVCKuAKhhh4q8kPNctaTS\r\n ujZU4roKqM/fFWVUou3rVmGDipjDzXFJc25pF8uxR59KmRMnJqfyasRw9KmNOMXdI3hNz92Ww6\r\n GPpWhHJsGzbnHenQw1MIfnqzT2UOw9Pn7YqG/s5ZIVZG2/h9K04YeK3YrZJLdFPXn+dXTpxm7S\r\n BrkV4nhPixZINObzF3/p3FeWaBN5kKALs5PGc9zX0b8QNPjj0p2x2/qtfOWiALgDpk/wBa+oyy\r\n hCOyPjM7m5J3OxmRliyG/SsqQSSxD5sfhWzc/wCprJH+rFfUTpxdNJnwdNctVtGK9rIjZ83P4U\r\n ioC+T97+9V6eiGLcA3rXP7Cn2Or2kjpNGu7qzwY5CPw+tenaN47ubZ1gkj3lf4t2M5z7V5HC/l\r\n iozdulyzD2/lWdSjBLRCc29z7P0TxQl/EA/7vPvn19q7SGW3MYbzA2favi7TfEF1ABtP8v8ACv\r\n QdL8ZTBFjduRn+vtWPs4knuGr3qop2rn8fpXkmtXu6SRtuOnGfpWg3iATplz/n8q4fWb9XmkKn\r\n jj+lc2KjaF4gefa9encfl/X6V53dT5cydz2rr9Yfex/z6VxRt3luWA6cfyrhvMBbcyTnAGPxou\r\n 7eRGZM9K6zTtOWMAsP8/nVTVRGsz/h/IVUXLqY1/hPNry3yfmNeZ+IrP8AeybT6f0r1TUrmNGN\r\n ea6xdRyTP36f0rjxJynjd3ayJIe9c5qOnvMWbdtz2x/9evXFso53zWLqmlBZnAHHH9PeuKhFSm\r\n 7mVaUlH3TwK7054XJ3Z/D/AOvWlo8xDLCV6d8/Wuq1LTPmPH+eKx7azMEu6lWXLsVR5pbnotlp\r\n wuIgfM2/h/8AXrbttHKqF3598f8A16x9InyAv+e9ek6ZGjRrnvmvNlXmna57uX4aEpvmXQzbbR\r\n Cw+9+n/wBeus0zw8flbf8Ap9feum03T43A4/z+ddzpulxgLxXbRbludlfDU47Ij0TR9igdf8mu\r\n pk8PiVTLvxntj/69dZpGlx4HH+ea6STTB5Z2jj/PvXp0qUd7HFCEeZo+a/EWhBAfn/T6e9eL3+\r\n neTeuQcjj+VfV/iXTODx/nivDtX0zFy5x/nArX2cTlxFKJX8LopYAr/nmvozw9pkc9tHzgnPb3\r\n NeFeH7XZIP8APrX0l4Qi3QxA+/8AM1rSowb1Rw0KUedl+58OYjyDn8P/AK9cFqXhx2uCc4/D2+\r\n tfUMGnwyW43Csa98PQyyb1HB/z610fV6fY6/ZQ7H//0P1sooooOMKBRQKDWluFFFFBuFFFFa0t\r\n zOrsFORSxweB602qepX8dpZkk4Yf41uc5auZba2GXlH5VwuqeMNMs5njMgLLjjnvj2rxHxp46u\r\n YZGSNsf5HtXjk9zfaox1FpT+8+nbj+lXCHM7ETnyq59Hal8TobdiIrbzP+B4/9lrg7/wCKNxNM\r\n 2228sHHG/P8A7LXis95NAcM2aoNdySnzB3rX6uZfWD1S68b31wcqdn4g/wBK5u78XanvZfMJH4\r\n f4Vx3nSUjEsuT1qalLlVyJ1eZWLl3r13MTvJP5f4VQ+2yOu9u/vVGbqaVP9UPxrEyJJL2Nfvxb\r\n v+Bf/Wqg94zSExptU9BnOKSeoPNRU2nrW1D4gNGO5z96rIMcnb8a5eWdui1o2UzeUu7rzXUBtC\r\n zEnR8fhUpgWBMH5sd+lRQzcVZlbdHmgCuhR2xtx+NaTAR24wM1lQffrcVPMjC0ActKhuHx939a\r\n r+SbWQnO7H4V0U1p5fzVhXX3moA1bXU/M+Qx/rW6sm6ADp1rjbL79bL3Xlts9KALTSLE2Su79K\r\n 1oj9rt0I+Trx171zu/zOa2LSTZEq/WsquxpT3Z2dldCCDytuffNeZ+PZDKI41XHlk8+udtdnDN\r\n WD4hs/tUYfrn/wCtTxP8E6su/jHtPwtf7TpUb/dKduvdq9Zml86QybcZxx9K8Y+FUuyMW3+f4j\r\n Xuc9tslK/Svzav/HZ+vYf/AHZGd+FUbj5WLYra8mqV1DwagDHjl8w424q15dNghO+rUg2uRWtL\r\n cCDyz605F2HNOorcCOePzhjpWDLC0MpGc4roqz7iPc5NZ1dgOfuXLjbjFZj+ds2b8L6Yrdmh5r\r\n HnG1iK5wObutMspyTPHvP1I/rXN3nh/TZCyrFtHpkn+tdnN1NUXi3ZPrVRny6kyhzKx5tL4S0s\r\n MS0YP5/41i3mhWsMjJFGAoxjn/69eoTQe1Qtp6SR7yOTV/WGR9XR4pc2CRniP9awrmxSUlTHiv\r\n ZrzTIs9Kw5dLjBJx/n86yrYh2D6ujyEeH4yd3T8P8A69WDoyFPLLYA9v8A69egzW0acYrIlhBc\r\n 4HFc/wBYD6ujko9AtEOXAb8x/Wr0ek2qtvSPHtk1t+R7VowWm6IGrhV5nYqNLldzAa24wny1LD\r\n ZEKCWyfpW/9i/zij7Pt4rUszEh2VOpwcYq55NIIPmrGv8ACBPC3HSrQUNzilhh4q8sIx0rlAo7\r\n B6fpViNelWPJHpViODpQbUPiHwpV6O13/NnGfanww8VrQQfKOKDqIYbLj736Vc8pocEc/pWhDD\r\n xVtbXzOMdK3ofEZ1fhPL/iIRLo787Tj+q18yaPEYYVkJzknj8a+gviNdeXE1v+n/fNeE2qbIVX\r\n 0z/OvqcuPis42ZryXvmJs2Y/Gs17loxt2ZA75p4p7+X5Qz15r6WXwI+Gj/FZHCgujgnZ+taYtR\r\n CPKDbsd8YrHt92/wCWt1N235utZGxCYSf4qgMIVy2c1frLmlxOy/Ss6uwGrDerBx5e78a1baXz\r\n iLgHZu/h64xxWDCnmCpt7xPsHAFc4Hcx3LFcbsVFPEZFLF859q5yGaTFa8c5MIB681M4cysBzt\r\n /Z5JG79Kr6fpwaXn863Zk3mtXTbZEjV2681n7AChdWTQRZU5/CvOdVW5edwE445yK9rnWORNtc\r\n PqkYildFXOMVlXpcsbmNf4T5812G4TJ/z2ry29ZjcMrNg8fyr23xV52DtT/PFeJXNhczXjyEYz\r\n j+VeNidjlNPSrIyMCG/T61e1LSjvY7snjtW/4b0xsjcP8APNdlcaIJpWGPT/PWuTDfG/QahzaH\r\n zdqGlsWPb/P1rj72zNuxxzj2r6T1nw35YLY/zx715PrelbdzY/zx71OI6no4fDnH6NORIBj/AD\r\n zXrelnciHOK8etv3E1eiaRe/Kgz/nmvHl8R72Fpcp7bpEhCjv/AJNel6TH5yqc4z2/OvKtBk3q\r\n D/nvXs2gQ7oozj1/rXo4cjEnf6dEYUBzmustv30A4x1/nWNaw/uxxXS6dDmNRj1r16Wx50PjZ5\r\n 34mscKWz/nivBNXizdSJj05/AV9WeIdP3xHj/PHvXh+qaNm5dsen8vrWpzYjqcNpFkVfdn/PNe\r\n /wDg+L9zEPr/ADNeY2On7G/z/jXrPhZPLCL6f/XrehucND42e0QW7GAYfH4VPHEVQKTnHenW3+\r\n oX8avQxBowfrXSdZ//0f1s5o5oooJ5I9g5pOaWirppN6kyXKroOaOaKK29nEz9pIOajd2Tnbwe\r\n 9SVT1XUILWyUMcMM5/OtqNOPMc2KrTULonuporW2NwzZx2x714f4o8ZLNJLBHFgcc7vp7VJ4o8\r\n TyG0dY2/zke1fPrapNcXLBzkk/57V0+yh2OD6zU7lXXka+lLE4z+PpXEzy3FnmBH+Ve2PWvRbg\r\n KE3NXDalGHnaQdDiqjBRd0ONWU9JGKskty2GGavCMxoFx0qSzeFHw1WLmeIzMF6cfyq7sqyMqS\r\n 5Kf8s8/jUsckcsYZ22E9sZq1sjeq76cHYsDgGpklJWYWIHghc/63/x01E0WxdqHcB36VZ/sz/a\r\n /SrEcaRKIj1FR7KHYZzc5f8Au1iyxSNMxzjOOK9B+zRuc1j3ViBOxA44qowitUBiQWm4fM36VZ\r\n 8ry2wDVvZsqFjkk1QD0lKe9SnUG2+V5ecd81VpjyxqNp60AaENyobJrdtbxeCFyPrXBSzt0WtC\r\n xuyqKGPNAHoTRLeLjOz9axL3QymWEuf+A/8A16ltL3jr/n8q3VlSWIZ60AcTbWjRycmob4GOdm\r\n z6cfhXWzRxx/NXI6jIJLh1X2/lQA+0ulc7W4rahmQyeWpyB3rh5o5o+VrT0hpmdWb/AD1o5U9z\r\n rwcYuT5ux6RFA23cDSyfvoZIWG3ygOfXPNaGn7fKG6q+o4h3OvST+lc2Jm7cvQKdRQre6bvwk1\r\n H7XqrQlPL2Ed85yGr6juiJJ2cDrj+VfHHgq5/sjWVOcbz/ACB+vrX2NZ/6RbJN/eFfJ47C0o++\r\n lqfpGXYypOmot6EGz2qjcjJK4re8mqFxD85rzfZxPQ9pI5wN5LZxmnEGYmT7ue1WpoOahVdoxT\r\n UUtg9pIj8o+v6UeUfX9Kmoqh+0kQ+UfX9KryRdavVXk70mk9xe0kY0yDP1rCurfMjHP6V0M3Wq\r\n MkW7JqfZxD2kjlZrY56/pVUoFXaTmuhmh5rBuoH8xscVzYqNoXidOFleXvGXMFz1qJpFWIClmg\r\n krKuVkUEV5/wC87nfaBRvJUyaw5p1IOKfeebk1gyF9xrSnBydp7GVXlS90gul3nIbH4VRaIxxB\r\n /vVpfZZZK0otPL26qRzz/P61t7Cn2OfmZzFoGun2bdv6108Vn5KCPOcd8VbstI8ts4rSmg2yEe\r\n lXGlGLvFCbb3Mb7OKqyW/zmt/yarSQ/MasRjfZ6BbkHOa1vJo8mlKKejAooNnbNXEOVBxTvJqz\r\n HD8oqPZQ7AVvwq5CpZQQMUeTWhbw/IKPZQ7FRk1qiWFOOla8CHaKhhh4rXgh+UUeyh2K9rIkhT\r\n jpVqObyC+VzjHfFTww8Vna5cJY2hduM/4iurCUISnsNVdHznzJ8SNRebUGUR4GfX2WvOd22MNj\r\n 8K9A8UPHeztL1/yK4CfGzivpcJQ5dj86z3GS9o4xehHHPvONuPxpkquzkA8VDB9+thNnGete5T\r\n i2rSPBjDTmG2aGI5I3fpWk8pYlwuM9qkh8umSyxBynpWvsodiihJeOh/1efxqmENzKZj8u7t1r\r\n Y2RvUDxrGxK9KxrUo8uxnVk0roYbv7Eudm/8cVYt7sXSLcFNu7tnOMcVX8n7RxViOH7OBF/drm\r\n 9nE5/ayNeFh6VbXk8cVRgq+vAzTUEtg9rPuXI7cP8AxfpVnd5I8oHOKy/tXl96PtG/5qdkHtZ9\r\n zTEzA9anEEM6b3XJPvWL51aME/7oc+tTOnGatJClOT0Zlah4XtL/ACCwXPsT/WvOdV+HRjneaF\r\n 9ycY+X2H+1XsHn+9XodVtjGLSQZI6n68+lc0sBQlvH8yDwGy0V7F8N29v/AK9dXaWkTtvZuvtX\r\n q/8Awj1le/PwM/X/ABqB/CkCMQh4/wA+9cWKy+jThzUlZ/M6cKlzanifiS3txEcNz9PpXz94hU\r\n FnQD5RjDflX2JrHglrsEIf88e9fPPjrwdf2PnRQoSFxzx3x714GIoyPdwygfMN7E8UpaP5/bpX\r\n RaF5siozrsJzx19azFtb21vCLlCAPp6V6Jo1mtyUlUYDf0yK5MNhVKo1NHrR5Ej1LwxbMyLz/n\r\n mvd/D9sVhjGfX+teeeFtM+ReP8817Xo1jtCDH+ea9OOEhHZHFiXE6q1hPliuh0xDuCHt/9enWl\r\n l+6HFa1pa+WQ9d+FopyakjyJzs7xIdV04SQ/e/T6V5HqumgTOM9MdvYV7lOvmptrh9T03MrHHX\r\n H9K7/q9PsYSfNueVQab8/3v0rttDszFIvOf8mp7fTPn6V02n2G2UDFONGC1SM404xd0dxYw+ZC\r\n BnFbMNuEjC5zjviqdpH5cYFakXKCq9nEs//S/WyiiigAooorWluZ1dgqFZWMxjK4A71NUV5Klt\r\n aeeevP863Ocqajfx6em4/N7dK8U8TeKWvLqSJE2KMY+bPYe1ReKfFDM7Rq3+ePavMJ9QaVi7Hk\r\n 1tQ+I5cX8Bo3d150Zjbv3rkrfSg95IwfgY7e31qea996k069QSSE+38jXUeaclq2qlbv7AI8f7\r\n WfYHpiq15ZGC3GW3e+MVymv6tHHrnXv/7KPaurvdQjl01Xz1B/nQa0tzhipaXHmbfwzSZZLkwl\r\n 92P4se1c/cXrfaDtNaFoskr+b60G52MEGFyZP0qhNLILho1fgY7e1NLyIlUVSSWYv60AX3eVBn\r\n zM/hWWNRc3JiIzjvn2+lXp4ZNlYPlmO4LmgDtIXfZuAzWh9iMtqtyxwW/hx0wcdaydOvoSArVv\r\n fb4mHkA8D/8AXQBycyMW24rJmkaKYxFc47/WvQfssb/N61zWp2Sm4dlHp/SgDHjZH6tis+a0Ml\r\n y22Tg47e1QXccyH5ansNxVd/XmgCY2flLktu/CqwOJODite4+5WM0Tliw6GgDdtZwoHNbdtdHd\r\n xyK4XfIlbmnTny1yeeaAOmu5C6ccVyG2X7cwxuHHP4VvTz/J1q1YRwyRLI33jmgCH7KkkfzcU2\r\n 1SOGby1Gcd6vXrrGny1g205N2R9P5VUTWlPluzv45iE+UVJMj3tsiH5fLzz1zk1HaJvjBxW+I0\r\n h09Sepz/ADrixO55n1j98cAL0jVosLt8snv1yK+1vBmoLqukW8gXZkN3z0J9vavjG6sG803Kj/\r\n PSvoT4Xa+q6db2jt8y7s/iWPpXzuYfD8z9LyKrzK3ke2zSLDL5eM+9QToGc46VBdbppQy96n2l\r\n eG615B9GUns9/wDFj8KyZ4PLlZM5xXR1mzxbpWbFAGT5Z9aibIOK1fI9qgeH5jQBQyfSq0hOSM\r\n Vq+TVaSH5jQBjvAX74qFoyvy1t+TVd4RuNAGG9rv71nzWoUkHnFdT5I9KgltN2SKmcOZWKjPl1\r\n OImtx6ViXVlvY49q76ay56VB9jTbz1rP2Bf1hnlNzpJY5zj8Kyz4e3PvMn6f/Xr1mayj9KyZbI\r\n eYcdKmVPlVy4VeZ2OFj0YJ/Fn8P/r1bTTgpzn9K6v7F/nFV5LcKxFZmhjrAF7Vn3EH7wtXS+SP\r\n SqFxD85oA5txt7VGIvM+fpmtKaHmiKH5BQBm/Z6kWz3DOf0rS8mrMcPyigDG+w+/6VKtrtGM1r\r\n +TR5NAGT9nq1CmwAYzVzyavwWm5FbHrQBDCvHSty2hzEH/AEpYbL2rUgg2qEx0oAZCijqcV5f8\r\n QL8HzLNONmPm+u09K9A1S4+yLnOMf/WrwvxTdSXl7M45B2/yFeplMOas15Hk5xiHRocy7/5nkl\r\n y0khaHrnvWDcWwgXymfJHfFddLGsT7mrjtXZnvZGX7vH8hX2OHw5+XYzFOpVKtvES/BzWlJZyD\r\n 95ux7Ypmmbd2HrpJvL8uvSnS5Y3PUlTtRTOfg8wnFOlsZGcyb8Z7YrRg8vfWkTHmsDmOZ3SwcE\r\n bv0qwrGdASNprd+yxyVA9sI2OOlY1/hMa/wkdnAIzuJzSXWWuWKjjj+VO37KniZH+ZuprlOUIQ\r\n 3pWosWYQScE0kPl0Sy7XIHQUAZFysgPAzUcDykbAnTvmtUzQ/wAVXbVrZjmgDHkWZBnbn8alhu\r\n ZFhB8v17+9dJcfZ9lZ7y2y24A7Z/nQBThuDKcFdtQyQMl20g5Bx/KoFmXf8tbsM0Pkru+9QA6O\r\n 7uNu1W2/rViK+uEARm3Ed+lZUsy5+WoVnOeauFH2j5RqfLqdlbakRyy5/GpLh9P1YG0ntQG7vu\r\n PPfpx6VzcM/FaNpJtm8z1rkxOAXY9DDYhniXxB+GdmFa4t5ME9tp/2f9qvHtK06TTmW2I3bCee\r\n nXJr7U1aKG/i2Nz/AJFeZ3Hg1TctMi8HGP8AOa86GDUZXPWjiHYb4QiMqqCu3/Jr3LTdMCosm/\r\n 8ADFcDoGkfZSBj/PPvXr+nQ/6On41v7A4cTiGaNu21Au2tSJdyAdKrww5FXUXadvpVQp8ruefT\r\n q80rEyWe48t+lZN/ZbpmXPpziujipJLXzHL461obnHR6bsbO7P4VrWtmARJnrWx9i9qnjt9vy4\r\n 6UAPjTcuOlX4YSIwM/pToYeKs7dvFAH//T/WyiiigAquZiJCgHSrFQiPdIxq6e5FTYa84QZbiv\r\n PfFPilIxJYCP7uPm3euD0xWn4m1L7DGTnH+R7V85a9q013eyzKcq2P0AHpXpUIRluebXqSjsUt\r\n Tkae4L5/CsdwCxUttqSB2d/nrD1id4LiTHQY/kK7Z0YRjzRR50q85+7Jl+S1VufN/Ss1IpIp5Q\r\n rbhx7dqyLfUJJH25/wA/lXWacqyod33qxJPnTxXbPFqvntJ36Y9hXT6bJLqOmoinaOeevc1znx\r\n LDW90xX/PC1e+HOpxT2cVrIfnG7P5saDWluYV+z6fclGXf+ldbo+oI9umY8de/uau+KdHVpPMU\r\n df8A63vXOWP7giL+7QbnbSyo6fdxS2isMER5Hrmsppv3dWrLV/LAtsdO/wBefSgio2loa9zPCi\r\n fOuK4zUbqMs3ljjsc//Wrr7iy+3JnOM/59q5e80d4sqOQO/wDk0GPtJHNQXkyyfKK6awmldxM3\r\n Ge1ZcFqsb/NW2iqq/LQHtJHc2cqSoFLbf1qtdWyGVgHz74rk/tU0f3TWtaXTPEpfqetAe0kLLp\r\n qP3/Sst9O8qY7W4HtXWwpvFNms8sWxQHtJHMNaeau3dj8KkgsFKiEtyM84q/MmyoBJsG6gPaSK\r\n 9zoSBdwl/wDHf/r1hSlrBioXeF/Cun+1+b8tVpreOYYPJoLpybepzY1fzzsMW33zn+laNtdNGA\r\n F5FZ93pzREsop1qCI1Ddf/AK9BsbzzGcY6VThtil0X3en8qmiqwy7RvouB19jeeXGF25/GtW4u\r\n jNaKMbevv3rk9Lk8xtv+e9bE8myUwf3cfrUSpxluY/V6d+a2pchukeI27J1/izUvhrU5NG1swA\r\n eYoIxzjqpP9ayN3l801WMc63394/y4rzMwwtN01ZdT6LJcbOnVtfSx9yaIY72wW8JwQPu/iR1q\r\n y8f2hvNHy7u3XGK868Ba59q09Yc5/wD1t7V6VCMIPxr5ytQUdkfpGGcJ0+ZkH2Q/3v0/+vVKWI\r\n pIV649q2c1Vki3OTXCua+pxxlL2ri9jM2H0/So3gz81ank0rQ/LVnQYDjb2quRuOcYrWmh5quI\r\n eOaAKGwen6VE0G45rV8kelHkj0oAyPs9IYwPlPatjyR6VXeD5jxTTtsJq+5ivah++KzJ7Uh2Ab\r\n 9K6ryPaoJLPcScU+Zi5UcLNbN/e/SqhgwcHmuwmsvaqLWXzHj/AD+dTL3lZm1FJPQ5zyR6VXk0\r\n /eTJuxntiup+xe1QS2+35aj2cToOSez2d8/hWfNa5JOa6qaHmoPsm5N2KipFJXQHETWnJ5/Sq4\r\n iKDbjOK6+ay56VQay5rEDA2H0q9DBujBq/9i/zirMdvtQCg1pRTepmfZ6Ps9a3k0eTQdHs49jJ\r\n +z1qW0e2JR6Zp3k1oQQjyhXPiZyjFOJlVglHQak2z+GriOuzzSOvaovJHpVW+m+zwH2rpwUXUf\r\n vnDOpynE+LdSG1lC/r9K8M1DXEido2i3Ed93/1q7vxHqJkcrn/ADx7V4Rrcr/2hKB04/kK+wyv\r\n CU4zckuh8txNib4ZJPr+jLtzcG/bCLsz75rMvLEww7mO49+MVNps67sNV3U7mJ8xDt/9avfj7u\r\n x+f8kb8xxVvcES7cYroyd0Q+fr7VzUkDCQstaMfm+Qv41pKrKSszreKqOPI3oadrbb3/1mPwrd\r\n OlhUE3n9e22uasvM31tPcSbvJ9KzM/az7ksUgRtuc1aYK3U1m+RIPmp3z0pRT0YpTk9GSyWgc8\r\n SY/D/69RR2TBtok4+n/wBej5/erdtnvUeyh2II3VrcZ3bqh86WVNyp196tXv3azYLqSNQgXIFH\r\n sodgKFxFeOflGPyqS0e6hAVhyPpW/Der/GtXlhjnXz8Y3f0o9lDsBk755lxnFVJLSY/L5n6V0e\r\n yNKrvGHYsOlHsodgMSC1aJtxbd+FLLHcNIWU/LWx5NbMEEP2VS33uf50eyh2A5FXdOGq3HH5gD\r\n 5xntVq8hUn5aht124WrglB3iJpPcsJ5i9Fz+NbVuGeBcjaef50+08nHzVpzvDHbhlqpPm3KjJx\r\n 2MrydvJk/Sty2eP7Iilc9efxri5LppJNqmuhtpGS0QHqM/zrNUYdjqpV5t2bOmsLRJX4bb+Fdt\r\n awiKNUB3Y715nY6hsbFegadfo8KEnnn+f0rlrxUdjSSUtzoYgR2qwIyWyeKks3jcVNIAJjjpxX\r\n A5NuxEaUYu6RPFFnHNaUcY2CqUPQVpR/dFBoJ5Ypvlc5zU1FADkbZ2zTiN53dKjqZPu0Af/9T9\r\n bKKKKACq8919lUvt3e2cVYrlPEOppbRvETyP/rVcNyJ7HlvjrXvtQaMR7Pxz6e1eNpdoIhCy5I\r\n z82feuj8Q3bXczBecn/CuHuIpIVya9XDHlYnqaAkRDkVzOpz/arl4duOnOfYVPbySSPtp1zbFJ\r\n GlPWu+t8B5i+IxY7AWrebv3+2MVd07V3N+8Qi445z7H2qpNPn5al0wILguev/wBauQs83+Kdoq\r\n xG5Lfhj/drx74caqz660f3VBHHX+FvavcPidE1xaEL/nla+W/DLy6Z4jftyP8A0E/40GtLc+y9\r\n blBiXC7uP8K86nVknaYDAPb8K9BtXW801Zm9P61xWoyxAsBQbjIrrzvkI2/rW9YRQ7wuMn+9XA\r\n LM2/5a67R5yWUN1/8A10GdXY6y73wRZRsVDHeJJYqsi5fnJz71duY/MhrmCrq5QdBQc5m3gbeS\r\n gqCK9kjAQx5x7108Vqr/AHuaZLYxhyRQBnxXW4fNF+tatqYpGBZ9h9MZxVfZElMitvNuC4bg0A\r\n djC8EK5Mm78MVJLqNt5fJ59Kxmsvk+9WbLprt8wbj/AD70AaTtFdNhXx+GazLqOSNjCg3Kv8XT\r\n OfatTTNLXcNzV1DWFuseOp9aAPNY43ibJq0rTGXzFTKn3roLuyXPyj/P51TWb7Moi25xQa0txj\r\n QyXC4MePxrFnsxDMyFsEY4xW9/a/l8bcf5+lZF0z3c7TgcNj9Big3I12r3qzK6m3AHv/OqXkye\r\n lHlSN+79KALml3otpcld3449a1Lq+Z7lrlU4bHGfQYrn/sssfzVr2rK8Ko33uf50AaMVx9t+Qj\r\n y/frWilt9oT+zw2PK/5aY67uelYwiaP5l6Vp6deCNzv+8f/r1lWhzRsZVcT7G0l3PSfAXiA6Zf\r\n rpzx7wTjfnHZj0xX1TEwMashyDXxFZu1vfC7Xj/9WK+o/COvLe6Vb7zlju/mfavFxGHP0zIcW6\r\n lJHfJgnnipvLB6HNRNGzpuWpIARGA3WvFxFLlVz13C07i+WKrSyBWKY6Vdqs8W5i2K5Cig4D9q\r\n i8oVo+R7UeR7UAZ/lijyxWh5HtR5HtQBn+WKrunzGtjyPaoHh+Y0AZmw+n6VMIQUye9WvJoZdq\r\n 4oAxprcZ61lyIFcj0rcm6mqDRbmLYoNaW5n7RVKeDcxNbfke1QSw0G5y01vyahGFXZjp3rcmh5\r\n rPaD5jxWdXYDMeMPVN7cbjW75HtUDw/Ma5wMf7OKqyfI5XHSt/yazp4R5poNqHxGdv8A9mrUcI\r\n kQP0zS+SPSrUY2oBQdRB9mHr+lTooRQvXFPqMH5iKmUObQahzE6Kp+8cVxfiy9is43UHdgD29K\r\n 1dUv/sik5/zxXiPi3VpruSQocqcf0r28vw58vm1X2aZxGoautzcspG38f/rVw+rhGupAOenP4C\r\n obkXAnLVULs9yyt14/lX19Clyq5+e4/Gur7jIokZGyGqCVXkumO/rjt7Vp3EflpuqhawPNN5g6\r\n Gug8wnKeWmdu79KswNHJGqsNh/Ot+OzXy/mFPGkRSIJAcZ/z60ARWVlag5M2P+AmrMljCLgzLL\r\n uBxgY9qzZdOZOFb/P51XR5Yn8onOKANyW4CrtWPP41VEgI5TFaFmiyAbqq3ihLl1Xpx/KgCLzF\r\n /u05Ou/oPSoKsj/Uj8aAI51SUEFtv4Zqxa/Z4rdYinmEZ+bJGefSudu/O/hrU0/d9kTf15/nQB\r\n fcQv0jx+NSxSKE8peMVBVIeZ9qbHTj+VAFu6V1GVOaLaU+Su5eeauNt2fNVQY7dKAJ/NHpSEXD\r\n DfGPl7VFV6HVEt4xCRkrn9fwoAypXuU6w5/4EKsxRs8AmcbCc/L1x+NaH9oRv/D/AJ/Kql1cAg\r\n kcCgCOMO5wGxW09mXsEzNzzxt965qCf5+taQuXdvLHSgChDE1vNk/P+ldGH82EHG3261DDAo+Z\r\n qlVgZjGvQVUTah8RDHEytnd+la1tqr2zCILuC98+v4VBcR+Um6s0HP7z1rixG51HsehagbkAEb\r\n f19a64jEhGc+9eMaNqXkMOf88+1esabcfarZJ/72f0NeZ9oDdh6CtKP7orNh6CtKP7oqgH04Lk\r\n ZzTamT7tADfLPrT1GBilooA//9X9bBUaSbpTHjp3qQVCBtkZq6fZxMK03HYLyZbRN33v0rwrxb\r\n q7XOoToF2j5e+ew9q9F8T6n5EZGf8APFeEareefM82c5x/hWtGlFy2PMqYqr3MCQrDKXY7vbpV\r\n C/liuVOBtz+NZeo3/lsef8/lXNtfvI+QeD/n0rtilHY5ZVZy3ZorKLOTeF8z8cVNcagt3FuKeX\r\n ntnNVYnWT71ZGpSNHIwTpxitHOTVmZWKk4RG3b/wBKrQXwiuSVGR/9auU1LUJEJ5rPt9TOVJ68\r\n /wCelQM7bxbGsunmY88dPxFfJ1/JHb6uboDBYj5fTAx1r6rv5ftmlEeo/rXx/wCP4JrG9aZeFy\r\n P/AGWg1pbn2F4SK6loQKvs49M/xGuav9BYuxNx+G3/AOvXPfB/XGudMETHt/VvavQtRic3LkdD\r\n j+QoNzz5rY2bHnzMfhVmw1NkuseTgcfxe30rYmgUHLVm+XHHMXoM6ux38Wo+bCB5ePx/+tVZ2U\r\n DeV5PvWVZ3sZG3NaUpDRgjpQc4RXW44C4/Gq11fNHK0ezOMc5pkH3q02sPNHnY6/59aAOfeZ5O\r\n cYpIVm83IkwPTFaE1rsqtGMS4oAuyyzon3/0q1aSvPCqM+3rzjPeqdx9yqsbvGm4dKAOhMMtv8\r\n 6z5/4DUserSABGG7HfpXO/apZPlpokKttPUUAdct8JOq/r/wDWq9GkM67mXBPvXKQzcVsR3WyI\r\n HNA02tht/BBACQu78cVlR3Y2jbDx9atSz/aOK0rWyT7KjMOef5/Wgr2kjI+0/wDTP9auQxRkee\r\n 3Bb+H6cU+ZI0rJkmbzCqdKA9pI0rm4iK7dv61heZ5U5cHj0qxskes+a3lEhOKA9pI6yzuhdDZs\r\n x75qvJZMl8ziTA44x7U3RnEZG7/PWtW6ZWuWdehx/KoqXtoY1o+0SUjbtlEkQQnB9a9A8J6r/Z\r\n 7R2hO7YTz065PpXlsN1s4zUSau9tflwcDj+X0rysS5n1uS4upSSimfd+karHc24Gzn6/X2q+3L\r\n EgY9q8L8B+KFuQqMf88+1e4q6ygOvQ14tZN6SPtIY3mjq9R1GcUUntXN7OPY7aE4y3HZx2oz7U\r\n 360CoqQSWh1VYwULxQ7PtRn2pKKxOYXPtUbJu+an0fw/jQaU4pvUpO4TtmoGIfnpT5utUHl2sR\r\n Qa+ziOe3D/xYqqyCNimc4qbzqz55/wB6eaio2lobUacb7Fnj2pjxoVyW5+lU/P8Aese6u3E7KD\r\n xxWPtJHV7OPYvzogPWqBjBOQar75HqzHnbz1pOTe4vZx7CeUPX9KoTHbIVxnFadVZIgzk1I/Zx\r\n 7FHf/s1TlUNIT0rX8kelV3g+Y8VjXlKMbxMa3uK8NzL8sVETh9gHStbyPaq8kGGziii5y3Jp1n\r\n 9ojjg3/wAWPwqnNtt5WBOf0q9v8uuN8Raj9m3vn0/p9a9rB4aEpe8icZjVSp80Hqcv4t1NQhCj\r\n 9fp7V5e0i3FsGYdc/wA6p654h+0SmPP+ePasuO9/0dRn1/nX0mGoU47I+BzjHTqJ3Zk36xxsSF\r\n zXN/Yg9012X2q2PlxnGBjrW7ePvrCv5CtqET7w/wAa9m2h8RFydR3HX3lyR7I2yfpUmlskFuiO\r\n uSM8/ia5rTEuXn/e5x+HvXVSQMGOzp2pGxt+YkwwPl/WsW4kvI52ihG5B0PFRB5ErXtrtVhXcM\r\n nn+f0oAzVivpOTx+VWhaFEDyH5u4xWh/a8cfG3/P5VSubwXHzjoaAHwTkHaBT54JnJmAzmorJP\r\n Meta4vPsy+Tj7v8AWgDFjhndsbcfjVmSJrePLcn0p1vqfz/dq1K32olvWgDBW6Vm2tF+tXkyQN\r\n q4FRzWvlHOK0rXZ9lXPXn+dAEaQhurY/CpRbxod27J+lV5d38FQr5uaAJLlWcYTirVtppFmkrS\r\n cnPGPenQ7f4qfc3QSLy16Cgio2loZTvtbb1pAisd7Cqyv5j1dAwKDH2kixHJGn/LPP41BKguXI\r\n X5Afxop8P+soLpybepB/Z/k/Pvz+GKtaZtnu2hJ27cc9exqzcfcrM05HXUJJB04/lQbHSXw8jE\r\n anPv0osrMLi4aTk9senFZt1fKbgKxqy0zeYdn3eKzqycVdFRk1qjVu381NgH41zks7W48jZu29\r\n 84681txTLj5qo6gYjlhXJKTluV7WfcjsJPMbJbbXr3hTVFlK6Vt4j/AOWmeucnpXgK3TJJ8pru\r\n /DWpG2lSdjy2f0zXPUglqjWlOTdmfRjxeQQoO736VdThaxLC5+2W4lzmteBt8QasjcmqZPu1DU\r\n yfdoAdRRRQB//W/XHyj6/pUbR7VZielWxXP+IdTj0+xLE4P/1x7V2HNiDxrxnrG64NqFx/tZ9g\r\n fSvLrtzGTCPmA/i6ZzzVvxBqDXty0yn/ADxWMlwrRBnPPetqHxHjVTmdQ057kk79v4ZrPGlrbQ\r\n AtLub6V1M00VcpqU7mZgv3eMfpXUYlBrh0baozj3/+tTirXKYZcH1qWyRZH+atZhErlB2oA8k8\r\n Q2QgBbfn8PpXns161uFdU3DPTOK9c8WWrPGdv+eleQyKqr5L9U6/jzQB6Xo98b3T9pTbx657mv\r\n GPippqjTvN/i/+utel+GL+PzBb/wCe5rC+KloHtpIgPugf+ymg1pbnFfBfUNpFuR+Of9/2r6gu\r\n NmSmM+9fFPwv1H7HrIt89/6NX2aH807uuQKDc5LVsx5IH+eK5CS8dyU24x3zXomqWvmKT/ntXL\r\n f2Zn5sf5/Ogzq7GXaNIjZzXZWd2JoVibgjPNYP2XZ2pVZ4myOlBznYLbJEN/mZ/CtCHVlWMW/l\r\n Z2/xZ65/CuQhu5JBtzWlbghsN1oA1LtwwzjGaoRW4f8AfbsZ7Yq3cfdFU4pdqAUAWZIA643YpU\r\n tkMQhLcjviofOpFLs+R0oAVrVLU7t+78MVmSSebOzLwDjird75m2su2znnrQBu21uXA+b9Kmup\r\n IoI/LZ/mX29afZ/dFVbzSXvLl3B4bH6CgCtaXsPmctXW295HJEsanj1rkv8AhG5Ivmz/AJ/OpI\r\n FktX8jP3f60AdFd2gcbvNx+FYyBFlMROcd6luJpNlZ9tHK83mHoaAOnjiCLkDNU7lkYkbMH61q\r\n I6xxjdWTcOrzMV6HFAGUZmhbKjNdBZstzbrIx2sc8fjWb9l8wZpqGSGYxDoK0pQ5nY1ox5maN1\r\n IYBkDd+lUDHPdRCYJtBzznPSpriZdvz1NaazEtutoBnbn9Tn0rnxOGO2FX2Z13hDVP7JlDSHd+\r\n nr9fWvrHwl4jt9XtI0UbTzznPc+w9K+K/Iab5lOK7/wT4kk0S9S3lb5VP8wfY+tfP46lyxv5nr\r\n 5bmDnUcfI+yJRJHIE25B71OYcHGf0qvperWup2KyqcnH9T7e1W0beu6vLPq8NiSPyff9KqyOY3\r\n KYzitGqskQZyazq7HrQq8ysVfOP92niQkZxUnkj0qJhtYiucod5h9KRpdqdKZTZPuUGtLcyrm8\r\n 2H7vT3rNlnLL5wHXt+lS3n3jUMKeZGF+tBuQRXLSNtK4/GpJLbcS+7r7VY+y+X82Kcfu1nV2N6\r\n G5kumzvmqT2gkkMm7Ge2K0ZutRr0rnOkijhVPeldMncOKlprdKAKLvspUO9d2MVHN1NPh+4KAJ\r\n MCq0h+bFWaqv8AfNHJzaClDmVhN1VnZmYgLx61PUd3dw21puPDDr+dd+Gw54eOq+zOf1G4S3GT\r\n Xh3j7xKsMLrHFvb/AHsf3fatbxT4qVHZAf8APHtXjlzdvq16+85Xj+X4elexSpcup8XmmatQSv\r\n 1OOiEt3I1zIfL9utaUE4f91np3qTWPLto/Ki4P/wCqsC0SZFDGvXoHzs8W6ho6jcCzTd9/9Kxb\r\n SY3z+cRtVv4evSrV9FJcLip7CyNvaISORn+Zr1Ohg4W1NMW0UaZUYNRNe+THsMW7HfOM03z8/L\r\n VwxRtaqx68/wA6kkzVuFuTgps/HNbMUaLAo27sd+nesBYW3/LXW2gVbRA/3uf50AYc8S/3P1qA\r\n WxYcHb7da3JvLzUSxBhlelAFe0c2xzjd+laEl1azjMi7WPXrUPk1Wk03zWL5xmgCxG1khz1/On\r\n NcqJC8aZXtzVP+yh/erYtrVI7ZUPJGf50AY13fNIu0RY/H/wCtTrOIvCr79uc8Yq7NDHmqW1kf\r\n 5fu9qANOOID3qKSTEhjEfA75oiulThqurcW7jd3NAFdLIzfx7PwzVW5019xjEmQO+K1vOUfdqy\r\n jIygt1NBnV2OYi0toznfn8P/r1Yktyi7if0rof3VYWpSgMyLQc5RRkZtucVrWGmyXMp2H5fXH/\r\n ANeuTVJpJPlrt9Fv2soBG45HX9aDWluZ+pJLbP5W3d75x6VPbxC2s1uX+82fl9OcdaytT17zLz\r\n bj/OB7VPd3260Hb/8AXQbnO3Ja4ut6nb7da6m2eNbVQx+bmuPtpN82amuJZ1umRfujH8qxr/CB\r\n 0M0x/hrHlu5HlMBXp3zV+0RpB81K9n/pTMB6fyrlApra7RvLZ/CtJrkW1vE69eePxouE8tKwJp\r\n Hlbyl/hrOrsbUPiPpXwXrKXNgEK7T9c9z7V3VtcBYwgGcd6+bPCWqSW8ggz/nmvd7GcmFSetc5\r\n 1HVo+/2q0vSsWGbiteE7owaAJaKKKAP/1/15QBoDMTj2rw/4i6qXjeBRjGOc+u32r2DU7n7Jpz\r\n HP+civmDxhqn2hn56//W9q6qT5tzy8TVl3OPtovMjYu36Vm3Vp5alxJkHtipkuPLty3+etYD6j\r\n 5vyZ/wA/lXoqnGOqPKc23qZ8kzlttL5CTDDPg/So5eOaxDdyLdso6DH8qYzcNqbX51bd+GKh+Y\r\n v9oLY3fw+mOKGvVKfOazri7GxSp4NAFjWYA1oZevt+Ir521lnS/mnAwGx8vpgAV9KbftdiR/nr\r\n XjHiXSfLLtj0/p70Acz4VR2vxMXx7Y9jXW/EC2+0WbXGeJAOPTG0VwekXP2W5xnHP+Neo6pF/a\r\n OgQS9dwb9GoGm1sfHegO+k+Lkj++HY+38J/wAa++LK2D26S7+o6Yr4W1u3/s/xZC+Mcn/0EfWv\r\n tnQLzztLglPQg/zNBXtJGjc27OuAKyZ4fIj5GSO1dbFND/FVC+hSdmZOhoE5N7nnslzvbbs2/j\r\n VeadANhHI71e1KD7OxNcrM7yOWHQ0EnT6aUZwSa6MQDeXB61w+meZuH+fWu7gz5Qz1oAfInmDH\r\n Sqz2RSISb+vbFXKdKQYMf560Acw9wynG3P410VgbY2ySSSbWOcrjpzWSLbfJUcumTmYlThaANu\r\n 5a2kGA/wChqO00aCfEn2nbu7bc/wBapxaY38Z/z+dbdnYBQBuoAurpcFsoP2jdj/ZxVAzMl2yp\r\n 8yjGD07Vpz2Q2ferPt0SObYecUAXpmlkTA4rBMZWYluTXXt5e2sSeIGQuOhoAh8hZ1xnbUkccd\r\n qoT72O/So9+yoJZ880ALdTl+F+WmWlv5ijL8/Ss6abmr1hN8q/jQBt+WsC5zuqs8UcmZs4z2x6\r\n cUs83yVjSTOcgVUJuLvEuE3F3RX1AbhgNj8KzLW4+zPtMfmY/izjNWJkkerMNughBYfNzRKTlu\r\n EqkpbmxFqBlQKB5f60jThGX95hl6tjrXPSuyH5avx2JnskuGPLZ/Q4rjxGHhUjZoKVWdKXNTdm\r\n fSvw/wDGcdtCttKd/vnH972r6M0m/t7yzjkjb72ePxNfnpogmglG1v8APNe7eE/FstjMlrM3yp\r\n /XJ9K8evhIL4UfUZbjakvjZ9VsrgbscU1SCMkVmaf4htL+1G1snHv6/StCM5QNXm1KN9D6+jiI\r\n 8um5JxnpVeSIFi27Ge2KsVQuN+446V59aLjsejRnGW5G+1O9MY7kqhN5masw5+zrn3rmpTm5Wk\r\n d/LBK8TMubfeT836Uy3i8nvmrk3U1CvSukkmlk8xduMVQZdo29cVaqvJ3pNJ7lRk47GVNWcbsr\r\n MYdmcd81ozdazfKzcF/Wp9nEv2si/wDw7jULSDHFJO+xKyYrrfOY/Ssa8eWN4kutItuC59KcoK\r\n Db1q+0GI91RrDujDCnRpuW5pTxC+0QfjVYgtOU6Ad6dM+ysC/1uCz3KzfMP8+lelDDRWtiMbjo\r\n 06d4PU1b6aCxTcz5/DFeKeLfGJWaWCKLKjGDu9h7Vh+MPGkh3LG3+ePavIrzW2uoN7n5mzn8D9\r\n K9PD4ddj4PNcyqtO0ihrOqtdTMWO39fSq+naikAxt3e+cevtXK3RmnkO3vVmKKWGEMevNezSw0\r\n Huj4ipUnVlao7ov6k2+f7QXyP7uPwqiNcVpfJW34Hfd/9aqM0kknFXdP08vhyOT/APX966o0oR\r\n 2Q4xS2NqK4UqGMf61eeRZLUELtznv71G1r5aUYxbhfr/OtLmjk3oYYyH9a34bZ5bdWBwDnjHvV\r\n SC23v0rq7eNIrdUPbP8AOgk5+OL7O2SN36VdjP2g8Hywe3WrU3l5rHkuBFKQvSgC3c2BUbhLn8\r\n P/AK9RxTLDEEfkipoZzc/LnrWvHoiTwiUnk/59aAOffUo0/h/z+VNgV7+Xcknlq3bGcVrTeHo8\r\n 9f8AP51nLatZzmNOi/1oAs3OkyW6bxdbvbZj+tUEvZYkEW3fj+LOM/pWhcSSSJtqKCFfKG/rzQ\r\n BnPdSP/B+tWluAtuu5Oee/vV3yovT9ajnhXZx0oIqNpaGE6tctgHZ+tLFZSiTZ5vA9qvwQ/PWm\r\n bfb+8oMfaSKwRrZclt/6VLHM0ih8Yz2p+3zPlqyttsjFAnJvcgBJ71kXMbyXDDPHH8q0Jn2URM\r\n jgMepoJL+mafGMFmz+Fb/2ODLntx/nrWPBnHy1fu5jbWCyHqc/zoNaW5wtxbwtqe3bxnr+FQ+J\r\n GSyJVTkDHH5VYVvMn8+uN8WXjzXDqOen8hQbmroqRz/vjJt9sZ9a6prOBl88PnPt6cV51pVvdC\r\n 23Ln9PU11FnLOlkiv1Gf50pRT0YG5FNsbCrn8atGXadxXmsmymUN81aMrK7nHSo9lDsBSu7ouM\r\n BP1rNt1CymQ857Vt/ZfMGaz54/JlK+lZVqUeU2ofEaGnEW1yLjrjt+Fey6Zrv2i3RxFtznjdnp\r\n +FeC/afL4zXo3hu532MPvu/ma5fZx7HUew2l0ZB0xXU2znyV49a5PR08wD/PrXWouxdvpUVIpL\r\n QCfzD6UeYfSo6KxA/9D9QvGepiCxaIJn3z7j2r5e1QNdE5bb+te3eOL7KMuf88V4LdT9TmurDn\r\n j4kxbk7IjED+NcuLYwuWL7vbFbV5NyawJJ8uRXqdDzF8Q+4u8rt2frWJvVpzu4Na2zfXK3++G9\r\n kx0GP5VJZfviwX5DWasxe3SNuCuefxqWK6WT5WNUr5GQmRPunpQB2+k3uIfJ2bvfP1rmPF8aLC\r\n 7d+OPyqXw/eqZQrf561L4vhM6SMnQ4/pQB80y3wiuyMd69g0/Wc+HLOEQ78+Z827H8X0rw/W4J\r\n Le5Y4/zxXq3gN11DSorduWi3Z/EsfagDw/4jw/ZdZhuhzknj8FFfUXgGf+0fDVpIPlyH9+jNXg\r\n PxM01p5jIo+5/9j716j8HtVU+GLKFzyPM/9DegD0qbzRP5QP411lpYmOyUs+489sd65y5ljFyG\r\n /wA9K66wuo5IlTNAHm/iQMARt/zxXBQ3SA+Qy/MvfNeweJ4IxGW/z2rwmfd/asm37vH8qAO0tr\r\n hbbDCPf+OK6m0vPtEKybNm7PGc1yttt8sbq6Oy2+Uu3pz/ADoA10G/2qCaUKxh9O/1qzD0FZt1\r\n E5uWI6HH8qALkAQHcatSqWG5TjPaqMMElXUBHytQBh3MtyhOwZ/KrNm92Y1lLYz24rpIraB/vV\r\n ObeJPlXpQBgyS3TjG7H4CoVSWL96zbjXSeTHVK6hGDjpQBTS/eT5NuPfNX9yJbB2bnnis2CH56\r\n q6iJldgn3eMUANlugzYUcVX80M+xjiqcG7fzXQQaXHcRibPLf0/GgBsGjQXXJutn/AM/1q7Foq\r\n W8nlrcbwvfbjOfxqMae0f3W/z+dOPmwLyaAJ7uxWNP9bn/AID/APXrnBIVmMO3cB/FnrVqa6kk\r\n +WiNVVA79e9ADZHES52bvxxWTJd3Ej/u4fl/3q2/Mjk+Wjz44Pk25x/n0oAyVinl6x4/Gp2M4j\r\n 8gfJt/HrzV/wDteOPjb/n8qry3kc5Mo6mtKUOZ2NaMeZjrEPbtvaTP4V0SXzbhKvBripp2/hrS\r\n tLgm3RD15/nXPiMOd0KrpnufhPxjJYsvmL5gHvj19q+kdB8T2up2cUuBGXzxknGCfYV8C/bJrc\r\n 7lrrdB8YXtoUQthVz6d8+1eTPDnrZbmDnUcX2PvxdjrujbP4UjeWF+c4buK8Y8JePoZUVZ3/zz\r\n /s16VHqlpqMpkR+G6fh+FeZicOfV4bEl1/s7HlsfhVZmVfkTkDvVifT1dNyt/n86oLGYhsPOK8\r\n qVLlZ7dCrzaDHTfVcrtJHWrlVn+8ak6RlV5O9WKryd6AMqbrUKAA5qabrUa9KAIbiEzjGcfrWb\r\n baUsd0ZGn69tvt9a2aiKwq5d2waOTm0Im7I0pnjWLbmsT+0jETB5WVX+PPXPPTFZmqa7Y2q/NI\r\n P19vavGfFHxLt7VpLW3bJXHP1wf7tehh8MeBjsa6R6V4g8S2enoXJDkdskentXz34h8YG/vppY\r\n k2q2MDdnoB7V59qPie71Wc73wp+n+A9KxZJXVygOQK9eGH0PlMZnUmuW5pahcm5YljXINPK141\r\n oE+VcYbPXIz0ra2SPU3kxQxeY/3+9elh8OeTPFuruNS3htE8x23e2MVmXeqxu5iSHAHfd/9aq9\r\n 3cSXB2R81HFpk3lhmHP+fevSnS5Y3MHC2osSozbjx7Vv210kKgBM496xPssiVYjilKA1gSbcmo\r\n LIMBMfjRGokiBzjNY/lS+n61fhcxxhD1FAGnb7YTk/NU81wWO5RgelZXnVYRt6igCtPcOD0zWX\r\n Ixkbniug+y+YM1i3MflXTJ6Y/kKALli5tzk/N+ldH9vlaMMnyj06/wBK5mKt20TzEC0AVpb+4J\r\n 64qSO63RjeuW9amvrTy1zWbCcoPrQBrx7W7VWuC4lIUcVYgq8sSMMnrQBh7pfSiS7ZIwhTJHfN\r\n b3kx1nz2oklIA4oM6uxn2cnmP93FaF5diFTHt3Y75qHyPs/OMVnzy+bKRQc4+2v/AN5zH+tasm\r\n pZG0RfrWD5flfNU0dwhwD1oASd3m6LiqSPLHLtxkCuihSN6JreIEnvQBasLtFA3LWd4i1sSJ9j\r\n SLAX+Ld64PTFU5naM/LXOXUpluijdeP5UGtLc37K2H2Qszfp715pqc6SavJa9dhHPrkA132q3f\r\n 8AZ+ll+nH9RXiNndvfaq10DkOR+gxQbnt+nXcVpaBPI3++7Heqsupl8otvtH+9/wDWqSw2/Zxv\r\n 9K1IordoQ3fmgDn0Zyd2Nta8E21BkU2WFP4akjtJDEGHegDRi1BUGCn61nXUonmZwMA1SmSVDS\r\n xElAT1rGt8JtQ+Igkti5+9j8K7jwxLsjjtTyVzz9cmuSrT0O72ah5eeh/oa5TqPpvRk8qIPnP+\r\n TXSh/MG7GM1y+iP5lsv+fWuljGEFZ1dgJKiaQgkYqWqz/eNc4H//0ftjxjrBlvWtRHgZ+9n2B9\r\n K80vofLdk3ZxjnHrXS63MLi5af/PauRv58qZPWvYjShHZHiSblucpqMxjJxzXMG8YzHKY/Gt2U\r\n /aJNtVZrDbITj0rS5z1IRWqLdowcc8VnaxZK+6RT1x2+lL53kcdKVrxJk2HrQZHnrvLBIRjNXp\r\n NXD2otTD8wz8271OemK0ry3jB3VgNEDMSOhoAis7ia1l8xV3e2cV3n2w3+lqzxbSc55z0NYtpB\r\n DjLV0VuYfL8legoA+bPHA+yMzhN3449PrSfDXXzbSlzFuEvG3djGN3tXYfEaxjETN/n+GvH/AA\r\n hcCLU/IU8Kf5g0Aeo+NIFFrJOfm3gcdMYxXP8AwmmdpE0z7ojJ+brnO49K7TxPD5+m/h/UV574\r\n EvI9O1lozwQf6NQB9B6tCbWdU37vfGOwrb0F3muvIB4Xv65BNcvrcrTxrOv+elbXgW5EkwL/AH\r\n j/APXoA0PFwkjj8sc57/lXjrxeTMZGG41774rSJzn/AD2rya/sxuJXpQBmQzmb5ANv612dhGIr\r\n KMs2Tz2964u3TY9b/nOLcAHj/wCvQB0sF2pO3FSG6XzzHszjHOfauPgnk39a6axQyMHPU0Abyz\r\n hFyEz+NVnn3uXC4z2zV1of3dZrjaxFAEouGHSpI7p3fYR+NVKmRdqiSgC9K5jXcDms+fUikHEW\r\n 4+mal8zzPlqFIQJyH+7QBkwa5Isnz22P+B//AFq2ptQhltBIY+T7+h+lQ6jDbeX+661zn73yhF\r\n 6UAaFqqXcuAdn61tTWUtrHlJ8gdBtrnrGOSNt1bMl0X/dHrQBn/wBqTI20jP8An6Vpi/SS2VXH\r\n PPOfesmaDHzVtWOmJcWaSk8tn9D9aAMczxRtk81SudRMrmNEwOMHNdDNosWev+fzrGk04RTELy\r\n BQAyzgdjuL/pXRm1g+zCVmyx7Y96zYUKVm3VxObl4l+6MfyoAfKI2cqF/Ws+WB0csp+X0rUigY\r\n fM1aUkMZtFbvz/OrhNxd4lQm4u8TCtY1kOHbH4VrJY+W3mK+R6YrnZHZH+StlL9YrJN555/n9K\r\n UpOW45TlLcku7wRrt8vP41Ri1U4EQgwR33f/Wqot9HcPitKGCPIasnTi+g6NWVKXNTdmdLpN7d\r\n IQyHHtx716DpXjW40yQLJl9vbOOufY15/ZvGgFJd2wlczhsbv6VlLC0pbo7o5ti47S/BH1Po/w\r\n ASI72MRumz/gWfX/Zr0LTr+0vYVfzgCc9jXwxYzTQt8r109r4yvNOlEJc7U+nf8K8vMMBSVNOC\r\n 1ue9kme1/btYiWluy8j7Ye3QLujk3fhisiWQLIVPUV4nofxOhKhZ3/zz/s12dv4s0++lM3mD5v\r\n r/AIV5H1PyPtKOcYeW7O8jCv1bH4Vm3MzJdPbqu4DHzZxnIqodc06JM7x+v+Fc9qPjXS7NC4cb\r\n h9f8K0pYNN+8j0Y5lhLXZ0c8MgG4CqsktrBb+bNKFfnKYzjn1r578RfGtbZikBzjp+n+xXmOqf\r\n E6+1NDdIxAftx24/u+1b/UafY8LMM8pw/hM+n7zxrZ2jFQgfH+0R/SvJPEnxJuFvpkgtvk+XBD\r\n j0H+zXzndeLdQmkJ3E/l/hVRtfuph5bDJ9eP8K6sJgKTm+ZHydfiXFSfLTn+C/yOo8R+MLy+LA\r\n ymHP0b09q4tbmSSIOzmdj/ABdM1FNpFxqR3dM/59R6Vs6RpDWKLDN0XP65969SODox2R5tbMsR\r\n V/iSv9xRt7Ca+bG7yPfG6tYWDWI8ppPO2/x425z7c1rXk1vDF+6xmuQl1W4aYxY4H+fStlSguh\r\n 50oRlubB1KG3++mfx/+tXL6lrT3Fy8UUe1OMHPt9K24dMa+GXOM0kugiFyoGcd/wDJrSPu7DjF\r\n R2Kmjqkb+ZId3t+ddg95akcLj8TXLDTpo+FFbFtpLywqznBOf89a0lVlJWZo5N6ENxeW46D/AD\r\n +VLHcKIVZY9wPvV3/hHA/f/P51cOnraWqwt/Dn9TmsyTHiuhI2PKx+NPkhV3Lbtue2KjV443pk\r\n rO7lk6UASfZ0/wCen6VqWliHjUiT9Kw/3vvVRdTu7e6aJQSq/TuKAO3aNrdeBv8A0rCubGS5ma\r\n 5Hy7sfL1xjimNrU2z5h/n8qiXXyF2EdP8APpQAhimi/gz+OK0bK9MGCyc+mao/2vv/AIf8/lVd\r\n rnzJC3rQB1NxeLex7dmz8c1Sisgqhd/T2/8Ar1Rhm4q+JvkoIqNpaGnDbRjrJj8KhmlWKQxq2c\r\n fhWLNPN/DVZGmZstQY+0kb3nuegzU8cxUbmXJ+tMs9uPmq68QYZXpQJyb3Mu7uvNG0Jj8ayYYC\r\n 0u7d1rYmh5pltAfNyaCSKezZo+K5m4t7uCUsi7h9QK9JZ4Y0+asKfU7YSmADO3/PpQBz1lf3e7\r\n a0H/jw/wAKu3N7IjZKcntmtATKPmVKhuYDMizkY3f04oAaIS8Hn4/CuPwZdSZ8benH4V6J50MF\r\n iQ3H/wCuuItQtzeSSp93j+VBrS3MDx1qPl6UYVXnHr7rXn3gS1F3bRF22tlu2e7VqeNLzzLg2p\r\n P+cA1P4SsXto1AHAz/AFoNzvJ5RagQg7vetPSrZ7vAMuwfTPrXM3KySXAFdbb5sLJJW4zn+dAE\r\n zx+ROIi2/wB+lbxnitLZYyNxHvjvXMQTfaX8ykv7h2yBQA261ON2wI8fj/8AWoj2vGJAcZ7Vzy\r\n pI71qKsiRhfSsa/wAJUZNaosvIqcdaNOfy7/7QOc9voKyZvMzVm3YxRI5965Svaz7n074W1cTR\r\n KmzH4/X2r0ESgcCvnrwbqmXVc/55r2+O43IGrOrsdGGk5StI1/OFVZJfnOBVXzqUNu5rnO3kj2\r\n P/0vqDUJRCGiPze9cbczM4NqB93+L1zzWzqF1vlNY0kiL85Ne4eGY7QGzbzM7/AG6VDPqO9d3l\r\n Y/4FVua7jk+WsieWNWKUGdXY5++vXJOI8fjUVkhuMSM+zPbGcVoTJG5rJl3W8pK/doOc17vTTJ\r\n HkS/p/9euOuZmspmtym/Z/FnGc89K6WHVEPysahvoIp0NwP4v/ANVAGVaTG4IBOz9a00uDZTbc\r\n +Z79K5CSZoJCEqT7YxKs5oAd42spNRsGlU7eOnXuK+ZI7p/DWqRzunmmQnjO3GBj39a+yWWG80\r\n 3Dc/8A66+R/irbpp97HInCgn/2WgD6Gvwtz4cS+zjcPu+nzAdf/rV4NYLIPED3CnAYj5fTC4r1\r\n LSNSF74Xhiz2P/oVcGAlrq7A9QR/KgD6KhiMukB254/rVLwnc+Rfkenb8DV/SrqOTSAvt/U1x2\r\n izOPE88S/dBXH/AHwaAPWddvGnYALj8fpXFXNyVkNuUzj+LPrzXWaoyxhWb/PSuMuriJp2IPXH\r\n 8qAFisFlO4ybfwq9JGkMQizvI79Ky/Pb+Gr9rDLcEEigB1pbmR+BXX2lq0Sg4zU2n6esYDMMVt\r\n 4hHFAFIysVxs/Ws6WMtIT0zW9+5rOnkjWUgUAZ3kn1/StCO18y3Vc468496j86OpJL+OG3AB5G\r\n f50ARpp6wncZd3tjH9asS20M0IxLsb6ZrBW+a4faprVWyPliUtgntQBkNp00b7hJ5o+mKgdCjl\r\n mXB9K0J9Q+y8dah8z7an2jGN/9OKAKZvhGMeVn8f8A61EH+kzecfl3duvSmTQ80RHykBoA1bmF\r\n RH96s+O6u4kEMYyo6HjvSfavN4qzHc+Su3GcUAMC303O7H4CnhniPlSjLDqad/a5T+H/AD+VV2\r\n n+0yGbpu/pQBcRd/TiqzQlJy+3d09qtw9BV4TQhdjfeoAy5bjK7fL2/jVOSd/K8vbwO9aMqK/3\r\n KckCeUA3WgDkpMq24rmnNp0uop8r+UD7Zremhiq1BNBbwKD15oA4weHprBt/n+Z7bcf1rbtlYw\r\n q5OCc8Vdm1G3kO3P8An8qpNOuMJQBaEwT+KoJLy6dikY+TscisuVJpD8tWLa+e3At3HK/15oA2\r\n bSKTO55cfhVu4jWbMZbH+3jr+FOtPJuB8xxVTVWWIGKA5x3/ACo9j7T3TKrOUFeJgX1rNaEtDd\r\n 7vbZiqNv4k1OwlRd5YMT6DH6UQx3Ekv73pVPUIB9tjC9Mn+VL+z0b4fFVdrnpF5r+piGMCU/Pn\r\n sOP0rF1Gx1GcFnvjz22Cr13D+7g49f6UahJ5c7R+gH8qieCUVdHdXxlaMNzza6t2tnLSjz8f8B\r\n qZDDLaKypsJz8mc459a6WZIZDlu9RW9haiTzmbg1n9XOCVSrUMCz0x535TA9a66HQbdIRI3X/P\r\n vVXUdatLGPEHJH+fSuTbxjcSkwgf5/KrhS5XcVDDyhLmkdPPNbWfGcYrHutdEgMMcWf9vd1/DF\r\n Z/2O41Ubs9f8+3pWjHojWtusbdVzz9T9a1Owq2WnSX8mWn2g9tua2XtIbE+QYvNKfx5xnPPSo7\r\n L9w2K6IvDJHlvvGgDkJb14v9Wm38c1ft78fZlkkXLHOefelu7VXPyViSxvEdh6CgDootURzjyM\r\n /8CqCW8la6ZUXYvHGc9qr6Ztz8/wDnrWtMsSyl/XFADWvp4F3Y3fpVCfUpbleY8E+9WxJHJ8tV\r\n 3WFG2mgDAe2ldt2cfhWlbgpEqsu4jPNW/wBzUsLRM3ljtQAyNEf7w21owQ2S/fTc3rkis+9jaJ\r\n dy1nQTSFQaAOqksbO4XgbfzNYFxpNulyyhs4x29vrVqGaTFVZzI1wx+n8qALkOm24HX/P51Wn0\r\n lDOzJLtBxxjPb61Yh8zAqN/M89vwoARNMZekmfwoMQjcoz8j2retNuPmqa40uOfM4OM/0/Ggzq\r\n 7GZBHa/wAUmPwqhPc26XbQJyBj5vqPSmXenMhwrf5/Oqttpyu252+Y0HObapCV3ebj8K1rYx+Q\r\n oD7uvOK5+fS22fK1NtxLbxCLP3c/rQB0Lwo/8f6VUkdYMgfNjv0qh5svr+lVpZzkg9aAKeo38j\r\n 5CjH41Hpmmi4IupJeW6rj0yKjmTeav2CuiKo7UAdOFt4I8Fd344qm93FdZtVTy9nfOevNQT+Zs\r\n rIgWRZ3k+n8qAMDxDqEkINqgz7/kad4agMVj5sjZJz29zWbqsiSXm1v88CtK4uBY6aGXgY/rQa\r\n 0tzxHxJcNP4i2AcZ/9lFelaXcmzCxiHdjvuxXnMcH2/WPN68/0r2q1toUgUMPmoNx9rCLiUTMN\r\n vt1rQ1R/tUItUGzb/F1znB6VWDrH92rSp5kYlPegCnYxfZI9hO736VVu7wRZTZux3z/9arE0nl\r\n mueuJfNuGX6fyoA0bO9V3wY/1rdLxsOmK5yGPywGqY3mHK+lY1/hA05IlY8Vn3TbUMQH3e/wCt\r\n XYZPMqvNHulcfT+VcoGr4M1RhfrAUx759jX1BaAmBTmvkvw8Ps+pqenP9DX1Hpt1vso2z1z/AD\r\n rOrsdeD+Nm1tPrUqvtXHWs7z/ejz/euc9E/9P3W6Xa5Oc1Qkszcx7hJsz7ZrSvPvGs+Obb8te4\r\n fNe0kcrd2j2TF/M3/hisOSV5pDJ0z2rsNTTzFJ/z2rkHXY5X0oE5N7jQzDqabJKsqeSRgjvS1S\r\n ETtdMR04/lQSZtxp8kZ3rJn8P/AK9XLW5eSFbRhgrn5v16VvNAuzDVQW3CyGRRxQBgX+neSPM3\r\n 7vbGKwo0F02zOwr+Ndter5qba4O53afdvM3CnH8qANy11J1YWLLgf3s/j0rxr4xaAs9v5qXGTD\r\n z93rkp716LJqEcq+bEeRWBr1lLrGkSysM8D+Y+npQBy/wwvzrOlm2K+WYe+c5yW+npVHxIslrq\r\n gucf60/d9NoA61mfCK8W01abT29Rx+DmvT/iDpCxGGdRwSf/AGX3oA7nR4mh0ZJDJneOmPQmqH\r\n h5ceKZ1PP3ef8AgBqCK+8nRolz0B/nV7wovnay9z/ex+ikUAeieJYS0Y2tjj0+ledCxdnLNL+G\r\n P/r16lrK+YAv+e1ca9jIJyQOKAI7WxIHLZ/Cur06IRADbmqloixgbq6O18rAagC1LcbY8BcfjW\r\n XJeMi7j+VWr26jRcVyF1fBmO00Abiam7nG39apXM0jTMw74qjZPvbNbD7PunrQBlG4cdajIe7O\r\n wPtHrjNWZbZn+7RFCYAC3UUAXLKw+w/vDJ5ntjH+NXJJJ7iQuh2Kei9cY96ZDJ5gArWiWNIxnr\r\n QBSTTVl5kOf8/WniCKNvs4OAv9eau/aY0rmdRvGF28i9DjH5UAbFxYRqN3m/pWZJaRvHjzcfhW\r\n Z/aMknGf8/lVCaafzSF9qAL4t1gbPm7vwxWjHqEKoIzDuI/i3Yz+lc1suH/yK1rW3YQKW68/zo\r\n A0h5M3Ozb+NTx6epXer4B7YrO8zy+PSrSXmIwM0AWtoh75rKuLaaWdplfCnHGPQVFNe+9adrfQ\r\n m2UMfm5/nQBDDK0I+Ybv0olvHZjtTj602Z1k+7To/LCDf1oApu8rdsVnXNtLOCok2/hmug/c1n\r\n SY+0HH3eKAOdXRLkNkT5/4D/8AXrXhs1hjBll+buNtdNaeTt+aqGp2CSu0yHAP/wBb3oAbaXNo\r\n p2sc/nVHUL6BLh0jg3Yx827GePSslbXZJ96tNYkMYBOTQBhz3c5OY28v9aba6uYJPLuP3hHU9M\r\n /pWjLp7OflFQjw4Zf3jcE/59aqM3F3iJpPc34r2yu0wP3R/E1j3lvbi6XE2dp67euaj/sKaP7p\r\n /wA/nUy6DLIMk8j/AD61p9Yqdyovl2O6lFlLZJcG4ClAeNpOea4zU9Zs5Xe4RuTj5ee3HpXJ6y\r\n 11APsyv/ng1za6Zc+QJGY5Of5/WplVnJWbLnVlJWkbNzrkrORDFuHrux/SsR9T1C6uWtwDCBju\r\n G7Vast1u/wAwzXTQWMdwfthXBb+nFRdijUlHYxItNeJfNnm8z224/rVqCC2lk8wR4z7mr97CxX\r\n atVLNDHhG6ii5csROSs2b0V2LJQVTP41si8NzZJMY8bs9/Q1zNx9ys4axNGPsKDhf68+lIj2kj\r\n dWSAv877PwzUU7hZiI5Ny9jjHasj+z7i6+fOKlitJoW8o84oD2kjYjuiv8G78ap3N0rsQUwfrW\r\n xZwqAN1Zl/aM125QccfyoD2kihHN5ZyK2FU3UCtu25z796yvsUnpWhATDEIz1FBdOTb1FisTG2\r\n 4y5/D/69UNQlkhlYj5hx7Vp+dWZPIks7Ifb+VBsZceoTSNt2Y/Gp7a4nS9O5Pl45z7VsxWUYG6\r\n rk8EAtQU+/3/Ogio2loWpZYp4cd6yCohTOM1mQvNHL8/3a2QBMOOlBj7SRHb34Ztvl/rVwybpC\r\n dn61D9k8r5q0IfL8hfXmgPaSJIpEA5GKnZI3+fPWsqbP8FPTzPKFAe0kWnlCdDVN7+bcUVsCqk\r\n 3mZrOMpWQg0Ccm9zWKSz8+bj8Kq/2dcCYyi44PbbT4ZuK0UbcuaCQXzQu0vn8KsQqhADvz9Kir\r\n NnWZZGdfumgDRu5VthkDf+lc3PfM7GQR4z2z/wDWq55jSfK1QzrGsW3vQBDBeCU4ZdtdFbTRxI\r\n pxu/SuHXdv+WuhsUlfANBdOKb1OkN0JRgR4/GpRBCLYyM2D6Y96gYLbpluK47X9aa3iYoflP8A\r\n 9b2oNvZxOVvsTarsD45649qteKmW00lYg+4gHnp1IrntOaW7ufP681leMb6Uu0BPTH9KBqKWxT\r\n 8Mg+cZsbvb869SjSe5bePkB7delcd4LtFaLc3+etesL9nhtl9Rn+dBRRh0wsMtLj8KvxIY/wDR\r\n OoX+L689Kit7pZH2qa1ZdkMHmnqaAOa1a3W3Qv5m72xj0rhYbsyXzDbxxzn2rb1e/a5Yop/zx7\r\n VRsLEqolYcmgDZnbZDuqrBZfaEF0ZNu7+HGenFS3Bym2kgDrbgL05/nWNf4QLiOtvxnd+lN+1Z\r\n lZwuQ2O9Zc3mVZhkVYAH+93/ADrlA0LVliuBPn8Pwr6C8LXq32lwsBtzu9+59q+Y5ZmP3a9q+H\r\n t6fsEMLHkbv5tWdXY68H8bPTzNibycfjU02IpCmc4qo4xcBv8APSkvJh9ob8P5Vznon//U9uuL\r\n je5AX9aohf3hJNWwm96pXZ8mVh9K9w+XKOo3HlJ93d+OK5CWXeTIRtz2610sx+0fL1rnL+1eN2\r\n A6CgBbdFnON238M1LNLFZOY/vkd+n+etYsDyI9R3rSNIz+tAGq179q+RU2e+c0sszWtuAV3kd8\r\n 4rFsrlY3+at2eaKe3GKAMWG/FzJtZNv45/pWX4tsFuNP/dvtPrjPcU6SNo5Cy1HfSma28pqAPI\r\n dPuJbSUwP+8Hr0r0nS72OaxewMXDD7+fcnpiuA1C2+zSF8V0Gh30YihJPLbv60AeFQK/hDx8qZ\r\n 89Zm6/dxhPx9a+p/GVuuoafAqHG0E7vXJWvBviTozW2rQ6oo6ZP6KPWvYPD+qLrGg25c5Yhv0Y\r\n /T0oAqpbfaLBYmfZt9s55rq/C0Jsokuh+83Z46dMiuI1GZrYmJT1r0bwvt/sO3aT73z/8AoRoA\r\n 66S6N2dxTb+OafI9ukW5vvelZv2mNK4nWNVlOoSwxn5RjH5D2oA6truORtoO2tNLmO3tlbfuPP\r\n t3ry7zrgfNWjbm7uEAHQ59KAN281Y3DFAuPxrIleVBkLurQi0uYfMwrpLPSklt03Dnn+f1oA5v\r\n TL2RXGYv1+tdIqSXEpl+6G7delWv7Ljt/mxWjAsaxK1AF2xslK/MaydVRUuniXtjn8Kvf2nHBx\r\n mudvL0T3ryjocfoKALFuXhbdjd+lajSNInmfdJ/h61DaTQ4G6opblXvHjTpx/KgCnMZCeuKyLi\r\n fkwlckd8101xBhN1c3LFumY+tAEVumG3Gnm6xctF5XTHOfar8MHFStbIh81upoAmSZI0z5Wfxp\r\n 6XCTfw7M9s5xVX7RGRtqt83nnZ04/lQBfntVxu3/pUS2aNEH83BPbFNn8zZWYPP7dKAEubbaeH\r\n z+FV4rGZzvEuAe2Ks/N/FV+GWNYQO/NAEltBsHzPn8KR0mkuWjjHy8YP4VTmmbPy1Ja6ytuRCw\r\n yy/wCfSgDZXSpyu4yY/D/69UZbcRSFGfkdeKsT+IG2fKP8/lXOTXslzIZj/F/SgDX246SY/Cq1\r\n zLLs8pX6d8Vm+dJU6MXUZ60AYU8NwG3CX9K1rDeIl3tk81Z+zeZ2qxFYuoBA4oA6GyEZGW5qC5\r\n EhunEZwnGPyqKFJYxV03MMUf7z73egDOnuHtVy3zfpVSPV1ALngt/D6fjimXk63BwtVP7H3Qi4\r\n Jxnt/k0Ac1qcM13c+ejcelZ015LG5hZMY961ry9+w8Yzisc3KXjm4IwW/pxQBatrlFOXh3f8Cx\r\n WourKW8pIdoHT5s/0qjD5XHpUwg/eeaOhoAuS3TKN3lbvxxVaMmZvtBXZu/h64xx1rdtFhkG1q\r\n bcW6JMyp0oAy5AXXHStjT9JtTbpcucuc5HPrj1qr5NWlkdIhGOgoAkupkjG2MYxWL/acSOYnXL\r\n Dqc/8A1qnmSSSiHw+1yBcE/e/px60AXYJ4pejbfwrT2RrEJM7v0qnDoWwdf8/nVe6mFsTaZ5T+\r\n vNAF6OWB22t8tUb63UTMyPkccYrmLu5mjO5KW01F5FUOef8APtQa0tyee5khOFTd+NZG+Zrhrg\r\n rjdj5c+gx1rt7SCG4ALU26sIlkbaOKDcxE1Vwm3yvxz/8AWqWO5T/XyPjPVMdO3WmzJFHVA6c1\r\n 25dG4NBnV2NnzrW8+QN5Z9eTVq1iW3k8oN5gX+LpnPtWbDoMkY3Z/wA/nWtFCbeMZ5x3oOcv3R\r\n Xy+BWbDFNIcgfKaseZ5ny00aj9lb7Pj7v9eaAEnmFoMuu6r1pcW9zapKTtLZ+Xr0NOitodS4Y/\r\n 5/Sq8+kraSmNG4X/AD60ALLHuP7td1Ys+nlpmdn2E4+XGcVp/b/snHWs+e4a6lM4/i/pxQAJaB\r\n P+Wn6f/Xq0snljZ97HeqHz+9aEERaIMRzQAvnn+7+tWFvVeIQGHkfxZqPyPalcxxR89aAMq622\r\n 539fasiR3ujvHyg9utW7wtcHatQQlbdRE/BFAEttaFDuJzXTWzpbxq+3JOeM4rJhmjxV1XEjKA\r\n eKDWluWdW8ya0Mqjb7de4rxnWr3zrdrdxtMffOc5INe76tLDb6WS/p/UV8reJtXRL1gh4kPH4A\r\n e1BueleCrNLuwkuHbZ5eOMZzkt715dr2p/2hrc9osW0KVw2c/wAIPp7V31nff2NoJcnG8fyb8f\r\n WvPNMgN/fG867z/IEUAek+H0NjbAfe/T1rZ1C7ZLRZt33s/L6YOKS3tfLgFYOqs7YhHb/61AHV\r\n eHW83967Y/ya1td1FUhKr/P6VyViXs7Mv0//AF1hTajJesUz1oA0NMYXdzhuAa7mS1SGIBTnHf\r\n FcXpdpJE3mV1T3BMIB60AZjqWbFXYHAAgK9O9RwR+Y9WpovKJesa/wgJPbRhd2f0rm7iJvOYq2\r\n BxxitGa+z8uaoM24k+tcoCJ8vXmvS/At2RcCILwP/r15pXa+CpduobfT/A1nV2OvB/Gz6Dlkwy\r\n nFUrn55mbOM4qOaflearSzfOa5z0T/1fcYiEbJ5rn9Xut1y6hfTv7Crc11s4zWBdyebIz+te4f\r\n LldL7yGyU3fjip5bmO7j37dhbtnPT8qyJupqgZXVyo6UAW2gCtkc0yQRyp5Z+U+vWpoplx81Yt\r\n 7Kftj7Pu8fyoAd/YIkO4XO3/gH/wBerI09rceWZt4XvtxUMM0mKsPMccnmgCtLGo461itD5t06\r\n bsDj+VaE0/NZxfbIZfWgDjfFliIIiytuP0+leb6XqpS4ihZdvlk9+uc17Bqkf9oKUrxXxLpc+l\r\n Xb3IGE4/kPc+tBdNJvU9H8clNY0ZXjXayj1znlfp6Vz3wr1A3TNpU/7o2/8XXO7celSeGdUj1a\r\n 1+zyHP8A+s/4VhmKTw94nuZIuEk2Y/BPx9aDb2cT0m/hF1euobAT268V3+gxk6PCc7fvcf8AAj\r\n XndiWknWRv+Wn9K9IB+xWiQj+H+pzQRUiktCveFo+jZrlDIWv3ymenf2rcWf7RJir1rpBkufMI\r\n 4P8Ah9aDEYkRkjGI8fjXW6DboIkjkTGM85+tatrp8McY3D/P51eZIo4QIuvNAFq8treOHKHJrC\r\n jvzbDHlZx70w3MiN+96VUluYpHJHQ0AOvdaaRdogx/wL/61VbfUHkjEW3b175/pUmyJ6rmMRzF\r\n h0oAivLOd13K/wClUkhuY4hldx9eldhaSQyAK1TS7Q5jRcgUAclbRXc7Yxt/I1bW2ntLgs3zn8\r\n u1b/nfZ+dtc9eapI125C8HH8vpQBfuNWndPLFtn/gf/wBaqdurzHLrsJ7daWLU1/iX/P5VO17F\r\n jzBxmgCw223XOc1AZBdptB2frWbLcNcfKpp0MUkIBNADZtOeD5xJu/DH9antZtiAsuT35q9FIs\r\n nDVWnUJKyr0FAE8l2rjGzH41JHMvkhfLzjvms6ti2EYt1J68/zoAz5bbzTx8tZ8tl5XzGX8MVr\r\n zXMaGubvrhmkZl+6cUATRyYbGN1VZIl+1NKR1xx+FFlOu/DVZuGDTkr04oA0InhZdpj/AFqIwJ\r\n JKQvyj060kFSLE7TEjpQASWSoM78/hUKwP95RkVfnhk2VUiupYwIMZA7/WgCZJli++OlW01hUA\r\n RYNwH8W7r+GKdDp63XLHFXl02KBfL647/wCTQBEl/wCZz5OP+Bf/AFq5bVGnmvXVfkXj37V2Gy\r\n OOoJrWKRTN3NAGBp+n7SGklz/wH/69VNW1KWzmeBBvRcYPTqAanu5mgPy9qxbmRZovMfqaAMCb\r\n UBcsQ8P/AI9VCVWU70GB2X0q8PK3mtSKzFwBjoaAMW0kkkOMY966VX2WyxkZIzz+NWodH8vnH+\r\n fzqvdLsYr6UAFnvL8NipX1RlvmszFu24+fPXIz0xTLL79WjAgu2mPU4/lQBosu2PfjPtVdZuM7\r\n P1q8Z4ym2kBiMI/GgCr9qQdU/WrSX6Kg2tt9vT9KwLzdn5K5G4lu1u3Vc7Rj09KAPQ5NUdfunP\r\n 8An6Vz88jz3b3BP3scfQYqraJM4BatQW5HJoAQ263C4JxWedLEch2y/p/9etHzPL49KryTgsTm\r\n gabWxbt3MAwGzWgswn4JwfzrB84etAkdTvHQ0Fe0kW77T2xuWTP4VFYxvCisZOfTFWortZflaq\r\n koYXLbfu8fyoE5N7m21zI64AqB7l/L8opkjvmrFptwN3WnzeV5hoJM2KVo23Fc1blmimTJiwx6\r\n nNO/dVXbHmHHSgCkJLqBsxn+VWAbu4/fO+N3bA7Vpw+TxvpskkKuQvSgCqsf99d36Vu2mlRXMC\r\n y+Z5ec/LjOPxzWT5sXr+lCag0b+Wh4FAGhdWEVtz5m78KyxehD5YTIHfNMvbqSRazYcmMMevNA\r\n HQxzh+2KxL8yvcMqjgY5/Cm/avL71sW8kEtsrt945/nQXTSb1Mm0j8o7nGaw9XWVr2SWNflOMD\r\n PsK6mbbn5axr25MYKlc4oNvZxMSCa4Jxsx+NdTaOyRIWHPP8645dX2P93/AD+VdPYXH2qNJMfe\r\n z+lA1FLYj8Y3rjSmA44/qPavk29aXUL63tkPKs2T9cGvpr4gzfZ9HY+39Vr578CW4vNSkvpuUB\r\n 4P4MP6UFHofjXFroVvbI+Xwe3+0prO8F27i3hSQcjdz+JqlrU0mtaosUfMaf4D6elei6bbQ21s\r\n kie/86AOnujHbWwOc4rlrTbqV6wYeWoxhuvaq+p6i0ymNTVaK6+yWCP/ABnOfzoA1dd1SOyi+x\r\n xR+Z/tZx6HpWToOnpcFZZZdhbPy7c461Xs4ZL+TzpeRXbWOjKQJ1OAf8+tAG8bW1t4OJM/hisb\r\n KTymNWwB3q9cWeU27qwEheC7YA8DH8qAOxtNKCAP5ufw/wDr1R1iRIFZc5I/+tU0eprBGAx/z+\r\n VcbrN+11cyFOQcfyFY1/hAzFm86YjpWgGAkMWeneseC3kD7qvJDKZy3+elcoGk0ZUZHNdH4Tk8\r\n q+8w9+30BrDZ1RPmrQ0CdTffL0/+sazq7HXg/jZ7+/zxCXP4VULeZ83TNNE3+iD/AD3qlHMNg5\r\n rnPRP/1vU9QtSmSH/SsUR5Xk10uqfdP+fSsMrttRJ9f517h8uZM8OOc5qgQnKnrVwSeY+KyrxX\r\n S7fHTj+VAEhtWk+6+PwqP7Dt5Z8n6VLFdKgw1EtyHJZTxQBFlYu2aY6eaPMB257VSmn5pyTfuh\r\n QBBNBz979KzZQWzF6d6uzTc1UWdCSD1oAobxZHe43+3Suf8Vww69pWEAhbB/2u4+npW1qUbSL8\r\n tYVtHIT5T9KDWlueHaDfT6Bqf2eRfMXP3s47H6+temeJfKubCHVo+Sc5HryB1qh4w8MNFEbyAc\r\n //AKh61g6LdyX2ipYSnLx7s/ixNBueheENah12aKFk+zlM853Zzn2HpXrGvYSRkU5AA/kK+SPC\r\n mozWXihbNT1PT/gJNfVOoljM0b9cD+QoM6uxnaUhafk/55r1GwiRYlOcmvObGPy3zXZW13tjUZ\r\n oOc6ow+cuA+38M1FHALaQ75N+O2MVRhvapy3Mj3bYPBx/KgBuu3O+MrHHg+ufpXKWIlfCsea7C\r\n 4RZE+esmK3Cz5XpQBpQ2RC5Mn6f/AF6huOCYh271fL7ErLdt7FvWgCKISRNkNn8K6fT9YijVYp\r\n YN7DOW3Yz+lc3UsETs+4UAdrc3NrOnEW38c1yly0CSMBDu984p87vGlS2qrLArN1Of50Ac7PcK\r\n pwIP/HqqrbzXhyv7sHt1rtP7Pjk7f5/OrC28FtGAeooA5mCxayG9j5nt0rUMwngH7vZn3zT5b2\r\n 3Pyk1Ra7iU7V6CgCi2+F8jmpxmRfNPBPapt8T0rYC8dKAKTvsqdZnMA2j1/nVWertgyMAje9AG\r\n HcRXMp4GPyq3Fp+60UO2H5zx712bRWkabm/rXOXNwhuGEf3OMflQBystnLCxKNu/Cr0MMxhWQj\r\n rXSRJDIPmrZSC3+zgfX+dAHn738tuf9Tu/4FitjTdVhdFMqbWOcjP1q1eQ2+axo9PV7guh4OP5\r\n UAddJd2zp/n/AAqKOe3MYCwbv9vdjP4VRbS8p96tSz8m3tUiY/Muf1NAFdopJOUfy/wzU6GaKM\r\n RH94R/F0z+FMmmUH5ayZtUeBymOBQBcmFw3Rf1pzyPDajcORnj8ayj4jVPvD/P5Up1aO7XI4zQ\r\n BiXV00rkGPH41hXjtuMQ4xXTTCMHdWDcRiSZnAyDQBgi2YHO/wDSum0q8MKrEY92O+cetUPI9q\r\n 1LFY1wD1oA6z7Yjx8pj8a5e8ZZrl1BxjH8q0Z92z5a59YpWu2Y+38qAL6I1v8AMBu/Sladpfm2\r\n 7c9utbMcK7PmqlJCN529KAM4GTPWti2tvMhVzJtznjFVfJo3vH8g6CgDQ+wRnrJn8Kxrm3ijuG\r\n GN2Mc/hVrzpKGjLr5h70ARxSpH0T9arz34ErII/TnNQzPsNQIvmHf60ASnM3OMVVkgcMQOa14Y\r\n eKuiFMc9aAOZ8mSt+2sVmsU3NtPPb3qz5UXp+tV3uRE3lL0FAGa2mNC+RLn/AID/APXrbt7BWt\r\n llL8nPb3qpv8zmtGGXbAE9KAM6YmDgc1SWWSV+mK05k31LaW6AgEc0AZkiyIM9aRJiUGV5rpZ4\r\n I9nSsZoRnjpQBnv5jHg4/Co/JlIzu/StLyasKqLHg9aAOdcyp70+2kYyfMv41fm8uqySxq+3vQ\r\n BpSBCnJxVbbCIvv4PpiqV7O2zC1y7tdvKdudp+lAGzdShT8pzVa11I+b9n6Y7/AK0yK1mflq0b\r\n fRVLee3BP+fWg1pbmq00cMe8tu9sYqrJqFpNANyfMfc/4U+4soym3d/n86x5dLG3huP8+9BuIl\r\n nZXL537fwNbNlCsEvkocqnQ+uazLLTPn+9W6kH2dyOuKAPPvideGTTmgC446591ryHw6RpXhiG\r\n QfO8m/J6dHP19a9I+IEnmRMv+f4a8hW68vSIbb+7u/Vs0Ad74PgBEjyHcz459MZr0aDSmXT0i8\r\n 7kZ52+p+tcF4RGLfd/nvXoJutlqvPr/OgDk7q0+yuWL+Z+GKzmWS+kCAeWPzrowv2x8da2LPRM\r\n OGx/n86AJdNsVjtfKB5/vfjU8k0lhaiJW37c89OprWMHkJiudvJPMdo/SgCjFqdxcybfuj8D/S\r\n uhhhYRBm+Y+tZNjZENu/z/ADrfuZ44LUKeo/xoA5jU8sCA+38Kw7Z9snlN82P4umalup2uJCq1\r\n NDamOMO3Wsa/wga67ETOM0gvEQZ8vn61nefn5aUnK5rlAivbozAhRt/WtbwyCkqljk5/xrnpup\r\n rX0KTbOB7/AONZ1djrwfxs99im8y2A6VXUhRjNU7ab/RxTPOrnPRP/1/Tby/8APJXZj8arO+61\r\n EOMYzz+OaypJ/wB51q9G26EN9a9w+XMpLf7PJv3bvwxUV3OsjsdnX3q9N1NZE/3jQBi3SM5OGx\r\n USPJFEEI3Y79M1am6mlTZ5Qz15oAxpp3/ufrTkuGEQyP1qzL5faqT4xx0oArTXJyeP1rGeaRZ2\r\n cDg44rQm6mq42d+tAEn9pkrgw5/H/wCtUDzowEgXafTNSfuqy73cCSnSg1pbm9LPBqVp9kkXbn\r\n +LOe+en4V5JPpH/COa1O4k86KTbjjbjC/U+tdXBcyI9O8RwC90hZo+ZFzn8xQbnlunaU0XjSC8\r\n Q70YnIxjHyYr6z1uyjbUZJlkwCE4x/sivnjwJPb317tkOZIz/MNXt19cSvIWPt/Kgzq7GjbWqS\r\n cCTH4VqJYbDtEmQPauWsppN1dlasWjVj1NBzlmGzOAd/6VdhsgZMFvxxSw9BU7v5Q30APudMUx\r\n 8S4/CslbXyD97djvjFLNquTtzTkfzIg/rQBXuJcgrisx5vLHTNXpuprKn70AWYZvOOMYretpkh\r\n URlckd65uy+9W0YnJ3DoaANWRY7oYzt/WqJQ2reUp3he/TOar75Eq/CyvCGbrQBD/azw/8ss/j\r\n /wDWqndXkl4CQPLz+NSzeXVJsZ46UAZDadMzbvPx7bf/AK9NazkQ583P4VsU94t0IagCnaQM52\r\n 78fhW8LNViGZMn6VhW77Hq287mQ46UAQXSlenNUYJpIpiwWuhiRZB81MlgiVzigClO814mwHZn\r\n 8aitNPIAieXJHfHWr2+JKrKzNclk6HH8qANP+ytq7hP/AOO//Xqu7vCvlBt23v096vt5nl1lS5\r\n yd3WgDJuWkf+KqMMs8c20NkCr83Wo4Nnm89aANIz3GzrT4oJJYxM0uN38OKtny9lVfm2/L07UA\r\n Oz5Z5bd+lNe7gK7Gi3H+9urPm82oBHIwzQBFc2kVwSQdv61jvBJZudrblH4VveTJT5oV+zDd1/\r\n 8Ar0Ac8b5pvkI2+/WlV2X5Mbsd6pyQtvJWtW3VVhXzPvc0ASRxlx6U9bMrIZfM4PbFN+0xpTzc\r\n q6/LQBo/ao0XaRms8X6C6ZBFkcc59vpWdMkz/d71Zt7VkiWRxzzmgDekuMpkDFLAgeFXJ5Oaxv\r\n Pz8laFvLtQDtQBO+V6Lmo0/ePtI2/rWlDPCfvVnXcqrOzp93j+VAE0sCxruBz+FWIoBLbK+cZz\r\n x+NZP2vzflqwl15cYjz0oAy760+Y/N+lNs48ARnt3qxM/mU224loA11gCLnOaDCWG/dj2xU7f6\r\n uqrS7Rj0oAhfKd81izgtcMc+n8qvTT81nk7nJoAvQdBVoSENtx0qtD0FaCxZUP60ASxKHHPFMB\r\n CXBTdwMdvak37KyLqVxO0g74/lQB0Vy4CferPSUbemaxftUsny1o2+REM9eaALnmj0qtIA7E7t\r\n vtT6xbqR1nYDpxQBbe0D/8tcfhWY1kUuGbzcjjt7fWjzZfX9KdJIVhDt1oLppN6lhkUrjOamtv\r\n KGIymSO+axoLrzX25rcVNkYk9aDb2cS+4iiXIXNYd3LI7M0bbQegxmmzXuTtzUAbcNx6UDUUtj\r\n EuJbxTw2fwFMF7cCEBjyK3j5P8VYV/t819nTj+VBRZsb+bf1rdOpsFKNHuI75/+tXK2X366ExZ\r\n TfQB5d40u9yNlcfj9K8Nl1JjOLZY+Aeufxr2Dxw/lof8+leP6Ram8vt3Xn+hoA9+8K2gTTRKX5\r\n x0x7mrVzqOE8nb075rLsbv7HbiCrcVm9zJvHQ0EVG0tDU0aZhJu2Z/H616Xb3AEQcx4B965PTr\r\n JYACwrevdQgTT1iQ/OM/z+lBj7SRX1LVowu1Uyfr/wDWrFt4Gu2FxnaW/h64xx1rEtzNPcHf0z\r\n XXWQW3ky33aC6cm3qXY0W3X5/zrkNYvfOuZIY/ujGD+A9q0fEmqqYStuef/wBVcTZPJJEry/eO\r\n c/nQbGlZw+U+9ju9ulbFxch49ipj8azoegrQEe5M1jX+EDDYlG3dfaphdZXG39ammhqiRtJFco\r\n Cu2/2q3pcvl3X+fSqVPgfy5t1Z1djrwfxs9ptLrdAABVpQWGc4rlNHu/MULXRNLsO3OK5z0T//\r\n 0O/l0VQ2fP8A/Hf/AK9KkQjHk7s7e/So5p5KoSXRTk17h8uF/IIBuHzfpWVG32pd/wB3PbrTpp\r\n /tOVqrG/lSmL0oAZdQeWCc5rJk3iPeO/auknj8xM1QkWNLcK3X/wCvQByjSSOxXGKvR27GEZPr\r\n Th5XmVLLcxxkr6UAZc1ucnmsuW1fcTu/StSa8jz1qD7RGyZoAxnR075qwfLNqu488/zpZp465y\r\n +u2WRlU8DFBrS3K91dJbtwN1SWmqRvBOGXcJAMLnpjNcvePI5rnxqElndOJD8nH8qDcZ4LhudP\r\n 8Ws2SySN04GMIfr619SaoEhJOcnA/kK8I8Ly2txqKzp978fQ165qEzz3LY5GB/IUGdXYmsL3dJ\r\n tEf6//AFq7i2l+QZGK4vTY1jbc1dOs4LfL0oOc6SGTjpSXExlBhC4x3zWdDPxVqKdPMwetAGFc\r\n 2UkTb92fbGKuWt0ywLGU6Z5zW7PHHIlYrtFHmPuKAJeJep21j3xeN2VF3j1zillmbPyVClzKx2\r\n YzQAtjLMXx5ePxruYXUWqFxhucj8a5eFpIudlWpLmR4t2MZoA1MRTNjO2obiMQZAfOPasaCaTf\r\n Ud7PJ5hFAFjHnNgNj8KtrabU+/n8KyrJJHauhKlE2nqKAMx12e9P+0qIfLI6e9E3U1QMTs5YdK\r\n AIHZlOQM1qWQ88AMNpP40sUK4+aryxrGu9elAF3+zwq7hL+lZNwCjsmc471c+3Z+XNY93PmVqA\r\n KU+496s2d5DbqBJyw69aypp+aI7L7Qglz97+lAHVHXbYrt2fqf8ACsG61XdMwSLK8YOfb6VX/s\r\n z/AGv0qytskcYU8kUAVfP8zkjFIlrK0nmr900ksDdVq1b3UscS25X7uefrzQBcXYVw8m38M1aj\r\n uLeGMRbt+P4sYzWf/Z8l2fT/AD9akl0YwwDLf5/OgAnvLYdOahTUowuBHkeuayRYea+3dUssH2\r\n YGH+7/AFoA0v7Vh7x4/H/61YN9rULTtHjAGP5fSsi787+GqS6NNdL9oY8t/T8aAN+C7tSclv51\r\n Uu7tmnbyUynGDmsz+yZI/wCLH+frXUWFtElkivywzn86AOfMUkv8W38M1rWlsqQqWlyeeMVPLC\r\n n8NUjDPvOPu0AbUd5HBx5e/wDHFW5Lhbi3DKuzPbOcVkRQtj5qesu2YwDt/wDroAqlGR85yKvw\r\n SCQBOhqSeDCbqyId4uTjp/8AWoA1prWUDckn6U5IC9uod8Nz2961I9vl/NWZcZ3ts6UAUlhEDZ\r\n 37vwqnNfD7S0eOmP5Us3mVmrYzy3JlA4OP5fWgDWNzsXIGaktLpnk3bMZ96a1qyJ81LbyRx4Tu\r\n KAOga5UJgisOfUUErJj9f/rVFeztswtcs6XEspYd6AOoLpL/ABYqrLOIHIHzY79Kz4YbirD2kr\r\n KCe9AF+11AOduzH410EV4gQIV6d81y1lZSb+n+fzrRmjkikI9KANzylmP39ufbNUbiKMMYN2cf\r\n xfXnpWZ9pkSmiSSWQv60ATNElr8+7d7dKfHqEb/w4rPvvM2Vzq+f5hx0oA9GhEcvO/H4VmXccY\r\n uWTdnp29qzrP7RgVHdRXDTs30/lQBsR2cLj/W4/Cq93ZowMIlxjvisjfcJ/kUnnynk9aDWluTW\r\n 2krbvv8AP3f8B/8Ar10LiM2iruwee3vXMedJVeSefcQOlBuR3YML7gd36U1dR2W4zHzz3pxRnH\r\n zVRul2ArQBC1087YHy/rVuGymmUL1z/FWXB9+uos74QoI8dKACHSJIPnL59sf/AF6m+2bC1uU+\r\n 5jnPrzUd7qc2z5V/z+VZBlcwG6k4Lf04oA8b+IOqt5jQrFn3z/u+1c/4WtBBbx6g5y0mcp6YJH\r\n WpfEt9DcajsY9/6D2qO1ukjmFoh4X+vNAHfwRtfyhwdg/OvUNEto0iRJO2fm9etcVoNpuUNj/P\r\n NdzMTDaKE+8P8aDOrsXtXljtIsxNvPp09PrXCLJc3MxnPAb+D0xx1q5Cbi4lxL0rpLWzihw7j5\r\n aDnILFFKgOuw+vWsjW9dFo7WUMe8pj5s4znB6YrT1fUIFjKwHn/wDV7Vw9lbS3upNLMMq2P0FB\r\n rS3FsTdXsu6Zdqn3zW7Jp7o58vle1dgbG1t7cFAN341hSX4i+QDOKDcyMzRceXnHvWrbzloF3J\r\n g896zptT5+7Vq2l86ESeuaxr/CBK67qom182Yjdj8K0KrO/lsWrlAbLpvlru8zP4f/AF6y2jw2\r\n M1p/avN+XrWPdSbJ2GfT+VZ1djrwfxs7PQZNhHf/ACa7CSYM5bpmvPdGm+Yf59a68zDPWuc9E/\r\n /R9FjjS5bDfJ+tc5rcTW0zoh3AYwenYVszM0RytVrlRPbB36n+hr3D5c5fTf3suHO2r17Zxw3D\r\n TiTOccY9qypN1vJlTVae6llJBNAGqupIfkK/jn/61Y1/dEytGo4GOazJZHjOQajDmQb26mgBBv\r\n Dbs1XmhaZy3mYz2xVqqjSETMtAGJfQyQDIfd+GKr2kryqE6e9a18m9eazIECDIoAqaiWtU353f\r\n pXPx3jXHJjxn3ra1Ri6EH/PSs2xiUKv+fWg1pbkE0RAztrznxI7zNJEqeXtx8+c56dq9guI12V\r\n xPiCyjaylkHBOP5ig3PP8A4fa2ya0tix3ZP3vwY+lfWk223bafnOBz07V8K+BEePxivzZ+b/2Q\r\n 19v37nzT9F/kKDOrsXYZjMdqjb+tdJa2rCBWLZ69q4mydt1d7aSn7Ki49f50HOSB/K681D5jea\r\n ZQeD2qVk381LHaZUHd1oAG1SQLtEefx/8ArVjl7i6umIXaDjvntW+tsg681qwW8SQK+3n/AOvQ\r\n Bkx6adm5m/StC0+zW5AePcR3yRTJ7kgbQOPrWJcTPuJFAHdC9090CmIL+JrBvpoPMZI+FGMVxc\r\n 91OvRqSKSWTDM3JoA3hciJshd3404n7SfMK7c9utVoIsjk1rxQAIKALVgqQ8kZrRuV3p544B7f\r\n pWWGKdKuLOzQhCOOaAMZ5tzEEYrftLSF7RHMnJz296xJ4RnINQrPKg2BuBQBp3EIQ/K36VRk1B\r\n o0+y+Vu2/xZ6556YpBK7dasLCroHPU0AZCytuziopWMshPTNX5QF4ArHkkPnHHFAEv9nedz5mP\r\n w/8Ar01LaWOTyBLwvfHrVqGRsVKw+bzO5oAgltZo13CbP/AabArsAWbmrLMXGDVZiY2KigDXgg\r\n Rupq68lrbRgGPcR3yRXNi7kQcUjzvMvPegDVXUo5G2qNn61m6nqEpBhU5A/i9e9Yc6Mp3BqsRI\r\n XtwzHJOf50AYX2+4tZN2d36f41r298b1RK67S3UdelY95CM9abbyGKMAdqANq5migUnbu/HFUF\r\n 1ePZjGz26/0qBpGl4NZ8ulrK5fdjNAF2S9RznzMfhUyXBSEOr7uvbFZH9kJ/f/AEp8UJif7OG4\r\n Xv8AXmgDZt9Sd2wYs++a6a1uUaNUaLn1zWJZWyKM1e3FZyBwB/hQBozKAMiuccOl68/UHHH0Fb\r\n U7tsqrGoZAx60AOl1IyR7PKx77v/rU6zhlZRKI8g+9J5a+lbVneGGFYgudue9AGbeSzRLxH+tV\r\n IL790A0fP1qzql+5B+XH+fpWNbuZIg575oAuvKr/AMOPxrUt75Le1XEHmMM/xY71iVq6bhnCMM\r\n igCvJfSXp2G38oeu7P9KxJrZorp8PkcdvavQL6KOOHcq4rh58mVmNAFlIhIuCcVZS2jjUDG7He\r\n soSsnStKGdmiXIoAebtIT/qc/wDAqY+oqV/1OP8AgX/1qk2huoqrLEN3FAF+xvMtxD/49V64SS\r\n eUuItoOO9M0pFBBIrVvb825aNU+77/AP1qAMI6V5v3m2fhmrsOkxRIMy5/4D/9euQ1PX7lGO0Y\r\n /Ef4Vc03Up7mzSV+rZ/mfagDZurONxjf+lUk02GNA2/J+lBlduppoZt23NBdOKb1JPtq2nCw7/\r\n 8AgWKgfWkdiDbY/wCBf/WrThtVk5asa/t1ju3A9v5UG3s4j/Ojn/g2/jmqcyoHNICV4FZ9w7GR\r\n j9KBqKWw950TtmrIkj+zrLtznPf3rmpmb1q9BKxt1Q9s/wA6Cib7Yrtt2Y/GoriATAtuxn2qlL\r\n lDkVGLlyMUAM8nyWznNdRpiRSQpK68nP8AOuZJLda17KZo41Uds0AdLcTWsacw7v8AgRrida1B\r\n GhkjWLy0HQ5z6VqXtw+0/wCfSvPPHF7Ja+HhOg+Zgf8A0IUG1GKlKzPm7xFeNHrJ8pt/P07Cu0\r\n 0PTJrrZqDPtL/wYzjGR1rynQnfVNaJnPf+hr6i0SxiRI4wOB/9egiulHY6/QGaONVKZx3z9a7V\r\n LRZUEpfGf4cdPxrLtLZIYwVpFupEu2XsMfyoOBzbdmaTQxx8EbfeuW1fXHjdtOih3bMfvN2M5w\r\n emK2dVvX8rgYIrK02zS8VZpeS2c/hQBzVpaXM0vmSPkemK7O1t4o41PRq2P7NhhTK1jXBKSsqn\r\n AGKBptbFpwXGDJx9KpsIk+QpvI/izjNR739asIm9QxPNBXtJFJ4YX/g/WnRIV+RVwoq95Iq8YV\r\n SzWTvz/Osa/wAJdObb1KK2yt1fH4Vi3jf6S1sP4cfN9RmlmupA5UU2NPMl3nqa5TYWLT/L+cyZ\r\n 9sVm3ttumaTd1x29q3pmKJxWPMSy59aia0NaMnGWhNpknksBjNdcspcbulcdZD5q6yEYQVwVZt\r\n bHq0Xzbn//2Q==\r\nEND:VCARD\r\n";



function $469f41b12f767204$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
        className: "vcard",
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("button", {
            className: "vcard__button",
            onClick: $469f41b12f767204$var$downloadVcard.bind(this),
            onTouchMove: (0, $ad12973d6e24df39$export$f3f8da4197e92521),
            children: [
                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $fc9ca4f87b8dc19e$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("span", {
                    className: "visually-hidden",
                    children: "In Adressbuch speichern"
                })
            ]
        })
    });
}
function $469f41b12f767204$var$downloadVcard(event) {
    event.stopPropagation();
    event.preventDefault();
    $469f41b12f767204$var$download((0, (/*@__PURE__*/$parcel$interopDefault($d44d9b633dca31fa$exports))), "Leon Dietsch.vcf");
}
function $469f41b12f767204$var$download(uri, name) {
    const blob = new Blob([
        (0, (/*@__PURE__*/$parcel$interopDefault($d44d9b633dca31fa$exports)))
    ], {
        type: "text/calendar"
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = name;
    link.click();
}


class $f1bc493e73489673$export$de9f45c659fccc16 extends (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).Component {
    constructor(props){
        super(props);
        this.state = {
            enableShiftView: false
        };
        this.refCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
        this.refWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
        this.refBackground = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
        this.refMouseCatcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
        this.refName = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
        this.refTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
        this.refPhone = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
        this.refEmail = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createRef();
    }
    componentDidMount() {
        (0, $ad12973d6e24df39$export$728a6effeb7267c1)(null);
        if ((0, $ad12973d6e24df39$export$a1d0d20ee9546562)()) {
            this.refMouseCatcher.current.addEventListener("touchmove", this.onMoveInputDevice.bind(this));
            this.refMouseCatcher.current.addEventListener("touchend", this.onInputDeviceLeave.bind(this));
        } else {
            this.refMouseCatcher.current.addEventListener("mousemove", this.onMoveInputDevice.bind(this));
            this.refMouseCatcher.current.addEventListener("mouseleave", this.onInputDeviceLeave.bind(this));
            this.refMouseCatcher.current.addEventListener("mouseenter", this.onInputDeviceEnter.bind(this));
        }
        if (this.state.enableShiftView) this.enableFluidTransitions();
    }
    render() {
        return /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
            className: "page",
            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                className: "mouse-catcher run-intro",
                ref: this.refMouseCatcher,
                children: [
                    !(0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).safari ? /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                        className: "background",
                        ref: this.refBackground
                    }) : "",
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                        className: "wrapper",
                        onAnimationEnd: this.onIntroEnd.bind(this),
                        ref: this.refWrapper,
                        children: [
                            (0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).safari ? /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                className: "background background--safari"
                            }) : "",
                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                className: "business-card",
                                ref: this.refCard,
                                children: [
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                        className: "business-card__backdrop-filter"
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                        className: "business-card__name",
                                        ref: this.refName,
                                        children: "Leon Dietsch"
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                        className: "business-card__title",
                                        ref: this.refTitle,
                                        children: "Web- und App-Entwicklung"
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                        className: "business-card__contact",
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "tel:+4917621015456",
                                                className: "business-card__phone",
                                                ref: this.refPhone,
                                                children: "+49 176 210 154 56"
                                            }),
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "mailto:" + (0, $ad12973d6e24df39$export$4e9e2e79518e2524)("hallo@leondietsch.de"),
                                                className: "business-card__mail",
                                                ref: this.refEmail,
                                                children: (0, $ad12973d6e24df39$export$4e9e2e79518e2524)("hallo@leondietsch.de")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $b0353496199e405a$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $469f41b12f767204$export$2e2bcd8739ae039), {})
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
    onIntroEnd(event) {
        if (event.animationName === "cardRotateIn") {
            this.enableFluidTransitions();
            this.setState({
                enableShiftView: true
            });
            this.refMouseCatcher.current.classList.remove("run-intro");
        }
    }
    // shiftByHeadTracker(offsetX, offsetY) {
    //     const rotateMax = 30;
    //     const rotateX = rotateMax * offsetY / 100;
    //     const rotateY = rotateMax * offsetX / 100;
    //
    //     this.updateShiftAnimation(rotateX, rotateY);
    // }
    enableFluidTransitions() {
        const transition = (0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).edge || (0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).ie ? "none" : "transform 75ms linear";
        (0, $ad12973d6e24df39$export$2ffdd0f7af684998)(transition, "none", [
            this.refWrapper,
            this.refBackground
        ]);
        for (let ref of [
            this.refName,
            this.refTitle,
            this.refPhone,
            this.refEmail
        ])ref.current.style.transition = "transform 25ms linear";
    }
    onInputDeviceEnter() {
        if (!this.state.enableShiftView || !this.props.followMouse || !this.refWrapper || !this.refBackground) return;
        this.enableFluidTransitions();
    }
    onMoveInputDevice(event) {
        if (!this.state.enableShiftView || !this.props.followMouse) return;
        event.preventDefault();
        event.stopPropagation();
        let clientX, clientY;
        if (event.touches && event.touches.length > 0) {
            clientX = event.touches[0].clientX;
            clientY = event.touches[0].clientY;
        } else {
            clientX = event.clientX;
            clientY = event.clientY;
        }
        // console.log(clientX, clientY);
        this.shiftView(clientX, clientY);
        !(0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).edge && !(0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).ie && this.moveCardElements(clientX, clientY);
    }
    onInputDeviceLeave(event) {
        if (!this.state.enableShiftView || !this.props.followMouse) return;
        event.stopPropagation();
        const transition = "transform 750ms ease-out";
        let refs = [
            this.refWrapper
        ];
        !(0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).safari && refs.push(this.refBackground);
        requestAnimationFrame(()=>{
            (0, $ad12973d6e24df39$export$2ffdd0f7af684998)(transition, `rotateX(0deg) rotateY(0deg)`, refs);
            (0, $ad12973d6e24df39$export$2ffdd0f7af684998)(transition, `translateZ(1px)`, [
                this.refWrapper,
                this.refName,
                this.refTitle,
                this.refPhone,
                this.refEmail
            ]);
        });
    }
    moveCardElements(clientX, clientY) {
        const center = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2
        };
        const shiftX = 100 / center.x * (clientX - center.x);
        const shiftY = 100 / center.y * (clientY - center.y);
        const threshold = (func)=>{
            return (max)=>{
                const val = func(max);
                return val > 0 ? val : 0;
            };
        };
        const upperLeft = threshold((max)=>max * (-shiftY + -shiftX) / 100);
        const lowerRight = threshold((max)=>max * (shiftY + shiftX) / 100);
        this.refName.current.style.transform = `translateZ(${upperLeft(50)}px)`;
        this.refTitle.current.style.transform = `translateZ(${upperLeft(40)}px)`;
        this.refPhone.current.style.transform = `translateZ(${lowerRight(40)}px)`;
        this.refEmail.current.style.transform = `translateZ(${lowerRight(50)}px)`;
    }
    shiftView(clientX, clientY) {
        const rotateMax = 20;
        let shiftX, shiftY, rotateX, rotateY;
        const center = {
            x: window.innerWidth / 2,
            y: window.innerHeight / 2
        };
        shiftX = 100 / center.x * (clientX - center.x);
        shiftY = 100 / center.y * (clientY - center.y);
        rotateX = rotateMax * -shiftY / 100;
        rotateY = rotateMax * shiftX / 100;
        this.updateShiftAnimation(rotateX, rotateY);
    }
    updateShiftAnimation(rotateX, rotateY) {
        const refs = [
            this.refWrapper
        ];
        !(0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).safari && refs.push(this.refBackground);
        requestAnimationFrame(()=>{
            (0, $ad12973d6e24df39$export$2ffdd0f7af684998)(false, `rotateX(${rotateX}deg) rotateY(${rotateY}deg)`, refs);
        });
    }
}




/**
 * React Router v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iawgr = parcelRequire("iawgr");
/**
 * @remix-run/router v1.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $78dc425114cabdd8$var$_extends() {
    $78dc425114cabdd8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $78dc425114cabdd8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $78dc425114cabdd8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($78dc425114cabdd8$export$e19cd5f9376f8cee || ($78dc425114cabdd8$export$e19cd5f9376f8cee = {}));
const $78dc425114cabdd8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $78dc425114cabdd8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $78dc425114cabdd8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $78dc425114cabdd8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $78dc425114cabdd8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $78dc425114cabdd8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $78dc425114cabdd8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $78dc425114cabdd8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $78dc425114cabdd8$export$fe53371bee54353d(to);
    }
    return $78dc425114cabdd8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $78dc425114cabdd8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $78dc425114cabdd8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $78dc425114cabdd8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $78dc425114cabdd8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $78dc425114cabdd8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $78dc425114cabdd8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $78dc425114cabdd8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $78dc425114cabdd8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $78dc425114cabdd8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $78dc425114cabdd8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $78dc425114cabdd8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $78dc425114cabdd8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $78dc425114cabdd8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $78dc425114cabdd8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $78dc425114cabdd8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $78dc425114cabdd8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $78dc425114cabdd8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($78dc425114cabdd8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Push;
        let location = $78dc425114cabdd8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $78dc425114cabdd8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $78dc425114cabdd8$export$e19cd5f9376f8cee.Replace;
        let location = $78dc425114cabdd8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $78dc425114cabdd8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $78dc425114cabdd8$export$fe53371bee54353d(to);
        $78dc425114cabdd8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($78dc425114cabdd8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($78dc425114cabdd8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $78dc425114cabdd8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($78dc425114cabdd8$var$ResultType || ($78dc425114cabdd8$var$ResultType = {}));
const $78dc425114cabdd8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $78dc425114cabdd8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $78dc425114cabdd8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $78dc425114cabdd8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $78dc425114cabdd8$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($78dc425114cabdd8$var$isIndexRoute(route)) {
            let indexRoute = $78dc425114cabdd8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $78dc425114cabdd8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $78dc425114cabdd8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $78dc425114cabdd8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $78dc425114cabdd8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $78dc425114cabdd8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $78dc425114cabdd8$var$flattenRoutes(routes);
    $78dc425114cabdd8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $78dc425114cabdd8$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $78dc425114cabdd8$var$safelyDecodeURI(pathname));
    return matches;
}
function $78dc425114cabdd8$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $78dc425114cabdd8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $78dc425114cabdd8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $78dc425114cabdd8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $78dc425114cabdd8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $78dc425114cabdd8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $78dc425114cabdd8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $78dc425114cabdd8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $78dc425114cabdd8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $78dc425114cabdd8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $78dc425114cabdd8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $78dc425114cabdd8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $78dc425114cabdd8$var$paramRe = /^:\w+$/;
const $78dc425114cabdd8$var$dynamicSegmentValue = 3;
const $78dc425114cabdd8$var$indexRouteValue = 2;
const $78dc425114cabdd8$var$emptySegmentValue = 1;
const $78dc425114cabdd8$var$staticSegmentValue = 10;
const $78dc425114cabdd8$var$splatPenalty = -2;
const $78dc425114cabdd8$var$isSplat = (s)=>s === "*";
function $78dc425114cabdd8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($78dc425114cabdd8$var$isSplat)) initialScore += $78dc425114cabdd8$var$splatPenalty;
    if (index) initialScore += $78dc425114cabdd8$var$indexRouteValue;
    return segments.filter((s)=>!$78dc425114cabdd8$var$isSplat(s)).reduce((score, segment)=>score + ($78dc425114cabdd8$var$paramRe.test(segment) ? $78dc425114cabdd8$var$dynamicSegmentValue : segment === "" ? $78dc425114cabdd8$var$emptySegmentValue : $78dc425114cabdd8$var$staticSegmentValue), initialScore);
}
function $78dc425114cabdd8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $78dc425114cabdd8$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $78dc425114cabdd8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $78dc425114cabdd8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $78dc425114cabdd8$export$a5c6d149b50c1d86($78dc425114cabdd8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $78dc425114cabdd8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $78dc425114cabdd8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $78dc425114cabdd8$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $78dc425114cabdd8$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $78dc425114cabdd8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $78dc425114cabdd8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $78dc425114cabdd8$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $78dc425114cabdd8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $78dc425114cabdd8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $78dc425114cabdd8$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $78dc425114cabdd8$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $78dc425114cabdd8$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $78dc425114cabdd8$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $78dc425114cabdd8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $78dc425114cabdd8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $78dc425114cabdd8$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $78dc425114cabdd8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $78dc425114cabdd8$var$normalizeSearch(search),
        hash: $78dc425114cabdd8$var$normalizeHash(hash)
    };
}
function $78dc425114cabdd8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $78dc425114cabdd8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $78dc425114cabdd8$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $78dc425114cabdd8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $78dc425114cabdd8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $78dc425114cabdd8$var$_extends({}, toArg);
        $78dc425114cabdd8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $78dc425114cabdd8$var$getInvalidPathError("?", "pathname", "search", to));
        $78dc425114cabdd8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $78dc425114cabdd8$var$getInvalidPathError("#", "pathname", "hash", to));
        $78dc425114cabdd8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $78dc425114cabdd8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $78dc425114cabdd8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $78dc425114cabdd8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $78dc425114cabdd8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $78dc425114cabdd8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $78dc425114cabdd8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $78dc425114cabdd8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $78dc425114cabdd8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $78dc425114cabdd8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $78dc425114cabdd8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $78dc425114cabdd8$export$42a99a7a4bc0e76a extends Error {
}
class $78dc425114cabdd8$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $78dc425114cabdd8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $78dc425114cabdd8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $78dc425114cabdd8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $78dc425114cabdd8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $78dc425114cabdd8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $78dc425114cabdd8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $78dc425114cabdd8$var$unwrapTrackedPromise(value) {
    if (!$78dc425114cabdd8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $78dc425114cabdd8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $78dc425114cabdd8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $78dc425114cabdd8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $78dc425114cabdd8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $78dc425114cabdd8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $78dc425114cabdd8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $78dc425114cabdd8$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $78dc425114cabdd8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $78dc425114cabdd8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $78dc425114cabdd8$var$validMutationMethods = new Set($78dc425114cabdd8$var$validMutationMethodsArr);
const $78dc425114cabdd8$var$validRequestMethodsArr = [
    "get",
    ...$78dc425114cabdd8$var$validMutationMethodsArr
];
const $78dc425114cabdd8$var$validRequestMethods = new Set($78dc425114cabdd8$var$validRequestMethodsArr);
const $78dc425114cabdd8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $78dc425114cabdd8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $78dc425114cabdd8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $78dc425114cabdd8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $78dc425114cabdd8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $78dc425114cabdd8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $78dc425114cabdd8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $78dc425114cabdd8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $78dc425114cabdd8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $78dc425114cabdd8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $78dc425114cabdd8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $78dc425114cabdd8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $78dc425114cabdd8$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $78dc425114cabdd8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $78dc425114cabdd8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $78dc425114cabdd8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $78dc425114cabdd8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $78dc425114cabdd8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $78dc425114cabdd8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $78dc425114cabdd8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$78dc425114cabdd8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($78dc425114cabdd8$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, viewTransitionOpts) {
        state = $78dc425114cabdd8$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state, {
                unstable_viewTransitionOpts: viewTransitionOpts
            }));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $78dc425114cabdd8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $78dc425114cabdd8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $78dc425114cabdd8$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $78dc425114cabdd8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $78dc425114cabdd8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $78dc425114cabdd8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($78dc425114cabdd8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $78dc425114cabdd8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), viewTransitionOpts);
        // Reset stateful navigation vars
        pendingAction = $78dc425114cabdd8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $78dc425114cabdd8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $78dc425114cabdd8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $78dc425114cabdd8$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $78dc425114cabdd8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $78dc425114cabdd8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $78dc425114cabdd8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $78dc425114cabdd8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $78dc425114cabdd8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $78dc425114cabdd8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $78dc425114cabdd8$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $78dc425114cabdd8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $78dc425114cabdd8$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $78dc425114cabdd8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $78dc425114cabdd8$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $78dc425114cabdd8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$78dc425114cabdd8$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $78dc425114cabdd8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $78dc425114cabdd8$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $78dc425114cabdd8$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $78dc425114cabdd8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $78dc425114cabdd8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $78dc425114cabdd8$var$ResultType.error,
            error: $78dc425114cabdd8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $78dc425114cabdd8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($78dc425114cabdd8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($78dc425114cabdd8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $78dc425114cabdd8$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $78dc425114cabdd8$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($78dc425114cabdd8$var$isDeferredResult(result)) throw $78dc425114cabdd8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $78dc425114cabdd8$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $78dc425114cabdd8$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $78dc425114cabdd8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $78dc425114cabdd8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $78dc425114cabdd8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($78dc425114cabdd8$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $78dc425114cabdd8$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $78dc425114cabdd8$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $78dc425114cabdd8$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $78dc425114cabdd8$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $78dc425114cabdd8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $78dc425114cabdd8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $78dc425114cabdd8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $78dc425114cabdd8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $78dc425114cabdd8$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $78dc425114cabdd8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $78dc425114cabdd8$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $78dc425114cabdd8$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $78dc425114cabdd8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $78dc425114cabdd8$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($78dc425114cabdd8$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $78dc425114cabdd8$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $78dc425114cabdd8$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    fetcherSubmission: submission
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($78dc425114cabdd8$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($78dc425114cabdd8$var$isDeferredResult(actionResult)) throw $78dc425114cabdd8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $78dc425114cabdd8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $78dc425114cabdd8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $78dc425114cabdd8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $78dc425114cabdd8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $78dc425114cabdd8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $78dc425114cabdd8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $78dc425114cabdd8$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $78dc425114cabdd8$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $78dc425114cabdd8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $78dc425114cabdd8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($78dc425114cabdd8$var$_extends({
                errors: errors,
                loaderData: $78dc425114cabdd8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $78dc425114cabdd8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $78dc425114cabdd8$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $78dc425114cabdd8$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($78dc425114cabdd8$var$isDeferredResult(result)) result = await $78dc425114cabdd8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($78dc425114cabdd8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $78dc425114cabdd8$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($78dc425114cabdd8$var$isErrorResult(result)) {
            let boundaryMatch = $78dc425114cabdd8$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $78dc425114cabdd8$export$3e9cee6b33872309(!$78dc425114cabdd8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $78dc425114cabdd8$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $78dc425114cabdd8$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $78dc425114cabdd8$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($78dc425114cabdd8$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $78dc425114cabdd8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $78dc425114cabdd8$export$e19cd5f9376f8cee.Replace : $78dc425114cabdd8$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $78dc425114cabdd8$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($78dc425114cabdd8$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $78dc425114cabdd8$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $78dc425114cabdd8$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $78dc425114cabdd8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$78dc425114cabdd8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $78dc425114cabdd8$var$callLoaderOrAction("loader", $78dc425114cabdd8$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $78dc425114cabdd8$var$ResultType.error,
                        error: $78dc425114cabdd8$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $78dc425114cabdd8$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $78dc425114cabdd8$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $78dc425114cabdd8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $78dc425114cabdd8$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $78dc425114cabdd8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $78dc425114cabdd8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $78dc425114cabdd8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $78dc425114cabdd8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $78dc425114cabdd8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $78dc425114cabdd8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $78dc425114cabdd8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $78dc425114cabdd8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$78dc425114cabdd8$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $78dc425114cabdd8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $78dc425114cabdd8$export$4d0306f8f6a4585b = Symbol("deferred");
function $78dc425114cabdd8$export$3336b097a6fbc59a(routes, opts) {
    $78dc425114cabdd8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $78dc425114cabdd8$var$defaultMapRouteProperties;
    let dataRoutes = $78dc425114cabdd8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $78dc425114cabdd8$var$createLocation("", $78dc425114cabdd8$export$fe53371bee54353d(url), null, "default");
        let matches = $78dc425114cabdd8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$78dc425114cabdd8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $78dc425114cabdd8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $78dc425114cabdd8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $78dc425114cabdd8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $78dc425114cabdd8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($78dc425114cabdd8$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $78dc425114cabdd8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $78dc425114cabdd8$var$createLocation("", $78dc425114cabdd8$export$fe53371bee54353d(url), null, "default");
        let matches = $78dc425114cabdd8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$78dc425114cabdd8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $78dc425114cabdd8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $78dc425114cabdd8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $78dc425114cabdd8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $78dc425114cabdd8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $78dc425114cabdd8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($78dc425114cabdd8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$78dc425114cabdd8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $78dc425114cabdd8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($78dc425114cabdd8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $78dc425114cabdd8$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $78dc425114cabdd8$var$isResponse(result) ? result : $78dc425114cabdd8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($78dc425114cabdd8$var$isQueryRouteResponse(e)) {
                if (e.type === $78dc425114cabdd8$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($78dc425114cabdd8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $78dc425114cabdd8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $78dc425114cabdd8$var$ResultType.error,
                error: error
            };
        } else {
            result = await $78dc425114cabdd8$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted: " + request.method + " " + request.url);
            }
        }
        if ($78dc425114cabdd8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($78dc425114cabdd8$var$isDeferredResult(result)) {
            let error = $78dc425114cabdd8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $78dc425114cabdd8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($78dc425114cabdd8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($78dc425114cabdd8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $78dc425114cabdd8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $78dc425114cabdd8$var$_extends({}, context, {
                statusCode: $78dc425114cabdd8$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $78dc425114cabdd8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $78dc425114cabdd8$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $78dc425114cabdd8$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $78dc425114cabdd8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $78dc425114cabdd8$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$78dc425114cabdd8$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted: " + request.method + " " + request.url);
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $78dc425114cabdd8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $78dc425114cabdd8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $78dc425114cabdd8$export$fec11da027c70692(routes, context, error) {
    let newContext = $78dc425114cabdd8$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $78dc425114cabdd8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $78dc425114cabdd8$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $78dc425114cabdd8$export$cae722b0cc860f13(to ? to : ".", $78dc425114cabdd8$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $78dc425114cabdd8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$78dc425114cabdd8$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $78dc425114cabdd8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $78dc425114cabdd8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $78dc425114cabdd8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$78dc425114cabdd8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$78dc425114cabdd8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $78dc425114cabdd8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $78dc425114cabdd8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $78dc425114cabdd8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$78dc425114cabdd8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$78dc425114cabdd8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $78dc425114cabdd8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $78dc425114cabdd8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $78dc425114cabdd8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $78dc425114cabdd8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $78dc425114cabdd8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($78dc425114cabdd8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $78dc425114cabdd8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $78dc425114cabdd8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $78dc425114cabdd8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $78dc425114cabdd8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $78dc425114cabdd8$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $78dc425114cabdd8$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($78dc425114cabdd8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $78dc425114cabdd8$var$shouldRevalidateLoader(match, $78dc425114cabdd8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $78dc425114cabdd8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $78dc425114cabdd8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $78dc425114cabdd8$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $78dc425114cabdd8$var$shouldRevalidateLoader(fetcherMatch, $78dc425114cabdd8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $78dc425114cabdd8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $78dc425114cabdd8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $78dc425114cabdd8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $78dc425114cabdd8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $78dc425114cabdd8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $78dc425114cabdd8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$78dc425114cabdd8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $78dc425114cabdd8$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $78dc425114cabdd8$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $78dc425114cabdd8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $78dc425114cabdd8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $78dc425114cabdd8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $78dc425114cabdd8$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $78dc425114cabdd8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $78dc425114cabdd8$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $78dc425114cabdd8$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($78dc425114cabdd8$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($78dc425114cabdd8$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $78dc425114cabdd8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$78dc425114cabdd8$var$ABSOLUTE_URL_REGEX.test(location)) location = $78dc425114cabdd8$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $78dc425114cabdd8$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $78dc425114cabdd8$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $78dc425114cabdd8$var$ResultType.error ? $78dc425114cabdd8$var$ResultType.error : $78dc425114cabdd8$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $78dc425114cabdd8$var$ResultType.error) return {
            type: resultType,
            error: new $78dc425114cabdd8$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $78dc425114cabdd8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $78dc425114cabdd8$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($78dc425114cabdd8$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $78dc425114cabdd8$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $78dc425114cabdd8$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $78dc425114cabdd8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($78dc425114cabdd8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $78dc425114cabdd8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $78dc425114cabdd8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $78dc425114cabdd8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $78dc425114cabdd8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $78dc425114cabdd8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $78dc425114cabdd8$export$3e9cee6b33872309(!$78dc425114cabdd8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($78dc425114cabdd8$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $78dc425114cabdd8$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $78dc425114cabdd8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($78dc425114cabdd8$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $78dc425114cabdd8$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $78dc425114cabdd8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $78dc425114cabdd8$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($78dc425114cabdd8$var$isErrorResult(result)) {
            let boundaryMatch = $78dc425114cabdd8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $78dc425114cabdd8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($78dc425114cabdd8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $78dc425114cabdd8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($78dc425114cabdd8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $78dc425114cabdd8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $78dc425114cabdd8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $78dc425114cabdd8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $78dc425114cabdd8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $78dc425114cabdd8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $78dc425114cabdd8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $78dc425114cabdd8$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $78dc425114cabdd8$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $78dc425114cabdd8$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($78dc425114cabdd8$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $78dc425114cabdd8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $78dc425114cabdd8$export$8ccf933b0513f8d0(path) : path;
    return $78dc425114cabdd8$export$fe53371bee54353d($78dc425114cabdd8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $78dc425114cabdd8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $78dc425114cabdd8$var$isDeferredResult(result) {
    return result.type === $78dc425114cabdd8$var$ResultType.deferred;
}
function $78dc425114cabdd8$var$isErrorResult(result) {
    return result.type === $78dc425114cabdd8$var$ResultType.error;
}
function $78dc425114cabdd8$var$isRedirectResult(result) {
    return (result && result.type) === $78dc425114cabdd8$var$ResultType.redirect;
}
function $78dc425114cabdd8$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $78dc425114cabdd8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $78dc425114cabdd8$var$isRedirectResponse(result) {
    if (!$78dc425114cabdd8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $78dc425114cabdd8$var$isQueryRouteResponse(obj) {
    return obj && $78dc425114cabdd8$var$isResponse(obj.response) && (obj.type === $78dc425114cabdd8$var$ResultType.data || obj.type === $78dc425114cabdd8$var$ResultType.error);
}
function $78dc425114cabdd8$var$isValidMethod(method) {
    return $78dc425114cabdd8$var$validRequestMethods.has(method.toLowerCase());
}
function $78dc425114cabdd8$var$isMutationMethod(method) {
    return $78dc425114cabdd8$var$validMutationMethods.has(method.toLowerCase());
}
async function $78dc425114cabdd8$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$78dc425114cabdd8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($78dc425114cabdd8$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $78dc425114cabdd8$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $78dc425114cabdd8$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $78dc425114cabdd8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $78dc425114cabdd8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $78dc425114cabdd8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $78dc425114cabdd8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $78dc425114cabdd8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $78dc425114cabdd8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $78dc425114cabdd8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $78dc425114cabdd8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $78dc425114cabdd8$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $78dc425114cabdd8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $78dc425114cabdd8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $78dc425114cabdd8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $78dc425114cabdd8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $78dc425114cabdd8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $78dc425114cabdd8$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $78dc425114cabdd8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($78dc425114cabdd8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $78dc425114cabdd8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($78dc425114cabdd8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $78dc425114cabdd8$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $9352744c2719600e$var$_extends() {
    $9352744c2719600e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9352744c2719600e$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $9352744c2719600e$export$3add0d5dce533e2e = /*#__PURE__*/ $iawgr.createContext(null);
const $9352744c2719600e$export$145dfa71566a64dc = /*#__PURE__*/ $iawgr.createContext(null);
const $9352744c2719600e$var$AwaitContext = /*#__PURE__*/ $iawgr.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $9352744c2719600e$export$26749e8557646306 = /*#__PURE__*/ $iawgr.createContext(null);
const $9352744c2719600e$export$c7914228fb69b0f5 = /*#__PURE__*/ $iawgr.createContext(null);
const $9352744c2719600e$export$9072aa6dd1f93057 = /*#__PURE__*/ $iawgr.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $9352744c2719600e$var$RouteErrorContext = /*#__PURE__*/ $iawgr.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $9352744c2719600e$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$9352744c2719600e$export$9c954a9d03d32f4a() && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $iawgr.useContext($9352744c2719600e$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $9352744c2719600e$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $78dc425114cabdd8$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $9352744c2719600e$export$9c954a9d03d32f4a() {
    return $iawgr.useContext($9352744c2719600e$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $9352744c2719600e$export$45d76561a5302f2b() {
    !$9352744c2719600e$export$9c954a9d03d32f4a() && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return $iawgr.useContext($9352744c2719600e$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $9352744c2719600e$export$1b3f31771c5d07c() {
    return $iawgr.useContext($9352744c2719600e$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $9352744c2719600e$export$6c330e8992e8a295(pattern) {
    !$9352744c2719600e$export$9c954a9d03d32f4a() && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $9352744c2719600e$export$45d76561a5302f2b();
    return $iawgr.useMemo(()=>(0, $78dc425114cabdd8$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $9352744c2719600e$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9352744c2719600e$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $iawgr.useContext($9352744c2719600e$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $iawgr.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $9352744c2719600e$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9352744c2719600e$var$useNavigateStable() : $9352744c2719600e$var$useNavigateUnstable();
}
function $9352744c2719600e$var$useNavigateUnstable() {
    !$9352744c2719600e$export$9c954a9d03d32f4a() && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let dataRouterContext = $iawgr.useContext($9352744c2719600e$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $iawgr.useContext($9352744c2719600e$export$26749e8557646306);
    let { matches: matches } = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9352744c2719600e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $78dc425114cabdd8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $iawgr.useRef(false);
    $9352744c2719600e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iawgr.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $78dc425114cabdd8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $78dc425114cabdd8$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $9352744c2719600e$var$OutletContext = /*#__PURE__*/ $iawgr.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $9352744c2719600e$export$4138103a3ae699cc() {
    return $iawgr.useContext($9352744c2719600e$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $9352744c2719600e$export$a3be3530d8e40d0b(context) {
    let outlet = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $9352744c2719600e$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $9352744c2719600e$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9352744c2719600e$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $78dc425114cabdd8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $iawgr.useMemo(()=>(0, $78dc425114cabdd8$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $9352744c2719600e$export$5d3fca4a98652595(routes, locationArg) {
    return $9352744c2719600e$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9352744c2719600e$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$9352744c2719600e$export$9c954a9d03d32f4a() && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $iawgr.useContext($9352744c2719600e$export$26749e8557646306);
    let { matches: parentMatches } = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $9352744c2719600e$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $78dc425114cabdd8$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $78dc425114cabdd8$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $9352744c2719600e$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $78dc425114cabdd8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $78dc425114cabdd8$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9352744c2719600e$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $78dc425114cabdd8$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9352744c2719600e$var$DefaultErrorComponent() {
    let error = $9352744c2719600e$export$ed527bf60f6e05f2();
    let message = (0, $78dc425114cabdd8$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $iawgr.createElement($iawgr.Fragment, null, /*#__PURE__*/ $iawgr.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $iawgr.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $iawgr.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $9352744c2719600e$var$defaultErrorElement = /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$DefaultErrorComponent, null);
class $9352744c2719600e$var$RenderErrorBoundary extends $iawgr.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $9352744c2719600e$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $iawgr.useContext($9352744c2719600e$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9352744c2719600e$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $9352744c2719600e$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $iawgr.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9352744c2719600e$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9352744c2719600e$var$DataRouterHook || {});
var $9352744c2719600e$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9352744c2719600e$var$DataRouterStateHook || {});
function $9352744c2719600e$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $9352744c2719600e$var$useDataRouterContext(hookName) {
    let ctx = $iawgr.useContext($9352744c2719600e$export$3add0d5dce533e2e);
    !ctx && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $9352744c2719600e$var$useDataRouterState(hookName) {
    let state = $iawgr.useContext($9352744c2719600e$export$145dfa71566a64dc);
    !state && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return state;
}
function $9352744c2719600e$var$useRouteContext(hookName) {
    let route = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    !route && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9352744c2719600e$var$useCurrentRouteId(hookName) {
    let route = $9352744c2719600e$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9352744c2719600e$export$5fc8298006ad9e58() {
    return $9352744c2719600e$var$useCurrentRouteId($9352744c2719600e$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9352744c2719600e$export$d0fd4b7106de2769() {
    let state = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9352744c2719600e$export$600dc272ed516c15() {
    let dataRouterContext = $9352744c2719600e$var$useDataRouterContext($9352744c2719600e$var$DataRouterHook.UseRevalidator);
    let state = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseRevalidator);
    return $iawgr.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9352744c2719600e$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseMatches);
    return $iawgr.useMemo(()=>matches.map((m)=>(0, $78dc425114cabdd8$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9352744c2719600e$export$1448a5050d252c4d() {
    let state = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseLoaderData);
    let routeId = $9352744c2719600e$var$useCurrentRouteId($9352744c2719600e$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9352744c2719600e$export$fd5d37484eab868d(routeId) {
    let state = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9352744c2719600e$export$fdc00f3f26066d5e() {
    let state = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseActionData);
    let route = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    !route && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9352744c2719600e$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $iawgr.useContext($9352744c2719600e$var$RouteErrorContext);
    let state = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseRouteError);
    let routeId = $9352744c2719600e$var$useCurrentRouteId($9352744c2719600e$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9352744c2719600e$export$78a72ddb39bdd145() {
    let value = $iawgr.useContext($9352744c2719600e$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9352744c2719600e$export$17f53340677d5831() {
    let value = $iawgr.useContext($9352744c2719600e$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $9352744c2719600e$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9352744c2719600e$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $9352744c2719600e$var$useDataRouterContext($9352744c2719600e$var$DataRouterHook.UseBlocker);
    let state = $9352744c2719600e$var$useDataRouterState($9352744c2719600e$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $iawgr.useState("");
    let blockerFunction = $iawgr.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $9352744c2719600e$var$_extends({}, currentLocation, {
                pathname: (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9352744c2719600e$var$_extends({}, nextLocation, {
                pathname: (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $iawgr.useEffect(()=>{
        let key = String(++$9352744c2719600e$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $iawgr.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $78dc425114cabdd8$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9352744c2719600e$var$useNavigateStable() {
    let { router: router } = $9352744c2719600e$var$useDataRouterContext($9352744c2719600e$var$DataRouterHook.UseNavigateStable);
    let id = $9352744c2719600e$var$useCurrentRouteId($9352744c2719600e$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $iawgr.useRef(false);
    $9352744c2719600e$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iawgr.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9352744c2719600e$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $9352744c2719600e$var$alreadyWarned = {};
function $9352744c2719600e$var$warningOnce(key, cond, message) {
    if (!cond && !$9352744c2719600e$var$alreadyWarned[key]) $9352744c2719600e$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $9352744c2719600e$var$START_TRANSITION = "startTransition";
const $9352744c2719600e$var$startTransitionImpl = $iawgr[$9352744c2719600e$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9352744c2719600e$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $iawgr.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iawgr.useCallback((newState)=>{
        if (v7_startTransition && $9352744c2719600e$var$startTransitionImpl) $9352744c2719600e$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $iawgr.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $iawgr.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $iawgr.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $iawgr.createElement($iawgr.Fragment, null, /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $9352744c2719600e$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $9352744c2719600e$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $9352744c2719600e$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $iawgr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $78dc425114cabdd8$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iawgr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iawgr.useCallback((newState)=>{
        v7_startTransition && $9352744c2719600e$var$startTransitionImpl ? $9352744c2719600e$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iawgr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $9352744c2719600e$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$9352744c2719600e$export$9c954a9d03d32f4a() && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let { matches: matches } = $iawgr.useContext($9352744c2719600e$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $9352744c2719600e$export$45d76561a5302f2b();
    let navigate = $9352744c2719600e$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $78dc425114cabdd8$export$cae722b0cc860f13)(to, (0, $78dc425114cabdd8$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $iawgr.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $9352744c2719600e$export$910ae8079b2c2852(props) {
    return $9352744c2719600e$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $9352744c2719600e$export$e7b0ac011bb776c6(_props) {
    (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $9352744c2719600e$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $78dc425114cabdd8$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$9352744c2719600e$export$9c954a9d03d32f4a() && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $iawgr.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $78dc425114cabdd8$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $iawgr.useMemo(()=>{
        let trailingPathname = (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $9352744c2719600e$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $9352744c2719600e$export$5d3fca4a98652595($9352744c2719600e$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9352744c2719600e$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$ResolveAwait, null, children));
}
var $9352744c2719600e$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9352744c2719600e$var$AwaitRenderStatus || {});
const $9352744c2719600e$var$neverSettledPromise = new Promise(()=>{});
class $9352744c2719600e$var$AwaitErrorBoundary extends $iawgr.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $9352744c2719600e$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $9352744c2719600e$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $9352744c2719600e$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $9352744c2719600e$var$AwaitRenderStatus.error : promise._data !== undefined ? $9352744c2719600e$var$AwaitRenderStatus.success : $9352744c2719600e$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $9352744c2719600e$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $9352744c2719600e$var$AwaitRenderStatus.error && promise._error instanceof (0, $78dc425114cabdd8$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $9352744c2719600e$var$neverSettledPromise;
        if (status === $9352744c2719600e$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $9352744c2719600e$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $9352744c2719600e$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $iawgr.createElement($9352744c2719600e$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9352744c2719600e$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $9352744c2719600e$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $iawgr.createElement($iawgr.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $9352744c2719600e$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $iawgr.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $iawgr.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $iawgr.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9352744c2719600e$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9352744c2719600e$export$e7b0ac011bb776c6) && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9352744c2719600e$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9352744c2719600e$export$daf73786167a7f72(matches) {
    return $9352744c2719600e$var$_renderMatches(matches);
}
function $9352744c2719600e$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $iawgr.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $iawgr.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9352744c2719600e$export$f30f7e456d254e83(routes, opts) {
    return (0, $78dc425114cabdd8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9352744c2719600e$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $78dc425114cabdd8$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9352744c2719600e$export$52b333d321859367
    }).initialize();
}

/**
 * React Router DOM v6.17.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iawgr = parcelRequire("iawgr");


function $c566805c483e906d$var$_extends() {
    $c566805c483e906d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c566805c483e906d$var$_extends.apply(this, arguments);
}
function $c566805c483e906d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c566805c483e906d$var$defaultMethod = "get";
const $c566805c483e906d$var$defaultEncType = "application/x-www-form-urlencoded";
function $c566805c483e906d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c566805c483e906d$var$isButtonElement(object) {
    return $c566805c483e906d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c566805c483e906d$var$isFormElement(object) {
    return $c566805c483e906d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c566805c483e906d$var$isInputElement(object) {
    return $c566805c483e906d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c566805c483e906d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c566805c483e906d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c566805c483e906d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c566805c483e906d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c566805c483e906d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c566805c483e906d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c566805c483e906d$var$_formDataSupportsSubmitter = null;
function $c566805c483e906d$var$isFormDataSubmitterSupported() {
    if ($c566805c483e906d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c566805c483e906d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c566805c483e906d$var$_formDataSupportsSubmitter = true;
    }
    return $c566805c483e906d$var$_formDataSupportsSubmitter;
}
const $c566805c483e906d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c566805c483e906d$var$getFormEncType(encType) {
    if (encType != null && !$c566805c483e906d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c566805c483e906d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c566805c483e906d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c566805c483e906d$var$defaultMethod;
        encType = $c566805c483e906d$var$getFormEncType(target.getAttribute("enctype")) || $c566805c483e906d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c566805c483e906d$var$isButtonElement(target) || $c566805c483e906d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c566805c483e906d$var$defaultMethod;
        encType = $c566805c483e906d$var$getFormEncType(target.getAttribute("formenctype")) || $c566805c483e906d$var$getFormEncType(form.getAttribute("enctype")) || $c566805c483e906d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c566805c483e906d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c566805c483e906d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c566805c483e906d$var$defaultMethod;
        action = null;
        encType = $c566805c483e906d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c566805c483e906d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $c566805c483e906d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $c566805c483e906d$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
function $c566805c483e906d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $78dc425114cabdd8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c566805c483e906d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $78dc425114cabdd8$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c566805c483e906d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9352744c2719600e$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c566805c483e906d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $78dc425114cabdd8$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c566805c483e906d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $78dc425114cabdd8$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c566805c483e906d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9352744c2719600e$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c566805c483e906d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c566805c483e906d$var$_extends({}, state, {
        errors: $c566805c483e906d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c566805c483e906d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $78dc425114cabdd8$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c566805c483e906d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $iawgr.createContext({
    isTransitioning: false
});
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c566805c483e906d$var$START_TRANSITION = "startTransition";
const $c566805c483e906d$var$startTransitionImpl = $iawgr[$c566805c483e906d$var$START_TRANSITION];
function $c566805c483e906d$var$startTransitionSafe(cb) {
    if ($c566805c483e906d$var$startTransitionImpl) $c566805c483e906d$var$startTransitionImpl(cb);
    else cb();
}
class $c566805c483e906d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c566805c483e906d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $iawgr.useState(router.state);
    let [pendingState, setPendingState] = $iawgr.useState();
    let [vtContext, setVtContext] = $iawgr.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $iawgr.useState();
    let [transition, setTransition] = $iawgr.useState();
    let [interruption, setInterruption] = $iawgr.useState();
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $iawgr.useCallback((cb)=>{
        if (v7_startTransition) $c566805c483e906d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $iawgr.useCallback((newState, _ref2)=>{
        let { unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        if (!viewTransitionOpts || router.window == null || typeof router.window.document.startViewTransition !== "function") // Mid-navigation state update, or startViewTransition isn't available
        optInStartTransition(()=>setStateImpl(newState));
        else if (transition && renderDfd) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        optInStartTransition,
        transition,
        renderDfd,
        router.window
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $iawgr.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $iawgr.useEffect(()=>{
        if (vtContext.isTransitioning) setRenderDfd(new $c566805c483e906d$var$Deferred());
    }, [
        vtContext.isTransitioning
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $iawgr.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $iawgr.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $iawgr.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $iawgr.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $iawgr.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $iawgr.createElement($iawgr.Fragment, null, /*#__PURE__*/ $iawgr.createElement((0, $9352744c2719600e$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $iawgr.createElement((0, $9352744c2719600e$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $iawgr.createElement($c566805c483e906d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $iawgr.createElement((0, $9352744c2719600e$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $iawgr.createElement($c566805c483e906d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement)))), null);
}
function $c566805c483e906d$var$DataRoutes(_ref3) {
    let { routes: routes, state: state } = _ref3;
    return (0, $9352744c2719600e$export$5fcee62552a12fbf)(routes, undefined, state);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c566805c483e906d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $iawgr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $78dc425114cabdd8$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iawgr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iawgr.useCallback((newState)=>{
        v7_startTransition && $c566805c483e906d$var$startTransitionImpl ? $c566805c483e906d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iawgr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $iawgr.createElement((0, $9352744c2719600e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c566805c483e906d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $iawgr.useRef();
    if (historyRef.current == null) historyRef.current = (0, $78dc425114cabdd8$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iawgr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iawgr.useCallback((newState)=>{
        v7_startTransition && $c566805c483e906d$var$startTransitionImpl ? $c566805c483e906d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iawgr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $iawgr.createElement((0, $9352744c2719600e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c566805c483e906d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $iawgr.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iawgr.useCallback((newState)=>{
        v7_startTransition && $c566805c483e906d$var$startTransitionImpl ? $c566805c483e906d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iawgr.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $iawgr.createElement((0, $9352744c2719600e$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $c566805c483e906d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c566805c483e906d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c566805c483e906d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $iawgr.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $c566805c483e906d$var$_objectWithoutPropertiesLoose(_ref7, $c566805c483e906d$var$_excluded);
    let { basename: basename } = $iawgr.useContext((0, $9352744c2719600e$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c566805c483e906d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c566805c483e906d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $9352744c2719600e$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c566805c483e906d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $iawgr.createElement("a", $c566805c483e906d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c566805c483e906d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $iawgr.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $c566805c483e906d$var$_objectWithoutPropertiesLoose(_ref8, $c566805c483e906d$var$_excluded2);
    let path = (0, $9352744c2719600e$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $9352744c2719600e$export$45d76561a5302f2b)();
    let routerState = $iawgr.useContext((0, $9352744c2719600e$export$145dfa71566a64dc));
    let { navigator: navigator } = $iawgr.useContext((0, $9352744c2719600e$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c566805c483e906d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $iawgr.createElement($c566805c483e906d$export$a6c7ac8248d6e38a, $c566805c483e906d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c566805c483e906d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $iawgr.forwardRef((props, ref)=>{
    let submit = $c566805c483e906d$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $iawgr.createElement($c566805c483e906d$var$FormImpl, $c566805c483e906d$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $c566805c483e906d$var$FormImpl = /*#__PURE__*/ $iawgr.forwardRef((_ref9, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c566805c483e906d$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $c566805c483e906d$var$_objectWithoutPropertiesLoose(_ref9, $c566805c483e906d$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $c566805c483e906d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $iawgr.createElement("form", $c566805c483e906d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c566805c483e906d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $c566805c483e906d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c566805c483e906d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c566805c483e906d$var$DataRouterHook || ($c566805c483e906d$var$DataRouterHook = {}));
var $c566805c483e906d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c566805c483e906d$var$DataRouterStateHook || ($c566805c483e906d$var$DataRouterStateHook = {}));
function $c566805c483e906d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c566805c483e906d$var$useDataRouterContext(hookName) {
    let ctx = $iawgr.useContext((0, $9352744c2719600e$export$3add0d5dce533e2e));
    !ctx && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c566805c483e906d$var$useDataRouterState(hookName) {
    let state = $iawgr.useContext((0, $9352744c2719600e$export$145dfa71566a64dc));
    !state && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c566805c483e906d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $9352744c2719600e$export$9770f232ac06a008)();
    let location = (0, $9352744c2719600e$export$45d76561a5302f2b)();
    let path = (0, $9352744c2719600e$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $iawgr.useCallback((event)=>{
        if ($c566805c483e906d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $78dc425114cabdd8$export$fe53371bee54353d)(location) === (0, $78dc425114cabdd8$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c566805c483e906d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $iawgr.useRef($c566805c483e906d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $iawgr.useRef(false);
    let location = (0, $9352744c2719600e$export$45d76561a5302f2b)();
    let searchParams = $iawgr.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c566805c483e906d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $9352744c2719600e$export$9770f232ac06a008)();
    let setSearchParams = $iawgr.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c566805c483e906d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c566805c483e906d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c566805c483e906d$export$47c85c6e3a081d3() {
    let { router: router } = $c566805c483e906d$var$useDataRouterContext($c566805c483e906d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $iawgr.useContext((0, $9352744c2719600e$export$26749e8557646306));
    let currentRouteId = (0, $9352744c2719600e$export$5fc8298006ad9e58)();
    return $iawgr.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c566805c483e906d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c566805c483e906d$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $c566805c483e906d$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $c566805c483e906d$var$useDataRouterContext($c566805c483e906d$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $iawgr.useContext((0, $9352744c2719600e$export$26749e8557646306));
    return $iawgr.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c566805c483e906d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c566805c483e906d$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c566805c483e906d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $iawgr.useContext((0, $9352744c2719600e$export$26749e8557646306));
    let routeContext = $iawgr.useContext((0, $9352744c2719600e$export$9072aa6dd1f93057));
    !routeContext && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c566805c483e906d$var$_extends({}, (0, $9352744c2719600e$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params of the resolved URL. This is
    // the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $9352744c2719600e$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $78dc425114cabdd8$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $78dc425114cabdd8$export$fe53371bee54353d)(path);
}
function $c566805c483e906d$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $iawgr.forwardRef((props, ref)=>{
        let submit = $c566805c483e906d$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $iawgr.createElement($c566805c483e906d$var$FormImpl, $c566805c483e906d$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $c566805c483e906d$var$fetcherId = 0;
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c566805c483e906d$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $c566805c483e906d$var$useDataRouterContext($c566805c483e906d$var$DataRouterHook.UseFetcher);
    let route = $iawgr.useContext((0, $9352744c2719600e$export$9072aa6dd1f93057));
    !route && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $iawgr.useState(()=>String(++$c566805c483e906d$var$fetcherId));
    let [Form] = $iawgr.useState(()=>{
        !routeId && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
        return $c566805c483e906d$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $iawgr.useState(()=>(href)=>{
            !router && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
            !routeId && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $c566805c483e906d$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $iawgr.useMemo(()=>$c566805c483e906d$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $iawgr.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c566805c483e906d$export$fa996778a3a31087() {
    let state = $c566805c483e906d$var$useDataRouterState($c566805c483e906d$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $c566805c483e906d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c566805c483e906d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c566805c483e906d$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c566805c483e906d$var$useDataRouterContext($c566805c483e906d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c566805c483e906d$var$useDataRouterState($c566805c483e906d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $iawgr.useContext((0, $9352744c2719600e$export$26749e8557646306));
    let location = (0, $9352744c2719600e$export$45d76561a5302f2b)();
    let matches = (0, $9352744c2719600e$export$2378eb7f5ff86053)();
    let navigation = (0, $9352744c2719600e$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $iawgr.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c566805c483e906d$var$usePageHide($iawgr.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c566805c483e906d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c566805c483e906d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c566805c483e906d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iawgr.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c566805c483e906d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c566805c483e906d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iawgr.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c566805c483e906d$var$_extends({}, location, {
                    pathname: (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c566805c483e906d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iawgr.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c566805c483e906d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $iawgr.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c566805c483e906d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $iawgr.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c566805c483e906d$export$39f4eb3dbd812741(_ref11) {
    let { when: when, message: message } = _ref11;
    let blocker = (0, $9352744c2719600e$export$2af03a1de5c0910)(when);
    $iawgr.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $iawgr.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c566805c483e906d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $iawgr.useContext($c566805c483e906d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $78dc425114cabdd8$export$3e9cee6b33872309)(false);
    let { basename: basename } = $c566805c483e906d$var$useDataRouterContext($c566805c483e906d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $9352744c2719600e$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $78dc425114cabdd8$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $78dc425114cabdd8$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $78dc425114cabdd8$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("iawgr");



function $e7c3a2511e3d825f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("nav", {
        className: "meta-navigation",
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
            children: [
                (0, $ad12973d6e24df39$export$a1d0d20ee9546562)() ? "" : /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)($e7c3a2511e3d825f$var$FollowMouse, {
                    ...props
                }),
                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $c566805c483e906d$export$a6c7ac8248d6e38a), {
                        to: "/datenschutz",
                        children: "Datenschutz"
                    })
                }),
                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $c566805c483e906d$export$a6c7ac8248d6e38a), {
                        to: "/impressum",
                        children: "Impressum"
                    })
                }),
                props.backLink && (0, $ad12973d6e24df39$export$a1d0d20ee9546562)() ? /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)($e7c3a2511e3d825f$var$Backlink, {}) : ""
            ]
        })
    });
}
const $e7c3a2511e3d825f$var$Backlink = ()=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $c566805c483e906d$export$a6c7ac8248d6e38a), {
            to: "/",
            children: "zur\xfcck"
        })
    });
const $e7c3a2511e3d825f$var$FollowMouse = (props)=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("button", {
            onClick: ()=>props.setFollowMouse(!props.followMouse),
            children: [
                "Maus folgen: ",
                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                    children: props.followMouse ? "An" : "Aus"
                })
            ]
        })
    });




var $iawgr = parcelRequire("iawgr");



var $iawgr = parcelRequire("iawgr");


const $477962fca4131a73$export$362a5dc2da4635ca = ()=>/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).Fragment, {
        children: !(0, $ad12973d6e24df39$export$a1d0d20ee9546562)() ? /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("nav", {
            className: "page__go-back",
            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $c566805c483e906d$export$a6c7ac8248d6e38a), {
                to: "/",
                children: "Zur\xfcck"
            })
        }) : ""
    });


const $5e534017dbaac379$export$89412e086ed76e41 = ()=>{
    (0, $iawgr.useEffect)(()=>{
        (0, $ad12973d6e24df39$export$728a6effeb7267c1)("Impressum");
    });
    return /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("article", {
        className: "page",
        children: [
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $477962fca4131a73$export$362a5dc2da4635ca), {}),
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                className: "page__content",
                children: [
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h1", {
                        children: "Impressum"
                    }),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                            children: "Leon Dietsch"
                        })
                    }),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                        children: [
                            "Lohm\xfchlenweg 15",
                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("br", {}),
                            "63571 Gelnhausen"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                        children: [
                            "E-Mail: ",
                            (0, $ad12973d6e24df39$export$4e9e2e79518e2524)("hallo@leondietsch.de"),
                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("br", {}),
                            "Telefon: +49 176 210 154 56"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                        children: "USt-IdNr. DE322964201"
                    })
                ]
            })
        ]
    });
};




var $iawgr = parcelRequire("iawgr");


const $32f750facf6f6a51$export$c5c352a5595119a5 = ()=>{
    (0, $iawgr.useEffect)(()=>{
        (0, $ad12973d6e24df39$export$728a6effeb7267c1)("Datenschutzerkl\xe4rung");
    });
    return /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $477962fca4131a73$export$362a5dc2da4635ca), {}),
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                className: "page__content",
                children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h1", {
                            children: "Datenschutzerkl\xe4rung"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m14",
                            children: "Einleitung"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: 'Mit der folgenden Datenschutzerkl\xe4rung m\xf6chten wir Sie dar\xfcber aufkl\xe4ren, welche Arten Ihrer personenbezogenen Daten (nachfolgend auch kurz als "Daten\u201C bezeichnet) wir zu welchen Zwecken und in welchem Umfang verarbeiten. Die Datenschutzerkl\xe4rung gilt f\xfcr alle von uns durchgef\xfchrten Verarbeitungen personenbezogener Daten, sowohl im Rahmen der Erbringung unserer Leistungen als auch insbesondere auf unseren Webseiten, in mobilen Applikationen sowie innerhalb externer Onlinepr\xe4senzen, wie z.B. unserer Social-Media-Profile (nachfolgend zusammenfassend bezeichnet als "Onlineangebot\u201C).'
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Die verwendeten Begriffe sind nicht geschlechtsspezifisch."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Stand: 19. Dezember 2019"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            children: "Inhalts\xfcbersicht"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "index",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m14",
                                        children: " Einleitung"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m3",
                                        children: " Verantwortlicher"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#mOverview",
                                        children: " \xdcbersicht der Verarbeitungen"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m13",
                                        children: " Ma\xdfgebliche Rechtsgrundlagen"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m27",
                                        children: " Sicherheitsma\xdfnahmen"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m25",
                                        children: " \xdcbermittlung und Offenbarung von personenbezogenen Daten"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m24",
                                        children: " Datenverarbeitung in Drittl\xe4ndern"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m134",
                                        children: " Einsatz von Cookies"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m317",
                                        children: " Kommerzielle und gesch\xe4ftliche Leistungen"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m182",
                                        children: " Kontaktaufnahme"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m391",
                                        children: " Kommunikation via Messenger"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m735",
                                        children: " Online-Konferenzen, -Meetings und Webinare"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m225",
                                        children: " Bereitstellung des Onlineangebotes und Webhosting"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m29",
                                        children: " Cloud-Dienste"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m263",
                                        children: " Webanalyse und Optimierung"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m136",
                                        children: " Pr\xe4senzen in sozialen Netzwerken"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m723",
                                        children: " Planung, Organisation und Hilfswerkzeuge"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m12",
                                        children: " L\xf6schung von Daten"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m15",
                                        children: " \xc4nderung und Aktualisierung der Datenschutzerkl\xe4rung"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m10",
                                        children: " Rechte der betroffenen Personen"
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        className: "index-link",
                                        href: "#m42",
                                        children: " Begriffsdefinitionen"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m3",
                            children: "Verantwortlicher"
                        }),
                        " ",
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                "Leon Dietsch",
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("br", {}),
                                "Lohm\xfchlenweg 15",
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("br", {}),
                                "63571 Gelnhausen"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "E-Mail-Adresse"
                                }),
                                ": ",
                                (0, $ad12973d6e24df39$export$4e9e2e79518e2524)("hallo@leondietsch.de")
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Telefon"
                                }),
                                ": +49 176 210 154 56"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Impressum"
                                }),
                                ": ",
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                    href: "https://leondietsch.de/impressum",
                                    children: "https://leondietsch.de/impressum"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "mOverview",
                            children: "\xdcbersicht der Verarbeitungen"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Die nachfolgende \xdcbersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer Verarbeitung zusammen und verweist auf die betroffenen Personen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h3", {
                            children: "Arten der verarbeiteten Daten"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Bestandsdaten (z.B. Namen, Adressen)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Kontaktdaten (z.B. E-Mail, Telefonnummern)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Vertragsdaten (z.B. Vertragsgegenstand, Laufzeit, Kundenkategorie)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Zahlungsdaten (z.B. Bankverbindungen, Rechnungen, Zahlungshistorie)."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h3", {
                            children: "Kategorien betroffener Personen"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Besch\xe4ftigte (z.B. Angestellte, Bewerber, ehemalige Mitarbeiter)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Gesch\xe4fts- und Vertragspartner."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Interessenten."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Kommunikationspartner."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Kunden."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten)."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h3", {
                            children: "Zwecke der Verarbeitung"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Affiliate-Nachverfolgung."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Besuchsaktionsauswertung."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "B\xfcro- und Organisationsverfahren."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Direktmarketing (z.B. per E-Mail oder postalisch)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Kontaktanfragen und Kommunikation."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Profiling (Erstellen von Nutzerprofilen)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Remarketing."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Reichweitenmessung (z.B. Zugriffsstatistiken, Erkennung wiederkehrender Besucher)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Tracking (z.B. interessens-/verhaltensbezogenes Profiling, Nutzung von Cookies)."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Vertragliche Leistungen und Service."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: "Verwaltung und Beantwortung von Anfragen."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {}),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h3", {
                            id: "m13",
                            children: "Ma\xdfgebliche Rechtsgrundlagen"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Im Folgenden teilen wir die Rechtsgrundlagen der Datenschutzgrundverordnung (DSGVO), auf deren Basis wir die personenbezogenen Daten verarbeiten, mit. Bitte beachten Sie, dass zus\xe4tzlich zu den Regelungen der DSGVO die nationalen Datenschutzvorgaben in Ihrem bzw. unserem Wohn- und Sitzland gelten k\xf6nnen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO)"
                                            }),
                                            " - Die betroffene Person hat ihre Einwilligung in die Verarbeitung der sie betreffenden personenbezogenen Daten f\xfcr einen spezifischen Zweck oder mehrere bestimmte Zwecke gegeben."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Vertragserf\xfcllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b. DSGVO)"
                                            }),
                                            " - Die Verarbeitung ist f\xfcr die Erf\xfcllung eines Vertrags, dessen Vertragspartei die betroffene Person ist, oder zur Durchf\xfchrung vorvertraglicher Ma\xdfnahmen erforderlich, die auf Anfrage der betroffenen Person erfolgen."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtliche Verpflichtung (Art. 6 Abs. 1 S. 1 lit. c. DSGVO)"
                                            }),
                                            " - Die Verarbeitung ist zur Erf\xfcllung einer rechtlichen Verpflichtung erforderlich, der der Verantwortliche unterliegt."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)"
                                            }),
                                            " - Die Verarbeitung ist zur Wahrung der berechtigten Interessen des Verantwortlichen oder eines Dritten erforderlich, sofern nicht die Interessen oder Grundrechte und Grundfreiheiten der betroffenen Person, die den Schutz personenbezogener Daten erfordern, \xfcberwiegen."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Nationale Datenschutzregelungen in Deutschland"
                                }),
                                ": Zus\xe4tzlich zu den Datenschutzregelungen der Datenschutz-Grundverordnung gelten nationale Regelungen zum Datenschutz in Deutschland. Hierzu geh\xf6rt insbesondere das Gesetz zum Schutz vor Missbrauch personenbezogener Daten bei der Datenverarbeitung (Bundesdatenschutzgesetz \u2013 BDSG). Das BDSG enth\xe4lt insbesondere Spezialregelungen zum Recht auf Auskunft, zum Recht auf L\xf6schung, zum Widerspruchsrecht, zur Verarbeitung besonderer Kategorien personenbezogener Daten, zur Verarbeitung f\xfcr andere Zwecke und zur \xdcbermittlung sowie automatisierten Entscheidungsfindung im Einzelfall einschlie\xdflich Profiling. Des Weiteren regelt es die Datenverarbeitung f\xfcr Zwecke des Besch\xe4ftigungsverh\xe4ltnisses (\xa7 26 BDSG), insbesondere im Hinblick auf die Begr\xfcndung, Durchf\xfchrung oder Beendigung von Besch\xe4ftigungsverh\xe4ltnissen sowie die Einwilligung von Besch\xe4ftigten. Ferner k\xf6nnen Landesdatenschutzgesetze der einzelnen Bundesl\xe4nder zur Anwendung gelangen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m27",
                            children: "Sicherheitsma\xdfnahmen"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir treffen nach Ma\xdfgabe der gesetzlichen Vorgaben unter Ber\xfccksichtigung des Stands der Technik, der Implementierungskosten und der Art, des Umfangs, der Umst\xe4nde und der Zwecke der Verarbeitung sowie der unterschiedlichen Eintrittswahrscheinlichkeiten und des Ausma\xdfes der Bedrohung der Rechte und Freiheiten nat\xfcrlicher Personen geeignete technische und organisatorische Ma\xdfnahmen, um ein dem Risiko angemessenes Schutzniveau zu gew\xe4hrleisten."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Zu den Ma\xdfnahmen geh\xf6ren insbesondere die Sicherung der Vertraulichkeit, Integrit\xe4t und Verf\xfcgbarkeit von Daten durch Kontrolle des physischen und elektronischen Zugangs zu den Daten als auch des sie betreffenden Zugriffs, der Eingabe, der Weitergabe, der Sicherung der Verf\xfcgbarkeit und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die eine Wahrnehmung von Betroffenenrechten, die L\xf6schung von Daten und Reaktionen auf die Gef\xe4hrdung der Daten gew\xe4hrleisten. Ferner ber\xfccksichtigen wir den Schutz personenbezogener Daten bereits bei der Entwicklung bzw. Auswahl von Hardware, Software sowie Verfahren entsprechend dem Prinzip des Datenschutzes, durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "SSL-Verschl\xfcsselung (https)"
                                }),
                                ": Um Ihre via unser Online-Angebot \xfcbermittelten Daten zu sch\xfctzen, nutzen wir eine SSL-Verschl\xfcsselung. Sie erkennen derart verschl\xfcsselte Verbindungen an dem Pr\xe4fix https:// in der Adresszeile Ihres Browsers."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m25",
                            children: "\xdcbermittlung und Offenbarung von personenbezogenen Daten"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Im Rahmen unserer Verarbeitung von personenbezogenen Daten kommt es vor, dass die Daten an andere Stellen, Unternehmen, rechtlich selbstst\xe4ndige Organisationseinheiten oder Personen \xfcbermittelt oder sie ihnen gegen\xfcber offengelegt werden. Zu den Empf\xe4ngern dieser Daten k\xf6nnen z.B. Zahlungsinstitute im Rahmen von Zahlungsvorg\xe4ngen, mit IT-Aufgaben beauftragte Dienstleister oder Anbieter von Diensten und Inhalten, die in eine Webseite eingebunden werden, geh\xf6ren. In solchen Fall beachten wir die gesetzlichen Vorgaben und schlie\xdfen insbesondere entsprechende Vertr\xe4ge bzw. Vereinbarungen, die dem Schutz Ihrer Daten dienen, mit den Empf\xe4ngern Ihrer Daten ab."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m24",
                            children: "Datenverarbeitung in Drittl\xe4ndern"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Sofern wir Daten in einem Drittland (d.h., au\xdferhalb der Europ\xe4ischen Union (EU), des Europ\xe4ischen Wirtschaftsraums (EWR)) verarbeiten oder die Verarbeitung im Rahmen der Inanspruchnahme von Diensten Dritter oder der Offenlegung bzw. \xdcbermittlung von Daten an andere Personen, Stellen oder Unternehmen stattfindet, erfolgt dies nur im Einklang mit den gesetzlichen Vorgaben. "
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                'Vorbehaltlich ausdr\xfccklicher Einwilligung oder vertraglich oder gesetzlich erforderlicher \xdcbermittlung verarbeiten oder lassen wir die Daten nur in Drittl\xe4ndern mit einem anerkannten Datenschutzniveau, zu denen die unter dem "Privacy-Shield" zertifizierten US-Verarbeiter geh\xf6ren, oder auf Grundlage besonderer Garantien, wie z.B. vertraglicher Verpflichtung durch sogenannte Standardschutzklauseln der EU-Kommission, des Vorliegens von Zertifizierungen oder verbindlicher interner Datenschutzvorschriften, verarbeiten (Art. 44 bis 49 DSGVO, Informationsseite der EU-Kommission: ',
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                    href: "https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection_de",
                                    children: "https://ec.europa.eu/info/law/law-topic/data-protection/international-dimension-data-protection_de"
                                }),
                                " )."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m134",
                            children: "Einsatz von Cookies"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: 'Cookies sind Textdateien, die Daten von besuchten Websites oder Domains enthalten und von einem Browser auf dem Computer des Benutzers gespeichert werden. Ein Cookie dient in erster Linie dazu, die Informationen \xfcber einen Benutzer w\xe4hrend oder nach seinem Besuch innerhalb eines Onlineangebotes zu speichern. Zu den gespeicherten Angaben k\xf6nnen z.B. die Spracheinstellungen auf einer Webseite, der Loginstatus, ein Warenkorb oder die Stelle, an der ein Video geschaut wurde, geh\xf6ren. Zu dem Begriff der Cookies z\xe4hlen wir ferner andere Technologien, die die gleichen Funktionen wie Cookies erf\xfcllen (z.B., wenn Angaben der Nutzer anhand pseudonymer Onlinekennzeichnungen gespeichert werden, auch als "Nutzer-IDs" bezeichnet)'
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Die folgenden Cookie-Typen und Funktionen werden unterschieden:"
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Tempor\xe4re Cookies (auch: Session- oder Sitzungs-Cookies):"
                                        }),
                                        " Tempor\xe4re Cookies werden sp\xe4testens gel\xf6scht, nachdem ein Nutzer ein Online-Angebot verlassen und seinen Browser geschlossen hat."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Permanente Cookies:"
                                        }),
                                        " Permanente Cookies bleiben auch nach dem Schlie\xdfen des Browsers gespeichert. So kann beispielsweise der Login-Status gespeichert oder bevorzugte Inhalte direkt angezeigt werden, wenn der Nutzer eine Website erneut besucht. Ebenso k\xf6nnen die Interessen von Nutzern, die zur Reichweitenmessung oder zu Marketingzwecken verwendet werden, in einem solchen Cookie gespeichert werden."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "First-Party-Cookies:"
                                        }),
                                        " First-Party-Cookies werden von uns selbst gesetzt."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Third-Party-Cookies (auch: Drittanbieter-Cookies)"
                                        }),
                                        ": Drittanbieter-Cookies werden haupts\xe4chlich von Werbetreibenden (sog. Dritten) verwendet, um Benutzerinformationen zu verarbeiten."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Notwendige (auch: essentielle oder unbedingt erforderliche) Cookies:"
                                        }),
                                        " Cookies k\xf6nnen zum einen f\xfcr den Betrieb einer Webseite unbedingt erforderlich sein (z.B. um Logins oder andere Nutzereingaben zu speichern oder aus Gr\xfcnden der Sicherheit)."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Statistik-, Marketing- und Personalisierungs-Cookies"
                                        }),
                                        ': Ferner werden Cookies im Regelfall auch im Rahmen der Reichweitenmessung eingesetzt sowie dann, wenn die Interessen eines Nutzers oder sein Verhalten (z.B. Betrachten bestimmter Inhalte, Nutzen von Funktionen etc.) auf einzelnen Webseiten in einem Nutzerprofil gespeichert werden. Solche Profile dienen dazu, den Nutzern z.B. Inhalte anzuzeigen, die ihren potentiellen Interessen entsprechen. Dieses Verfahren wird auch als "Tracking", d.h., Nachverfolgung der potentiellen Interessen der Nutzer bezeichnet. . Soweit wir Cookies oder "Tracking"-Technologien einsetzen, informieren wir Sie gesondert in unserer Datenschutzerkl\xe4rung oder im Rahmen der Einholung einer Einwilligung.'
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Hinweise zu Rechtsgrundlagen: "
                                }),
                                " Auf welcher Rechtsgrundlage wir Ihre personenbezogenen Daten mit Hilfe von Cookies verarbeiten, h\xe4ngt davon ab, ob wir Sie um eine Einwilligung bitten. Falls dies zutrifft und Sie in die Nutzung von Cookies einwilligen, ist die Rechtsgrundlage der Verarbeitung Ihrer Daten die erkl\xe4rte Einwilligung. Andernfalls werden die mithilfe von Cookies verarbeiteten Daten auf Grundlage unserer berechtigten Interessen (z.B. an einem betriebswirtschaftlichen Betrieb unseres Onlineangebotes und dessen Verbesserung) verarbeitet oder, wenn der Einsatz von Cookies erforderlich ist, um unsere vertraglichen Verpflichtungen zu erf\xfcllen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Allgemeine Hinweise zum Widerruf und Widerspruch (Opt-Out): "
                                }),
                                ' Abh\xe4ngig davon, ob die Verarbeitung auf Grundlage einer Einwilligung oder gesetzlichen Erlaubnis erfolgt, haben Sie jederzeit die M\xf6glichkeit, eine erteilte Einwilligung zu widerrufen oder der Verarbeitung Ihrer Daten durch Cookie-Technologien zu widersprechen (zusammenfassend als "Opt-Out" bezeichnet). Sie k\xf6nnen Ihren Widerspruch zun\xe4chst mittels der Einstellungen Ihres Browsers erkl\xe4ren, z.B., indem Sie die Nutzung von Cookies deaktivieren (wobei hierdurch auch die Funktionsf\xe4higkeit unseres Onlineangebotes eingeschr\xe4nkt werden kann). Ein Widerspruch gegen den Einsatz von Cookies zu Zwecken des Onlinemarketings kann auch mittels einer Vielzahl von Diensten, vor allem im Fall des Trackings, \xfcber die Webseiten ',
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                    href: "http://optout.aboutads.info",
                                    children: "http://optout.aboutads.info"
                                }),
                                " und ",
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                    href: "http://www.youronlinechoices.com/",
                                    children: "http://www.youronlinechoices.com/"
                                }),
                                " erkl\xe4rt werden. Daneben k\xf6nnen Sie weitere Widerspruchshinweise im Rahmen der Angaben zu den eingesetzten Dienstleistern und Cookies erhalten."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Verarbeitung von Cookie-Daten auf Grundlage einer Einwilligung"
                                }),
                                ": Bevor wir Daten im Rahmen der Nutzung von Cookies verarbeiten oder verarbeiten lassen, bitten wir die Nutzer um eine jederzeit widerrufbare Einwilligung. Bevor die Einwilligung nicht ausgesprochen wurde, werden allenfalls Cookies eingesetzt, die f\xfcr den Betrieb unseres Onlineangebotes erforderlich sind. Deren Einsatz erfolgt auf der Grundlage unseres Interesses und des Interesses der Nutzer an der erwarteten Funktionsf\xe4higkeit unseres Onlineangebotes."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m317",
                            children: "Kommerzielle und gesch\xe4ftliche Leistungen"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: 'Wir verarbeiten Daten unserer Vertrags- und Gesch\xe4ftspartner, z.B. Kunden und Interessenten (zusammenfassend bezeichnet als "Vertragspartner") im Rahmen von vertraglichen und vergleichbaren Rechtsverh\xe4ltnissen sowie damit verbundenen Ma\xdfnahmen und im Rahmen der Kommunikation mit den Vertragspartnern (oder vorvertraglich), z.B., um Anfragen zu beantworten.'
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Diese Daten verarbeiten wir zur Erf\xfcllung unserer vertraglichen Pflichten, zur Sicherung unserer Rechte und zu Zwecken der mit diesen Angaben einhergehenden Verwaltungsaufgaben sowie der unternehmerischen Organisation. Die Daten der Vertragspartner geben wir im Rahmen des geltenden Rechts nur insoweit an Dritte weiter, als dies zu den vorgenannten Zwecken oder zur Erf\xfcllung gesetzlicher Pflichten erforderlich ist oder mit Einwilligung der Vertragspartner erfolgt (z.B. an beteiligte Telekommunikations-, Transport- und sonstige Hilfsdienste sowie Subunternehmer, Banken, Steuer- und Rechtsberater, Zahlungsdienstleister oder Steuerbeh\xf6rden). \xdcber weitere Verarbeitungsformen, z.B. zu Zwecken des Marketings, werden die Vertragspartner im Rahmen dieser Datenschutzerkl\xe4rung informiert."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Welche Daten f\xfcr die vorgenannten Zwecke erforderlich sind, teilen wir den Vertragspartnern vor oder im Rahmen der Datenerhebung, z.B. in Onlineformularen, durch besondere Kennzeichnung (z.B. Farben) bzw. Symbole (z.B. Sternchen o.\xe4.), oder pers\xf6nlich mit."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir l\xf6schen die Daten nach Ablauf gesetzlicher Gew\xe4hrleistungs- und vergleichbarer Pflichten, d.h., grunds\xe4tzlich nach Ablauf von 4 Jahren, es sei denn, dass die Daten in einem Kundenkonto gespeichert werden, z.B., solange sie aus gesetzlichen Gr\xfcnden der Archivierung aufbewahrt werden m\xfcssen (z.B. f\xfcr Steuerzwecke im Regelfall 10 Jahre). Daten, die uns im Rahmen eines Auftrags durch den Vertragspartner offengelegt wurden, l\xf6schen wir entsprechend den Vorgaben des Auftrags, grunds\xe4tzlich nach Ende des Auftrags."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Soweit wir zur Erbringung unserer Leistungen Drittanbieter oder Plattformen einsetzen, gelten im Verh\xe4ltnis zwischen den Nutzern und den Anbietern die Gesch\xe4ftsbedingungen und Datenschutzhinweise der jeweiligen Drittanbieter oder Plattformen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Agenturdienstleistungen"
                                }),
                                ": Wir verarbeiten die Daten unserer Kunden im Rahmen unserer vertraglichen Leistungen, zu denen z.B. konzeptionelle und strategische Beratung, Kampagnenplanung, Software- und Designentwicklung/-beratung oder -pflege, Umsetzung von Kampagnen und Prozessen, Handling, Serveradministration, Datenanalyse/ Beratungsleistungen und Schulungsleistungen geh\xf6ren k\xf6nnen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {})
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                            className: "dsg-license-content-blurred",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Consulting"
                            })
                        }),
                        ": ",
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                            className: "dsg-license-content-blurred",
                            children: [
                                "For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. For full text please purchase the license. ",
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                    className: "dsg-lc-missing dsg-license-content-info-shop dsg-bg-green",
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                            className: "title",
                                            children: 'Dieses Modul ist nur nach Eingabe des Lizenzcodes "Datenschutzerkl\xe4rung Deutsch" zug\xe4nglich'
                                        }),
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                            className: "dsg-license-content-info-shop-left",
                                            children: [
                                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                    children: [
                                                        "Sie haben schon einen Lizenzcode? ",
                                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                            title: "Lizenzcode im Premiumbereich eingeben.",
                                                            href: "#dsg-group-premium",
                                                            children: "Geben Sie ihn bitte oben im Premiumbereich ein"
                                                        }),
                                                        "."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                    children: [
                                                        "Oder erwerben Sie bitte die Lizenz ",
                                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                            href: "https://datenschutz-generator.de/produkt-kategorie/datenschutzerklaerung/",
                                                            className: " dsg-license-content-info-shop-link",
                                                            title: "Bitte erwerben Sie die Lizenz bei uns im Shop",
                                                            children: "bei uns im Shop f\xfcr Gesch\xe4ftskunden."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                    children: [
                                                        "Sie m\xf6chten wissen wie der Lizenzerwerb funktioniert? Schauen Sie dazu bitte ",
                                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                            href: "https://datenschutz-generator.de/help-premium/",
                                                            title: "Anleitung f\xfcr den Lizenzerwerb",
                                                            children: "in unsere Anleitung"
                                                        }),
                                                        "."
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                            href: "https://datenschutz-generator.de/help-license/",
                                            title: "Anleitung f\xfcr den Lizenzerwerb",
                                            className: "dsg-license-content-info-shop-right"
                                        })
                                    ]
                                }),
                                "Wir For full text please purchase the license. die For full text please purchase the license. unserer For full text please purchase the license. Mandanten For full text please purchase the license. Interessenten For full text please purchase the license. "
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Projekt- und Entwicklungsleistungen"
                                }),
                                ': Wir verarbeiten die Daten unserer Kunden sowie Auftraggeber (nachfolgend einheitlich als "Kunden" bezeichnet), um ihnen die Auswahl, den Erwerb bzw. die Beauftragung der gew\xe4hlten Leistungen oder Werke sowie verbundener T\xe4tigkeiten als auch deren Bezahlung und Zurverf\xfcgungstellung bzw. Ausf\xfchrung oder Erbringung zu erm\xf6glichen.'
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Die erforderlichen Angaben sind als solche im Rahmen des Auftrags-, Bestell- bzw. vergleichbaren Vertragsschlusses gekennzeichnet und umfassen die zur Leistungserbringung und Abrechnung ben\xf6tigten Angaben sowie Kontaktinformationen, um etwaige R\xfccksprachen halten zu k\xf6nnen. Soweit wir Zugang zu Informationen der Endkunden, Mitarbeitern oder anderer Personen erhalten, verarbeiten wir diese im Einklang mit den gesetzlichen und vertraglichen Vorgaben."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Technische Dienstleistungen"
                                }),
                                ': Wir verarbeiten die Daten unserer Kunden sowie Auftraggeber (nachfolgend einheitlich als "Kunden" bezeichnet), um ihnen die Auswahl, den Erwerb bzw. die Beauftragung der gew\xe4hlten Leistungen oder Werke sowie verbundener T\xe4tigkeiten als auch deren Bezahlung und Zurverf\xfcgungstellung bzw. Ausf\xfchrung oder Erbringung zu erm\xf6glichen.'
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Die erforderlichen Angaben sind als solche im Rahmen des Auftrags-, Bestell- bzw. vergleichbaren Vertragsschlusses gekennzeichnet und umfassen die zur Leistungserbringung und Abrechnung ben\xf6tigten Angaben sowie Kontaktinformationen, um etwaige R\xfccksprachen halten zu k\xf6nnen. Soweit wir Zugang zu Informationen der Endkunden, Mitarbeitern oder anderer Personen erhalten, verarbeiten wir diese im Einklang mit den gesetzlichen und vertraglichen Vorgaben."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Bestandsdaten (z.B. Namen, Adressen), Zahlungsdaten (z.B. Bankverbindungen, Rechnungen, Zahlungshistorie), Kontaktdaten (z.B. E-Mail, Telefonnummern), Vertragsdaten (z.B. Vertragsgegenstand, Laufzeit, Kundenkategorie)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Interessenten, Gesch\xe4fts- und Vertragspartner."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Zwecke der Verarbeitung:"
                                            }),
                                            " Vertragliche Leistungen und Service, Kontaktanfragen und Kommunikation, B\xfcro- und Organisationsverfahren, Verwaltung und Beantwortung von Anfragen."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Vertragserf\xfcllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b. DSGVO), Rechtliche Verpflichtung (Art. 6 Abs. 1 S. 1 lit. c. DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m182",
                            children: "Kontaktaufnahme"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Bei der Kontaktaufnahme mit uns (z.B. per Kontaktformular, E-Mail, Telefon oder via soziale Medien) werden die Angaben der anfragenden Personen verarbeitet, soweit dies zur Beantwortung der Kontaktanfragen und etwaiger angefragter Ma\xdfnahmen erforderlich ist."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Die Beantwortung der Kontaktanfragen im Rahmen von vertraglichen oder vorvertraglichen Beziehungen erfolgt zur Erf\xfcllung unserer vertraglichen Pflichten oder zur Beantwortung von (vor)vertraglichen Anfragen und im \xdcbrigen auf Grundlage der berechtigten Interessen an der Beantwortung der Anfragen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Bestandsdaten (z.B. Namen, Adressen), Kontaktdaten (z.B. E-Mail, Telefonnummern), Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Kommunikationspartner."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Zwecke der Verarbeitung:"
                                            }),
                                            " Kontaktanfragen und Kommunikation."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Vertragserf\xfcllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b. DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m391",
                            children: "Kommunikation via Messenger"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir setzen zu Zwecken der Kommunikation Messenger-Dienste ein und bitten daher darum, die nachfolgenden Hinweise zur Funktionsf\xe4higkeit der Messenger, zur Verschl\xfcsselung, zur Nutzung der Metadaten der Kommunikation und zu Ihren Widerspruchsm\xf6glichkeiten zu beachten."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Sie k\xf6nnen uns auch auf alternativen Wegen, z.B. via Telefon oder E-Mail, kontaktieren. Bitte nutzen Sie die Ihnen mitgeteilten Kontaktm\xf6glichkeiten oder die innerhalb unseres Onlineangebotes angegebenen Kontaktm\xf6glichkeiten."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Im Fall einer Ende-zu-Ende-Verschl\xfcsselung von Inhalten (d.h., der Inhalt Ihrer Nachricht und Anh\xe4nge) weisen wir darauf hin, dass die Kommunikationsinhalte (d.h., der Inhalt der Nachricht und angeh\xe4ngte Bilder) von Ende zu Ende verschl\xfcsselt werden. Das bedeutet, dass der Inhalt der Nachrichten nicht einsehbar ist, nicht einmal durch die Messenger-Anbieter selbst. Sie sollten immer eine aktuelle Version der Messenger mit aktivierter Verschl\xfcsselung nutzen, damit die Verschl\xfcsselung der Nachrichteninhalte sichergestellt ist. "
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir weisen unsere Kommunikationspartner jedoch zus\xe4tzlich darauf hin, dass die Anbieter der Messenger zwar nicht den Inhalt einsehen, aber in Erfahrung bringen k\xf6nnen, dass und wann Kommunikationspartner mit uns kommunizieren sowie technische Informationen zum verwendeten Ger\xe4t der Kommunikationspartner und je nach Einstellungen ihres Ger\xe4tes auch Standortinformationen (sogenannte Metadaten) verarbeitet werden."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Hinweise zu Rechtsgrundlagen: "
                                }),
                                " Sofern wir Kommunikationspartner vor der Kommunikation mit ihnen via Messenger um eine Erlaubnis bitten, ist die Rechtsgrundlage unserer Verarbeitung ihrer Daten deren Einwilligung. Im \xdcbrigen, falls wir nicht um eine Einwilligung bitten und sie z.B. von sich aus Kontakt mit uns aufnehmen, nutzen wir Messenger im Verh\xe4ltnis zu unseren Vertragspartnern sowie im Rahmen der Vertragsanbahnung als eine vertragliche Ma\xdfnahme und im Fall anderer Interessenten und Kommunikationspartner auf Grundlage unserer berechtigten Interessen an einer schnellen und effizienten Kommunikation und Erf\xfcllung der Bed\xfcrfnisse unser Kommunikationspartner an der Kommunikation via Messengern. Ferner weisen wir Sie darauf hin, dass wir die uns mitgeteilten Kontaktdaten ohne Ihre Einwilligung nicht erstmalig an die Messenger \xfcbermitteln."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Widerruf, Widerspruch und L\xf6schung:"
                                }),
                                " Sie k\xf6nnen jederzeit eine erteilte Einwilligung widerrufen und der Kommunikation mit uns via Messenger jederzeit widersprechen. Im Fall der Kommunikation via Messenger l\xf6schen wir die Nachrichten entsprechend unseren generellen L\xf6schrichtlinien (d.h. z.B., wie oben beschrieben, nach Ende vertraglicher Beziehungen, im Kontext von Archivierungsvorgaben etc.) und sonst, sobald wir davon ausgehen k\xf6nnen, etwaige Ausk\xfcnfte der Kommunikationspartner beantwortet zu haben, wenn kein R\xfcckbezug auf eine vorhergehende Konversation zu erwarten ist und der L\xf6schung keine gesetzlichen Aufbewahrungspflichten entgegenstehen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Vorbehalt des Verweises auf andere Kommunikationswege:"
                                }),
                                " Zum Abschluss m\xf6chten wir darauf hinweisen, dass wir uns aus Gr\xfcnden Ihrer Sicherheit vorbehalten, Anfragen \xfcber Messenger nicht zu beantworten. Das ist der Fall, wenn z.B. Vertragsinterna besonderer Geheimhaltung bed\xfcrfen oder eine Antwort \xfcber den Messenger den formellen Anspr\xfcchen nicht gen\xfcgt. In solchen F\xe4llen verweisen wir Sie auf ad\xe4quatere Kommunikationswege."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Skype"
                                }),
                                ": Die Ende-zu-Ende-Verschl\xfcsselung von Skype setzt deren Aktivierung voraus (sofern sie nicht standardm\xe4\xdfig aktiviert sein sollte)."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Kontaktdaten (z.B. E-Mail, Telefonnummern), Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen), Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Kommunikationspartner."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Zwecke der Verarbeitung:"
                                            }),
                                            " Kontaktanfragen und Kommunikation, Direktmarketing (z.B. per E-Mail oder postalisch)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Eingesetzte Dienste und Diensteanbieter:"
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Skype:"
                                        }),
                                        " Skype Messenger mit Ende-zu-Ende-Verschl\xfcsselung; Dienstanbieter: Microsoft Corporation, One Microsoft Way, Redmond, WA 98052-6399 USA; Website: ",
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                            href: "https://www.skype.com/de/",
                                            children: "https://www.skype.com/de/"
                                        }),
                                        "; Datenschutzerkl\xe4rung: ",
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                            href: "https://privacy.microsoft.com/de-de/privacystatement",
                                            children: "https://privacy.microsoft.com/de-de/privacystatement"
                                        }),
                                        ", Sicherheitshinweise: ",
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                            href: "https://www.microsoft.com/de-de/trustcenter",
                                            children: "https://www.microsoft.com/de-de/trustcenter"
                                        }),
                                        "; Privacy Shield (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung von Daten in den USA): ",
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                            href: "https://www.privacyshield.gov/participant?id=a2zt0000000KzNaAAK&status=Active",
                                            children: "https://www.privacyshield.gov/participant?id=a2zt0000000KzNaAAK&status=Active"
                                        }),
                                        "."
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m735",
                            children: "Online-Konferenzen, -Meetings und Webinare"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir setzen Plattformen und Anwendungen anderer Anbieter (nachfolgend bezeichnet als \u201CDrittanbieter\u201D) zu Zwecken der Durchf\xfchrung von Video und Audio-Konferenzen, Webinaren und sonstigen Arten von Video und Audio-Meetings ein. Bei der Auswahl der Drittanbieter und ihrer Leistungen beachten wir die gesetzlichen Vorgaben. "
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "In diesem Rahmen werden Daten der Kommunikationsteilnehmer verarbeitet und auf den Servern der Drittanbieter gespeichert, soweit diese Bestandteil von Kommunikationsvorg\xe4ngen mit uns sind. Zu diesen Daten k\xf6nnen insbesondere Anmelde- und Kontaktdaten, visuelle sowie stimmliche Beitr\xe4ge sowie Eingaben in Chats und geteilte Bilschirminhalte geh\xf6ren."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Sofern Nutzer im Rahmen der Kommunikation, Gesch\xe4fts- oder anderen Beziehungen mit uns auf die Drittanbieter, bzw. deren Software "
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                            className: "dsg-lc-missing dsg-license-content-info-shop dsg-bg-green",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                    className: "title",
                                    children: 'Dieses Modul ist nur nach Eingabe des Lizenzcodes "Datenschutzerkl\xe4rung Deutsch" zug\xe4nglich'
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                    className: "dsg-license-content-info-shop-left",
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                            children: [
                                                "Sie haben schon einen Lizenzcode? ",
                                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                    title: "Lizenzcode im Premiumbereich eingeben.",
                                                    href: "#dsg-group-premium",
                                                    children: "Geben Sie ihn bitte oben im Premiumbereich ein"
                                                }),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                            children: [
                                                "Oder erwerben Sie bitte die Lizenz ",
                                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                    href: "https://datenschutz-generator.de/produkt-kategorie/datenschutzerklaerung/",
                                                    className: " dsg-license-content-info-shop-link",
                                                    title: "Bitte erwerben Sie die Lizenz bei uns im Shop",
                                                    children: "bei uns im Shop f\xfcr Gesch\xe4ftskunden."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                            children: [
                                                "Sie m\xf6chten wissen wie der Lizenzerwerb funktioniert? Schauen Sie dazu bitte ",
                                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                    href: "https://datenschutz-generator.de/help-premium/",
                                                    title: "Anleitung f\xfcr den Lizenzerwerb",
                                                    children: "in unsere Anleitung"
                                                }),
                                                "."
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                    href: "https://datenschutz-generator.de/help-license/",
                                    title: "Anleitung f\xfcr den Lizenzerwerb",
                                    className: "dsg-license-content-info-shop-right"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                            className: "dsg-license-content-blurred",
                            children: "oder For full text please purchase the license. verwiesen For full text please purchase the license. k\xf6nnen For full text please purchase the license. Drittanbieterverarbeiten For full text please purchase the license. und For full text please purchase the license. die For full text please purchase the license. ihnen For full text please purchase the license. Sicherheitszwecken, For full text please purchase the license. oder For full text please purchase the license. verarbeitet For full text please purchase the license. Wir For full text please purchase the license. daher, For full text please purchase the license. Datenschutzhinweise For full text please purchase the license. jeweiligen For full text please purchase the license. zu For full text please purchase the license. zu For full text please purchase the license. Sofern For full text please purchase the license. die For full text please purchase the license. um For full text please purchase the license. Einwilligung For full text please purchase the license. den For full text please purchase the license. der For full text please purchase the license. bitten, For full text please purchase the license. die For full text please purchase the license. der For full text please purchase the license. die For full text please purchase the license. Ferner For full text please purchase the license. deren For full text please purchase the license. ein For full text please purchase the license. unserer For full text please purchase the license. Leistungen For full text please purchase the license. sofern For full text please purchase the license. Einsatz For full text please purchase the license. Drittanbieter For full text please purchase the license. diesem For full text please purchase the license. vereinbart For full text please purchase the license. Ansonsten For full text please purchase the license. die For full text please purchase the license. der For full text please purchase the license. auf For full text please purchase the license. unserer For full text please purchase the license. Interessen For full text please purchase the license. Interesse For full text please purchase the license. effizie For full text please purchase the license. diesem For full text please purchase the license. m\xf6chten For full text please purchase the license. Sie For full text please purchase the license. auf For full text please purchase the license. Informationen For full text please purchase the license. Verwendung For full text please purchase the license."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {})
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                            className: "dsg-license-content-blurred",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "TeamViewer"
                            })
                        }),
                        ": ",
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                            className: "dsg-license-content-blurred",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                className: "dsg-lc-missing dsg-license-content-info-shop dsg-bg-green",
                                children: [
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                        className: "title",
                                        children: 'Dieses Modul ist nur nach Eingabe des Lizenzcodes "Datenschutzerkl\xe4rung Deutsch" zug\xe4nglich'
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                        className: "dsg-license-content-info-shop-left",
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                children: [
                                                    "Sie haben schon einen Lizenzcode? ",
                                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                        title: "Lizenzcode im Premiumbereich eingeben.",
                                                        href: "#dsg-group-premium",
                                                        children: "Geben Sie ihn bitte oben im Premiumbereich ein"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                children: [
                                                    "Oder erwerben Sie bitte die Lizenz ",
                                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                        href: "https://datenschutz-generator.de/produkt-kategorie/datenschutzerklaerung/",
                                                        className: " dsg-license-content-info-shop-link",
                                                        title: "Bitte erwerben Sie die Lizenz bei uns im Shop",
                                                        children: "bei uns im Shop f\xfcr Gesch\xe4ftskunden."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                children: [
                                                    "Sie m\xf6chten wissen wie der Lizenzerwerb funktioniert? Schauen Sie dazu bitte ",
                                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                        href: "https://datenschutz-generator.de/help-premium/",
                                                        title: "Anleitung f\xfcr den Lizenzerwerb",
                                                        children: "in unsere Anleitung"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        href: "https://datenschutz-generator.de/help-license/",
                                        title: "Anleitung f\xfcr den Lizenzerwerb",
                                        className: "dsg-license-content-info-shop-right"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Bestandsdaten (z.B. Namen, Adressen), Kontaktdaten (z.B. E-Mail, Telefonnummern), Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos), Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Kommunikationspartner, Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Zwecke der Verarbeitung:"
                                            }),
                                            " Vertragliche Leistungen und Service, Kontaktanfragen und Kommunikation, B\xfcro- und Organisationsverfahren."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO), Vertragserf\xfcllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b. DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Eingesetzte Dienste und Diensteanbieter:"
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {})
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                        className: "dsg-license-content-blurred",
                                        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "TeamViewer"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                        children: ":"
                                    }),
                                    " Konferenz-Softwareplaceholder placeholder placeholder; Dienstanbieter: TeamViewer GmbHplaceholder placeholder placeholder; Website: ",
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        href: "https://www.teamviewplaceholder",
                                        children: "https://www.teamviewplaceholder"
                                    }),
                                    " placeholder placeholder; Datenschutzerkl\xe4rung: ",
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        href: "https://www.teamviewplaceholder",
                                        children: "https://www.teamviewplaceholder"
                                    }),
                                    " placeholder placeholder."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m225",
                            children: "Bereitstellung des Onlineangebotes und Webhosting"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Um unser Onlineangebot sicher und effizient bereitstellen zu k\xf6nnen, nehmen wir die Leistungen von einem oder mehreren Webhosting-Anbietern in Anspruch, von deren Servern (bzw. von ihnen verwalteten Servern) das Onlineangebot abgerufen werden kann. Zu diesen Zwecken k\xf6nnen wir Infrastruktur- und Plattformdienstleistungen, Rechenkapazit\xe4t, Speicherplatz und Datenbankdienste sowie Sicherheitsleistungen und technische Wartungsleistungen in Anspruch nehmen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Zu den im Rahmen der Bereitstellung des Hostingangebotes verarbeiteten Daten k\xf6nnen alle die Nutzer unseres Onlineangebotes betreffenden Angaben geh\xf6ren, die im Rahmen der Nutzung und der Kommunikation anfallen. Hierzu geh\xf6ren regelm\xe4\xdfig die IP-Adresse, die notwendig ist, um die Inhalte von Onlineangeboten an Browser ausliefern zu k\xf6nnen, und alle innerhalb unseres Onlineangebotes oder von Webseiten get\xe4tigten Eingaben."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "E-Mail-Versand und -Hosting"
                                }),
                                ": Die von uns in Anspruch genommenen Webhosting-Leistungen umfassen ebenfalls den Versand, den Empfang sowie die Speicherung von E-Mails. Zu diesen Zwecken werden die Adressen der Empf\xe4nger sowie Absender als auch weitere Informationen betreffend den E-Mailversand (z.B. die beteiligten Provider) sowie die Inhalte der jeweiligen E-Mails verarbeitet. Die vorgenannten Daten k\xf6nnen ferner zu Zwecken der Erkennung von SPAM verarbeitet werden. Wir bitten darum, zu beachten, dass E-Mails im Internet grunds\xe4tzlich nicht verschl\xfcsselt versendet werden. Im Regelfall werden E-Mails zwar auf dem Transportweg verschl\xfcsselt, aber (sofern kein sogenanntes Ende-zu-Ende-Verschl\xfcsselungsverfahren eingesetzt wird) nicht auf den Servern, von denen sie abgesendet und empfangen werden. Wir k\xf6nnen daher f\xfcr den \xdcbertragungsweg der E-Mails zwischen dem Absender und dem Empfang auf unserem Server keine Verantwortung \xfcbernehmen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Erhebung von Zugriffsdaten und Logfiles"
                                }),
                                ": Wir selbst (bzw. unser Webhostinganbieter) erheben Daten zu jedem Zugriff auf den Server (sogenannte Serverlogfiles). Zu den Serverlogfiles k\xf6nnen die Adresse und Name der abgerufenen Webseiten und Dateien, Datum und Uhrzeit des Abrufs, \xfcbertragene Datenmengen, Meldung \xfcber erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer URL (die zuvor besuchte Seite) und im Regelfall IP-Adressen und der anfragende Provider geh\xf6ren."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Die Serverlogfiles k\xf6nnen zum einen zu Zwecken der Sicherheit eingesetzt werden, z.B., um eine \xdcberlastung der Server zu vermeiden (insbesondere im Fall von missbr\xe4uchlichen Angriffen, sogenannten DDoS-Attacken) und zum anderen, um die Auslastung der Server und ihre Stabilit\xe4t sicherzustellen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos), Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m29",
                            children: "Cloud-Dienste"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: 'Wir nutzen \xfcber das Internet zug\xe4ngliche und auf den Servern ihrer Anbieter ausgef\xfchrte Softwaredienste (sogenannte "Cloud-Dienste", auch bezeichnet als "Software as a Service") f\xfcr die folgenden Zwecke: Dokumentenspeicherung und Verwaltung, Kalenderverwaltung, E-Mail-Versand, Tabellenkalkulationen und Pr\xe4sentationen, Austausch von Dokumenten, Inhalten und Informationen mit bestimmten Empf\xe4ngern oder Ver\xf6ffentlichung von Webseiten, Formularen oder sonstigen Inhalten und Informationen sowie Chats und Teilnahme an Audio- und Videokonferenzen.'
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "In diesem Rahmen k\xf6nnen personenbezogenen Daten verarbeitet und auf den Servern der Anbieter gespeichert werden, soweit diese Bestandteil von Kommunikationsvorg\xe4ngen mit uns sind oder von uns sonst, wie im Rahmen dieser Datenschutzerkl\xe4rung dargelegt, verarbeitet werden. Zu diesen Daten k\xf6nnen insbesondere Stammdaten und Kontaktdaten der Nutzer, Daten zu Vorg\xe4ngen, Vertr\xe4gen, sonstigen Prozessen und deren Inhalte geh\xf6ren. Die Anbieter der Cloud-Dienste verarbeiten ferner Nutzungsdaten und Metadaten, die von ihnen zu Sicherheitszwecken und zur Serviceoptimierung verwendet werden."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Sofern wir mit Hilfe der Cloud-Dienste f\xfcr andere Nutzer oder \xf6ffentlich zug\xe4ngliche Webseiten Formulare o.a. Dokumente und Inhalte bereitstellen, k\xf6nnen die Anbieter Cookies auf den Ger\xe4ten der Nutzer f\xfcr Zwecke der Webanalyse oder, um sich Einstellungen der Nutzer (z.B. im Fall der Mediensteuerung) zu merken, speichern."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Hinweise zu Rechtsgrundlagen:"
                                }),
                                " Sofern wir um eine Einwilligung in den Einsatz der Cloud-Dienste bitten, ist die Rechtsgrundlage der Verarbeitung die Einwilligung. Ferner kann deren Einsatz ein Bestandteil unserer (vor)vertraglichen Leistungen sein, sofern der Einsatz der Cloud-Dienste in diesem Rahmen vereinbart wurde. Ansonsten werden die Daten der Nutzer auf Grundlage unserer berechtigten Interessen (d.h., Interesse an effizienten und sicheren Verwaltungs- und Kollaborationsprozessen) verarbeitet"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Bestandsdaten (z.B. Namen, Adressen), Kontaktdaten (z.B. E-Mail, Telefonnummern), Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos), Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen), Vertragsdaten (z.B. Vertragsgegenstand, Laufzeit, Kundenkategorie)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Kunden, Besch\xe4ftigte (z.B. Angestellte, Bewerber, ehemalige Mitarbeiter), Interessenten, Kommunikationspartner."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Zwecke der Verarbeitung:"
                                            }),
                                            " B\xfcro- und Organisationsverfahren."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO), Vertragserf\xfcllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b. DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Eingesetzte Dienste und Diensteanbieter:"
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Apple iCloud:"
                                            }),
                                            " Cloud-Speicher-Dienste; Dienstanbieter: Apple Inc., Infinite Loop, Cupertino, CA 95014, USA; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.apple.com/de/",
                                                children: "https://www.apple.com/de/"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.apple.com/legal/privacy/de-ww/",
                                                children: "https://www.apple.com/legal/privacy/de-ww/"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Dropbox:"
                                            }),
                                            " Cloud-Speicher-Dienste; Dienstanbieter: Dropbox, Inc., 333 Brannan Street, San Francisco, California 94107, USA; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.dropbox.com/de",
                                                children: "https://www.dropbox.com/de"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.dropbox.com/privacy",
                                                children: "https://www.dropbox.com/privacy"
                                            }),
                                            "; Privacy Shield (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung von Daten in den USA): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.privacyshield.gov/participant?id=a2zt0000000GnCLAA0&status=Active",
                                                children: "https://www.privacyshield.gov/participant?id=a2zt0000000GnCLAA0&status=Active"
                                            }),
                                            "; Standardvertragsklauseln (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung im Drittland): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.dropbox.com/terms/business-agreement-2016",
                                                children: "https://www.dropbox.com/terms/business-agreement-2016"
                                            }),
                                            "."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m263",
                            children: "Webanalyse und Optimierung"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: 'Die Webanalyse (auch als "Reichweitenmessung" bezeichnet) dient der Auswertung der Besucherstr\xf6me unseres Onlineangebotes und kann Verhalten, Interessen oder demographische Informationen zu den Besuchern, wie z.B. das Alter oder das Geschlecht, als pseudonyme Werte umfassen. Mit Hilfe der Reichweitenanalyse k\xf6nnen wir z.B. erkennen, zu welcher Zeit unser Onlineangebot oder dessen Funktionen oder Inhalte am h\xe4ufigsten genutzt werden oder zur Wiederverwendung einladen. Ebenso k\xf6nnen wir nachvollziehen, welche Bereiche der Optimierung bed\xfcrfen. '
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Neben der Webanalyse k\xf6nnen wir auch Testverfahren einsetzen, um z.B. unterschiedliche Versionen unseres Onlineangebotes oder seiner Bestandteile zu testen und optimieren."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: 'Zu diesen Zwecken k\xf6nnen sogenannte Nutzerprofile angelegt und in einer Datei (sogenannte "Cookie") gespeichert oder \xe4hnliche Verfahren mit dem gleichen Zweck genutzt werden. Zu diesen Angaben k\xf6nnen z.B. betrachtete Inhalte, besuchte Webseiten und dort genutzte Elemente und technische Angaben, wie der verwendete Browser, das verwendete Computersystem sowie Angaben zu Nutzungszeiten geh\xf6ren. Sofern Nutzer in die Erhebung ihrer Standortdaten eingewilligt haben, k\xf6nnen je nach Anbieter auch diese verarbeitet werden.'
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Es werden ebenfalls die IP-Adressen der Nutzer gespeichert. Jedoch nutzen wir ein IP-Masking-Verfahren (d.h., Pseudonymisierung durch K\xfcrzung der IP-Adresse) zum Schutz der Nutzer. Generell werden die im Rahmen von Webanalyse, A/B-Testings und Optimierung keine Klardaten der Nutzer (wie z.B. E-Mail-Adressen oder Namen) gespeichert, sondern Pseudonyme. D.h., wir als auch die Anbieter der eingesetzten Software kennen nicht die tats\xe4chliche Identit\xe4t der Nutzer, sondern nur den f\xfcr Zwecke der jeweiligen Verfahren in deren Profilen gespeicherten Angaben."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Hinweise zu Rechtsgrundlagen:"
                                }),
                                " Sofern wir die Nutzer um deren Einwilligung in den Einsatz der Drittanbieter bitten, ist die Rechtsgrundlage der Verarbeitung von Daten die Einwilligung. Ansonsten werden die Daten der Nutzer auf Grundlage unserer berechtigten Interessen (d.h. Interesse an effizienten, wirtschaftlichen und empf\xe4ngerfreundlichen Leistungen) verarbeitet. In diesem Zusammenhang m\xf6chten wir Sie auch auf die Informationen zur Verwendung von Cookies in dieser Datenschutzerkl\xe4rung hinweisen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Zwecke der Verarbeitung:"
                                            }),
                                            " Reichweitenmessung (z.B. Zugriffsstatistiken, Erkennung wiederkehrender Besucher), Tracking (z.B. interessens-/verhaltensbezogenes Profiling, Nutzung von Cookies), Besuchsaktionsauswertung, Profiling (Erstellen von Nutzerprofilen)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Sicherheitsma\xdfnahmen:"
                                            }),
                                            " IP-Masking (Pseudonymisierung der IP-Adresse)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m136",
                            children: "Pr\xe4senzen in sozialen Netzwerken"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir unterhalten Onlinepr\xe4senzen innerhalb sozialer Netzwerke, um mit den dort aktiven Nutzern zu kommunizieren oder um dort Informationen \xfcber uns anzubieten."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir weisen darauf hin, dass dabei Daten der Nutzer au\xdferhalb des Raumes der Europ\xe4ischen Union verarbeitet werden k\xf6nnen. Hierdurch k\xf6nnen sich f\xfcr die Nutzer Risiken ergeben, weil so z.B. die Durchsetzung der Rechte der Nutzer erschwert werden k\xf6nnte. Im Hinblick auf US-Anbieter, die unter dem Privacy-Shield zertifiziert sind oder vergleichbare Garantien eines sicheren Datenschutzniveaus bieten, weisen wir darauf hin, dass sie sich damit verpflichten, die Datenschutzstandards der EU einzuhalten."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Ferner werden die Daten der Nutzer innerhalb sozialer Netzwerke im Regelfall f\xfcr Marktforschungs- und Werbezwecke verarbeitet. So k\xf6nnen z.B. anhand des Nutzungsverhaltens und sich daraus ergebender Interessen der Nutzer Nutzungsprofile erstellt werden. Die Nutzungsprofile k\xf6nnen wiederum verwendet werden, um z.B. Werbeanzeigen innerhalb und au\xdferhalb der Netzwerke zu schalten, die mutma\xdflich den Interessen der Nutzer entsprechen. Zu diesen Zwecken werden im Regelfall Cookies auf den Rechnern der Nutzer gespeichert, in denen das Nutzungsverhalten und die Interessen der Nutzer gespeichert werden. Ferner k\xf6nnen in den Nutzungsprofilen auch Daten unabh\xe4ngig der von den Nutzern verwendeten Ger\xe4te gespeichert werden (insbesondere, wenn die Nutzer Mitglieder der jeweiligen Plattformen sind und bei diesen eingeloggt sind)."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "F\xfcr eine detaillierte Darstellung der jeweiligen Verarbeitungsformen und der Widerspruchsm\xf6glichkeiten (Opt-Out) verweisen wir auf die Datenschutzerkl\xe4rungen und Angaben der Betreiber der jeweiligen Netzwerke."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Auch im Fall von Auskunftsanfragen und der Geltendmachung von Betroffenenrechten weisen wir darauf hin, dass diese am effektivsten bei den Anbietern geltend gemacht werden k\xf6nnen. Nur die Anbieter haben jeweils Zugriff auf die Daten der Nutzer und k\xf6nnen direkt entsprechende Ma\xdfnahmen ergreifen und Ausk\xfcnfte geben. Sollten Sie dennoch Hilfe ben\xf6tigen, dann k\xf6nnen Sie sich an uns wenden."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Bestandsdaten (z.B. Namen, Adressen), Kontaktdaten (z.B. E-Mail, Telefonnummern), Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos), Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Zwecke der Verarbeitung:"
                                            }),
                                            " Kontaktanfragen und Kommunikation, Tracking (z.B. interessens-/verhaltensbezogenes Profiling, Nutzung von Cookies), Remarketing, Reichweitenmessung (z.B. Zugriffsstatistiken, Erkennung wiederkehrender Besucher), Affiliate-Nachverfolgung."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Eingesetzte Dienste und Diensteanbieter:"
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Instagram :"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: Instagram Inc., 1601 Willow Road, Menlo Park, CA, 94025, USA; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.instagram.com",
                                                children: "https://www.instagram.com"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "http://instagram.com/about/legal/privacy",
                                                children: "http://instagram.com/about/legal/privacy"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Facebook:"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: Facebook Ireland Ltd., 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland, Mutterunternehmen: Facebook, 1 Hacker Way, Menlo Park, CA 94025, USA; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.facebook.com",
                                                children: "https://www.facebook.com"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.facebook.com/about/privacy",
                                                children: "https://www.facebook.com/about/privacy"
                                            }),
                                            "; Privacy Shield (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung von Daten in den USA): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active",
                                                children: "https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active"
                                            }),
                                            "; Widerspruchsm\xf6glichkeit (Opt-Out): Einstellungen f\xfcr Werbeanzeigen: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.facebook.com/settings?tab=ads",
                                                children: "https://www.facebook.com/settings?tab=ads"
                                            }),
                                            "; Zus\xe4tzliche Hinweise zum Datenschutz: Vereinbarung \xfcber gemeinsame Verarbeitung personenbezogener Daten auf Facebook-Seiten: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.facebook.com/legal/terms/page_controller_addendum",
                                                children: "https://www.facebook.com/legal/terms/page_controller_addendum"
                                            }),
                                            ", Datenschutzhinweise f\xfcr Facebook-Seiten: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.facebook.com/legal/terms/information_about_page_insights_data",
                                                children: "https://www.facebook.com/legal/terms/information_about_page_insights_data"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Flickr:"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: Flickr Inc., 475 Sansome St San Francisco, California 94111, USA; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.flickr.com",
                                                children: "https://www.flickr.com"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.flickr.com/help/privacy",
                                                children: "https://www.flickr.com/help/privacy"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "LinkedIn:"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: LinkedIn Ireland Unlimited Company, Wilton Place, Dublin 2, Irland; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.linkedin.com",
                                                children: "https://www.linkedin.com"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.linkedin.com/legal/privacy-policy",
                                                children: "https://www.linkedin.com/legal/privacy-policy"
                                            }),
                                            "; Privacy Shield (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung von Daten in den USA): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.privacyshield.gov/participant?id=a2zt0000000L0UZAA0&status=Active",
                                                children: "https://www.privacyshield.gov/participant?id=a2zt0000000L0UZAA0&status=Active"
                                            }),
                                            "; Widerspruchsm\xf6glichkeit (Opt-Out): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out",
                                                children: "https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Pinterest:"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: Pinterest Inc., 635 High Street, Palo Alto, CA, 94301, USA,; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.pinterest.com",
                                                children: "https://www.pinterest.com"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://about.pinterest.com/de/privacy-policy",
                                                children: "https://about.pinterest.com/de/privacy-policy"
                                            }),
                                            "; Widerspruchsm\xf6glichkeit (Opt-Out): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://about.pinterest.com/de/privacy-policy",
                                                children: "https://about.pinterest.com/de/privacy-policy"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Twitter:"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103, USA; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://twitter.com/de/privacy",
                                                children: "https://twitter.com/de/privacy"
                                            }),
                                            ", (Einstellungen) ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://twitter.com/personalization",
                                                children: "https://twitter.com/personalization"
                                            }),
                                            "; Privacy Shield (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung von Daten in den USA): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active",
                                                children: "https://www.privacyshield.gov/participant?id=a2zt0000000TORzAAO&status=Active"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "YouTube:"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland, Mutterunternehmen: Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://policies.google.com/privacy",
                                                children: "https://policies.google.com/privacy"
                                            }),
                                            "; Privacy Shield (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung von Daten in den USA): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active",
                                                children: "https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active"
                                            }),
                                            "; Widerspruchsm\xf6glichkeit (Opt-Out): ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://adssettings.google.com/authenticated",
                                                children: "https://adssettings.google.com/authenticated"
                                            }),
                                            "."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Xing:"
                                            }),
                                            " Soziales Netzwerk; Dienstanbieter: XING AG, Dammtorstra\xdfe 29-32, 20354 Hamburg, Deutschland; Website: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://www.xing.de",
                                                children: "https://www.xing.de"
                                            }),
                                            "; Datenschutzerkl\xe4rung: ",
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                href: "https://privacy.xing.com/de/datenschutzerklaerung",
                                                children: "https://privacy.xing.com/de/datenschutzerklaerung"
                                            }),
                                            "."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m723",
                            children: "Planung, Organisation und Hilfswerkzeuge"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: 'Wir setzen Dienstleistungen, Plattformen und Software anderer Anbieter (nachfolgend bezeichnet als "Drittanbieter\u201D) zu Zwecken der Organisation, Verwaltung, Planung sowie Erbringung unserer Leistungen ein. Bei der Auswahl der Drittanbieter und ihrer Leistungen beachten wir die gesetzlichen Vorgaben. '
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "In diesem Rahmen k\xf6nnen personenbezogenen Daten verarbeitet und auf den Servern der Drittanbieter gespeichert werden. Hiervon k\xf6nnen diverse Daten betroffen sein, die wir entsprechend dieser Datenschutzerkl\xe4rung verarbeiten. Zu diesen Daten k\xf6nnen insbesondere Stammdaten und Kontaktdaten der Nutzer, Daten zu Vorg\xe4ngen, Vertr\xe4gen, sonstigen Prozessen und deren Inhalte geh\xf6ren."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Sofern Nutzer im Rahmen der Kommunikation, von Gesch\xe4fts- oder anderen Beziehungen mit uns auf die Drittanbieter bzw. deren Software oder Plattformen verwiesen werden, k\xf6nnen die Drittanbieter Nutzungsdaten und Metadaten zu Sicherheitszwecken, zur Serviceoptimierung oder zu Marketingzwecken verarbeiten. Wir bitten daher darum, die Datenschutzhinweise der jeweiligen Drittanbieter zu beachten."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                    children: "Hinweise zu Rechtsgrundlagen:"
                                }),
                                " Sofern wir die Nutzer um deren Einwilligung in den Einsatz der Drittanbieter bitten, ist die Rechtsgrundlage der Verarbeitung von Daten die Einwilligung. Ferner kann deren Einsatz ein Bestandteil unserer (vor)vertraglichen Leistungen sein, sofern der Einsatz der Drittanbieter in diesem Rahmen vereinbart wurde. Ansonsten werden die Daten der Nutzer auf Grundlage unserer berechtigten Interessen (d.h. Interesse an effizienten, wirtschaftlichen und empf\xe4ngerfreundlichen Leistungen) verarbeitet. In diesem Zusammenhang m\xf6chten wir Sie auch auf die Informationen zur Verwendung von Cookies in dieser Datenschutzerkl\xe4rung hinweisen."
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {})
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                            className: "dsg-license-content-blurred",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Trello"
                            })
                        }),
                        ": ",
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                            className: "dsg-license-content-blurred",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                className: "dsg-lc-missing dsg-license-content-info-shop dsg-bg-green",
                                children: [
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                        className: "title",
                                        children: 'Dieses Modul ist nur nach Eingabe des Lizenzcodes "Datenschutzerkl\xe4rung Deutsch" zug\xe4nglich'
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("div", {
                                        className: "dsg-license-content-info-shop-left",
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                children: [
                                                    "Sie haben schon einen Lizenzcode? ",
                                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                        title: "Lizenzcode im Premiumbereich eingeben.",
                                                        href: "#dsg-group-premium",
                                                        children: "Geben Sie ihn bitte oben im Premiumbereich ein"
                                                    }),
                                                    "."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                children: [
                                                    "Oder erwerben Sie bitte die Lizenz ",
                                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                        href: "https://datenschutz-generator.de/produkt-kategorie/datenschutzerklaerung/",
                                                        className: " dsg-license-content-info-shop-link",
                                                        title: "Bitte erwerben Sie die Lizenz bei uns im Shop",
                                                        children: "bei uns im Shop f\xfcr Gesch\xe4ftskunden."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                                children: [
                                                    "Sie m\xf6chten wissen wie der Lizenzerwerb funktioniert? Schauen Sie dazu bitte ",
                                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                                        href: "https://datenschutz-generator.de/help-premium/",
                                                        title: "Anleitung f\xfcr den Lizenzerwerb",
                                                        children: "in unsere Anleitung"
                                                    }),
                                                    "."
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        href: "https://datenschutz-generator.de/help-license/",
                                        title: "Anleitung f\xfcr den Lizenzerwerb",
                                        className: "dsg-license-content-info-shop-right"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "m-elements",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Verarbeitete Datenarten:"
                                            }),
                                            " Bestandsdaten (z.B. Namen, Adressen), Kontaktdaten (z.B. E-Mail, Telefonnummern), Inhaltsdaten (z.B. Texteingaben, Fotografien, Videos), Nutzungsdaten (z.B. besuchte Webseiten, Interesse an Inhalten, Zugriffszeiten), Meta-/Kommunikationsdaten (z.B. Ger\xe4te-Informationen, IP-Adressen)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Betroffene Personen:"
                                            }),
                                            " Kommunikationspartner, Nutzer (z.B. Webseitenbesucher, Nutzer von Onlinediensten)."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                                children: "Rechtsgrundlagen:"
                                            }),
                                            " Einwilligung (Art. 6 Abs. 1 S. 1 lit. a DSGVO), Vertragserf\xfcllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b. DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f. DSGVO)."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                children: "Eingesetzte Dienste und Diensteanbieter:"
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements",
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                                        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {})
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("div", {
                                        className: "dsg-license-content-blurred",
                                        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Trello"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                        children: ":"
                                    }),
                                    " Projektmanagement-Toplaceholder placeholder placeholder; Dienstanbieter: Trello Inc., 55placeholder placeholder placeholder; Website: ",
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        href: "https://trello.com/placeholder",
                                        children: "https://trello.com/placeholder"
                                    }),
                                    " placeholder placeholder; Datenschutzerkl\xe4rung: ",
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        href: "https://trello.com/pplaceholder",
                                        children: "https://trello.com/pplaceholder"
                                    }),
                                    " placeholder placeholder; Privacy Shield (Gew\xe4hrleistung Datenschutzniveau bei Verarbeitung von Daten in den USA): ",
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("a", {
                                        href: "https://www.privacysplaceholder",
                                        children: "https://www.privacysplaceholder"
                                    }),
                                    " placeholder placeholder."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m12",
                            children: "L\xf6schung von Daten"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Die von uns verarbeiteten Daten werden nach Ma\xdfgabe der gesetzlichen Vorgaben gel\xf6scht, sobald deren zur Verarbeitung erlaubten Einwilligungen widerrufen werden oder sonstige Erlaubnisse entfallen (z.B., wenn der Zweck der Verarbeitung dieser Daten entfallen ist oder sie f\xfcr den Zweck nicht erforderlich sind)."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Sofern die Daten nicht gel\xf6scht werden, weil sie f\xfcr andere und gesetzlich zul\xe4ssige Zwecke erforderlich sind, wird deren Verarbeitung auf diese Zwecke beschr\xe4nkt. D.h., die Daten werden gesperrt und nicht f\xfcr andere Zwecke verarbeitet. Das gilt z.B. f\xfcr Daten, die aus handels- oder steuerrechtlichen Gr\xfcnden aufbewahrt werden m\xfcssen oder deren Speicherung zur Geltendmachung, Aus\xfcbung oder Verteidigung von Rechtsanspr\xfcchen oder zum Schutz der Rechte einer anderen nat\xfcrlichen oder juristischen Person erforderlich ist."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Weitere Hinweise zu der L\xf6schung von personenbezogenen Daten k\xf6nnen ferner im Rahmen der einzelnen Datenschutzhinweise dieser Datenschutzerkl\xe4rung erfolgen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("ul", {
                            className: "m-elements"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m15",
                            children: "\xc4nderung und Aktualisierung der Datenschutzerkl\xe4rung"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Wir bitten Sie, sich regelm\xe4\xdfig \xfcber den Inhalt unserer Datenschutzerkl\xe4rung zu informieren. Wir passen die Datenschutzerkl\xe4rung an, sobald die \xc4nderungen der von uns durchgef\xfchrten Datenverarbeitungen dies erforderlich machen. Wir informieren Sie, sobald durch die \xc4nderungen eine Mitwirkungshandlung Ihrerseits (z.B. Einwilligung) oder eine sonstige individuelle Benachrichtigung erforderlich wird."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Sofern wir in dieser Datenschutzerkl\xe4rung Adressen und Kontaktinformationen von Unternehmen und Organisationen angeben, bitten wir zu beachten, dass die Adressen sich \xfcber die Zeit \xe4ndern k\xf6nnen und bitten die Angaben vor Kontaktaufnahme zu pr\xfcfen."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m10",
                            children: "Rechte der betroffenen Personen"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "Ihnen stehen als Betroffene nach der DSGVO verschiedene Rechte zu, die sich insbesondere aus Art. 15 bis 18 und 21 DSGVO ergeben:"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                        children: "Widerspruchsrecht: Sie haben das Recht, aus Gr\xfcnden, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch f\xfcr ein auf diese Bestimmungen gest\xfctztes Profiling. Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch f\xfcr das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht."
                                    })
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Widerrufsrecht bei Einwilligungen:"
                                        }),
                                        " Sie haben das Recht, erteilte Einwilligungen jederzeit zu widerrufen."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Auskunftsrecht:"
                                        }),
                                        " Sie haben das Recht, eine Best\xe4tigung dar\xfcber zu verlangen, ob betreffende Daten verarbeitet werden und auf Auskunft \xfcber diese Daten sowie auf weitere Informationen und Kopie der Daten entsprechend den gesetzlichen Vorgaben."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Recht auf Berichtigung:"
                                        }),
                                        " Sie haben entsprechend den gesetzlichen Vorgaben das Recht, die Vervollst\xe4ndigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Recht auf L\xf6schung und Einschr\xe4nkung der Verarbeitung:"
                                        }),
                                        " Sie haben nach Ma\xdfgabe der gesetzlichen Vorgaben das Recht, zu verlangen, dass Sie betreffende Daten unverz\xfcglich gel\xf6scht werden, bzw. alternativ nach Ma\xdfgabe der gesetzlichen Vorgaben eine Einschr\xe4nkung der Verarbeitung der Daten zu verlangen."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Recht auf Daten\xfcbertragbarkeit:"
                                        }),
                                        " Sie haben das Recht, Sie betreffende Daten, die Sie uns bereitgestellt haben, nach Ma\xdfgabe der gesetzlichen Vorgaben in einem strukturierten, g\xe4ngigen und maschinenlesbaren Format zu erhalten oder deren \xdcbermittlung an einen anderen Verantwortlichen zu fordern."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Beschwerde bei Aufsichtsbeh\xf6rde:"
                                        }),
                                        " Sie haben ferner nach Ma\xdfgabe der gesetzlichen Vorgaben das Recht, bei einer Aufsichtsbeh\xf6rde, insbesondere in dem Mitgliedstaat Ihres gew\xf6hnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutma\xdflichen Versto\xdfes, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verst\xf6\xdft."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("h2", {
                            id: "m42",
                            children: "Begriffsdefinitionen"
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("p", {
                            children: "In diesem Abschnitt erhalten Sie eine \xdcbersicht \xfcber die in dieser Datenschutzerkl\xe4rung verwendeten Begrifflichkeiten. Viele der Begriffe sind dem Gesetz entnommen und vor allem im Art. 4 DSGVO definiert. Die gesetzlichen Definitionen sind verbindlich. Die nachfolgenden Erl\xe4uterungen sollen dagegen vor allem dem Verst\xe4ndnis dienen. Die Begriffe sind alphabetisch sortiert."
                        }),
                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("ul", {
                            className: "glossary",
                            children: [
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Affiliate-Nachverfolgung:"
                                        }),
                                        " Im Rahmen der Affiliate-Nachverfolgung werden Links, mit deren Hilfe die verlinkenden Webseiten Nutzer zu Webseiten mit Produkt- oder sonstigen Angeboten verweisen, protokolliert. Die Betreiber der jeweils verlinkenden Webseiten k\xf6nnen eine Provision erhalten, wenn Nutzer diesen sogenannten Affiliate-Links folgen und anschlie\xdfend die Angebote wahrnehmen (z.B. Waren kaufen oder Dienstleistungen in Anspruch nehmen). Hierzu ist es erforderlich, dass die Anbieter nachverfolgen k\xf6nnen, ob Nutzer, die sich f\xfcr bestimmte Angebote interessieren, diese anschlie\xdfend auf die Veranlassung der Affiliate-Links wahrnehmen. Daher ist es f\xfcr die Funktionsf\xe4higkeit von Affiliate-Links erforderlich, dass sie um bestimmte Werte erg\xe4nzt werden, die ein Bestandteil des Links werden oder anderweitig, z.B. in einem Cookie, gespeichert werden. Zu den Werten geh\xf6ren insbesondere die Ausgangswebseite (Referrer), der Zeitpunkt, eine Online-Kennung der Betreiber der Webseite, auf der sich der Affiliate-Link befand, eine Online-Kennung des jeweiligen Angebotes, eine Online-Kennung des Nutzers als auch nachverfolgungsspezifische Werte, wie, z.B. Werbemittel-ID, Partner-ID und Kategorisierungen."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Besuchsaktionsauswertung:"
                                        }),
                                        ' "Besuchsaktionsauswertung" (englisch "Conversion Tracking") bezeichnet ein Verfahren, mit dem die Wirksamkeit von Marketingma\xdfnahmen festgestellt werden kann. Dazu wird im Regelfall ein Cookie auf den Ger\xe4ten der Nutzer innerhalb der Webseiten, auf denen die Marketingma\xdfnahmen erfolgen, gespeichert und dann erneut auf der Zielwebseite abgerufen. Beispielsweise k\xf6nnen wir so nachvollziehen, ob die von uns auf anderen Webseiten geschalteten Anzeigen erfolgreich waren).'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "IP-Masking:"
                                        }),
                                        ' Als "IP-Masking\u201D wird eine Methode bezeichnet, bei der das letzte Oktett, d.h., die letzten beiden Zahlen einer IP-Adresse, gel\xf6scht wird, damit die IP-Adresse nicht mehr der eindeutigen Identifizierung einer Person dienen kann. Daher ist das IP-Masking ein Mittel zur Pseudonymisierung von Verarbeitungsverfahren, insbesondere im Onlinemarketing'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Personenbezogene Daten:"
                                        }),
                                        ' "Personenbezogene Daten\u201C sind alle Informationen, die sich auf eine identifizierte oder identifizierbare nat\xfcrliche Person (im Folgenden "betroffene Person\u201C) beziehen; als identifizierbar wird eine nat\xfcrliche Person angesehen, die direkt oder indirekt, insbesondere mittels Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer Online-Kennung (z.B. Cookie) oder zu einem oder mehreren besonderen Merkmalen identifiziert werden kann, die Ausdruck der physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen Identit\xe4t dieser nat\xfcrlichen Person sind.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Profiling:"
                                        }),
                                        ' Als "Profiling\u201C wird jede Art der automatisierten Verarbeitung personenbezogener Daten bezeichnet, die darin besteht, dass diese personenbezogenen Daten verwendet werden, um bestimmte pers\xf6nliche Aspekte, die sich auf eine nat\xfcrliche Person beziehen (je nach Art des Profilings geh\xf6ren dazu Informationen betreffend das Alter, das Geschlecht, Standortdaten und Bewegungsdaten, Interaktion mit Webseiten und deren Inhalten, Einkaufsverhalten, soziale Interaktionen mit anderen Menschen) zu analysieren, zu bewerten oder, um sie vorherzusagen (z.B. die Interessen an bestimmten Inhalten oder Produkten, das Klickverhalten auf einer Webseite oder den Aufenthaltsort). Zu Zwecken des Profilings werden h\xe4ufig Cookies und Web-Beacons eingesetzt.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Reichweitenmessung:"
                                        }),
                                        " Die Reichweitenmessung (auch als Web Analytics bezeichnet) dient der Auswertung der Besucherstr\xf6me eines Onlineangebotes und kann das Verhalten oder Interessen der Besucher an bestimmten Informationen, wie z.B. Inhalten von Webseiten, umfassen. Mit Hilfe der Reichweitenanalyse k\xf6nnen Webseiteninhaber z.B. erkennen, zu welcher Zeit Besucher ihre Webseite besuchen und f\xfcr welche Inhalte sie sich interessieren. Dadurch k\xf6nnen sie z.B. die Inhalte der Webseite besser an die Bed\xfcrfnisse ihrer Besucher anpassen. Zu Zwecken der Reichweitenanalyse werden h\xe4ufig pseudonyme Cookies und Web-Beacons eingesetzt, um wiederkehrende Besucher zu erkennen und so genauere Analysen zur Nutzung eines Onlineangebotes zu erhalten."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Remarketing:"
                                        }),
                                        ' Vom "Remarketing\u201C bzw. "Retargeting\u201C spricht man, wenn z.B. zu Werbezwecken vermerkt wird, f\xfcr welche Produkte sich ein Nutzer auf einer Webseite interessiert hat, um den Nutzer auf anderen Webseiten an diese Produkte, z.B. in Werbeanzeigen, zu erinnern.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Tracking:"
                                        }),
                                        ' Vom "Tracking\u201C spricht man, wenn das Verhalten von Nutzern \xfcber mehrere Onlineangebote hinweg nachvollzogen werden kann. Im Regelfall werden im Hinblick auf die genutzten Onlineangebote Verhaltens- und Interessensinformationen in Cookies oder auf Servern der Anbieter der Trackingtechnologien gespeichert (sogenanntes Profiling). Diese Informationen k\xf6nnen anschlie\xdfend z.B. eingesetzt werden, um den Nutzern Werbeanzeigen anzuzeigen, die voraussichtlich deren Interessen entsprechen.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Verantwortlicher:"
                                        }),
                                        ' Als "Verantwortlicher\u201C wird die nat\xfcrliche oder juristische Person, Beh\xf6rde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen \xfcber die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet, bezeichnet.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("strong", {
                                            children: "Verarbeitung:"
                                        }),
                                        ' "Verarbeitung" ist jeder mit oder ohne Hilfe automatisierter Verfahren ausgef\xfchrte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der Begriff reicht weit und umfasst praktisch jeden Umgang mit Daten, sei es das Erheben, das Auswerten, das Speichern, das \xdcbermitteln oder das L\xf6schen.'
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("br", {}),
                                /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("br", {})
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


function $3c70deb718af584a$export$2e2bcd8739ae039() {
    $3c70deb718af584a$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3c70deb718af584a$export$2e2bcd8739ae039.apply(this, arguments);
}


function $dd64fffb54911a24$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function $1423c2b0598e318b$export$2e2bcd8739ae039(o, p) {
    $1423c2b0598e318b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1423c2b0598e318b$export$2e2bcd8739ae039(o, p);
}


function $d8c7edeedb2d46fa$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $1423c2b0598e318b$export$2e2bcd8739ae039)(subClass, superClass);
}



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $abfc2e338717d0d0$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $3712b9327fd53597$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $abfc2e338717d0d0$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}


function $919c01943d75a76e$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $919c01943d75a76e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $919c01943d75a76e$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $919c01943d75a76e$var$replaceClassName(element.className && element.className.baseVal || "", className));
}



var $iawgr = parcelRequire("iawgr");




var $iawgr = parcelRequire("iawgr");

var $d8a770bdea8788c5$export$2e2bcd8739ae039 = {
    disabled: false
};




var $iawgr = parcelRequire("iawgr");
var $32e6366ab89e05b5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createContext(null);


var $8733bfe525281fcd$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $977e2cb3d94bb562$export$bb38bb9a1161268 = "unmounted";
var $977e2cb3d94bb562$export$84cbff306f539230 = "exited";
var $977e2cb3d94bb562$export$df38205c966be359 = "entering";
var $977e2cb3d94bb562$export$78e9e6e3e014d60a = "entered";
var $977e2cb3d94bb562$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $977e2cb3d94bb562$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $d8c7edeedb2d46fa$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $977e2cb3d94bb562$export$84cbff306f539230;
                _this.appearStatus = $977e2cb3d94bb562$export$df38205c966be359;
            } else initialStatus = $977e2cb3d94bb562$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $977e2cb3d94bb562$export$bb38bb9a1161268;
        else initialStatus = $977e2cb3d94bb562$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $977e2cb3d94bb562$export$bb38bb9a1161268) return {
            status: $977e2cb3d94bb562$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $977e2cb3d94bb562$export$df38205c966be359 && status !== $977e2cb3d94bb562$export$78e9e6e3e014d60a) nextStatus = $977e2cb3d94bb562$export$df38205c966be359;
            } else if (status === $977e2cb3d94bb562$export$df38205c966be359 || status === $977e2cb3d94bb562$export$78e9e6e3e014d60a) nextStatus = $977e2cb3d94bb562$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $977e2cb3d94bb562$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($26cdf06a4340f785$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $8733bfe525281fcd$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $977e2cb3d94bb562$export$84cbff306f539230) this.setState({
            status: $977e2cb3d94bb562$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($26cdf06a4340f785$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $d8a770bdea8788c5$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $977e2cb3d94bb562$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $977e2cb3d94bb562$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $977e2cb3d94bb562$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($26cdf06a4340f785$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $d8a770bdea8788c5$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $977e2cb3d94bb562$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $977e2cb3d94bb562$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $977e2cb3d94bb562$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($26cdf06a4340f785$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $977e2cb3d94bb562$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $dd64fffb54911a24$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement((0, $32e6366ab89e05b5$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).Component);
$977e2cb3d94bb562$var$Transition.contextType = (0, $32e6366ab89e05b5$export$2e2bcd8739ae039);
$977e2cb3d94bb562$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $977e2cb3d94bb562$var$noop() {}
$977e2cb3d94bb562$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $977e2cb3d94bb562$var$noop,
    onEntering: $977e2cb3d94bb562$var$noop,
    onEntered: $977e2cb3d94bb562$var$noop,
    onExit: $977e2cb3d94bb562$var$noop,
    onExiting: $977e2cb3d94bb562$var$noop,
    onExited: $977e2cb3d94bb562$var$noop
};
$977e2cb3d94bb562$var$Transition.UNMOUNTED = $977e2cb3d94bb562$export$bb38bb9a1161268;
$977e2cb3d94bb562$var$Transition.EXITED = $977e2cb3d94bb562$export$84cbff306f539230;
$977e2cb3d94bb562$var$Transition.ENTERING = $977e2cb3d94bb562$export$df38205c966be359;
$977e2cb3d94bb562$var$Transition.ENTERED = $977e2cb3d94bb562$export$78e9e6e3e014d60a;
$977e2cb3d94bb562$var$Transition.EXITING = $977e2cb3d94bb562$export$4aacc83d4d59139f;
var $977e2cb3d94bb562$export$2e2bcd8739ae039 = $977e2cb3d94bb562$var$Transition;




var $4bd8875b459028f1$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $3712b9327fd53597$export$2e2bcd8739ae039)(node, c);
    });
};
var $4bd8875b459028f1$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $919c01943d75a76e$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $4bd8875b459028f1$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $d8c7edeedb2d46fa$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") {
            if (node) (0, $8733bfe525281fcd$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $4bd8875b459028f1$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $4bd8875b459028f1$var$removeClass(node, baseClassName);
        if (activeClassName) $4bd8875b459028f1$var$removeClass(node, activeClassName);
        if (doneClassName) $4bd8875b459028f1$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $dd64fffb54911a24$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement((0, $977e2cb3d94bb562$export$2e2bcd8739ae039), (0, $3c70deb718af584a$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).Component);
$4bd8875b459028f1$var$CSSTransition.defaultProps = {
    classNames: ""
};
$4bd8875b459028f1$var$CSSTransition.propTypes = {};
var $4bd8875b459028f1$export$2e2bcd8739ae039 = $4bd8875b459028f1$var$CSSTransition;



function $a250316c99c189f0$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}





var $iawgr = parcelRequire("iawgr");


var $iawgr = parcelRequire("iawgr");
function $dc31d17dc37532da$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $iawgr.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $iawgr.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $dc31d17dc37532da$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $dc31d17dc37532da$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $dc31d17dc37532da$export$fa71e2345c31d7a2(props, onExited) {
    return $dc31d17dc37532da$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $iawgr.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $dc31d17dc37532da$var$getProp(child, "appear", props),
            enter: $dc31d17dc37532da$var$getProp(child, "enter", props),
            exit: $dc31d17dc37532da$var$getProp(child, "exit", props)
        });
    });
}
function $dc31d17dc37532da$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $dc31d17dc37532da$export$bbc8a025727ea824(nextProps.children);
    var children = $dc31d17dc37532da$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $iawgr.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $iawgr.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $iawgr.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $dc31d17dc37532da$var$getProp(child, "exit", nextProps),
            enter: $dc31d17dc37532da$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $iawgr.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $iawgr.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $iawgr.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $dc31d17dc37532da$var$getProp(child, "exit", nextProps),
            enter: $dc31d17dc37532da$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $7f969331f666f90e$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $7f969331f666f90e$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $7f969331f666f90e$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $d8c7edeedb2d46fa$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $a250316c99c189f0$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $dc31d17dc37532da$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $dc31d17dc37532da$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $dc31d17dc37532da$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $3c70deb718af584a$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $dd64fffb54911a24$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $7f969331f666f90e$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement((0, $32e6366ab89e05b5$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement((0, $32e6366ab89e05b5$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).Component);
$7f969331f666f90e$var$TransitionGroup.propTypes = {};
$7f969331f666f90e$var$TransitionGroup.defaultProps = $7f969331f666f90e$var$defaultProps;
var $7f969331f666f90e$export$2e2bcd8739ae039 = $7f969331f666f90e$var$TransitionGroup;


// src/index.tsx

var $iawgr = parcelRequire("iawgr");
var $c14576c539166091$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $c14576c539166091$var$hasElementType = typeof Element !== "undefined";
var $c14576c539166091$var$hasMap = typeof Map === "function";
var $c14576c539166091$var$hasSet = typeof Set === "function";
var $c14576c539166091$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $c14576c539166091$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$c14576c539166091$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($c14576c539166091$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$c14576c539166091$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($c14576c539166091$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($c14576c539166091$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($c14576c539166091$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$c14576c539166091$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$c14576c539166091$exports = function isEqual(a, b) {
    try {
        return $c14576c539166091$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};


var $b6fbe0ee0089a922$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $b6fbe0ee0089a922$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$b6fbe0ee0089a922$exports = $b6fbe0ee0089a922$var$invariant;


var $032e59d9d93c7ab0$exports = {};
//
$032e59d9d93c7ab0$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


// src/constants.ts
var $dc687f20fbf411ab$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($dc687f20fbf411ab$var$TAG_NAMES || {});
var $dc687f20fbf411ab$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $dc687f20fbf411ab$var$VALID_TAG_NAMES = Object.values($dc687f20fbf411ab$var$TAG_NAMES);
var $dc687f20fbf411ab$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $dc687f20fbf411ab$var$HTML_TAG_MAP = Object.entries($dc687f20fbf411ab$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $dc687f20fbf411ab$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $dc687f20fbf411ab$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $dc687f20fbf411ab$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $dc687f20fbf411ab$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $dc687f20fbf411ab$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $dc687f20fbf411ab$var$getInnermostProperty(propsList, $dc687f20fbf411ab$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $dc687f20fbf411ab$var$getInnermostProperty(propsList, $dc687f20fbf411ab$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $dc687f20fbf411ab$var$getOnChangeClientState = (propsList)=>$dc687f20fbf411ab$var$getInnermostProperty(propsList, $dc687f20fbf411ab$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $dc687f20fbf411ab$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $dc687f20fbf411ab$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $dc687f20fbf411ab$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $dc687f20fbf411ab$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $dc687f20fbf411ab$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $dc687f20fbf411ab$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $dc687f20fbf411ab$var$reducePropsToState = (propsList)=>({
        baseTag: $dc687f20fbf411ab$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $dc687f20fbf411ab$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $dc687f20fbf411ab$var$getInnermostProperty(propsList, $dc687f20fbf411ab$var$HELMET_PROPS.DEFER),
        encode: $dc687f20fbf411ab$var$getInnermostProperty(propsList, $dc687f20fbf411ab$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $dc687f20fbf411ab$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $dc687f20fbf411ab$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $dc687f20fbf411ab$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $dc687f20fbf411ab$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $dc687f20fbf411ab$var$getOnChangeClientState(propsList),
        scriptTags: $dc687f20fbf411ab$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $dc687f20fbf411ab$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $dc687f20fbf411ab$var$getTitleFromPropsList(propsList),
        titleAttributes: $dc687f20fbf411ab$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $dc687f20fbf411ab$var$getAnyTrueFromPropsList(propsList, $dc687f20fbf411ab$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $dc687f20fbf411ab$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $dc687f20fbf411ab$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $dc687f20fbf411ab$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($dc687f20fbf411ab$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $dc687f20fbf411ab$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $dc687f20fbf411ab$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $dc687f20fbf411ab$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $dc687f20fbf411ab$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $dc687f20fbf411ab$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $dc687f20fbf411ab$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $dc687f20fbf411ab$var$flattenArray(title);
    return attributeString ? `<${type} ${$dc687f20fbf411ab$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$dc687f20fbf411ab$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$dc687f20fbf411ab$var$HELMET_ATTRIBUTE}="true">${$dc687f20fbf411ab$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $dc687f20fbf411ab$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$dc687f20fbf411ab$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $dc687f20fbf411ab$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$dc687f20fbf411ab$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $dc687f20fbf411ab$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $dc687f20fbf411ab$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $dc687f20fbf411ab$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$dc687f20fbf411ab$var$HELMET_ATTRIBUTE]: true
    };
    const props = $dc687f20fbf411ab$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $dc687f20fbf411ab$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$dc687f20fbf411ab$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $dc687f20fbf411ab$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement(type, mappedTag);
    });
var $dc687f20fbf411ab$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$dc687f20fbf411ab$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$dc687f20fbf411ab$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$dc687f20fbf411ab$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$dc687f20fbf411ab$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$dc687f20fbf411ab$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$dc687f20fbf411ab$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $dc687f20fbf411ab$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $dc687f20fbf411ab$var$prioritizer(metaTags, $dc687f20fbf411ab$var$SEO_PRIORITY_TAGS.meta);
    const link = $dc687f20fbf411ab$var$prioritizer(linkTags, $dc687f20fbf411ab$var$SEO_PRIORITY_TAGS.link);
    const script = $dc687f20fbf411ab$var$prioritizer(scriptTags, $dc687f20fbf411ab$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$dc687f20fbf411ab$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$dc687f20fbf411ab$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$dc687f20fbf411ab$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$dc687f20fbf411ab$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$dc687f20fbf411ab$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$dc687f20fbf411ab$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $dc687f20fbf411ab$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $dc687f20fbf411ab$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $dc687f20fbf411ab$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $dc687f20fbf411ab$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $dc687f20fbf411ab$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $dc687f20fbf411ab$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $dc687f20fbf411ab$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $dc687f20fbf411ab$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $dc687f20fbf411ab$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $dc687f20fbf411ab$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $dc687f20fbf411ab$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $dc687f20fbf411ab$var$server_default = $dc687f20fbf411ab$var$mapStateOnServer;
// src/HelmetData.ts
var $dc687f20fbf411ab$var$instances = [];
var $dc687f20fbf411ab$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $dc687f20fbf411ab$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $dc687f20fbf411ab$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $dc687f20fbf411ab$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $dc687f20fbf411ab$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $dc687f20fbf411ab$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $dc687f20fbf411ab$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $dc687f20fbf411ab$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var $dc687f20fbf411ab$var$defaultValue = {};
var $dc687f20fbf411ab$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createContext($dc687f20fbf411ab$var$defaultValue);
var $dc687f20fbf411ab$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $iawgr.Component) {
    static canUseDOM = $dc687f20fbf411ab$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new $dc687f20fbf411ab$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement($dc687f20fbf411ab$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $dc687f20fbf411ab$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$dc687f20fbf411ab$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($dc687f20fbf411ab$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $dc687f20fbf411ab$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($dc687f20fbf411ab$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($dc687f20fbf411ab$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($dc687f20fbf411ab$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($dc687f20fbf411ab$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $dc687f20fbf411ab$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $dc687f20fbf411ab$var$flattenArray(title);
    $dc687f20fbf411ab$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $dc687f20fbf411ab$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $dc687f20fbf411ab$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $dc687f20fbf411ab$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $dc687f20fbf411ab$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $dc687f20fbf411ab$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $dc687f20fbf411ab$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $dc687f20fbf411ab$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $dc687f20fbf411ab$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $dc687f20fbf411ab$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $dc687f20fbf411ab$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $dc687f20fbf411ab$var$_helmetCallback = null;
var $dc687f20fbf411ab$var$handleStateChangeOnClient = (newState)=>{
    if ($dc687f20fbf411ab$var$_helmetCallback) cancelAnimationFrame($dc687f20fbf411ab$var$_helmetCallback);
    if (newState.defer) $dc687f20fbf411ab$var$_helmetCallback = requestAnimationFrame(()=>{
        $dc687f20fbf411ab$var$commitTagChanges(newState, ()=>{
            $dc687f20fbf411ab$var$_helmetCallback = null;
        });
    });
    else {
        $dc687f20fbf411ab$var$commitTagChanges(newState);
        $dc687f20fbf411ab$var$_helmetCallback = null;
    }
};
var $dc687f20fbf411ab$var$client_default = $dc687f20fbf411ab$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $dc687f20fbf411ab$var$HelmetDispatcher = class extends (0, $iawgr.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($032e59d9d93c7ab0$exports)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $dc687f20fbf411ab$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if ($dc687f20fbf411ab$export$4719288a8f5f7e71.canUseDOM) $dc687f20fbf411ab$var$client_default(state);
        else if ($dc687f20fbf411ab$var$server_default) serverState = $dc687f20fbf411ab$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var $dc687f20fbf411ab$export$dcef8f9bb9a41431 = class extends (0, $iawgr.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($c14576c539166091$exports)))($dc687f20fbf411ab$var$without(this.props, "helmetData"), $dc687f20fbf411ab$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($b6fbe0ee0089a922$exports)))($dc687f20fbf411ab$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$dc687f20fbf411ab$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($b6fbe0ee0089a922$exports)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$dc687f20fbf411ab$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $dc687f20fbf411ab$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $dc687f20fbf411ab$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement($dc687f20fbf411ab$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement($dc687f20fbf411ab$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($iawgr))).createElement($dc687f20fbf411ab$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};


const $b52621a126e1ad32$export$86fbec116b87613f = ()=>{
    const matchReduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const [followMouse, setFollowMouse] = (0, $iawgr.useState)(!matchReduceMotion.matches);
    const location = (0, $9352744c2719600e$export$45d76561a5302f2b)();
    (0, $ad12973d6e24df39$export$ae1d0d62f31e3240)("(prefers-reduced-motion: reduce)", (event)=>setFollowMouse(!event.matches));
    const card = /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $f1bc493e73489673$export$de9f45c659fccc16), {
        followMouse: followMouse
    });
    const getCanonicalUrl = (path)=>{
        const baseUrl = "https://leondietsch.de";
        return `${baseUrl}${path}`;
    };
    return /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)((0, $dc687f20fbf411ab$export$4719288a8f5f7e71), {
        children: [
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $dc687f20fbf411ab$export$dcef8f9bb9a41431), {
                children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)("link", {
                    rel: "canonical",
                    href: getCanonicalUrl(location.pathname)
                })
            }),
            /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)("main", {
                className: $b52621a126e1ad32$var$getClassNames(location),
                children: [
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $7f969331f666f90e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $4bd8875b459028f1$export$2e2bcd8739ae039), {
                            classNames: "page",
                            timeout: 1000,
                            children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsxs)((0, $9352744c2719600e$export$3565eb3d00ca5a74), {
                                location: location,
                                children: [
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $9352744c2719600e$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/impressum",
                                        element: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $5e534017dbaac379$export$89412e086ed76e41), {})
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $9352744c2719600e$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/datenschutz",
                                        element: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $32f750facf6f6a51$export$c5c352a5595119a5), {})
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $9352744c2719600e$export$e7b0ac011bb776c6), {
                                        exact: true,
                                        path: "/",
                                        element: card
                                    }),
                                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $9352744c2719600e$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: card
                                    })
                                ]
                            })
                        }, location.key)
                    }),
                    /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $e7c3a2511e3d825f$export$2e2bcd8739ae039), {
                        followMouse: followMouse,
                        setFollowMouse: setFollowMouse,
                        backLink: location.pathname !== "/"
                    })
                ]
            })
        ]
    });
};
const $b52621a126e1ad32$var$getClassNames = ({ pathname: pathname })=>{
    let base = [
        "app"
    ];
    if ((0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).safari) base.push("safari-compat");
    else if ((0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).ie) base.push("ie-compat");
    else if ((0, $49f6b8e9145f1ed5$export$8514dfc5d66e21a5).edge) base.push("edge-compat");
    else base.push("no-compat");
    if (pathname === "/") base.push("app--static-viewport");
    return (0, $ad12973d6e24df39$export$188d75d71883854a)(...base);
};



const $d455c38af1392934$var$container = document.getElementById("app");
const $d455c38af1392934$var$root = (0, $e6396f5ab52e7921$export$882461b6382ed46c)($d455c38af1392934$var$container);
$d455c38af1392934$var$root.render(/*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $c566805c483e906d$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $d6a3100aa477035c$exports.jsx)((0, $b52621a126e1ad32$export$86fbec116b87613f), {})
}));


//# sourceMappingURL=index.4ede9aa6.js.map
